import type * as z from 'zod';
export type Maybe<T> = T extends PromiseLike<infer U> ? Promise<U | null | undefined> : T | null | undefined;
export type InputMaybe<T> = T extends PromiseLike<infer U> ? Promise<U | null | undefined> : T | null | undefined;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Date: { input: string; output: string };
  Float32: { input: number; output: number };
  Float64: { input: number; output: number };
  Int32: { input: number; output: number };
  Int64: { input: bigint; output: bigint };
  JSON: { input: string; output: z.util.JSONType };
  JSONObject: { input: string; output: z.util.JSONType };
  Timestamp: { input: number; output: Date };
};

/** View 'AlarmDefinition' in the iPSO production optimization solution data model. */
export type AlarmDefinition = {
  /** Text attribute 'alarmCategory' for this 'AlarmDefinition' row. */
  alarmCategory: Maybe<Scalars['String']['output']>;
  /** Numeric value 'alarmCounterToTicket' (integer) for this 'AlarmDefinition' row. */
  alarmCounterToTicket: Maybe<Scalars['Int']['output']>;
  /** Text attribute 'alarmCriticality' for this 'AlarmDefinition' row. */
  alarmCriticality: Maybe<Scalars['String']['output']>;
  /** Text attribute 'alarmDataSource' for this 'AlarmDefinition' row. */
  alarmDataSource: Maybe<Scalars['String']['output']>;
  /** Text attribute 'alarmDescription' for this 'AlarmDefinition' row. */
  alarmDescription: Maybe<Scalars['String']['output']>;
  /** Text attribute 'alarmMessage' for this 'AlarmDefinition' row. */
  alarmMessage: Maybe<Scalars['String']['output']>;
  /** Text attribute 'alarmMsgParameter' for this 'AlarmDefinition' row. */
  alarmMsgParameter: Maybe<Scalars['String']['output']>;
  /** Text attribute 'alarmName' for this 'AlarmDefinition' row. */
  alarmName: Maybe<Scalars['String']['output']>;
  /** Text attribute 'alarmPriority' for this 'AlarmDefinition' row. */
  alarmPriority: Maybe<Scalars['String']['output']>;
  /** Text attribute 'alarmType' for this 'AlarmDefinition' row. */
  alarmType: Maybe<Scalars['String']['output']>;
  /** Text attribute 'alarmTypeCategory' for this 'AlarmDefinition' row. */
  alarmTypeCategory: Maybe<Scalars['String']['output']>;
  /** Text attribute 'alarmTypeSubCategory' for this 'AlarmDefinition' row. */
  alarmTypeSubCategory: Maybe<Scalars['String']['output']>;
  /** Text attribute 'alarmUnifiedCode' for this 'AlarmDefinition' row. */
  alarmUnifiedCode: Maybe<Scalars['String']['output']>;
  /** Text attribute 'isAlarmTicket' for this 'AlarmDefinition' row. */
  isAlarmTicket: Maybe<Scalars['String']['output']>;
  /** Text attribute 'subCategory' for this 'AlarmDefinition' row. */
  subCategory: Maybe<Scalars['String']['output']>;
  /** Text attribute 'subWorkflowName' for this 'AlarmDefinition' row. */
  subWorkflowName: Maybe<Scalars['String']['output']>;
  /** Text attribute 'ticketAsset' for this 'AlarmDefinition' row. */
  ticketAsset: Maybe<Scalars['String']['output']>;
  /** Text attribute 'ticketAssignedGroup' for this 'AlarmDefinition' row. */
  ticketAssignedGroup: Maybe<Scalars['String']['output']>;
  /** Text attribute 'ticketAssignedTo' for this 'AlarmDefinition' row. */
  ticketAssignedTo: Maybe<Scalars['String']['output']>;
  /** Text attribute 'ticketDept' for this 'AlarmDefinition' row. */
  ticketDept: Maybe<Scalars['String']['output']>;
  /** Text attribute 'ticketRecommedation' for this 'AlarmDefinition' row. */
  ticketRecommedation: Maybe<Scalars['String']['output']>;
  /** Text attribute 'workflowCode' for this 'AlarmDefinition' row. */
  workflowCode: Maybe<Scalars['String']['output']>;
  /** Text attribute 'workflowName' for this 'AlarmDefinition' row. */
  workflowName: Maybe<Scalars['String']['output']>;
};

/**
 * Allocated injection volumes per well string for water and gas (WF15).
 *
 * Daily and monthly allocated gas and water injection, active hours/days per type.
 * Use for injection performance, reporting, and trend analysis. For measured rates see MeasuredInjection_String_Agent.
 *
 * Use for: Water or Gas Injection Monitoring (WF15), Production Allocation (WF5).
 */
export type AllocatedInjectionStringAgent = {
  /** Number of hours (0-24) the string was actively injecting gas during the day. */
  dayGasInjActiveHours: Maybe<TimeSeries>;
  /**
   * Daily allocated gas injection volume (MSCF/d). Use for Day/Week time ranges.
   * The string's allocated share of total metered gas injection.
   */
  dayGasInjGasInjVolume: Maybe<TimeSeries>;
  /** Number of hours (0-24) the string was actively injecting water during the day. */
  dayWaterInjActiveHours: Maybe<TimeSeries>;
  /**
   * Daily allocated water injection volume (stb/d). Use for Day/Week time ranges.
   * The string's allocated share of total metered water injection.
   */
  dayWaterInjWaterInjVolume: Maybe<TimeSeries>;
  /** Number of days (0-31) the string was actively injecting gas during the month. */
  monthGasInjActiveDays: Maybe<TimeSeries>;
  /**
   * Monthly allocated gas injection volume (MSCF). Use for Month/Quarter/Year queries.
   * Sum of daily gas injection for the calendar month.
   */
  monthGasInjGasInjVolume: Maybe<TimeSeries>;
  /** Number of days (0-31) the string was actively injecting water during the month. */
  monthWaterInjActiveDays: Maybe<TimeSeries>;
  /**
   * Monthly allocated water injection volume (stb). Use for Month/Quarter/Year queries.
   * Sum of daily water injection for the calendar month.
   */
  monthWaterInjWaterInjVolume: Maybe<TimeSeries>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString: Maybe<StringAsset>;
};

/** Daily and monthly allocated production and injection properties for each well string, including allocated oil, gas, water, gas lift and water injection volumes, flow directions, production methods and modes for use in production allocation and performance analysis. */
export type AllocatedPropertiesString = {
  /** Daily time series of the number of hours this string was actively producing in the allocation period. */
  dayAllocProdActiveHours: Maybe<TimeSeries>;
  /** Daily allocated gas production volume or rate for this string resulting from the production allocation process. */
  dayAllocProdAllocatedGas: Maybe<TimeSeries>;
  /** Daily allocated oil production volume for this string resulting from the production allocation process. */
  dayAllocProdAllocatedOil: Maybe<TimeSeries>;
  /** Daily allocated water production volume or rate for this string resulting from the production allocation process. */
  dayAllocProdAllocatedWater: Maybe<TimeSeries>;
  /** Daily time series describing the net flow direction of production for this string (for example flowing from reservoir to surface or reversed). */
  dayAllocProdFlowDirection: Maybe<TimeSeries>;
  /** Daily time series of the production method applied to this string for allocated production (for example natural flow, gas lift, ESP). */
  dayAllocProdProdMethod: Maybe<TimeSeries>;
  /** Daily time series of the operating or production mode of this string during production allocation (for example normal, test, shut-in). */
  dayAllocProdProdMode: Maybe<TimeSeries>;
  /** Daily time series indicating the string function classification (for example producer or injector) used in the production allocation for this string. */
  dayAllocProdStringFunction: Maybe<TimeSeries>;
  /** Daily time series of the number of hours contributing to gas plant (GP) allocated gas volume for this string. */
  dayGPAllocVolActiveHours: Maybe<TimeSeries>;
  /** Daily allocated gas volume at the gas plant (GP) level attributed to this string. */
  dayGPAllocVolAllocatedGas: Maybe<TimeSeries>;
  /** Daily time series describing the flow direction associated with gas plant (GP) allocated gas volume for this string. */
  dayGPAllocVolFlowDirection: Maybe<TimeSeries>;
  /** Daily time series of the production method associated with gas plant (GP) allocated gas volume for this string. */
  dayGPAllocVolProdMethod: Maybe<TimeSeries>;
  /** Daily time series of the operating mode associated with gas plant (GP) allocated gas volume for this string. */
  dayGPAllocVolProdMode: Maybe<TimeSeries>;
  /** Daily time series indicating the string function classification associated with gas plant (GP) allocated gas volume for this string. */
  dayGPAllocVolStringFunction: Maybe<TimeSeries>;
  /** Daily time series of the number of hours this string was active for gas injection. */
  dayGasInjActiveHours: Maybe<TimeSeries>;
  /** Daily time series describing the flow direction of gas injection associated with this string. */
  dayGasInjFlowDirection: Maybe<TimeSeries>;
  /** Daily allocated gas injection volume for this string. */
  dayGasInjGasInjVolume: Maybe<TimeSeries>;
  /** Daily time series indicating the type of gas or material being injected through this string. */
  dayGasInjMaterialType: Maybe<TimeSeries>;
  /** Daily time series of the operating mode applicable while gas is being injected through this string. */
  dayGasInjProdMode: Maybe<TimeSeries>;
  /** Daily time series indicating the string function classification for gas injection service on this string. */
  dayGasInjStringFunction: Maybe<TimeSeries>;
  /** Daily time series of the number of hours this string was active for water injection. */
  dayWaterInjActiveHours: Maybe<TimeSeries>;
  /** Daily time series describing the flow direction of water injection associated with this string. */
  dayWaterInjFlowDirection: Maybe<TimeSeries>;
  /** Daily time series indicating the type of water or chemical being injected through this string. */
  dayWaterInjMaterialType: Maybe<TimeSeries>;
  /** Daily time series of the operating mode applicable while water is being injected through this string. */
  dayWaterInjProdMode: Maybe<TimeSeries>;
  /** Daily time series indicating the string function classification for water injection service on this string. */
  dayWaterInjStringFunction: Maybe<TimeSeries>;
  /** Daily allocated water injection volume for this string. */
  dayWaterInjWaterInjVolume: Maybe<TimeSeries>;
  /** Name of the well string (completion) for which allocated production and injection properties are calculated, sourced from the 'String_asset' view. */
  entityName: Maybe<StringAsset>;
  /** Monthly time series indicating the number of days this string was actively producing within the month. */
  monthAllocProdActiveDays: Maybe<TimeSeries>;
  /** Monthly allocated gas production volume for this string resulting from the production allocation process. */
  monthAllocProdAllocatedGas: Maybe<TimeSeries>;
  /** Monthly allocated oil production volume for this string resulting from the production allocation process. */
  monthAllocProdAllocatedOil: Maybe<TimeSeries>;
  /** Monthly allocated water production volume for this string resulting from the production allocation process. */
  monthAllocProdAllocatedWater: Maybe<TimeSeries>;
  /** Monthly time series describing the dominant production flow direction for this string. */
  monthAllocProdFlowDirection: Maybe<TimeSeries>;
  /** Monthly time series summarizing the dominant production method applied to this string for allocated production. */
  monthAllocProdProdMethod: Maybe<TimeSeries>;
  /** Monthly time series indicating the string function classification used in the production allocation for this string. */
  monthAllocProdStringFunction: Maybe<TimeSeries>;
  /** Monthly time series of the number of hours contributing to gas plant (GP) allocated gas volume for this string. */
  monthGPAllocVolActiveHours: Maybe<TimeSeries>;
  /** Monthly allocated gas volume at the gas plant (GP) level attributed to this string. */
  monthGPAllocVolAllocatedGas: Maybe<TimeSeries>;
  /** Monthly time series describing the dominant flow direction associated with gas plant (GP) allocated gas volume for this string. */
  monthGPAllocVolFlowDirection: Maybe<TimeSeries>;
  /** Monthly time series of the dominant production method associated with gas plant (GP) allocated gas volume for this string. */
  monthGPAllocVolProdMethod: Maybe<TimeSeries>;
  /** Monthly time series of the operating mode associated with gas plant (GP) allocated gas volume for this string. */
  monthGPAllocVolProdMode: Maybe<TimeSeries>;
  /** Monthly time series indicating the string function classification associated with gas plant (GP) allocated gas volume for this string. */
  monthGPAllocVolStringFunction: Maybe<TimeSeries>;
  /** Monthly time series indicating the number of days this string was active for gas injection. */
  monthGasInjActiveDays: Maybe<TimeSeries>;
  /** Monthly time series describing the dominant gas injection flow direction associated with this string. */
  monthGasInjFlowDirection: Maybe<TimeSeries>;
  /** Monthly allocated gas injection volume for this string. */
  monthGasInjGasInjVolume: Maybe<TimeSeries>;
  /** Monthly time series indicating the predominant gas or material type injected through this string. */
  monthGasInjMaterialType: Maybe<TimeSeries>;
  /** Monthly time series summarizing the operating mode while gas is being injected through this string. */
  monthGasInjProdMode: Maybe<TimeSeries>;
  /** Monthly time series indicating the string function classification for gas injection service on this string. */
  monthGasInjStringFunction: Maybe<TimeSeries>;
  /** Monthly time series indicating the number of days this string was active for water injection. */
  monthWaterInjActiveDays: Maybe<TimeSeries>;
  /** Monthly time series describing the dominant water injection flow direction associated with this string. */
  monthWaterInjFlowDirection: Maybe<TimeSeries>;
  /** Monthly time series indicating the predominant water or chemical type injected through this string. */
  monthWaterInjMaterialType: Maybe<TimeSeries>;
  /** Monthly time series summarizing the operating mode while water is being injected through this string. */
  monthWaterInjProdMode: Maybe<TimeSeries>;
  /** Monthly time series indicating the string function classification for water injection service on this string. */
  monthWaterInjStringFunction: Maybe<TimeSeries>;
  /** Monthly allocated water injection volume for this string. */
  monthWaterInjWaterInjVolume: Maybe<TimeSeries>;
};

/**
 * Daily and monthly allocated production volumes per well string (WF5).
 *
 * Allocated oil, gas, water; active hours and days per string from reconciled
 * metered volumes. Use for production performance, uptime, and forecasting. For raw/unallocated data see other views.
 *
 * Use for: Production Allocation (WF5), Gas Lift Estimation and Allocation (WF13).
 *
 * @name Allocated Rates - Daily/Monthly (Agent)
 */
export type AllocatedRatesDailyStringAgent = {
  /**
   * Number of hours (0-24) the string was actively producing during the day.
   * Used to calculate onstream efficiency.
   */
  dayAllocProdActiveHours: Maybe<TimeSeries>;
  /** Daily allocated gas production volume (MSCF/d). Use for Day/Week time ranges. */
  dayAllocProdAllocatedGas: Maybe<TimeSeries>;
  /**
   * Daily allocated oil production volume (stb/d). Use for Day/Week time ranges.
   * This is the string's official allocated share of total metered oil.
   */
  dayAllocProdAllocatedOil: Maybe<TimeSeries>;
  /**
   * Daily allocated water production volume (stb/d). Use for Day/Week time ranges.
   * Used for water cut analysis and water handling planning.
   */
  dayAllocProdAllocatedWater: Maybe<TimeSeries>;
  /**
   * Number of days (0-31) the string was actively producing during the month.
   * Used to calculate monthly onstream efficiency.
   */
  monthAllocProdActiveDays: Maybe<TimeSeries>;
  /**
   * Monthly allocated gas production volume (MSCF). Use for Month/Quarter/Year queries.
   * Sum of daily allocated gas for the calendar month.
   */
  monthAllocProdAllocatedGas: Maybe<TimeSeries>;
  /**
   * Monthly allocated oil production volume (stb). Use for Month/Quarter/Year queries.
   * Sum of daily allocated oil for the calendar month.
   */
  monthAllocProdAllocatedOil: Maybe<TimeSeries>;
  /**
   * Monthly allocated water production volume (stb). Use for Month/Quarter/Year queries.
   * Sum of daily allocated water for the calendar month.
   */
  monthAllocProdAllocatedWater: Maybe<TimeSeries>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString: Maybe<StringAsset>;
};

/**
 * VFM-based allocation rates per well string from WF05 (WF5).
 *
 * Preferred and weighted-average VFM rates, per-method average oil rates. Use for
 * comparison of allocated rates across methods and preferred vs weighted average. Excludes raw production data.
 *
 * Use for: Production Allocation (WF5), Gas Lift Estimation and Allocation (WF13).
 *
 * @name Allocated Rates - VFM Reconciliation (Agent)
 */
export type AllocatedRatesVfmStringAgent = {
  /** Average gas injection rate (MSCF/d, TS). */
  averageGasInjectionRate: Maybe<TimeSeries>;
  /** Average water injection rate (stb/d, TS). */
  averageWaterInjectionRate: Maybe<TimeSeries>;
  /** Oil allocation workflow status. */
  oilProductionAllocationStatus: Maybe<TimeSeries>;
  /** Preferred VFM method average associated gas rate (MSCF/d, TS). */
  preferredVFMAverageAssociatedGasRate: Maybe<TimeSeries>;
  /** Preferred VFM method average non-associated gas rate (MSCF/d, TS). */
  preferredVFMAverageNonAssociatedGasRate: Maybe<TimeSeries>;
  /** Preferred VFM method average oil rate (stb/d, TS). */
  preferredVFMAverageOilRate: Maybe<TimeSeries>;
  /** Preferred VFM method average water rate (stb/d, TS). */
  preferredVFMAverageWaterRate: Maybe<TimeSeries>;
  /** Which VFM method was selected as preferred. */
  preferredVFMDataSourceFlag: Maybe<TimeSeries>;
  /** Estimated well oil volume from preferred VFM method (stb, TS). */
  preferredVFMEstimatedWellOilVolume: Maybe<TimeSeries>;
  /** Estimated well water volume from preferred VFM method (stb, TS). */
  preferredVFMEstimatedWellWaterVolume: Maybe<TimeSeries>;
  /** Choke analysis average oil rate (stb/d, TS). */
  vfmChokeAverageOilRate: Maybe<TimeSeries>;
  /** Data-driven model average oil rate (stb/d, TS). */
  vfmDataDrivenAverageOilRate: Maybe<TimeSeries>;
  /** ESP analysis average oil rate (stb/d, TS). */
  vfmESPAverageOilRate: Maybe<TimeSeries>;
  /** IPR analysis average oil rate (stb/d, TS). */
  vfmIPRAverageOilRate: Maybe<TimeSeries>;
  /** Allocated AG rate from preferred VFM method (MSCF/d, TS). */
  vfmPreferredMethodAssociatedGasAllocationRate: Maybe<TimeSeries>;
  /** Allocated NAG rate from preferred VFM method (MSCF/d, TS). */
  vfmPreferredMethodNonAssociatedGasAllocationRate: Maybe<TimeSeries>;
  /** Allocated oil rate from preferred VFM method (stb/d, TS). */
  vfmPreferredMethodOilAllocationRate: Maybe<TimeSeries>;
  /** Allocated water rate from preferred VFM method (stb/d, TS). */
  vfmPreferredMethodWaterAllocationRate: Maybe<TimeSeries>;
  /** System analysis average oil rate (stb/d, TS). */
  vfmSystemAnalysisAverageOilRate: Maybe<TimeSeries>;
  /** VLP analysis average oil rate (stb/d, TS). */
  vfmVLPAverageOilRate: Maybe<TimeSeries>;
  /** Allocated AG rate from weighted average method (MSCF/d, TS). */
  vfmWeightedAverageAssociatedGasAllocationRate: Maybe<TimeSeries>;
  /** Allocated oil rate from weighted average method (stb/d, TS). */
  vfmWeightedAverageMethodOilAllocationRate: Maybe<TimeSeries>;
  /** Allocated NAG rate from weighted average method (MSCF/d, TS). */
  vfmWeightedAverageNonAssociatedGasAllocationRate: Maybe<TimeSeries>;
  /** Allocated water rate from weighted average method (stb/d, TS). */
  vfmWeightedAverageWaterAllocationRate: Maybe<TimeSeries>;
  /** Data source flag for weighted average method. */
  weightedAverageDataSourceFlag: Maybe<TimeSeries>;
  /** Weighted average associated gas rate across VFM methods (MSCF/d, TS). */
  weightedAverageVFMAssociatedGasRate: Maybe<TimeSeries>;
  /** Estimated oil volume from weighted average method (stb, TS). */
  weightedAverageVFMEstimatedWellOilVolume: Maybe<TimeSeries>;
  /** Weighted average non-associated gas rate (MSCF/d, TS). */
  weightedAverageVFMNonAssociatedGasRate: Maybe<TimeSeries>;
  /** Weighted average oil rate across all VFM methods (stb/d, TS). */
  weightedAverageVFMOilRate: Maybe<TimeSeries>;
  /** Weighted average water rate across VFM methods (stb/d, TS). */
  weightedAverageVFMWaterRate: Maybe<TimeSeries>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString: Maybe<StringAsset>;
  /** Well uptime hours in allocation period (hrs, TS). */
  wellUptime: Maybe<TimeSeries>;
};

/**
 * Field-level allocation factor time series (WF5).
 *
 * VFM-based allocation factors for oil, assoc/non-assoc gas, water production, and gas/water injection at field level. Use for allocation factor trends by period and field/reservoir/sector. Use with FlatHierarchy_Agent or DailyRollupField_Agent for context.
 *
 * Use for: Production Allocation (WF5), Gas Lift Estimation and Allocation (WF13).
 *
 * @name Allocation Factors - Field (Agent)
 */
export type AllocationFactorsFieldAgent = {
  /** Reference to field. Use for Field scope and to join to hierarchy views. */
  field: Maybe<Field>;
  /**
   * Gas injection allocation factor for this field (fraction, TS).
   * Use for "Show injection gas Allocation Factor trend" over Day/Week/Month/Quarter/Year.
   */
  gasInjectionAllocationFactor: Maybe<TimeSeries>;
  /**
   * Associated gas production allocation factor for this field (fraction, TS). Preferred VFM method.
   * Use for "Show associated gas Allocation Factor trend" over Day/Week/Month/Quarter/Year.
   */
  preferredVFMAssociatedGasAllocationFactor: Maybe<TimeSeries>;
  /**
   * Non-associated gas production allocation factor for this field (fraction, TS). Preferred VFM method.
   * Use for "Show non associated gas Allocation Factor trend" over Day/Week/Month/Quarter/Year.
   */
  preferredVFMNonAssociatedGasAllocationFactor: Maybe<TimeSeries>;
  /**
   * Oil production allocation factor for this field (fraction, TS). Preferred VFM method.
   * Use for "Show oil Allocation Factor trend" over Day/Week/Month/Quarter/Year.
   */
  preferredVFMOilAllocationFactor: Maybe<TimeSeries>;
  /**
   * Water production allocation factor for this field (fraction, TS). Preferred VFM method.
   * Use for "Show water Allocation Factor trend" over Day/Week/Month/Quarter/Year.
   */
  preferredVFMWaterAllocationFactor: Maybe<TimeSeries>;
  /**
   * Water injection allocation factor for this field (fraction, TS).
   * Use for "Show injection water Allocation Factor trend" over Day/Week/Month/Quarter/Year.
   */
  waterInjectionAllocationFactor: Maybe<TimeSeries>;
  /** Weighted average VFM associated gas allocation factor for this field (fraction, TS). */
  weightedAverageVFMAssociatedGasAllocationFactor: Maybe<TimeSeries>;
  /** Weighted average VFM non-associated gas allocation factor for this field (fraction, TS). */
  weightedAverageVFMNonAssociatedGasAllocationFactor: Maybe<TimeSeries>;
  /** Weighted average VFM oil production allocation factor for this field (fraction, TS). */
  weightedAverageVFMOilAllocationFactor: Maybe<TimeSeries>;
  /** Weighted average VFM water allocation factor for this field (fraction, TS). */
  weightedAverageVFMWaterAllocationFactor: Maybe<TimeSeries>;
};

/** Instantaneous allocation outputs for each well string, including allocated oil, gas and water production rates, associated injection rates and active hours used in the production and injection allocation process. */
export type AllocationOutputString = {
  /** Time series of hours this string was actively injecting during each allocation period. */
  allocInjActiveHours: Maybe<TimeSeries>;
  /** Time series of hours this string was actively producing during each allocation period. */
  allocProdActiveHours: Maybe<TimeSeries>;
  /** Time series of allocated gas injection rate for this string at the allocation time resolution. */
  allocatedGasInjRate: Maybe<TimeSeries>;
  /** Time series of allocated gas production rate for this string at the allocation time resolution. */
  allocatedGasRate: Maybe<TimeSeries>;
  /** Time series of allocated oil production rate for this string at the allocation time resolution. */
  allocatedOilRate: Maybe<TimeSeries>;
  /** Time series of allocated water injection rate for this string at the allocation time resolution. */
  allocatedWaterInjRate: Maybe<TimeSeries>;
  /** Time series of allocated water production rate for this string at the allocation time resolution. */
  allocatedWaterRate: Maybe<TimeSeries>;
  /** Name of the well string (completion) whose instantaneous allocation outputs are represented in this view, sourced from the 'String_asset' view. */
  entityName: Maybe<StringAsset>;
};

/** View 'Asphaltene_Curve' in the iPSO production optimization solution data model. */
export type AsphalteneCurve = {
  /** Numeric value 'asphP' (floating point) for this 'Asphaltene_Curve' row. */
  asphP: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'asphT' (floating point) for this 'Asphaltene_Curve' row. */
  asphT: Maybe<Scalars['Float32']['output']>;
  /** Text attribute 'asphTable' for this 'Asphaltene_Curve' row. */
  asphTable: Maybe<Scalars['String']['output']>;
  /** Timestamp 'date' associated with this 'Asphaltene_Curve' row. */
  date: Maybe<Scalars['Timestamp']['output']>;
  /** Numeric value 'sequence' (integer) for this 'Asphaltene_Curve' row. */
  sequence: Maybe<Scalars['Int']['output']>;
};

/** Typed view over 'Entity' showing assets only (where 'entityType' = 'asset'). Use this view to identify an asset by name, then navigate to its fields, reservoirs, wells or strings via the 'FlatHierarchy' navigation view. */
export type Asset = {
  /** Timestamp 'endDateTime' associated with this 'Asset' row. */
  endDateTime: Maybe<Scalars['Timestamp']['output']>;
  /** Text attribute 'entityType' for this 'Asset' row. */
  entityType: Maybe<Scalars['String']['output']>;
  /** Name of the asset. To retrieve all wells in an asset, find the asset here and filter 'FlatHierarchy' on this asset while reading the 'well' (and optionally 'string') property. */
  name: Maybe<Scalars['String']['output']>;
  /** Timestamp 'startDateTime' associated with this 'Asset' row. */
  startDateTime: Maybe<Scalars['Timestamp']['output']>;
};

/** View 'Choke' in the iPSO production optimization solution data model. */
export type Choke = {
  /** Timestamp 'endDateTime' associated with this 'Choke' row. */
  endDateTime: Maybe<Scalars['Timestamp']['output']>;
  /** Text attribute 'entityType' for this 'Choke' row. */
  entityType: Maybe<Scalars['String']['output']>;
  /** Text attribute 'name' for this 'Choke' row. */
  name: Maybe<Scalars['String']['output']>;
  /** Timestamp 'startDateTime' associated with this 'Choke' row. */
  startDateTime: Maybe<Scalars['Timestamp']['output']>;
};

/**
 * Choke-level outputs from WF7 GAP network simulation (WF7/WF20).
 *
 * Upstream and downstream pressures, pressure differentials, flow regimes, and
 * operating conditions per choke. Use for choke performance analysis, pressure
 * drop evaluation, and flow-regime assessment across operational scenarios.
 * Excludes historical performance or maintenance records.
 *
 * Use for: Network Surveillance (WF7), Flow Assurance Detection and Mitigation (WF20).
 *
 * @name Choke Outputs - Network (Agent)
 */
export type ChokeOutputsNetworkAgent = {
  /** Choke entity name. */
  entityName: Maybe<Entity>;
  /** Reference to parent network model. */
  network: Maybe<Network>;
  /** Choke bean size (64ths inch, TS). */
  nmvChokeSize: Maybe<TimeSeries>;
};

/** View 'Choke_Curve_Info' in the iPSO production optimization solution data model. */
export type ChokeCurveInfo = {
  /** Numeric value 'chokeBeanSize' (floating point) for this 'Choke_Curve_Info' row. */
  chokeBeanSize: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'chokeOpening' (floating point) for this 'Choke_Curve_Info' row. */
  chokeOpening: Maybe<Scalars['Float32']['output']>;
  /** Text attribute 'chokeType' for this 'Choke_Curve_Info' row. */
  chokeType: Maybe<Scalars['String']['output']>;
};

export const Cognite3DGroupGroupType = {
  Station360: 'Station360',
} as const;

export type Cognite3DGroupGroupType = (typeof Cognite3DGroupGroupType)[keyof typeof Cognite3DGroupGroupType];
/** Groups revisions of 3D data of various kinds together (CAD, PointCloud, Image360) */
export type Cognite3DModel = {
  /** Alternative names for the node */
  aliases: Maybe<Maybe<Scalars['String']['output']>[]>;
  /** Description of the instance */
  description: Maybe<Scalars['String']['output']>;
  /** Name of the instance */
  name: Maybe<Scalars['String']['output']>;
  /** Text based labels for generic use, limited to 1000 */
  tags: Maybe<Maybe<Scalars['String']['output']>[]>;
  /** Thumbnail of the 3D model */
  thumbnail: Maybe<CogniteFile>;
  /** CAD, PointCloud or Image360 */
  type: Maybe<Cognite3DModelType>;
};

export const Cognite3DModelType = {
  Cad: 'CAD',
  Image360: 'Image360',
  PointCloud: 'PointCloud',
} as const;

export type Cognite3DModelType = (typeof Cognite3DModelType)[keyof typeof Cognite3DModelType];
/** This is the virtual position representation of an object in the physical world, connecting an asset to one or more 3D resources */
export type Cognite3DObject = CogniteDescribable & {
  /** Alternative names for the node */
  aliases: Maybe<Maybe<Scalars['String']['output']>[]>;
  /** Asset that is tied to this 3D object */
  asset: Maybe<CogniteAsset>;
  /** List of up to 1000 CADNodes that represents the connected CogniteAsset */
  cadNodes: Maybe<Maybe<CogniteCadNode>[]>;
  /** Description of the instance */
  description: Maybe<Scalars['String']['output']>;
  /** Edge connection to Cognite360Image annotations that represents the connected CogniteAsset */
  images360: Maybe<Maybe<Cognite360Image>[]>;
  /** Name of the instance */
  name: Maybe<Scalars['String']['output']>;
  /** List of up to 1000 PointCloudVolumes that represents the connected CogniteAsset */
  pointCloudVolumes: Maybe<Maybe<CognitePointCloudVolume>[]>;
  /** Text based labels for generic use, limited to 1000 */
  tags: Maybe<Maybe<Scalars['String']['output']>[]>;
  /** Highest X value in bounding box */
  xMax: Maybe<Scalars['Float']['output']>;
  /** Lowest X value in bounding box */
  xMin: Maybe<Scalars['Float']['output']>;
  /** Highest Y value in bounding box */
  yMax: Maybe<Scalars['Float']['output']>;
  /** Lowest Y value in bounding box */
  yMin: Maybe<Scalars['Float']['output']>;
  /** Highest Z value in bounding box */
  zMax: Maybe<Scalars['Float']['output']>;
  /** Lowest Z value in bounding box */
  zMin: Maybe<Scalars['Float']['output']>;
};

/** Shared revision information for various 3D data types. Normally not used directly, but through CognitePointCloudRevision, Image360Collection or CogniteCADRevision */
export type Cognite3DRevision = {
  model3D: Maybe<Cognite3DModel>;
  published: Maybe<Scalars['Boolean']['output']>;
  status: Maybe<Cognite3DRevisionStatus>;
  type: Maybe<Cognite3DRevisionType>;
};

export const Cognite3DRevisionStatus = {
  Done: 'Done',
  Failed: 'Failed',
  Processing: 'Processing',
  Queued: 'Queued',
} as const;

export type Cognite3DRevisionStatus = (typeof Cognite3DRevisionStatus)[keyof typeof Cognite3DRevisionStatus];
export const Cognite3DRevisionType = {
  Cad: 'CAD',
  Image360: 'Image360',
  PointCloud: 'PointCloud',
} as const;

export type Cognite3DRevisionType = (typeof Cognite3DRevisionType)[keyof typeof Cognite3DRevisionType];
/** The Cognite3DTransformation object defines a comprehensive 3D transformation, enabling precise adjustments to an object's position, orientation, and size in the 3D coordinate system. It allows for the translation of objects along the three spatial axes, rotation around these axes using Euler angles, and scaling along each axis to modify the object's dimensions. The object's transformation is defined in "CDF space", a coordinate system where the positive Z axis is the up direction */
export type Cognite3DTransformation = {
  /** The rotation of the object around the X-axis in radians */
  eulerRotationX: Maybe<Scalars['Float']['output']>;
  /** The rotation of the object around the Y-axis in radians */
  eulerRotationY: Maybe<Scalars['Float']['output']>;
  /** The rotation of the object around the Z-axis in radians */
  eulerRotationZ: Maybe<Scalars['Float']['output']>;
  /** The scaling factor applied to the object along the X-axis */
  scaleX: Maybe<Scalars['Float']['output']>;
  /** The scaling factor applied to the object along the Y-axis */
  scaleY: Maybe<Scalars['Float']['output']>;
  /** The scaling factor applied to the object along the Z-axis */
  scaleZ: Maybe<Scalars['Float']['output']>;
  /** The displacement of the object along the X-axis in the 3D coordinate system */
  translationX: Maybe<Scalars['Float']['output']>;
  /** The displacement of the object along the Y-axis in the 3D coordinate system */
  translationY: Maybe<Scalars['Float']['output']>;
  /** The displacement of the object along the Z-axis in the 3D coordinate system */
  translationZ: Maybe<Scalars['Float']['output']>;
};

export type Cognite360Image = Cognite3DTransformation &
  CogniteCubeMap & {
    /** Direct relation to a file holding the back projection of the cube map */
    back: Maybe<CogniteFile>;
    /** Direct relation to a file holding the bottom projection of the cube map */
    bottom: Maybe<CogniteFile>;
    /** Direct relation to Cognite360ImageCollection */
    collection360: Maybe<Cognite360ImageCollection>;
    /** The rotation of the object around the X-axis in radians */
    eulerRotationX: Maybe<Scalars['Float']['output']>;
    /** The rotation of the object around the Y-axis in radians */
    eulerRotationY: Maybe<Scalars['Float']['output']>;
    /** The rotation of the object around the Z-axis in radians */
    eulerRotationZ: Maybe<Scalars['Float']['output']>;
    /** Direct relation to a file holding the front projection of the cube map */
    front: Maybe<CogniteFile>;
    /** Direct relation to a file holding the left projection of the cube map */
    left: Maybe<CogniteFile>;
    /** Direct relation to a file holding the right projection of the cube map */
    right: Maybe<CogniteFile>;
    /** The scaling factor applied to the object along the X-axis */
    scaleX: Maybe<Scalars['Float']['output']>;
    /** The scaling factor applied to the object along the Y-axis */
    scaleY: Maybe<Scalars['Float']['output']>;
    /** The scaling factor applied to the object along the Z-axis */
    scaleZ: Maybe<Scalars['Float']['output']>;
    /** Direct relation to Cognite3DGroup instance that groups different Cognite360Image instances to the same station */
    station360: Maybe<Cognite360ImageStation>;
    /** The timestamp when the 6 photos were taken */
    takenAt: Maybe<Scalars['Timestamp']['output']>;
    /** Direct relation to a file holding the top projection of the cube map */
    top: Maybe<CogniteFile>;
    /** The displacement of the object along the X-axis in the 3D coordinate system */
    translationX: Maybe<Scalars['Float']['output']>;
    /** The displacement of the object along the Y-axis in the 3D coordinate system */
    translationY: Maybe<Scalars['Float']['output']>;
    /** The displacement of the object along the Z-axis in the 3D coordinate system */
    translationZ: Maybe<Scalars['Float']['output']>;
  };

export type Cognite360ImageAnnotation = CogniteAnnotation &
  CogniteDescribable &
  CogniteSourceable & {
    /** Alternative names for the node */
    aliases: Maybe<Maybe<Scalars['String']['output']>[]>;
    /** The confidence that the annotation is a good match */
    confidence: Maybe<Scalars['Float']['output']>;
    /** Description of the instance */
    description: Maybe<Scalars['String']['output']>;
    /** Specifies the storage representation for the polygon */
    formatVersion: Maybe<Scalars['String']['output']>;
    /** Name of the instance */
    name: Maybe<Scalars['String']['output']>;
    /** List of floats representing the polygon. Format depends on formatVersion */
    polygon: Maybe<Maybe<Scalars['Float']['output']>[]>;
    /** Direct relation to a source system */
    source: Maybe<CogniteSourceSystem>;
    /** Context of the source id. For systems where the sourceId is globally unique, the sourceContext is expected to not be set. */
    sourceContext: Maybe<Scalars['String']['output']>;
    /** When the instance was created in source system (if available) */
    sourceCreatedTime: Maybe<Scalars['Timestamp']['output']>;
    /** User identifier from the source system on who created the source data. This identifier is not guaranteed to match the user identifiers in CDF */
    sourceCreatedUser: Maybe<Scalars['String']['output']>;
    /** Identifier from the source system */
    sourceId: Maybe<Scalars['String']['output']>;
    /** When the instance was last updated in the source system (if available) */
    sourceUpdatedTime: Maybe<Scalars['Timestamp']['output']>;
    /** User identifier from the source system on who last updated the source data. This identifier is not guaranteed to match the user identifiers in CDF */
    sourceUpdatedUser: Maybe<Scalars['String']['output']>;
    /** The status of the annotation */
    status: Maybe<CogniteAnnotationStatus>;
    /** Text based labels for generic use, limited to 1000 */
    tags: Maybe<Maybe<Scalars['String']['output']>[]>;
  };

/** Represents a logical collection of Cognite360Image instances */
export type Cognite360ImageCollection = Cognite3DRevision &
  CogniteDescribable & {
    /** Alternative names for the node */
    aliases: Maybe<Maybe<Scalars['String']['output']>[]>;
    /** Description of the instance */
    description: Maybe<Scalars['String']['output']>;
    model3D: Maybe<Cognite360ImageModel>;
    /** Name of the instance */
    name: Maybe<Scalars['String']['output']>;
    published: Maybe<Scalars['Boolean']['output']>;
    status: Maybe<Cognite3DRevisionStatus>;
    /** Text based labels for generic use, limited to 1000 */
    tags: Maybe<Maybe<Scalars['String']['output']>[]>;
    type: Maybe<Cognite3DRevisionType>;
  };

/** Navigational aid for traversing Cognite360ImageModel instances */
export type Cognite360ImageModel = Cognite3DModel &
  CogniteDescribable & {
    /** Alternative names for the node */
    aliases: Maybe<Maybe<Scalars['String']['output']>[]>;
    /** List Cognite360Image collections for this instance */
    collections: Maybe<Maybe<Cognite360ImageCollection>[]>;
    /** Description of the instance */
    description: Maybe<Scalars['String']['output']>;
    /** Name of the instance */
    name: Maybe<Scalars['String']['output']>;
    /** Text based labels for generic use, limited to 1000 */
    tags: Maybe<Maybe<Scalars['String']['output']>[]>;
    /** Thumbnail of the 3D model */
    thumbnail: Maybe<CogniteFile>;
    /** CAD, PointCloud or Image360 */
    type: Maybe<Cognite3DModelType>;
  };

/** A way to group images across collections. Used for creating visual scan history */
export type Cognite360ImageStation = CogniteDescribable & {
  /** Alternative names for the node */
  aliases: Maybe<Maybe<Scalars['String']['output']>[]>;
  /** Description of the instance */
  description: Maybe<Scalars['String']['output']>;
  /** Type of group */
  groupType: Maybe<Cognite3DGroupGroupType>;
  /** Name of the instance */
  name: Maybe<Scalars['String']['output']>;
  /** Text based labels for generic use, limited to 1000 */
  tags: Maybe<Maybe<Scalars['String']['output']>[]>;
};

/**
 * Represents activities. Activities typically happen over a period and have a start and end time.
 * @name Activity
 */
export type CogniteActivity = CogniteDescribable &
  CogniteSchedulable &
  CogniteSourceable & {
    /** Alternative names for the node */
    aliases: Maybe<Maybe<Scalars['String']['output']>[]>;
    /**
     * A list of assets the activity is related to.
     * @name Assets
     */
    assets: Maybe<Maybe<CogniteAsset>[]>;
    /** Description of the instance */
    description: Maybe<Scalars['String']['output']>;
    /** The actual end time of an activity (or similar that extends this) */
    endTime: Maybe<Scalars['Timestamp']['output']>;
    /**
     * A list of equipment the activity is related to.
     * @name Equipment
     */
    equipment: Maybe<Maybe<CogniteEquipment>[]>;
    /** Name of the instance */
    name: Maybe<Scalars['String']['output']>;
    /** The planned end time of an activity (or similar that extends this) */
    scheduledEndTime: Maybe<Scalars['Timestamp']['output']>;
    /** The planned start time of an activity (or similar that extends this) */
    scheduledStartTime: Maybe<Scalars['Timestamp']['output']>;
    /** Direct relation to a source system */
    source: Maybe<CogniteSourceSystem>;
    /** Context of the source id. For systems where the sourceId is globally unique, the sourceContext is expected to not be set. */
    sourceContext: Maybe<Scalars['String']['output']>;
    /** When the instance was created in source system (if available) */
    sourceCreatedTime: Maybe<Scalars['Timestamp']['output']>;
    /** User identifier from the source system on who created the source data. This identifier is not guaranteed to match the user identifiers in CDF */
    sourceCreatedUser: Maybe<Scalars['String']['output']>;
    /** Identifier from the source system */
    sourceId: Maybe<Scalars['String']['output']>;
    /** When the instance was last updated in the source system (if available) */
    sourceUpdatedTime: Maybe<Scalars['Timestamp']['output']>;
    /** User identifier from the source system on who last updated the source data. This identifier is not guaranteed to match the user identifiers in CDF */
    sourceUpdatedUser: Maybe<Scalars['String']['output']>;
    /** The actual start time of an activity (or similar that extends this) */
    startTime: Maybe<Scalars['Timestamp']['output']>;
    /** Text based labels for generic use, limited to 1000 */
    tags: Maybe<Maybe<Scalars['String']['output']>[]>;
    /**
     * A list of time series the activity is related to.
     * @name Time series
     */
    timeSeries: Maybe<Maybe<CogniteTimeSeries>[]>;
  };

/** Annotation represents contextualization results or links */
export type CogniteAnnotation = {
  /** Alternative names for the node */
  aliases: Maybe<Maybe<Scalars['String']['output']>[]>;
  /** The confidence that the annotation is a good match */
  confidence: Maybe<Scalars['Float']['output']>;
  /** Description of the instance */
  description: Maybe<Scalars['String']['output']>;
  /** Name of the instance */
  name: Maybe<Scalars['String']['output']>;
  /** Direct relation to a source system */
  source: Maybe<CogniteSourceSystem>;
  /** Context of the source id. For systems where the sourceId is globally unique, the sourceContext is expected to not be set. */
  sourceContext: Maybe<Scalars['String']['output']>;
  /** When the instance was created in source system (if available) */
  sourceCreatedTime: Maybe<Scalars['Timestamp']['output']>;
  /** User identifier from the source system on who created the source data. This identifier is not guaranteed to match the user identifiers in CDF */
  sourceCreatedUser: Maybe<Scalars['String']['output']>;
  /** Identifier from the source system */
  sourceId: Maybe<Scalars['String']['output']>;
  /** When the instance was last updated in the source system (if available) */
  sourceUpdatedTime: Maybe<Scalars['Timestamp']['output']>;
  /** User identifier from the source system on who last updated the source data. This identifier is not guaranteed to match the user identifiers in CDF */
  sourceUpdatedUser: Maybe<Scalars['String']['output']>;
  /** The status of the annotation */
  status: Maybe<CogniteAnnotationStatus>;
  /** Text based labels for generic use, limited to 1000 */
  tags: Maybe<Maybe<Scalars['String']['output']>[]>;
};

export const CogniteAnnotationStatus = {
  Approved: 'Approved',
  Rejected: 'Rejected',
  Suggested: 'Suggested',
} as const;

export type CogniteAnnotationStatus = (typeof CogniteAnnotationStatus)[keyof typeof CogniteAnnotationStatus];
/**
 * Assets represent systems that support industrial functions or processes. Assets are often called 'functional location'.
 * @name Asset
 */
export type CogniteAsset = CogniteDescribable &
  CogniteSourceable &
  CogniteVisualizable & {
    /**
     * An automatically updated list of activities related to the asset.
     * @name Activities
     */
    activities: Maybe<Maybe<CogniteActivity>[]>;
    /** Alternative names for the node */
    aliases: Maybe<Maybe<Scalars['String']['output']>[]>;
    /**
     * Specifies the class of the asset. It's a direct relation to CogniteAssetClass.
     * @name Asset class
     */
    assetClass: Maybe<CogniteAssetClass>;
    /**
     * An automatically updated list of assets with this asset as their parent.
     * @name Children
     */
    children: Maybe<Maybe<CogniteAsset>[]>;
    /** Description of the instance */
    description: Maybe<Scalars['String']['output']>;
    /**
     * An automatically updated list of equipment related to the asset.
     * @name Equipment
     */
    equipment: Maybe<Maybe<CogniteEquipment>[]>;
    /**
     * An automatically updated list of files related to the asset.
     * @name Files
     */
    files: Maybe<Maybe<CogniteFile>[]>;
    /** Name of the instance */
    name: Maybe<Scalars['String']['output']>;
    /** Direct relation to an Object3D instance representing the 3D resource */
    object3D: Maybe<Cognite3DObject>;
    /**
     * The parent of the asset.
     * @name Parent
     */
    parent: Maybe<CogniteAsset>;
    /**
     * An automatically updated ordered list of this asset's ancestors, starting with the root asset. Enables subtree filtering to find all assets under a parent.
     * @name Path
     */
    path: Maybe<Maybe<CogniteAsset>[]>;
    /**
     * The last time the path was updated for this asset.
     * @name Path last updated time
     */
    pathLastUpdatedTime: Maybe<Scalars['Timestamp']['output']>;
    /**
     * An automatically updated reference to the top-level asset of the hierarchy.
     * @name Root
     */
    root: Maybe<CogniteAsset>;
    /** Direct relation to a source system */
    source: Maybe<CogniteSourceSystem>;
    /** Context of the source id. For systems where the sourceId is globally unique, the sourceContext is expected to not be set. */
    sourceContext: Maybe<Scalars['String']['output']>;
    /** When the instance was created in source system (if available) */
    sourceCreatedTime: Maybe<Scalars['Timestamp']['output']>;
    /** User identifier from the source system on who created the source data. This identifier is not guaranteed to match the user identifiers in CDF */
    sourceCreatedUser: Maybe<Scalars['String']['output']>;
    /** Identifier from the source system */
    sourceId: Maybe<Scalars['String']['output']>;
    /** When the instance was last updated in the source system (if available) */
    sourceUpdatedTime: Maybe<Scalars['Timestamp']['output']>;
    /** User identifier from the source system on who last updated the source data. This identifier is not guaranteed to match the user identifiers in CDF */
    sourceUpdatedUser: Maybe<Scalars['String']['output']>;
    /** Text based labels for generic use, limited to 1000 */
    tags: Maybe<Maybe<Scalars['String']['output']>[]>;
    /**
     * An automatically updated list of time series related to the asset.
     * @name Time series
     */
    timeSeries: Maybe<Maybe<CogniteTimeSeries>[]>;
    /**
     * Specifies the type of the asset. It's a direct relation to CogniteAssetType.
     * @name Asset type
     */
    type: Maybe<CogniteAssetType>;
  };

/**
 * Represents the class of an asset.
 * @name Asset class
 */
export type CogniteAssetClass = CogniteDescribable & {
  /** Alternative names for the node */
  aliases: Maybe<Maybe<Scalars['String']['output']>[]>;
  /**
   * A unique identifier for the class of asset.
   * @name Code
   */
  code: Maybe<Scalars['String']['output']>;
  /** Description of the instance */
  description: Maybe<Scalars['String']['output']>;
  /** Name of the instance */
  name: Maybe<Scalars['String']['output']>;
  /**
   * A text string to specify which standard the class is from.
   * @name Standard
   */
  standard: Maybe<Scalars['String']['output']>;
  /** Text based labels for generic use, limited to 1000 */
  tags: Maybe<Maybe<Scalars['String']['output']>[]>;
};

/**
 * Represents the type of an asset.
 * @name Asset type
 */
export type CogniteAssetType = CogniteDescribable & {
  /** Alternative names for the node */
  aliases: Maybe<Maybe<Scalars['String']['output']>[]>;
  /**
   * Specifies the class the type belongs to. It's a direct relation to CogniteAssetClass.
   * @name Asset class
   */
  assetClass: Maybe<CogniteAssetClass>;
  /**
   * A unique identifier for the type of asset.
   * @name Code
   */
  code: Maybe<Scalars['String']['output']>;
  /** Description of the instance */
  description: Maybe<Scalars['String']['output']>;
  /** Name of the instance */
  name: Maybe<Scalars['String']['output']>;
  /**
   * A text string to specify which standard the type is from.
   * @name Standard
   */
  standard: Maybe<Scalars['String']['output']>;
  /** Text based labels for generic use, limited to 1000 */
  tags: Maybe<Maybe<Scalars['String']['output']>[]>;
};

/** Navigational aid for traversing CogniteCADModel instances */
export type CogniteCadModel = Cognite3DModel &
  CogniteDescribable & {
    /** Alternative names for the node */
    aliases: Maybe<Maybe<Scalars['String']['output']>[]>;
    /** Description of the instance */
    description: Maybe<Scalars['String']['output']>;
    /** Name of the instance */
    name: Maybe<Scalars['String']['output']>;
    /** List of revisions for this CAD model */
    revisions: Maybe<Maybe<CogniteCadRevision>[]>;
    /** Text based labels for generic use, limited to 1000 */
    tags: Maybe<Maybe<Scalars['String']['output']>[]>;
    /** Thumbnail of the 3D model */
    thumbnail: Maybe<CogniteFile>;
    /** CAD, PointCloud or Image360 */
    type: Maybe<Cognite3DModelType>;
  };

/** Represents nodes from the 3D model that have been contextualized */
export type CogniteCadNode = CogniteDescribable & {
  /** Alternative names for the node */
  aliases: Maybe<Maybe<Scalars['String']['output']>[]>;
  /** Reference to a node within a CAD model from the 3D API */
  cadNodeReference: Maybe<Scalars['String']['output']>;
  /** Description of the instance */
  description: Maybe<Scalars['String']['output']>;
  /** Direct relation to Cognite3DModel */
  model3D: Maybe<CogniteCadModel>;
  /** Name of the instance */
  name: Maybe<Scalars['String']['output']>;
  /** Direct relation to object3D grouping for this node */
  object3D: Maybe<Cognite3DObject>;
  /** List of direct relations to instances of Cognite3DRevision which this CogniteCADNode exists in. */
  revisions: Maybe<Maybe<CogniteCadRevision>[]>;
  /** List of subtree sizes in the same order as revisions. Used by Reveal and similar applications to know how many nodes exists below this node in the hierarchy */
  subTreeSizes: Maybe<Maybe<Scalars['Int64']['output']>[]>;
  /** Text based labels for generic use, limited to 1000 */
  tags: Maybe<Maybe<Scalars['String']['output']>[]>;
  /** List of tree indexes in the same order as revisions. Used by Reveal and similar applications to map from CogniteCADNode to tree index */
  treeIndexes: Maybe<Maybe<Scalars['Int64']['output']>[]>;
};

export type CogniteCadRevision = Cognite3DRevision & {
  /** . */
  model3D: Maybe<CogniteCadModel>;
  published: Maybe<Scalars['Boolean']['output']>;
  /** The 3D API revision identifier for this CAD model */
  revisionId: Maybe<Scalars['Int64']['output']>;
  status: Maybe<Cognite3DRevisionStatus>;
  type: Maybe<Cognite3DRevisionType>;
};

/** The cube map holds references to 6 images in used to visually represent the surrounding environment */
export type CogniteCubeMap = {
  /** Direct relation to a file holding the back projection of the cube map */
  back: Maybe<CogniteFile>;
  /** Direct relation to a file holding the bottom projection of the cube map */
  bottom: Maybe<CogniteFile>;
  /** Direct relation to a file holding the front projection of the cube map */
  front: Maybe<CogniteFile>;
  /** Direct relation to a file holding the left projection of the cube map */
  left: Maybe<CogniteFile>;
  /** Direct relation to a file holding the right projection of the cube map */
  right: Maybe<CogniteFile>;
  /** Direct relation to a file holding the top projection of the cube map */
  top: Maybe<CogniteFile>;
};

/** The describable core concept is used as a standard way of holding the bare minimum of information about the instance */
export type CogniteDescribable = {
  /** Alternative names for the node */
  aliases: Maybe<Maybe<Scalars['String']['output']>[]>;
  /** Description of the instance */
  description: Maybe<Scalars['String']['output']>;
  /** Name of the instance */
  name: Maybe<Scalars['String']['output']>;
  /** Text based labels for generic use, limited to 1000 */
  tags: Maybe<Maybe<Scalars['String']['output']>[]>;
};

/** Annotation for diagrams */
export type CogniteDiagramAnnotation = CogniteAnnotation &
  CogniteDescribable &
  CogniteSourceable & {
    /** Alternative names for the node */
    aliases: Maybe<Maybe<Scalars['String']['output']>[]>;
    /** The confidence that the annotation is a good match */
    confidence: Maybe<Scalars['Float']['output']>;
    /** Description of the instance */
    description: Maybe<Scalars['String']['output']>;
    /** The number of the page on which this annotation is located in the endNode File if an endNode is present. The first page has number 1 */
    endNodePageNumber: Maybe<Scalars['Int64']['output']>;
    /** The text extracted from within the bounding box on the endNode. Only applicable if an endNode is defined */
    endNodeText: Maybe<Scalars['String']['output']>;
    /** Value between [0,1]. Maximum abscissa of the bounding box (right edge). Must be strictly more than endNodeXMin. Only applicable if an endNode is defined */
    endNodeXMax: Maybe<Scalars['Float']['output']>;
    /** Value between [0,1]. Minimum abscissa of the bounding box (left edge). Must be strictly less than endNodeXMax. Only applicable if an endNode is defined */
    endNodeXMin: Maybe<Scalars['Float']['output']>;
    /** Value between [0,1]. Maximum ordinate of the bounding box (top edge). Must be strictly more than endNodeYMin. Only applicable if an endNode is defined */
    endNodeYMax: Maybe<Scalars['Float']['output']>;
    /** Value between [0,1]. Minimum ordinate of the bounding box (bottom edge). Must be strictly less than endNodeYMax. Only applicable if an endNode is defined */
    endNodeYMin: Maybe<Scalars['Float']['output']>;
    /** Name of the instance */
    name: Maybe<Scalars['String']['output']>;
    /** Direct relation to a source system */
    source: Maybe<CogniteSourceSystem>;
    /** Context of the source id. For systems where the sourceId is globally unique, the sourceContext is expected to not be set. */
    sourceContext: Maybe<Scalars['String']['output']>;
    /** When the instance was created in source system (if available) */
    sourceCreatedTime: Maybe<Scalars['Timestamp']['output']>;
    /** User identifier from the source system on who created the source data. This identifier is not guaranteed to match the user identifiers in CDF */
    sourceCreatedUser: Maybe<Scalars['String']['output']>;
    /** Identifier from the source system */
    sourceId: Maybe<Scalars['String']['output']>;
    /** When the instance was last updated in the source system (if available) */
    sourceUpdatedTime: Maybe<Scalars['Timestamp']['output']>;
    /** User identifier from the source system on who last updated the source data. This identifier is not guaranteed to match the user identifiers in CDF */
    sourceUpdatedUser: Maybe<Scalars['String']['output']>;
    /** The number of the page on which this annotation is located in `startNode` File. The first page has number 1 */
    startNodePageNumber: Maybe<Scalars['Int64']['output']>;
    /** The text extracted from within the bounding box on the startNode */
    startNodeText: Maybe<Scalars['String']['output']>;
    /** Value between [0,1]. Maximum abscissa of the bounding box (right edge). Must be strictly more than startNodeXMin */
    startNodeXMax: Maybe<Scalars['Float']['output']>;
    /** Value between [0,1]. Minimum abscissa of the bounding box (left edge). Must be strictly less than startNodeXMax */
    startNodeXMin: Maybe<Scalars['Float']['output']>;
    /** Value between [0,1]. Maximum ordinate of the bounding box (top edge). Must be strictly more than startNodeYMin */
    startNodeYMax: Maybe<Scalars['Float']['output']>;
    /** Value between [0,1]. Minimum ordinate of the bounding box (bottom edge). Must be strictly less than startNodeYMax */
    startNodeYMin: Maybe<Scalars['Float']['output']>;
    /** The status of the annotation */
    status: Maybe<CogniteAnnotationStatus>;
    /** Text based labels for generic use, limited to 1000 */
    tags: Maybe<Maybe<Scalars['String']['output']>[]>;
  };

/**
 * Equipment represents physical supplies or devices.
 * @name Equipment
 */
export type CogniteEquipment = CogniteDescribable &
  CogniteSourceable & {
    /**
     * An automatically updated list of activities related to the equipment.
     * @name Activities
     */
    activities: Maybe<Maybe<CogniteActivity>[]>;
    /** Alternative names for the node */
    aliases: Maybe<Maybe<Scalars['String']['output']>[]>;
    /**
     * The asset the equipment is related to.
     * @name Asset
     */
    asset: Maybe<CogniteAsset>;
    /** Description of the instance */
    description: Maybe<Scalars['String']['output']>;
    /**
     * Specifies the type of the equipment. It's a direct relation to CogniteEquipmentType.
     * @name Equipment type
     */
    equipmentType: Maybe<CogniteEquipmentType>;
    /**
     * A list of files the equipment relates to.
     * @name Files
     */
    files: Maybe<Maybe<CogniteFile>[]>;
    /**
     * The manufacturer of the equipment.
     * @name Manufacturer
     */
    manufacturer: Maybe<Scalars['String']['output']>;
    /** Name of the instance */
    name: Maybe<Scalars['String']['output']>;
    /**
     * The serial number of the equipment.
     * @name Serial number
     */
    serialNumber: Maybe<Scalars['String']['output']>;
    /** Direct relation to a source system */
    source: Maybe<CogniteSourceSystem>;
    /** Context of the source id. For systems where the sourceId is globally unique, the sourceContext is expected to not be set. */
    sourceContext: Maybe<Scalars['String']['output']>;
    /** When the instance was created in source system (if available) */
    sourceCreatedTime: Maybe<Scalars['Timestamp']['output']>;
    /** User identifier from the source system on who created the source data. This identifier is not guaranteed to match the user identifiers in CDF */
    sourceCreatedUser: Maybe<Scalars['String']['output']>;
    /** Identifier from the source system */
    sourceId: Maybe<Scalars['String']['output']>;
    /** When the instance was last updated in the source system (if available) */
    sourceUpdatedTime: Maybe<Scalars['Timestamp']['output']>;
    /** User identifier from the source system on who last updated the source data. This identifier is not guaranteed to match the user identifiers in CDF */
    sourceUpdatedUser: Maybe<Scalars['String']['output']>;
    /** Text based labels for generic use, limited to 1000 */
    tags: Maybe<Maybe<Scalars['String']['output']>[]>;
    /**
     * An automatically updated list of time series related to the equipment.
     * @name Time series
     */
    timeSeries: Maybe<Maybe<CogniteTimeSeries>[]>;
  };

/**
 * Represents the type of equipment.
 * @name Equipment type
 */
export type CogniteEquipmentType = CogniteDescribable & {
  /** Alternative names for the node */
  aliases: Maybe<Maybe<Scalars['String']['output']>[]>;
  /**
   * A unique identifier for the type of equipment.
   * @name Code
   */
  code: Maybe<Scalars['String']['output']>;
  /** Description of the instance */
  description: Maybe<Scalars['String']['output']>;
  /**
   * Represents the class of equipment.
   * @name Equipment class
   */
  equipmentClass: Maybe<Scalars['String']['output']>;
  /** Name of the instance */
  name: Maybe<Scalars['String']['output']>;
  /**
   * An identifier for the standard this equipment type is sourced from, for example, ISO14224.
   * @name Standard
   */
  standard: Maybe<Scalars['String']['output']>;
  /**
   * A reference to the source of the equipment standard.
   * @name Standard reference
   */
  standardReference: Maybe<Scalars['String']['output']>;
  /** Text based labels for generic use, limited to 1000 */
  tags: Maybe<Maybe<Scalars['String']['output']>[]>;
};

/**
 * Represents files.
 * @name File
 */
export type CogniteFile = CogniteDescribable &
  CogniteSourceable & {
    /** Alternative names for the node */
    aliases: Maybe<Maybe<Scalars['String']['output']>[]>;
    /**
     * A list of assets this file is related to.
     * @name Assets
     */
    assets: Maybe<Maybe<CogniteAsset>[]>;
    /**
     * Specifies the detected category the file belongs to. It's a direct relation to an instance of CogniteFileCategory.
     * @name Category
     */
    category: Maybe<CogniteFileCategory>;
    /** Description of the instance */
    description: Maybe<Scalars['String']['output']>;
    /**
     * Contains the path elements from the source (if the source system has a file system hierarchy or similar.)
     * @name Directory
     */
    directory: Maybe<Scalars['String']['output']>;
    /**
     * An automatically updated list of equipment this file is related to.
     * @name Equipment
     */
    equipment: Maybe<Maybe<CogniteEquipment>[]>;
    /**
     * Specifies if the file content has been uploaded to Cognite Data Fusion or not.
     * @name Is uploaded
     */
    isUploaded: Maybe<Scalars['Boolean']['output']>;
    /**
     * The MIME type of the file.
     * @name MIME type
     */
    mimeType: Maybe<Scalars['String']['output']>;
    /** Name of the instance */
    name: Maybe<Scalars['String']['output']>;
    /** Direct relation to a source system */
    source: Maybe<CogniteSourceSystem>;
    /** Context of the source id. For systems where the sourceId is globally unique, the sourceContext is expected to not be set. */
    sourceContext: Maybe<Scalars['String']['output']>;
    /** When the instance was created in source system (if available) */
    sourceCreatedTime: Maybe<Scalars['Timestamp']['output']>;
    /** User identifier from the source system on who created the source data. This identifier is not guaranteed to match the user identifiers in CDF */
    sourceCreatedUser: Maybe<Scalars['String']['output']>;
    /** Identifier from the source system */
    sourceId: Maybe<Scalars['String']['output']>;
    /** When the instance was last updated in the source system (if available) */
    sourceUpdatedTime: Maybe<Scalars['Timestamp']['output']>;
    /** User identifier from the source system on who last updated the source data. This identifier is not guaranteed to match the user identifiers in CDF */
    sourceUpdatedUser: Maybe<Scalars['String']['output']>;
    /** Text based labels for generic use, limited to 1000 */
    tags: Maybe<Maybe<Scalars['String']['output']>[]>;
    /**
     * The time the file upload completed.
     * @name Uploaded time
     */
    uploadedTime: Maybe<Scalars['Timestamp']['output']>;
  };

/**
 * Represents the categories of files as determined by contextualization or categorization.
 * @name File category
 */
export type CogniteFileCategory = CogniteDescribable & {
  /** Alternative names for the node */
  aliases: Maybe<Maybe<Scalars['String']['output']>[]>;
  /**
   * An identifier for the category, for example, 'AA' for Accounting (from Norsok.)
   * @name Code
   */
  code: Maybe<Scalars['String']['output']>;
  /** Description of the instance */
  description: Maybe<Scalars['String']['output']>;
  /** Name of the instance */
  name: Maybe<Scalars['String']['output']>;
  /**
   * The name of the standard the category originates from, for example, 'Norsok'.
   * @name Standard
   */
  standard: Maybe<Scalars['String']['output']>;
  /**
   * A reference to the source of the category standard.
   * @name Standard reference
   */
  standardReference: Maybe<Scalars['String']['output']>;
  /** Text based labels for generic use, limited to 1000 */
  tags: Maybe<Maybe<Scalars['String']['output']>[]>;
};

/**
 * A formal request or directive to perform maintenance tasks such as repair, inspection, or servicing of equipment or assets. It's often called a 'work order'.
 * @name Maintenance order
 */
export type CogniteMaintenanceOrder = CogniteActivity &
  CogniteDescribable &
  CogniteSchedulable &
  CogniteSourceable & {
    /** Alternative names for the node */
    aliases: Maybe<Maybe<Scalars['String']['output']>[]>;
    /**
     * A list of assets the activity is related to.
     * @name Assets
     */
    assets: Maybe<Maybe<CogniteAsset>[]>;
    /** Description of the instance */
    description: Maybe<Scalars['String']['output']>;
    /** The actual end time of an activity (or similar that extends this) */
    endTime: Maybe<Scalars['Timestamp']['output']>;
    /**
     * A list of equipment the activity is related to.
     * @name Equipment
     */
    equipment: Maybe<Maybe<CogniteEquipment>[]>;
    /**
     * The primary asset (functional location) the maintenance order refers to.
     * @name Main asset
     */
    mainAsset: Maybe<CogniteAsset>;
    /** Name of the instance */
    name: Maybe<Scalars['String']['output']>;
    /**
     * Lists the individual work items on the maintenance order. An automatically populated list of operations related to the maintenance order.
     * @name Operations
     */
    operations: Maybe<Maybe<CogniteOperation>[]>;
    /**
     * A number that shows how important this maintenance order is. Lower numbers mean it's more important, and 0 means it's the most important.
     * @name Priority
     */
    priority: Maybe<Scalars['Int64']['output']>;
    /**
     * Describes the priority of the maintenance order.
     * @name Priority description
     */
    priorityDescription: Maybe<Scalars['String']['output']>;
    /** The planned end time of an activity (or similar that extends this) */
    scheduledEndTime: Maybe<Scalars['Timestamp']['output']>;
    /** The planned start time of an activity (or similar that extends this) */
    scheduledStartTime: Maybe<Scalars['Timestamp']['output']>;
    /** Direct relation to a source system */
    source: Maybe<CogniteSourceSystem>;
    /** Context of the source id. For systems where the sourceId is globally unique, the sourceContext is expected to not be set. */
    sourceContext: Maybe<Scalars['String']['output']>;
    /** When the instance was created in source system (if available) */
    sourceCreatedTime: Maybe<Scalars['Timestamp']['output']>;
    /** User identifier from the source system on who created the source data. This identifier is not guaranteed to match the user identifiers in CDF */
    sourceCreatedUser: Maybe<Scalars['String']['output']>;
    /** Identifier from the source system */
    sourceId: Maybe<Scalars['String']['output']>;
    /** When the instance was last updated in the source system (if available) */
    sourceUpdatedTime: Maybe<Scalars['Timestamp']['output']>;
    /** User identifier from the source system on who last updated the source data. This identifier is not guaranteed to match the user identifiers in CDF */
    sourceUpdatedUser: Maybe<Scalars['String']['output']>;
    /** The actual start time of an activity (or similar that extends this) */
    startTime: Maybe<Scalars['Timestamp']['output']>;
    /**
     * The lifecycle status of the maintenance order, for example, 'Partially complete'. It's often derived from the 'SystemStatus' field in SAP.
     * @name Status
     */
    status: Maybe<Scalars['String']['output']>;
    /** Text based labels for generic use, limited to 1000 */
    tags: Maybe<Maybe<Scalars['String']['output']>[]>;
    /**
     * A list of time series the activity is related to.
     * @name Time series
     */
    timeSeries: Maybe<Maybe<CogniteTimeSeries>[]>;
    /**
     * The code for the type of maintenance order, for example, 'PM01' for 'Corrective maintenance'.
     * @name Type
     */
    type: Maybe<Scalars['String']['output']>;
  };

/**
 * A formal record to report maintenance issues, defects, or requests, starting the process for planning and running maintenance activities.
 * @name Notification
 */
export type CogniteNotification = CogniteDescribable &
  CogniteSchedulable &
  CogniteSourceable & {
    /** Alternative names for the node */
    aliases: Maybe<Maybe<Scalars['String']['output']>[]>;
    /**
     * The asset (functional location) the notification is related to.
     * @name Asset
     */
    asset: Maybe<CogniteAsset>;
    /** Description of the instance */
    description: Maybe<Scalars['String']['output']>;
    /** The actual end time of an activity (or similar that extends this) */
    endTime: Maybe<Scalars['Timestamp']['output']>;
    /**
     * The maintenance order that was created from the notification.
     * @name Maintenance order
     */
    maintenanceOrder: Maybe<CogniteMaintenanceOrder>;
    /** Name of the instance */
    name: Maybe<Scalars['String']['output']>;
    /**
     * A number that shows how important the notification is. Lower numbers mean it's more important, and 0 means it's the most important.
     * @name Priority
     */
    priority: Maybe<Scalars['Int64']['output']>;
    /**
     * Describes the priority of the notification.
     * @name Priority description
     */
    priorityDescription: Maybe<Scalars['String']['output']>;
    /** The planned end time of an activity (or similar that extends this) */
    scheduledEndTime: Maybe<Scalars['Timestamp']['output']>;
    /** The planned start time of an activity (or similar that extends this) */
    scheduledStartTime: Maybe<Scalars['Timestamp']['output']>;
    /** Direct relation to a source system */
    source: Maybe<CogniteSourceSystem>;
    /** Context of the source id. For systems where the sourceId is globally unique, the sourceContext is expected to not be set. */
    sourceContext: Maybe<Scalars['String']['output']>;
    /** When the instance was created in source system (if available) */
    sourceCreatedTime: Maybe<Scalars['Timestamp']['output']>;
    /** User identifier from the source system on who created the source data. This identifier is not guaranteed to match the user identifiers in CDF */
    sourceCreatedUser: Maybe<Scalars['String']['output']>;
    /** Identifier from the source system */
    sourceId: Maybe<Scalars['String']['output']>;
    /** When the instance was last updated in the source system (if available) */
    sourceUpdatedTime: Maybe<Scalars['Timestamp']['output']>;
    /** User identifier from the source system on who last updated the source data. This identifier is not guaranteed to match the user identifiers in CDF */
    sourceUpdatedUser: Maybe<Scalars['String']['output']>;
    /** The actual start time of an activity (or similar that extends this) */
    startTime: Maybe<Scalars['Timestamp']['output']>;
    /**
     * The current lifecycle status of the notification, for example, 'order created'.
     * @name Status
     */
    status: Maybe<Scalars['String']['output']>;
    /** Text based labels for generic use, limited to 1000 */
    tags: Maybe<Maybe<Scalars['String']['output']>[]>;
    /**
     * The code for the notification type, for example, 'M1' for  'Maintenance request'.
     * @name Type
     */
    type: Maybe<Scalars['String']['output']>;
  };

/**
 * Operations represent a specific part of the work included in a maintenance order. Often called a 'work order item'.
 * @name Operation
 */
export type CogniteOperation = CogniteActivity &
  CogniteDescribable &
  CogniteSchedulable &
  CogniteSourceable & {
    /** Alternative names for the node */
    aliases: Maybe<Maybe<Scalars['String']['output']>[]>;
    /**
     * A list of assets the activity is related to.
     * @name Assets
     */
    assets: Maybe<Maybe<CogniteAsset>[]>;
    /** Description of the instance */
    description: Maybe<Scalars['String']['output']>;
    /** The actual end time of an activity (or similar that extends this) */
    endTime: Maybe<Scalars['Timestamp']['output']>;
    /**
     * A list of equipment the activity is related to.
     * @name Equipment
     */
    equipment: Maybe<Maybe<CogniteEquipment>[]>;
    /**
     * The primary asset (functional location) the operation is related to.
     * @name Main asset
     */
    mainAsset: Maybe<CogniteAsset>;
    /**
     * The primary skill or resource required to perform the operation, for example, 'maintenance technician').
     * @name Main discipline
     */
    mainDiscipline: Maybe<Scalars['String']['output']>;
    /**
     * The maintenance order the operation is related to.
     * @name Maintenance order
     */
    maintenanceOrder: Maybe<CogniteMaintenanceOrder>;
    /** Name of the instance */
    name: Maybe<Scalars['String']['output']>;
    /**
     * The number of resources required to perform the operation, for example, the number of required maintenance technicians.
     * @name Number of main discipline
     */
    numberOfMainDiscipline: Maybe<Scalars['Int64']['output']>;
    /**
     * The number of hours required to perform the maintenance operation. The duration is calculated by dividing the personHours by the numberOfMainDiscipline.
     * @name Person hours
     */
    personHours: Maybe<Scalars['Float']['output']>;
    /**
     * The code for the phase the operation belongs to. Each operation belongs to a single phase, for example, 'Scaffolding'.
     * @name Phase
     */
    phase: Maybe<Scalars['String']['output']>;
    /** The planned end time of an activity (or similar that extends this) */
    scheduledEndTime: Maybe<Scalars['Timestamp']['output']>;
    /** The planned start time of an activity (or similar that extends this) */
    scheduledStartTime: Maybe<Scalars['Timestamp']['output']>;
    /**
     * A number that shows the order in which the operations are performed. Lower numbers mean they happen earlier, and 0 means it's the first operation.
     * @name Sequence
     */
    sequence: Maybe<Scalars['Int64']['output']>;
    /** Direct relation to a source system */
    source: Maybe<CogniteSourceSystem>;
    /** Context of the source id. For systems where the sourceId is globally unique, the sourceContext is expected to not be set. */
    sourceContext: Maybe<Scalars['String']['output']>;
    /** When the instance was created in source system (if available) */
    sourceCreatedTime: Maybe<Scalars['Timestamp']['output']>;
    /** User identifier from the source system on who created the source data. This identifier is not guaranteed to match the user identifiers in CDF */
    sourceCreatedUser: Maybe<Scalars['String']['output']>;
    /** Identifier from the source system */
    sourceId: Maybe<Scalars['String']['output']>;
    /** When the instance was last updated in the source system (if available) */
    sourceUpdatedTime: Maybe<Scalars['Timestamp']['output']>;
    /** User identifier from the source system on who last updated the source data. This identifier is not guaranteed to match the user identifiers in CDF */
    sourceUpdatedUser: Maybe<Scalars['String']['output']>;
    /** The actual start time of an activity (or similar that extends this) */
    startTime: Maybe<Scalars['Timestamp']['output']>;
    /**
     * The lifecycle status of the operation, for example, 'Partially complete'. It's often derived from the UserStatus field in SAP.
     * @name Status
     */
    status: Maybe<Scalars['String']['output']>;
    /** Text based labels for generic use, limited to 1000 */
    tags: Maybe<Maybe<Scalars['String']['output']>[]>;
    /**
     * A list of time series the activity is related to.
     * @name Time series
     */
    timeSeries: Maybe<Maybe<CogniteTimeSeries>[]>;
  };

/** Navigational aid for traversing CognitePointCloudModel instances */
export type CognitePointCloudModel = Cognite3DModel &
  CogniteDescribable & {
    /** Alternative names for the node */
    aliases: Maybe<Maybe<Scalars['String']['output']>[]>;
    /** Description of the instance */
    description: Maybe<Scalars['String']['output']>;
    /** Name of the instance */
    name: Maybe<Scalars['String']['output']>;
    /** List of revisions for this PointCloud model */
    revisions: Maybe<Maybe<CognitePointCloudRevision>[]>;
    /** Text based labels for generic use, limited to 1000 */
    tags: Maybe<Maybe<Scalars['String']['output']>[]>;
    /** Thumbnail of the 3D model */
    thumbnail: Maybe<CogniteFile>;
    /** CAD, PointCloud or Image360 */
    type: Maybe<Cognite3DModelType>;
  };

/** Navigational aid for traversing CognitePointCloudRevision instances */
export type CognitePointCloudRevision = Cognite3DRevision & {
  /** . */
  model3D: Maybe<CognitePointCloudModel>;
  published: Maybe<Scalars['Boolean']['output']>;
  /** The 3D API revision identifier for this PointCloud model */
  revisionId: Maybe<Scalars['Int64']['output']>;
  status: Maybe<Cognite3DRevisionStatus>;
  type: Maybe<Cognite3DRevisionType>;
};

/** PointCloud volume definition */
export type CognitePointCloudVolume = CogniteDescribable & {
  /** Alternative names for the node */
  aliases: Maybe<Maybe<Scalars['String']['output']>[]>;
  /** Description of the instance */
  description: Maybe<Scalars['String']['output']>;
  /** Specifies the version the ‘volume’ field is following. Volume definition is today 9 floats (property volume) */
  formatVersion: Maybe<Scalars['String']['output']>;
  /** Direct relation to Cognite3DModel instance */
  model3D: Maybe<CogniteCadModel>;
  /** Name of the instance */
  name: Maybe<Scalars['String']['output']>;
  /** Direct relation to object3D grouping for this node */
  object3D: Maybe<Cognite3DObject>;
  /** List of direct relations to revision information */
  revisions: Maybe<Maybe<CogniteCadRevision>[]>;
  /** Text based labels for generic use, limited to 1000 */
  tags: Maybe<Maybe<Scalars['String']['output']>[]>;
  /** Relevant coordinates for the volume type, 9 floats in total, that defines the volume */
  volume: Maybe<Maybe<Scalars['Float']['output']>[]>;
  /** Unique volume metric hashes used to access the 3D specialized data storage */
  volumeReferences: Maybe<Maybe<Scalars['String']['output']>[]>;
  /** Type of volume (Cylinder or Box) */
  volumeType: Maybe<CognitePointCloudVolumeVolumeType>;
};

export const CognitePointCloudVolumeVolumeType = {
  Box: 'Box',
  Cylinder: 'Cylinder',
} as const;

export type CognitePointCloudVolumeVolumeType =
  (typeof CognitePointCloudVolumeVolumeType)[keyof typeof CognitePointCloudVolumeVolumeType];
/** CogniteSchedulable represents the metadata about when an activity (or similar) starts and ends. */
export type CogniteSchedulable = {
  /** The actual end time of an activity (or similar that extends this) */
  endTime: Maybe<Scalars['Timestamp']['output']>;
  /** The planned end time of an activity (or similar that extends this) */
  scheduledEndTime: Maybe<Scalars['Timestamp']['output']>;
  /** The planned start time of an activity (or similar that extends this) */
  scheduledStartTime: Maybe<Scalars['Timestamp']['output']>;
  /** The actual start time of an activity (or similar that extends this) */
  startTime: Maybe<Scalars['Timestamp']['output']>;
};

/** The CogniteSourceSystem core concept is used to standardize the way source system is stored. */
export type CogniteSourceSystem = CogniteDescribable & {
  /** Alternative names for the node */
  aliases: Maybe<Maybe<Scalars['String']['output']>[]>;
  /** Description of the instance */
  description: Maybe<Scalars['String']['output']>;
  /** Manufacturer of the source system */
  manufacturer: Maybe<Scalars['String']['output']>;
  /** Name of the instance */
  name: Maybe<Scalars['String']['output']>;
  /** Text based labels for generic use, limited to 1000 */
  tags: Maybe<Maybe<Scalars['String']['output']>[]>;
  /** Version identifier for the source system */
  version: Maybe<Scalars['String']['output']>;
};

export type CogniteSourceable = {
  /** Direct relation to a source system */
  source: Maybe<CogniteSourceSystem>;
  /** Context of the source id. For systems where the sourceId is globally unique, the sourceContext is expected to not be set. */
  sourceContext: Maybe<Scalars['String']['output']>;
  /** When the instance was created in source system (if available) */
  sourceCreatedTime: Maybe<Scalars['Timestamp']['output']>;
  /** User identifier from the source system on who created the source data. This identifier is not guaranteed to match the user identifiers in CDF */
  sourceCreatedUser: Maybe<Scalars['String']['output']>;
  /** Identifier from the source system */
  sourceId: Maybe<Scalars['String']['output']>;
  /** When the instance was last updated in the source system (if available) */
  sourceUpdatedTime: Maybe<Scalars['Timestamp']['output']>;
  /** User identifier from the source system on who last updated the source data. This identifier is not guaranteed to match the user identifiers in CDF */
  sourceUpdatedUser: Maybe<Scalars['String']['output']>;
};

/**
 * Represents a series of data points in time order.
 * @name Time series
 */
export type CogniteTimeSeries = CogniteDescribable &
  CogniteSourceable & {
    /**
     * An automatically updated list of activities the time series is related to.
     * @name Activities
     */
    activities: Maybe<Maybe<CogniteActivity>[]>;
    /** Alternative names for the node */
    aliases: Maybe<Maybe<Scalars['String']['output']>[]>;
    /**
     * A list of assets the time series is related to.
     * @name Assets
     */
    assets: Maybe<Maybe<CogniteAsset>[]>;
    /** Description of the instance */
    description: Maybe<Scalars['String']['output']>;
    /**
     * A list of equipment the time series is related to.
     * @name Equipment
     */
    equipment: Maybe<Maybe<CogniteEquipment>[]>;
    /**
     * Specifies whether the time series is a step time series or not.
     * @name Is step
     */
    isStep: Maybe<Scalars['Boolean']['output']>;
    /** Name of the instance */
    name: Maybe<Scalars['String']['output']>;
    /** Direct relation to a source system */
    source: Maybe<CogniteSourceSystem>;
    /** Context of the source id. For systems where the sourceId is globally unique, the sourceContext is expected to not be set. */
    sourceContext: Maybe<Scalars['String']['output']>;
    /** When the instance was created in source system (if available) */
    sourceCreatedTime: Maybe<Scalars['Timestamp']['output']>;
    /** User identifier from the source system on who created the source data. This identifier is not guaranteed to match the user identifiers in CDF */
    sourceCreatedUser: Maybe<Scalars['String']['output']>;
    /** Identifier from the source system */
    sourceId: Maybe<Scalars['String']['output']>;
    /**
     * The unit specified in the source system.
     * @name Source unit
     */
    sourceUnit: Maybe<Scalars['String']['output']>;
    /** When the instance was last updated in the source system (if available) */
    sourceUpdatedTime: Maybe<Scalars['Timestamp']['output']>;
    /** User identifier from the source system on who last updated the source data. This identifier is not guaranteed to match the user identifiers in CDF */
    sourceUpdatedUser: Maybe<Scalars['String']['output']>;
    /**
     * The state set of the time series. It is only in effect when the type is 'state'.
     * @name State set
     */
    stateSet: Maybe<Scalars['JSONObject']['output']>;
    /** Text based labels for generic use, limited to 1000 */
    tags: Maybe<Maybe<Scalars['String']['output']>[]>;
    /**
     * Specifies the data type of the data points.
     * @name Type
     */
    type: Maybe<CogniteTimeSeriesType>;
    /**
     * The unit of the time series.
     * @name Unit
     */
    unit: Maybe<CogniteUnit>;
  };

export const CogniteTimeSeriesType = {
  /** Time series with double floating point data points. */
  Numeric: 'numeric',
  /** Time series with state data points. */
  State: 'state',
  /** Time series with string data points. */
  String: 'string',
} as const;

export type CogniteTimeSeriesType = (typeof CogniteTimeSeriesType)[keyof typeof CogniteTimeSeriesType];
/** Represents a single unit of measurement */
export type CogniteUnit = CogniteDescribable & {
  /** Alternative names for the node */
  aliases: Maybe<Maybe<Scalars['String']['output']>[]>;
  /** Description of the instance */
  description: Maybe<Scalars['String']['output']>;
  /** Name of the instance */
  name: Maybe<Scalars['String']['output']>;
  /** Specifies the physical quantity the unit measures */
  quantity: Maybe<Scalars['String']['output']>;
  /** Source of the unit definition */
  source: Maybe<Scalars['String']['output']>;
  /** Reference to the source of the unit definition */
  sourceReference: Maybe<Scalars['String']['output']>;
  /** The symbol for the unit of measurement */
  symbol: Maybe<Scalars['String']['output']>;
  /** Text based labels for generic use, limited to 1000 */
  tags: Maybe<Maybe<Scalars['String']['output']>[]>;
};

/** CogniteVisualizable defines the standard way to reference a related 3D resource */
export type CogniteVisualizable = {
  /** Direct relation to an Object3D instance representing the 3D resource */
  object3D: Maybe<Cognite3DObject>;
};

/** Typed view over 'Entity' showing companies only (where 'entityType' = 'company'). Use this view to identify the top-level company context, then navigate down to assets, fields, reservoirs, wells and strings through the 'FlatHierarchy' navigation view. */
export type Company = {
  /** Timestamp 'endDateTime' associated with this 'Company' row. */
  endDateTime: Maybe<Scalars['Timestamp']['output']>;
  /** Text attribute 'entityType' for this 'Company' row. */
  entityType: Maybe<Scalars['String']['output']>;
  /** Name of the company. Use together with 'FlatHierarchy' to scope navigation to assets, fields, reservoirs, wells and strings belonging to this company. */
  name: Maybe<Scalars['String']['output']>;
  /** Timestamp 'startDateTime' associated with this 'Company' row. */
  startDateTime: Maybe<Scalars['Timestamp']['output']>;
};

/** Asset-level daily rollup of allocated oil, gas, and water production and injection volumes, rates, and targets. */
export type DailyRollupAssetAgent = {
  /** Reference to asset. Join to FlatHierarchy_Agent for field/company context. */
  assetEntity: Maybe<Asset>;
  /** Daily allocated gas injection volume (Sm3). Asset total. */
  dayAllocInjGasInjection: Maybe<TimeSeries>;
  /** Daily allocated gas injection rate (Sm3/d). */
  dayAllocInjGasInjectionRate: Maybe<TimeSeries>;
  /** Daily allocated water injection volume (Sm3). Asset total. */
  dayAllocInjWaterInjection: Maybe<TimeSeries>;
  /** Daily allocated water injection rate (Sm3/d). */
  dayAllocInjWaterInjectionRate: Maybe<TimeSeries>;
  /** Daily allocated gas production volume (Sm3). Asset total. */
  dayAllocProdAllocatedGas: Maybe<TimeSeries>;
  /** Daily allocated gas production rate (Sm3/d). */
  dayAllocProdAllocatedGasRate: Maybe<TimeSeries>;
  /** Daily allocated oil production volume (Sm3). Asset total. */
  dayAllocProdAllocatedOil: Maybe<TimeSeries>;
  /** Daily allocated oil production rate (Sm3/d or bbl/d). */
  dayAllocProdAllocatedOilRate: Maybe<TimeSeries>;
  /** Daily allocated water production volume (Sm3). Asset total. */
  dayAllocProdAllocatedWater: Maybe<TimeSeries>;
  /** Daily allocated water production rate (Sm3/d). */
  dayAllocProdAllocatedWaterRate: Maybe<TimeSeries>;
  /** Unconstrained gas injection potential. For injection performance. */
  potentialGasInjection: Maybe<TimeSeries>;
  /** Unconstrained gas production potential. Performance benchmark. */
  potentialGasProduction: Maybe<TimeSeries>;
  /** Unconstrained oil production potential. Performance benchmark. */
  potentialOilProduction: Maybe<TimeSeries>;
  /** Unconstrained water injection potential. For injection performance. */
  potentialWaterInjection: Maybe<TimeSeries>;
  /** Unconstrained water production potential. Performance benchmark. */
  potentialWaterProduction: Maybe<TimeSeries>;
  /** Target gas injection from planning. For gap analysis. */
  targetGasInjection: Maybe<TimeSeries>;
  /** Target gas production from planning. For gap analysis. */
  targetGasProduction: Maybe<TimeSeries>;
  /** Target oil production from planning. For gap analysis. */
  targetOilproduction: Maybe<TimeSeries>;
  /** Target water injection from planning. For gap analysis. */
  targetWaterInjection: Maybe<TimeSeries>;
  /** Target water production from planning. For gap analysis. */
  targetWaterProduction: Maybe<TimeSeries>;
};

/** Company-level daily rollup of allocated oil, gas, and water production and injection volumes, rates, and targets. */
export type DailyRollupCompanyAgent = {
  /** Reference to company. Top of the hierarchy; join to FlatHierarchy_Agent for asset/field breakdown. */
  companyEntity: Maybe<Company>;
  /** Daily allocated gas injection volume (Sm3). Company total. */
  dayAllocInjGasInjection: Maybe<TimeSeries>;
  /** Daily allocated gas injection rate (Sm3/d). */
  dayAllocInjGasInjectionRate: Maybe<TimeSeries>;
  /** Daily allocated water injection volume (Sm3). Company total. */
  dayAllocInjWaterInjection: Maybe<TimeSeries>;
  /** Daily allocated water injection rate (Sm3/d). */
  dayAllocInjWaterInjectionRate: Maybe<TimeSeries>;
  /** Daily allocated gas production volume (Sm3). Company total. */
  dayAllocProdAllocatedGas: Maybe<TimeSeries>;
  /** Daily allocated gas production rate (Sm3/d). */
  dayAllocProdAllocatedGasRate: Maybe<TimeSeries>;
  /** Daily allocated oil production volume (Sm3). Company total. */
  dayAllocProdAllocatedOil: Maybe<TimeSeries>;
  /** Daily allocated oil production rate (Sm3/d or bbl/d). */
  dayAllocProdAllocatedOilRate: Maybe<TimeSeries>;
  /** Daily allocated water production volume (Sm3). Company total. */
  dayAllocProdAllocatedWater: Maybe<TimeSeries>;
  /** Daily allocated water production rate (Sm3/d). */
  dayAllocProdAllocatedWaterRate: Maybe<TimeSeries>;
  /** Unconstrained gas injection potential. For injection performance. */
  potentialGasInjection: Maybe<TimeSeries>;
  /** Unconstrained gas production potential. Performance benchmark. */
  potentialGasProduction: Maybe<TimeSeries>;
  /** Unconstrained oil production potential. Performance benchmark. */
  potentialOilProduction: Maybe<TimeSeries>;
  /** Unconstrained water injection potential. For injection performance. */
  potentialWaterInjection: Maybe<TimeSeries>;
  /** Unconstrained water production potential. Performance benchmark. */
  potentialWaterProduction: Maybe<TimeSeries>;
  /** Target gas injection from planning. For gap analysis. */
  targetGasInjection: Maybe<TimeSeries>;
  /** Target gas production from planning. For gap analysis. */
  targetGasProduction: Maybe<TimeSeries>;
  /** Target oil production from planning. For gap analysis. */
  targetOilproduction: Maybe<TimeSeries>;
  /** Target water injection from planning. For gap analysis. */
  targetWaterInjection: Maybe<TimeSeries>;
  /** Target water production from planning. For gap analysis. */
  targetWaterProduction: Maybe<TimeSeries>;
};

/** Field-level daily rollup of allocated oil, gas, and water production and injection volumes, rates, and targets. */
export type DailyRollupFieldAgent = {
  /** Daily allocated gas injection volume (Sm3). Field total. */
  dayAllocInjGasInjection: Maybe<TimeSeries>;
  /** Daily allocated gas injection rate (Sm3/d). */
  dayAllocInjGasInjectionRate: Maybe<TimeSeries>;
  /** Daily allocated water injection volume (Sm3). Field total. */
  dayAllocInjWaterInjection: Maybe<TimeSeries>;
  /** Daily allocated water injection rate (Sm3/d). */
  dayAllocInjWaterInjectionRate: Maybe<TimeSeries>;
  /** Daily allocated gas production volume (Sm3). Field total. */
  dayAllocProdAllocatedGas: Maybe<TimeSeries>;
  /** Daily allocated gas production rate (Sm3/d). */
  dayAllocProdAllocatedGasRate: Maybe<TimeSeries>;
  /** Daily allocated oil production volume (Sm3). Field total. */
  dayAllocProdAllocatedOil: Maybe<TimeSeries>;
  /** Daily allocated oil production rate (Sm3/d or bbl/d). */
  dayAllocProdAllocatedOilRate: Maybe<TimeSeries>;
  /** Daily allocated water production volume (Sm3). Field total. */
  dayAllocProdAllocatedWater: Maybe<TimeSeries>;
  /** Daily allocated water production rate (Sm3/d). */
  dayAllocProdAllocatedWaterRate: Maybe<TimeSeries>;
  /** Reference to field. Join to FlatHierarchy_Agent for reservoir/sector context. */
  fieldEntity: Maybe<Field>;
  /** Unconstrained gas injection potential. For injection performance. */
  potentialGasInjection: Maybe<TimeSeries>;
  /** Unconstrained gas production potential. Performance benchmark. */
  potentialGasProduction: Maybe<TimeSeries>;
  /** Unconstrained oil production potential. Performance benchmark. */
  potentialOilProduction: Maybe<TimeSeries>;
  /** Unconstrained water injection potential. For injection performance. */
  potentialWaterInjection: Maybe<TimeSeries>;
  /** Unconstrained water production potential. Performance benchmark. */
  potentialWaterProduction: Maybe<TimeSeries>;
  /** Target gas injection from planning. For gap analysis. */
  targetGasInjection: Maybe<TimeSeries>;
  /** Target gas production from planning. For gap analysis. */
  targetGasProduction: Maybe<TimeSeries>;
  /** Target oil production from planning. For gap analysis. */
  targetOilproduction: Maybe<TimeSeries>;
  /** Target water injection from planning. For gap analysis. */
  targetWaterInjection: Maybe<TimeSeries>;
  /** Target water production from planning. For gap analysis. */
  targetWaterProduction: Maybe<TimeSeries>;
};

/** Location-level daily rollup of allocated oil, gas, and water production and injection volumes, rates, and targets. */
export type DailyRollupLocationAgent = {
  /** Daily allocated gas injection volume (Sm3). Location total. */
  dayAllocInjGasInjection: Maybe<TimeSeries>;
  /** Daily allocated gas injection rate (Sm3/d). */
  dayAllocInjGasInjectionRate: Maybe<TimeSeries>;
  /** Daily allocated water injection volume (Sm3). Location total. */
  dayAllocInjWaterInjection: Maybe<TimeSeries>;
  /** Daily allocated water injection rate (Sm3/d). */
  dayAllocInjWaterInjectionRate: Maybe<TimeSeries>;
  /** Daily allocated gas production volume (Sm3). Location total. */
  dayAllocProdAllocatedGas: Maybe<TimeSeries>;
  /** Daily allocated gas production rate (Sm3/d). */
  dayAllocProdAllocatedGasRate: Maybe<TimeSeries>;
  /** Daily allocated oil production volume (Sm3). Location total. */
  dayAllocProdAllocatedOil: Maybe<TimeSeries>;
  /** Daily allocated oil production rate (Sm3/d or bbl/d). */
  dayAllocProdAllocatedOilRate: Maybe<TimeSeries>;
  /** Daily allocated water production volume (Sm3). Location total. */
  dayAllocProdAllocatedWater: Maybe<TimeSeries>;
  /** Daily allocated water production rate (Sm3/d). */
  dayAllocProdAllocatedWaterRate: Maybe<TimeSeries>;
  /** Reference to location (facility or network node). Join to FlatHierarchy_Agent for field/asset context. */
  locationEntity: Maybe<Location>;
  /** Unconstrained gas injection potential. For injection performance. */
  potentialGasInjection: Maybe<TimeSeries>;
  /** Unconstrained gas production potential. Performance benchmark. */
  potentialGasProduction: Maybe<TimeSeries>;
  /** Unconstrained oil production potential. Performance benchmark. */
  potentialOilProduction: Maybe<TimeSeries>;
  /** Unconstrained water injection potential. For injection performance. */
  potentialWaterInjection: Maybe<TimeSeries>;
  /** Unconstrained water production potential. Performance benchmark. */
  potentialWaterProduction: Maybe<TimeSeries>;
  /** Target gas injection from planning. For gap analysis. */
  targetGasInjection: Maybe<TimeSeries>;
  /** Target gas production from planning. For gap analysis. */
  targetGasProduction: Maybe<TimeSeries>;
  /** Target oil production from planning. For gap analysis. */
  targetOilproduction: Maybe<TimeSeries>;
  /** Target water injection from planning. For gap analysis. */
  targetWaterInjection: Maybe<TimeSeries>;
  /** Target water production from planning. For gap analysis. */
  targetWaterProduction: Maybe<TimeSeries>;
};

/** Asset-level daily rollup of allocated production and injection, including daily oil, gas and water volumes and rates, as well as potential versus target production and injection used for asset performance tracking. */
export type DailyRollupOutputAsset = {
  /** Reference to a time series for 'dayAllocInjGasInjection' in this 'DailyRollupOutput_Asset' view. */
  dayAllocInjGasInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'dayAllocInjGasInjectionRate' in this 'DailyRollupOutput_Asset' view. */
  dayAllocInjGasInjectionRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'dayAllocInjWaterInjection' in this 'DailyRollupOutput_Asset' view. */
  dayAllocInjWaterInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'dayAllocInjWaterInjectionRate' in this 'DailyRollupOutput_Asset' view. */
  dayAllocInjWaterInjectionRate: Maybe<TimeSeries>;
  /** Daily time series of total allocated gas production volume for the asset. */
  dayAllocProdAllocatedGas: Maybe<TimeSeries>;
  /** Daily time series of average allocated gas production rate for the asset. */
  dayAllocProdAllocatedGasRate: Maybe<TimeSeries>;
  /** Daily time series of total allocated oil production volume for the asset. */
  dayAllocProdAllocatedOil: Maybe<TimeSeries>;
  /** Daily time series of average allocated oil production rate for the asset. */
  dayAllocProdAllocatedOilRate: Maybe<TimeSeries>;
  /** Daily time series of total allocated water production volume for the asset. */
  dayAllocProdAllocatedWater: Maybe<TimeSeries>;
  /** Daily time series of average allocated water production rate for the asset. */
  dayAllocProdAllocatedWaterRate: Maybe<TimeSeries>;
  /** Asset name for which daily allocated production and injection rollups are reported in this view. */
  entityName: Maybe<Asset>;
  /** Reference to a time series for 'potentialGasInjection' in this 'DailyRollupOutput_Asset' view. */
  potentialGasInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'potentialGasProduction' in this 'DailyRollupOutput_Asset' view. */
  potentialGasProduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'potentialOilProduction' in this 'DailyRollupOutput_Asset' view. */
  potentialOilProduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'potentialWaterInjection' in this 'DailyRollupOutput_Asset' view. */
  potentialWaterInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'potentialWaterProduction' in this 'DailyRollupOutput_Asset' view. */
  potentialWaterProduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'targetGasInjection' in this 'DailyRollupOutput_Asset' view. */
  targetGasInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'targetGasProduction' in this 'DailyRollupOutput_Asset' view. */
  targetGasProduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'targetOilproduction' in this 'DailyRollupOutput_Asset' view. */
  targetOilproduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'targetWaterInjection' in this 'DailyRollupOutput_Asset' view. */
  targetWaterInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'targetWaterProduction' in this 'DailyRollupOutput_Asset' view. */
  targetWaterProduction: Maybe<TimeSeries>;
};

/** Company-level daily rollup of allocated production and injection, including daily oil, gas and water volumes and rates, as well as potential versus target production and injection used for corporate performance tracking. */
export type DailyRollupOutputCompany = {
  /** Reference to a time series for 'dayAllocInjGasInjection' in this 'DailyRollupOutput_Company' view. */
  dayAllocInjGasInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'dayAllocInjGasInjectionRate' in this 'DailyRollupOutput_Company' view. */
  dayAllocInjGasInjectionRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'dayAllocInjWaterInjection' in this 'DailyRollupOutput_Company' view. */
  dayAllocInjWaterInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'dayAllocInjWaterInjectionRate' in this 'DailyRollupOutput_Company' view. */
  dayAllocInjWaterInjectionRate: Maybe<TimeSeries>;
  /** Daily time series of total allocated gas production volume for the company. */
  dayAllocProdAllocatedGas: Maybe<TimeSeries>;
  /** Daily time series of average allocated gas production rate for the company. */
  dayAllocProdAllocatedGasRate: Maybe<TimeSeries>;
  /** Daily time series of total allocated oil production volume for the company. */
  dayAllocProdAllocatedOil: Maybe<TimeSeries>;
  /** Daily time series of average allocated oil production rate for the company. */
  dayAllocProdAllocatedOilRate: Maybe<TimeSeries>;
  /** Daily time series of total allocated water production volume for the company. */
  dayAllocProdAllocatedWater: Maybe<TimeSeries>;
  /** Daily time series of average allocated water production rate for the company. */
  dayAllocProdAllocatedWaterRate: Maybe<TimeSeries>;
  /** Company name for which daily allocated production and injection rollups are reported in this view. */
  entityName: Maybe<Company>;
  /** Reference to a time series for 'potentialGasInjection' in this 'DailyRollupOutput_Company' view. */
  potentialGasInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'potentialGasProduction' in this 'DailyRollupOutput_Company' view. */
  potentialGasProduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'potentialOilProduction' in this 'DailyRollupOutput_Company' view. */
  potentialOilProduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'potentialWaterInjection' in this 'DailyRollupOutput_Company' view. */
  potentialWaterInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'potentialWaterProduction' in this 'DailyRollupOutput_Company' view. */
  potentialWaterProduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'targetGasInjection' in this 'DailyRollupOutput_Company' view. */
  targetGasInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'targetGasProduction' in this 'DailyRollupOutput_Company' view. */
  targetGasProduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'targetOilproduction' in this 'DailyRollupOutput_Company' view. */
  targetOilproduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'targetWaterInjection' in this 'DailyRollupOutput_Company' view. */
  targetWaterInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'targetWaterProduction' in this 'DailyRollupOutput_Company' view. */
  targetWaterProduction: Maybe<TimeSeries>;
};

/** Field-level daily rollup of allocated production and injection, including daily oil, gas and water volumes and rates, as well as potential versus target production and injection used for field performance tracking. */
export type DailyRollupOutputField = {
  /** Reference to a time series for 'dayAllocInjGasInjection' in this 'DailyRollupOutput_Field' view. */
  dayAllocInjGasInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'dayAllocInjGasInjectionRate' in this 'DailyRollupOutput_Field' view. */
  dayAllocInjGasInjectionRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'dayAllocInjWaterInjection' in this 'DailyRollupOutput_Field' view. */
  dayAllocInjWaterInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'dayAllocInjWaterInjectionRate' in this 'DailyRollupOutput_Field' view. */
  dayAllocInjWaterInjectionRate: Maybe<TimeSeries>;
  /** Daily time series of total allocated gas production volume for the field. */
  dayAllocProdAllocatedGas: Maybe<TimeSeries>;
  /** Daily time series of average allocated gas production rate for the field. */
  dayAllocProdAllocatedGasRate: Maybe<TimeSeries>;
  /** Daily time series of total allocated oil production volume for the field. */
  dayAllocProdAllocatedOil: Maybe<TimeSeries>;
  /** Daily time series of average allocated oil production rate for the field. */
  dayAllocProdAllocatedOilRate: Maybe<TimeSeries>;
  /** Daily time series of total allocated water production volume for the field. */
  dayAllocProdAllocatedWater: Maybe<TimeSeries>;
  /** Daily time series of average allocated water production rate for the field. */
  dayAllocProdAllocatedWaterRate: Maybe<TimeSeries>;
  /** Field name for which daily allocated production and injection rollups are reported in this view. */
  entityName: Maybe<Field>;
  /** Reference to a time series for 'potentialGasInjection' in this 'DailyRollupOutput_Field' view. */
  potentialGasInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'potentialGasProduction' in this 'DailyRollupOutput_Field' view. */
  potentialGasProduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'potentialOilProduction' in this 'DailyRollupOutput_Field' view. */
  potentialOilProduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'potentialWaterInjection' in this 'DailyRollupOutput_Field' view. */
  potentialWaterInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'potentialWaterProduction' in this 'DailyRollupOutput_Field' view. */
  potentialWaterProduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'targetGasInjection' in this 'DailyRollupOutput_Field' view. */
  targetGasInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'targetGasProduction' in this 'DailyRollupOutput_Field' view. */
  targetGasProduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'targetOilproduction' in this 'DailyRollupOutput_Field' view. */
  targetOilproduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'targetWaterInjection' in this 'DailyRollupOutput_Field' view. */
  targetWaterInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'targetWaterProduction' in this 'DailyRollupOutput_Field' view. */
  targetWaterProduction: Maybe<TimeSeries>;
};

/** Location-level daily rollup of allocated production and injection, including daily oil, gas and water volumes and rates, as well as potential versus target production and injection used for facility or network node performance tracking. */
export type DailyRollupOutputLocation = {
  /** Reference to a time series for 'dayAllocInjGasInjection' in this 'DailyRollupOutput_Location' view. */
  dayAllocInjGasInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'dayAllocInjGasInjectionRate' in this 'DailyRollupOutput_Location' view. */
  dayAllocInjGasInjectionRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'dayAllocInjWaterInjection' in this 'DailyRollupOutput_Location' view. */
  dayAllocInjWaterInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'dayAllocInjWaterInjectionRate' in this 'DailyRollupOutput_Location' view. */
  dayAllocInjWaterInjectionRate: Maybe<TimeSeries>;
  /** Daily time series of allocated gas production volume for the location. */
  dayAllocProdAllocatedGas: Maybe<TimeSeries>;
  /** Daily time series of average allocated gas production rate for the location. */
  dayAllocProdAllocatedGasRate: Maybe<TimeSeries>;
  /** Daily time series of allocated oil production volume for the location. */
  dayAllocProdAllocatedOil: Maybe<TimeSeries>;
  /** Daily time series of average allocated oil production rate for the location. */
  dayAllocProdAllocatedOilRate: Maybe<TimeSeries>;
  /** Daily time series of allocated water production volume for the location. */
  dayAllocProdAllocatedWater: Maybe<TimeSeries>;
  /** Daily time series of average allocated water production rate for the location. */
  dayAllocProdAllocatedWaterRate: Maybe<TimeSeries>;
  /** Location name (facility or network node) for which daily allocated production and injection rollups are reported in this view. */
  entityName: Maybe<Location>;
  /** Reference to a time series for 'potentialGasInjection' in this 'DailyRollupOutput_Location' view. */
  potentialGasInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'potentialGasProduction' in this 'DailyRollupOutput_Location' view. */
  potentialGasProduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'potentialOilProduction' in this 'DailyRollupOutput_Location' view. */
  potentialOilProduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'potentialWaterInjection' in this 'DailyRollupOutput_Location' view. */
  potentialWaterInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'potentialWaterProduction' in this 'DailyRollupOutput_Location' view. */
  potentialWaterProduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'targetGasInjection' in this 'DailyRollupOutput_Location' view. */
  targetGasInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'targetGasProduction' in this 'DailyRollupOutput_Location' view. */
  targetGasProduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'targetOilproduction' in this 'DailyRollupOutput_Location' view. */
  targetOilproduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'targetWaterInjection' in this 'DailyRollupOutput_Location' view. */
  targetWaterInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'targetWaterProduction' in this 'DailyRollupOutput_Location' view. */
  targetWaterProduction: Maybe<TimeSeries>;
};

/** Reservoir-level daily rollup of allocated production and injection, including daily oil, gas and water volumes and rates, as well as potential versus target production and injection used for reservoir performance tracking. */
export type DailyRollupOutputReservoir = {
  /** Reference to a time series for 'dayAllocInjGasInjection' in this 'DailyRollupOutput_Reservoir' view. */
  dayAllocInjGasInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'dayAllocInjGasInjectionRate' in this 'DailyRollupOutput_Reservoir' view. */
  dayAllocInjGasInjectionRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'dayAllocInjWaterInjection' in this 'DailyRollupOutput_Reservoir' view. */
  dayAllocInjWaterInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'dayAllocInjWaterInjectionRate' in this 'DailyRollupOutput_Reservoir' view. */
  dayAllocInjWaterInjectionRate: Maybe<TimeSeries>;
  /** Daily time series of total allocated gas production volume for the reservoir. */
  dayAllocProdAllocatedGas: Maybe<TimeSeries>;
  /** Daily time series of average allocated gas production rate for the reservoir. */
  dayAllocProdAllocatedGasRate: Maybe<TimeSeries>;
  /** Daily time series of total allocated oil production volume for the reservoir. */
  dayAllocProdAllocatedOil: Maybe<TimeSeries>;
  /** Daily time series of average allocated oil production rate for the reservoir. */
  dayAllocProdAllocatedOilRate: Maybe<TimeSeries>;
  /** Daily time series of total allocated water production volume for the reservoir. */
  dayAllocProdAllocatedWater: Maybe<TimeSeries>;
  /** Daily time series of average allocated water production rate for the reservoir. */
  dayAllocProdAllocatedWaterRate: Maybe<TimeSeries>;
  /** Reservoir name for which daily allocated production and injection rollups are reported in this view. */
  entityName: Maybe<Reservoir>;
  /** Reference to a time series for 'potentialGasInjection' in this 'DailyRollupOutput_Reservoir' view. */
  potentialGasInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'potentialGasProduction' in this 'DailyRollupOutput_Reservoir' view. */
  potentialGasProduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'potentialOilProduction' in this 'DailyRollupOutput_Reservoir' view. */
  potentialOilProduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'potentialWaterInjection' in this 'DailyRollupOutput_Reservoir' view. */
  potentialWaterInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'potentialWaterProduction' in this 'DailyRollupOutput_Reservoir' view. */
  potentialWaterProduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'targetGasInjection' in this 'DailyRollupOutput_Reservoir' view. */
  targetGasInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'targetGasProduction' in this 'DailyRollupOutput_Reservoir' view. */
  targetGasProduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'targetOilproduction' in this 'DailyRollupOutput_Reservoir' view. */
  targetOilproduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'targetWaterInjection' in this 'DailyRollupOutput_Reservoir' view. */
  targetWaterInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'targetWaterProduction' in this 'DailyRollupOutput_Reservoir' view. */
  targetWaterProduction: Maybe<TimeSeries>;
};

/** Well-level daily rollup of allocated production and injection, including daily oil, gas and water volumes and rates, as well as potential versus target production and injection used for individual well performance tracking. */
export type DailyRollupOutputWell = {
  /** Reference to a time series for 'dayAllocInjGasInjection' in this 'DailyRollupOutput_Well' view. */
  dayAllocInjGasInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'dayAllocInjGasInjectionRate' in this 'DailyRollupOutput_Well' view. */
  dayAllocInjGasInjectionRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'dayAllocInjWaterInjection' in this 'DailyRollupOutput_Well' view. */
  dayAllocInjWaterInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'dayAllocInjWaterInjectionRate' in this 'DailyRollupOutput_Well' view. */
  dayAllocInjWaterInjectionRate: Maybe<TimeSeries>;
  /** Daily time series of allocated gas production volume for the well. */
  dayAllocProdAllocatedGas: Maybe<TimeSeries>;
  /** Daily time series of average allocated gas production rate for the well. */
  dayAllocProdAllocatedGasRate: Maybe<TimeSeries>;
  /** Daily time series of allocated oil production volume for the well. */
  dayAllocProdAllocatedOil: Maybe<TimeSeries>;
  /** Daily time series of average allocated oil production rate for the well. */
  dayAllocProdAllocatedOilRate: Maybe<TimeSeries>;
  /** Daily time series of allocated water production volume for the well. */
  dayAllocProdAllocatedWater: Maybe<TimeSeries>;
  /** Daily time series of average allocated water production rate for the well. */
  dayAllocProdAllocatedWaterRate: Maybe<TimeSeries>;
  /** Well name for which daily allocated production and injection rollups are reported in this view. */
  entityName: Maybe<Well>;
  /** Reference to a time series for 'potentialGasInjection' in this 'DailyRollupOutput_Well' view. */
  potentialGasInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'potentialGasProduction' in this 'DailyRollupOutput_Well' view. */
  potentialGasProduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'potentialOilProduction' in this 'DailyRollupOutput_Well' view. */
  potentialOilProduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'potentialWaterInjection' in this 'DailyRollupOutput_Well' view. */
  potentialWaterInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'potentialWaterProduction' in this 'DailyRollupOutput_Well' view. */
  potentialWaterProduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'targetGasInjection' in this 'DailyRollupOutput_Well' view. */
  targetGasInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'targetGasProduction' in this 'DailyRollupOutput_Well' view. */
  targetGasProduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'targetOilproduction' in this 'DailyRollupOutput_Well' view. */
  targetOilproduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'targetWaterInjection' in this 'DailyRollupOutput_Well' view. */
  targetWaterInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'targetWaterProduction' in this 'DailyRollupOutput_Well' view. */
  targetWaterProduction: Maybe<TimeSeries>;
};

/** Reservoir-level daily rollup of allocated oil, gas, and water production and injection volumes, rates, and targets. */
export type DailyRollupReservoirAgent = {
  /** Daily allocated gas injection volume (Sm3). Reservoir total. */
  dayAllocInjGasInjection: Maybe<TimeSeries>;
  /** Daily allocated gas injection rate (Sm3/d). */
  dayAllocInjGasInjectionRate: Maybe<TimeSeries>;
  /** Daily allocated water injection volume (Sm3). Reservoir total. */
  dayAllocInjWaterInjection: Maybe<TimeSeries>;
  /** Daily allocated water injection rate (Sm3/d). */
  dayAllocInjWaterInjectionRate: Maybe<TimeSeries>;
  /** Daily allocated gas production volume (Sm3). Reservoir total. */
  dayAllocProdAllocatedGas: Maybe<TimeSeries>;
  /** Daily allocated gas production rate (Sm3/d). */
  dayAllocProdAllocatedGasRate: Maybe<TimeSeries>;
  /** Daily allocated oil production volume (Sm3). Reservoir total. */
  dayAllocProdAllocatedOil: Maybe<TimeSeries>;
  /** Daily allocated oil production rate (Sm3/d or bbl/d). */
  dayAllocProdAllocatedOilRate: Maybe<TimeSeries>;
  /** Daily allocated water production volume (Sm3). Reservoir total. */
  dayAllocProdAllocatedWater: Maybe<TimeSeries>;
  /** Daily allocated water production rate (Sm3/d). */
  dayAllocProdAllocatedWaterRate: Maybe<TimeSeries>;
  /** Unconstrained gas injection potential. For injection performance. */
  potentialGasInjection: Maybe<TimeSeries>;
  /** Unconstrained gas production potential. Performance benchmark. */
  potentialGasProduction: Maybe<TimeSeries>;
  /** Unconstrained oil production potential. Performance benchmark. */
  potentialOilProduction: Maybe<TimeSeries>;
  /** Unconstrained water injection potential. For injection performance. */
  potentialWaterInjection: Maybe<TimeSeries>;
  /** Unconstrained water production potential. Performance benchmark. */
  potentialWaterProduction: Maybe<TimeSeries>;
  /** Reference to reservoir. Join to FlatHierarchy_Agent for field/asset context. */
  reservoirEntity: Maybe<Reservoir>;
  /** Target gas injection from planning. For gap analysis. */
  targetGasInjection: Maybe<TimeSeries>;
  /** Target gas production from planning. For gap analysis. */
  targetGasProduction: Maybe<TimeSeries>;
  /** Target oil production from planning. For gap analysis. */
  targetOilproduction: Maybe<TimeSeries>;
  /** Target water injection from planning. For gap analysis. */
  targetWaterInjection: Maybe<TimeSeries>;
  /** Target water production from planning. For gap analysis. */
  targetWaterProduction: Maybe<TimeSeries>;
};

/**
 * Data-driven and ML rate estimates with injection compliance per well string (WF10).
 *
 * Properties from WellOutputs_Ext_1_String. ML-derived oil, gas, water, liquid
 * rates and injector compliance. Use when querying ML outputs or injector compliance. For physics-based and priority rates use EstimatedRates_String_Agent.
 *
 * Use for: Real-Time Well Rate and Pressure Estimation (WF10).
 *
 * @name Data-Driven Rates - String (Agent)
 */
export type DataDrivenRatesStringAgent = {
  dataDrivenGasRateStd: Maybe<TimeSeries>;
  dataDrivenLiquidRateStd: Maybe<TimeSeries>;
  dataDrivenOilRateStd: Maybe<TimeSeries>;
  dataDrivenWaterRateStd: Maybe<TimeSeries>;
  giBHPCompliance: Maybe<TimeSeries>;
  giTargetRateCompliance: Maybe<TimeSeries>;
  giTechnicalRateCompliance: Maybe<TimeSeries>;
  giWHPCompliance: Maybe<TimeSeries>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString: Maybe<StringAsset>;
  wiBHPCompliance: Maybe<TimeSeries>;
  wiTargetRateCompliance: Maybe<TimeSeries>;
  wiTechnicalRateCompliance: Maybe<TimeSeries>;
  wiWHPCompliance: Maybe<TimeSeries>;
};

/** View 'Data_Mapping' in the iPSO production optimization solution data model. */
export type DataMapping = {
  /** Timestamp 'date' associated with this 'Data_Mapping' row. */
  date: Maybe<Scalars['Timestamp']['output']>;
  /** Text attribute 'fieldName' for this 'Data_Mapping' row. */
  fieldName: Maybe<Scalars['String']['output']>;
  /** Text attribute 'isOfficial' for this 'Data_Mapping' row. */
  isOfficial: Maybe<Scalars['String']['output']>;
  /** Numeric value 'lat' (floating point) for this 'Data_Mapping' row. */
  lat: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'long' (floating point) for this 'Data_Mapping' row. */
  long: Maybe<Scalars['Float32']['output']>;
  /** Text attribute 'reservoirName' for this 'Data_Mapping' row. */
  reservoirName: Maybe<Scalars['String']['output']>;
  /** Numeric value 'reservoirPressureRMSError' (floating point) for this 'Data_Mapping' row. */
  reservoirPressureRMSError: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'reservoirPressureString' (floating point) for this 'Data_Mapping' row. */
  reservoirPressureString: Maybe<Scalars['Float32']['output']>;
  /** Timestamp 'runDate' associated with this 'Data_Mapping' row. */
  runDate: Maybe<Scalars['Timestamp']['output']>;
  /** Text attribute 'stringName' for this 'Data_Mapping' row. */
  stringName: Maybe<Scalars['String']['output']>;
  /** Numeric value 'x' (floating point) for this 'Data_Mapping' row. */
  x: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'y' (floating point) for this 'Data_Mapping' row. */
  y: Maybe<Scalars['Float32']['output']>;
};

/**
 * ESP and motor performance alarms (WF12) with medium or high priority.
 *
 * Contains alarms generated by Electric Submersible Pumps (ESPs) and associated
 * motors, medium and high-priority alarms as part of the WF12 workflow. Sourced
 * from operational monitoring systems that track ESP performance and
 * diagnostics, to analyze alarm occurrences, their severity, and potential
 * impacts on production. It can answer questions regarding the frequency and
 * types of alarms, trends in alarm priorities, and the relationship between
 * alarm occurrences and operational performance. Excludes low-priority or non-WF12 alarms.
 *
 * Use for: ESP and Motor Performance and Diagnostics (WF12), Real-Time Surveillance (WF18).
 *
 * @name ESP Alarms (Agent)
 */
export type EspAlarmsAgent = {
  /** Alarm category (ESP). */
  alarmCategory: Maybe<Scalars['String']['output']>;
  /** Reference to AlarmDefinition node. */
  alarmCode: Maybe<Scalars['JSONObject']['output']>;
  /** Alarm code identifier (WF12-001, WF12-002, etc.). */
  alarmCodeExternalId: Maybe<Scalars['String']['output']>;
  /** Count of how many times this alarm has occurred. */
  alarmCounter: Maybe<Scalars['Int']['output']>;
  /** Alarm criticality level. Pre-filtered to 2 and 3. */
  alarmCriticality: Maybe<Scalars['String']['output']>;
  /** Alarm validity flag. Pre-filtered to 'Valid'. */
  alarmFlags: Maybe<Scalars['String']['output']>;
  /** Human-readable alarm name from AlarmDefinition. */
  alarmName: Maybe<Scalars['String']['output']>;
  /** Alarm priority level. Pre-filtered to Medium and High. */
  alarmPriority: Maybe<Scalars['String']['output']>;
  /** Detailed alarm message with specific conditions that triggered it. */
  customWorkflowAlarmMessage: Maybe<Scalars['String']['output']>;
  /** When the alarm was cleared. Null means alarm is still active. */
  endDateTime: Maybe<Scalars['Timestamp']['output']>;
  /** External ID of the entity for joining to other views. */
  entityExternalId: Scalars['String']['output'];
  /** Display name of the entity (well, string) with the alarm. */
  entityName: Scalars['String']['output'];
  /** Type of entity (string, well, field). */
  entityType: Scalars['String']['output'];
  /** When the alarm was triggered. */
  startDateTime: Scalars['Timestamp']['output'];
  /** Alarm sub-category for domain filtering. */
  subCategory: Maybe<Scalars['String']['output']>;
  /** Sub-workflow that generated the alarm. */
  subWorkflowName: Maybe<Scalars['String']['output']>;
  /** Associated troubleshooting ticket ID if one was created. */
  ticketId: Maybe<Scalars['String']['output']>;
  wellString: Maybe<StringAsset>;
  /** Workflow code (WF12 for ESP). */
  workflowCode: Maybe<Scalars['String']['output']>;
  /** Workflow name from AlarmDefinition. */
  workflowName: Maybe<Scalars['String']['output']>;
};

/** View 'ESPCable' in the iPSO production optimization solution data model. */
export type EspCable = {
  /** Text attribute 'cableType' for this 'ESPCable' row. */
  cableType: Maybe<Scalars['String']['output']>;
  /** Text attribute 'description' for this 'ESPCable' row. */
  description: Maybe<Scalars['String']['output']>;
  /** Numeric value 'maxCurrentAllowed' (floating point) for this 'ESPCable' row. */
  maxCurrentAllowed: Maybe<Scalars['Float']['output']>;
  /** Numeric value 'prosperIndex' (integer) for this 'ESPCable' row. */
  prosperIndex: Maybe<Scalars['Int64']['output']>;
  /** Numeric value 'voltageDropCoefficient' (floating point) for this 'ESPCable' row. */
  voltageDropCoefficient: Maybe<Scalars['Float']['output']>;
};

/**
 * Model-calculated ESP performance outputs per well string (WF12).
 *
 * Motor efficiency and load, pump head, average pump rate, calculation status.
 * Use with ESPMeasurements_String_Agent and ESPLimits_String_Agent for full ESP diagnostics.
 *
 * Use for: ESP and Motor Performance and Diagnostics (WF12).
 *
 * @name ESP Calculations - Well String (Agent)
 */
export type EspCalculationsStringAgent = {
  /** Status of ESP rate calculation. Values: SUCCESS, FAILED, NO_DATA. Check before using ESP-derived outputs. */
  espqlAnalysisStatus: Maybe<TimeSeries>;
  /**
   * ESP motor efficiency (%, TS). Ratio of hydraulic power output to electrical
   * power input. Declining trend may indicate motor degradation.
   */
  motorEfficiency: Maybe<TimeSeries>;
  /**
   * ESP motor load (%, TS). Current electrical load as percentage of rated
   * capacity. High values indicate operating near limits.
   */
  motorLoad: Maybe<TimeSeries>;
  /** Average pump rate (stb/d, TS) over the calculation period. */
  pumpAvgRate: Maybe<TimeSeries>;
  /**
   * ESP pump head (ft, TS). Pressure increase provided by the pump. Compare
   * to pump curve to assess operating point and efficiency.
   */
  pumpHead: Maybe<TimeSeries>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString: Maybe<StringAsset>;
};

/**
 * JSON plot/curve file references per well string from WF12.
 *
 * Contains file pointers to specialised JSON curve outputs generated during
 * ESP and motor performance diagnostics (WF12). Covers the gradient plot
 * (pressure vs depth) produced by the ESP model run. All files are JSON and
 * cannot be represented as scalar timeseries values.
 *
 * Use with ESPMeasurements_String_Agent and ESPCalculations_String_Agent for
 * full WF12 ESP diagnostics including live sensor data and calculated outputs.
 *
 * Use for: ESP and Motor Performance and Diagnostics (WF12).
 *
 * @name ESP Curve Data - String (Agent)
 */
export type EspCurveDataStringAgent = {
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString: Maybe<StringAsset>;
};

/**
 * ESP operating limit thresholds per well string (WF12).
 *
 * Engineering limits: motor temp/current/power, pump delta-T, fluid rates,
 * intake/discharge pressures, head, free gas tolerance, monitoring flags.
 * Compare against ESPMeasurements_String_Agent for limit exceedances. For gas lift use GasLiftLimits_String_Agent.
 *
 * Use for: ESP and Motor Performance and Diagnostics (WF12).
 *
 * @name ESP Operating Limits - Well String (Agent)
 */
export type EspLimitsStringAgent = {
  /** Asphaltene deposition risk flag or score for this well string. */
  asphalteneRisk: Maybe<Scalars['Boolean']['output']>;
  /** Maximum discharge pressure limit (psia, TS). Exceeding may cause mechanical overload. */
  espMaxDischargePressure: Maybe<TimeSeries>;
  /**
   * Maximum fluid rate pump can handle (stb/d, TS). Above this, pump
   * experiences upthrust and shaft wear.
   */
  espMaxFluidRate: Maybe<TimeSeries>;
  /**
   * Maximum free gas the pump can tolerate (%, TS). High gas causes gas
   * locking and damage — use gas separator if exceeded.
   */
  espMaxFreeGasInPump: Maybe<TimeSeries>;
  /** Maximum head the pump can develop (ft, TS). Exceeding causes mechanical overload. */
  espMaxHead: Maybe<TimeSeries>;
  /**
   * Maximum allowable motor current (amps, TS). When pumpCurrent exceeds this,
   * motor is overloaded — indicates undersized pump or high head conditions.
   */
  espMaxMotorAmps: Maybe<TimeSeries>;
  /** Boolean flag — espMaxMotorAmps limit is actively monitored for alarms. */
  espMaxMotorAmps_active: Maybe<TimeSeries>;
  /** Maximum motor power limit (HP or kW, TS). Used to size VSD and cables. */
  espMaxMotorPwr: Maybe<TimeSeries>;
  /**
   * Maximum allowable motor temperature (°F, TS). When pumpMotorTemp exceeds
   * this, motor damage risk is high. Critical alarm threshold.
   */
  espMaxMotorTemp: Maybe<TimeSeries>;
  /** Boolean flag — espMaxMotorTemp limit is actively monitored for alarms. */
  espMaxMotorTemp_active: Maybe<TimeSeries>;
  /**
   * Maximum temperature rise across pump (°F, TS). High delta-T indicates low
   * flow — motor not adequately cooled by fluid.
   */
  espMaxPumpDeltaTemp: Maybe<TimeSeries>;
  /**
   * Minimum fluid rate for stable operation (stb/d, TS). Below this, pump may
   * experience downthrust and motor overheating.
   */
  espMinFluidRate: Maybe<TimeSeries>;
  /**
   * Minimum intake pressure limit (psia, TS). Below this, gas breakout causes
   * cavitation and pump damage. Critical operating limit.
   */
  espMinIntakePressure: Maybe<TimeSeries>;
  /** Boolean flag — espMinIntakePressure limit is actively monitored for alarms. */
  espMinIntakePressure_active: Maybe<TimeSeries>;
  /** Fluid velocity limit or reference value (ft/s, TS). Used for erosion and flow assurance checks. */
  fluidVelocity: Maybe<Scalars['Boolean']['output']>;
  /** Hydrate formation risk flag or score for this well string. */
  hydrateRisk: Maybe<Scalars['Boolean']['output']>;
  /** Maximum GOR limit (scf/stb, TS). High GOR may indicate gas breakthrough or lift issues. */
  maxGOR: Maybe<TimeSeries>;
  /** Maximum liquid rate limit (stb/d, TS). Facility or well capacity constraint. */
  maxLiquidRate: Maybe<TimeSeries>;
  /** Maximum oil rate limit (stb/d, TS). Allocation or facility constraint. */
  maxOilRate: Maybe<TimeSeries>;
  /** PE5 flow stability criteria threshold for this well string. */
  pe5StabilityCriteria: Maybe<Scalars['Boolean']['output']>;
  /** Wax deposition risk flag or score for this well string. */
  waxRisk: Maybe<Scalars['Boolean']['output']>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString: Maybe<StringAsset>;
};

/**
 * Real-time ESP sensor readings per well string (WF12).
 *
 * Live measurements: pump frequency, intake/discharge pressures and temperatures,
 * motor current, voltage, vibration, downhole BHP/BHT. Use to monitor pump health
 * and compare against ESPLimits_String_Agent. For calculated outputs see ESPCalculations_String_Agent.
 *
 * Use for: ESP and Motor Performance and Diagnostics (WF12).
 *
 * @name ESP Measurements - Well String (Agent)
 */
export type EspMeasurementsStringAgent = {
  /** Annulus pressure (psia, TS). Difference from casingHeadPress can indicate tubing leaks. */
  annulusPress: Maybe<TimeSeries>;
  /**
   * Bottom-hole flowing pressure (psia, TS). Used to calculate drawdown and
   * compare to reservoir pressure for productivity analysis.
   */
  bottomHolePress: Maybe<TimeSeries>;
  /** Bottom-hole temperature (°F, TS). Important for PVT and pump performance calculations. */
  bottomHoleTemp: Maybe<TimeSeries>;
  /** Casing head pressure (psia, TS). Surface annulus pressure; useful for well integrity and flow context. */
  casingHeadPress: Maybe<TimeSeries>;
  /** Production choke opening (% or 64ths, TS). Affects backpressure on well and ESP discharge. */
  chokeOpening: Maybe<TimeSeries>;
  /** Choke size (64ths or mm, TS). With wellhead pressure defines backpressure and rate. */
  chokeSize: Maybe<TimeSeries>;
  /** Flowline pressure (psia, TS). Downstream backpressure on ESP; high value can indicate restriction or manifold pressure. */
  flowLinePress: Maybe<TimeSeries>;
  /** Flowline temperature (°F, TS). Surface fluid temp; compare to wellHeadTemp for heat loss. */
  flowLineTemp: Maybe<TimeSeries>;
  /** Artificial lift type (TS). Confirm value = ESP before querying ESP-specific diagnostics. */
  liftType: Maybe<TimeSeries>;
  /**
   * Motor current draw (amps, TS). Indicates motor loading. Compare to
   * espMaxMotorAmps limit — overload causes overheating and potential failure.
   */
  pumpCurrent: Maybe<TimeSeries>;
  /**
   * Pressure at pump discharge (psia, TS). Differential with intake shows pump
   * head. Compare to espMaxDischargePressure limit.
   */
  pumpDischargePress: Maybe<TimeSeries>;
  /**
   * Temperature at pump discharge (°F, TS). High delta-T (discharge - intake)
   * may indicate low flow. Compare to espMaxPumpDeltaTemp.
   */
  pumpDischargeTemp: Maybe<TimeSeries>;
  /**
   * ESP pump operating frequency (Hz, TS). Controlled by VSD. Compare to design
   * frequency for speed-related diagnostics.
   */
  pumpFrequency: Maybe<TimeSeries>;
  /**
   * Pressure at pump intake (psia, TS). Low intake pressure may indicate gas
   * interference or upthrust condition. Compare to espMinIntakePressure limit.
   */
  pumpIntakePress: Maybe<TimeSeries>;
  /** Temperature at pump intake (°F, TS). Fluid cools the motor — low temp with high motor temp indicates poor cooling. */
  pumpIntakeTemp: Maybe<TimeSeries>;
  /**
   * ESP motor winding temperature (°F, TS). CRITICAL for motor protection.
   * Compare to espMaxMotorTemp limit — exceeding causes insulation damage.
   */
  pumpMotorTemp: Maybe<TimeSeries>;
  /**
   * Vibration sensor reading (TS). High vibration indicates mechanical issues:
   * worn bearings, shaft misalignment, or gas slugging through pump.
   */
  pumpVibration: Maybe<TimeSeries>;
  /** Surface voltage supplied to ESP (volts, TS). Low voltage causes high current and overheating. */
  pumpVoltage: Maybe<TimeSeries>;
  /** Flowing wellhead pressure (psia, TS). Tubing head pressure; compare with intake/discharge for pump head. */
  wellHeadPress: Maybe<TimeSeries>;
  /** Flowing wellhead temperature (°F, TS). Surface fluid temp; useful for flow assurance and pump cooling context. */
  wellHeadTemp: Maybe<TimeSeries>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString: Maybe<StringAsset>;
};

/** View 'ESPMotor' in the iPSO production optimization solution data model. */
export type EspMotor = {
  /** Numeric value 'current' (floating point) for this 'ESPMotor' row. */
  current: Maybe<Scalars['Float']['output']>;
  /** Text attribute 'description' for this 'ESPMotor' row. */
  description: Maybe<Scalars['String']['output']>;
  /** Text attribute 'manufacturer' for this 'ESPMotor' row. */
  manufacturer: Maybe<Scalars['String']['output']>;
  /** Text attribute 'motorSeries' for this 'ESPMotor' row. */
  motorSeries: Maybe<Scalars['String']['output']>;
  /** Numeric value 'power' (floating point) for this 'ESPMotor' row. */
  power: Maybe<Scalars['Float']['output']>;
  /** Numeric value 'prosperIndex' (integer) for this 'ESPMotor' row. */
  prosperIndex: Maybe<Scalars['Int64']['output']>;
  /** Numeric value 'voltage' (floating point) for this 'ESPMotor' row. */
  voltage: Maybe<Scalars['Float']['output']>;
};

/** View 'ESPPump' in the iPSO production optimization solution data model. */
export type EspPump = {
  /** Text attribute 'description' for this 'ESPPump' row. */
  description: Maybe<Scalars['String']['output']>;
  /** Numeric value 'frequency' (floating point) for this 'ESPPump' row. */
  frequency: Maybe<Scalars['Float']['output']>;
  /** Text attribute 'manufacturer' for this 'ESPPump' row. */
  manufacturer: Maybe<Scalars['String']['output']>;
  /** Numeric value 'maximumRate' (floating point) for this 'ESPPump' row. */
  maximumRate: Maybe<Scalars['Float']['output']>;
  /** Numeric value 'minimumRate' (floating point) for this 'ESPPump' row. */
  minimumRate: Maybe<Scalars['Float']['output']>;
  /** Text attribute 'name' for this 'ESPPump' row. */
  name: Maybe<Scalars['String']['output']>;
  /** Numeric value 'prosperIndex' (integer) for this 'ESPPump' row. */
  prosperIndex: Maybe<Scalars['Int64']['output']>;
  /** Numeric value 'pumpSize' (floating point) for this 'ESPPump' row. */
  pumpSize: Maybe<Scalars['Float']['output']>;
  /** Numeric value 'stages' (integer) for this 'ESPPump' row. */
  stages: Maybe<Scalars['Int']['output']>;
};

/** View 'ESP_Pump_Details' in the iPSO production optimization solution data model. */
export type EspPumpDetails = {
  /** Numeric value 'adcoInstallation' (floating point) for this 'ESP_Pump_Details' row. */
  adcoInstallation: Maybe<Scalars['Float32']['output']>;
  /** Text attribute 'aghMatl' for this 'ESP_Pump_Details' row. */
  aghMatl: Maybe<Scalars['String']['output']>;
  /** Text attribute 'aghModel' for this 'ESP_Pump_Details' row. */
  aghModel: Maybe<Scalars['String']['output']>;
  /** Text attribute 'agh_nORu' for this 'ESP_Pump_Details' row. */
  agh_nORu: Maybe<Scalars['String']['output']>;
  /** Text attribute 'bohMatl' for this 'ESP_Pump_Details' row. */
  bohMatl: Maybe<Scalars['String']['output']>;
  /** Numeric value 'bohSeries' (floating point) for this 'ESP_Pump_Details' row. */
  bohSeries: Maybe<Scalars['Float32']['output']>;
  /** Text attribute 'bohThd' for this 'ESP_Pump_Details' row. */
  bohThd: Maybe<Scalars['String']['output']>;
  /** Numeric value 'cableSize' (floating point) for this 'ESP_Pump_Details' row. */
  cableSize: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'cableTotalLength' (floating point) for this 'ESP_Pump_Details' row. */
  cableTotalLength: Maybe<Scalars['Float32']['output']>;
  /** Text attribute 'cableType' for this 'ESP_Pump_Details' row. */
  cableType: Maybe<Scalars['String']['output']>;
  /** Text attribute 'cable_nORu' for this 'ESP_Pump_Details' row. */
  cable_nORu: Maybe<Scalars['String']['output']>;
  /** Text attribute 'comments' for this 'ESP_Pump_Details' row. */
  comments: Maybe<Scalars['String']['output']>;
  /** Timestamp 'commissionDate' associated with this 'ESP_Pump_Details' row. */
  commissionDate: Maybe<Scalars['Timestamp']['output']>;
  /** Reference to the related 'String_asset' entity for this 'ESP_Pump_Details' row. */
  entityName: Maybe<StringAsset>;
  /** Text attribute 'espComponent' for this 'ESP_Pump_Details' row. */
  espComponent: Maybe<Scalars['String']['output']>;
  /** Numeric value 'espSensorDepth_MD_ft' (floating point) for this 'ESP_Pump_Details' row. */
  espSensorDepth_MD_ft: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'espSensorDepth_TVD_ft' (floating point) for this 'ESP_Pump_Details' row. */
  espSensorDepth_TVD_ft: Maybe<Scalars['Float32']['output']>;
  /** Reference to the related 'Field' entity for this 'ESP_Pump_Details' row. */
  field: Maybe<Field>;
  /** Text attribute 'intakeVgsaMatl' for this 'ESP_Pump_Details' row. */
  intakeVgsaMatl: Maybe<Scalars['String']['output']>;
  /** Text attribute 'intakeVgsaModel' for this 'ESP_Pump_Details' row. */
  intakeVgsaModel: Maybe<Scalars['String']['output']>;
  /** Numeric value 'intakeVgsaSeries' (floating point) for this 'ESP_Pump_Details' row. */
  intakeVgsaSeries: Maybe<Scalars['Float32']['output']>;
  /** Text attribute 'intakeVgsa_nORu' for this 'ESP_Pump_Details' row. */
  intakeVgsa_nORu: Maybe<Scalars['String']['output']>;
  /** Numeric value 'mle' (floating point) for this 'ESP_Pump_Details' row. */
  mle: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'mleSeries' (floating point) for this 'ESP_Pump_Details' row. */
  mleSeries: Maybe<Scalars['Float32']['output']>;
  /** Text attribute 'mleType' for this 'ESP_Pump_Details' row. */
  mleType: Maybe<Scalars['String']['output']>;
  /** Text attribute 'monitorType' for this 'ESP_Pump_Details' row. */
  monitorType: Maybe<Scalars['String']['output']>;
  /** Text attribute 'monitor_nORu' for this 'ESP_Pump_Details' row. */
  monitor_nORu: Maybe<Scalars['String']['output']>;
  /** Numeric value 'motorA' (floating point) for this 'ESP_Pump_Details' row. */
  motorA: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'motorHsg' (floating point) for this 'ESP_Pump_Details' row. */
  motorHsg: Maybe<Scalars['Float32']['output']>;
  /** Text attribute 'motorMatl' for this 'ESP_Pump_Details' row. */
  motorMatl: Maybe<Scalars['String']['output']>;
  /** Numeric value 'motorRefW' (floating point) for this 'ESP_Pump_Details' row. */
  motorRefW: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'motorSeries' (floating point) for this 'ESP_Pump_Details' row. */
  motorSeries: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'motorTotalPower' (floating point) for this 'ESP_Pump_Details' row. */
  motorTotalPower: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'motorTotalV' (floating point) for this 'ESP_Pump_Details' row. */
  motorTotalV: Maybe<Scalars['Float32']['output']>;
  /** Text attribute 'motor_nORu' for this 'ESP_Pump_Details' row. */
  motor_nORu: Maybe<Scalars['String']['output']>;
  /** Text attribute 'nORu' for this 'ESP_Pump_Details' row. */
  nORu: Maybe<Scalars['String']['output']>;
  /** Numeric value 'numberOfPoles' (integer) for this 'ESP_Pump_Details' row. */
  numberOfPoles: Maybe<Scalars['Int']['output']>;
  /** Text attribute 'packer' for this 'ESP_Pump_Details' row. */
  packer: Maybe<Scalars['String']['output']>;
  /** Numeric value 'panelVsdA' (floating point) for this 'ESP_Pump_Details' row. */
  panelVsdA: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'panelVsdKVA' (floating point) for this 'ESP_Pump_Details' row. */
  panelVsdKVA: Maybe<Scalars['Float32']['output']>;
  /** Text attribute 'panelVsdType' for this 'ESP_Pump_Details' row. */
  panelVsdType: Maybe<Scalars['String']['output']>;
  /** Text attribute 'protectorMatl' for this 'ESP_Pump_Details' row. */
  protectorMatl: Maybe<Scalars['String']['output']>;
  /** Text attribute 'protectorModel' for this 'ESP_Pump_Details' row. */
  protectorModel: Maybe<Scalars['String']['output']>;
  /** Numeric value 'protectorSeries' (floating point) for this 'ESP_Pump_Details' row. */
  protectorSeries: Maybe<Scalars['Float32']['output']>;
  /** Text attribute 'protector_nORu' for this 'ESP_Pump_Details' row. */
  protector_nORu: Maybe<Scalars['String']['output']>;
  /** Timestamp 'pullDate' associated with this 'ESP_Pump_Details' row. */
  pullDate: Maybe<Scalars['Timestamp']['output']>;
  /** Text attribute 'pullReason' for this 'ESP_Pump_Details' row. */
  pullReason: Maybe<Scalars['String']['output']>;
  /** Text attribute 'pumpAr' for this 'ESP_Pump_Details' row. */
  pumpAr: Maybe<Scalars['String']['output']>;
  /** Numeric value 'pumpHsg' (floating point) for this 'ESP_Pump_Details' row. */
  pumpHsg: Maybe<Scalars['Float32']['output']>;
  /** Text attribute 'pumpMatl' for this 'ESP_Pump_Details' row. */
  pumpMatl: Maybe<Scalars['String']['output']>;
  /** Text attribute 'pumpModel' for this 'ESP_Pump_Details' row. */
  pumpModel: Maybe<Scalars['String']['output']>;
  /** Numeric value 'pumpSeries' (floating point) for this 'ESP_Pump_Details' row. */
  pumpSeries: Maybe<Scalars['Float32']['output']>;
  /** Text attribute 'pump_nORu' for this 'ESP_Pump_Details' row. */
  pump_nORu: Maybe<Scalars['String']['output']>;
  /** Text attribute 'rootCause' for this 'ESP_Pump_Details' row. */
  rootCause: Maybe<Scalars['String']['output']>;
  /** Timestamp 'runDate' associated with this 'ESP_Pump_Details' row. */
  runDate: Maybe<Scalars['Timestamp']['output']>;
  /** Text attribute 'status' for this 'ESP_Pump_Details' row. */
  status: Maybe<Scalars['String']['output']>;
  /** Timestamp 'stopORfailureDate' associated with this 'ESP_Pump_Details' row. */
  stopORfailureDate: Maybe<Scalars['Timestamp']['output']>;
  /** Text attribute 'supplyCompany' for this 'ESP_Pump_Details' row. */
  supplyCompany: Maybe<Scalars['String']['output']>;
  /** Numeric value 'tol_MD' (floating point) for this 'ESP_Pump_Details' row. */
  tol_MD: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'tol_TVD' (floating point) for this 'ESP_Pump_Details' row. */
  tol_TVD: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'topReservoirDepth_MD' (floating point) for this 'ESP_Pump_Details' row. */
  topReservoirDepth_MD: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'topReservoirDepth_TVD' (floating point) for this 'ESP_Pump_Details' row. */
  topReservoirDepth_TVD: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'totalStages' (floating point) for this 'ESP_Pump_Details' row. */
  totalStages: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'transformerA' (floating point) for this 'ESP_Pump_Details' row. */
  transformerA: Maybe<Scalars['Float32']['output']>;
  /** Text attribute 'transformerComments' for this 'ESP_Pump_Details' row. */
  transformerComments: Maybe<Scalars['String']['output']>;
  /** Numeric value 'transformerKVA' (floating point) for this 'ESP_Pump_Details' row. */
  transformerKVA: Maybe<Scalars['Float32']['output']>;
  /** Text attribute 'transformerTapSetting' for this 'ESP_Pump_Details' row. */
  transformerTapSetting: Maybe<Scalars['String']['output']>;
  /** Numeric value 'transformerVoltageRatio' (floating point) for this 'ESP_Pump_Details' row. */
  transformerVoltageRatio: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'wellInstallationNumber' (floating point) for this 'ESP_Pump_Details' row. */
  wellInstallationNumber: Maybe<Scalars['Float32']['output']>;
  /** Text attribute 'yTool' for this 'ESP_Pump_Details' row. */
  yTool: Maybe<Scalars['String']['output']>;
};

export type Entity = {
  endDateTime: Maybe<Scalars['Timestamp']['output']>;
  entityType: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  startDateTime: Maybe<Scalars['Timestamp']['output']>;
};

/**
 * Base entity registry — companies, assets, fields, reservoirs, sectors,
 * locations, wells, and strings — scoped to in-scope instance spaces.
 *
 * Single catalogue of every logical entity in the iPSO model with its display
 * name, type, and effective date range. Underpins the hierarchy and per-entity
 * views; sourced from the central entity repository. Excludes operational or
 * measurement data.
 *
 * @name Entity (Agent Scoped)
 */
export type EntityAgent = {
  /** Timestamp at which the entity was deactivated. */
  endDateTime: Maybe<Scalars['Timestamp']['output']>;
  /** Type of entity. Values are company, asset, field, reservoir, sector, location, well, string. */
  entityType: Maybe<Scalars['String']['output']>;
  /** Display name of the entity. */
  name: Maybe<Scalars['String']['output']>;
  /** Timestamp at which the entity became active. */
  startDateTime: Maybe<Scalars['Timestamp']['output']>;
};

/**
 * All estimated rates and BHP per well string across every estimation method.
 *
 * For simple rate lookups use PriorityRates_String_Agent. Use this view when
 * comparing estimation methods. Exposes priority, system analysis (IPR+VLP),
 * choke, IPR-only, VLP-only, performance curve, and data-driven/ML. For
 * performance scores and analysis status see RateDiagnostics_String_Agent.
 *
 * Use for: comparing estimation methods (WF10).
 *
 * @name Estimated Rates - Well String (Agent)
 */
export type EstimatedRatesStringAgent = {
  /** Flowing bottom-hole pressure from choke analysis (psi, TS). */
  chokeAnalysisFbhp: Maybe<TimeSeries>;
  /** Gas rate from choke equation analysis (MSCF/d, TS). */
  chokeAnalysisGasRateStd: Maybe<TimeSeries>;
  /** Total liquid rate from choke equation analysis, oil + water (stb/d, TS). */
  chokeAnalysisLiquidRateStd: Maybe<TimeSeries>;
  /** Oil rate from choke equation analysis (stb/d, TS). */
  chokeAnalysisOilRateStd: Maybe<TimeSeries>;
  /** Choke analysis calculation status. Values: SUCCESS, FAILED, CRITICAL_FLOW, SUBCRITICAL_FLOW. */
  chokeAnalysisStatus: Maybe<TimeSeries>;
  /** Water rate from choke equation analysis (stb/d, TS). */
  chokeAnalysisWaterRateStd: Maybe<TimeSeries>;
  /** Flowing BHP from performance curve analysis (psi, TS). */
  curveAnalysisFbhp: Maybe<TimeSeries>;
  /** Gas rate from performance curve analysis (MSCF/d, TS). */
  curveAnalysisGasRateStd: Maybe<TimeSeries>;
  /** Total liquid rate from performance curve lookup (stb/d, TS). */
  curveAnalysisLiquidRateStd: Maybe<TimeSeries>;
  /** Oil rate from performance curve lookup (stb/d, TS). */
  curveAnalysisOilRateStd: Maybe<TimeSeries>;
  /** Water rate from performance curve analysis (stb/d, TS). */
  curveAnalysisWaterRateStd: Maybe<TimeSeries>;
  /** Flowing BHP from data-driven analysis / ML models (psi, TS). */
  dataAnalysisFbhp: Maybe<TimeSeries>;
  /** Gas rate from data-driven analysis / ML models (MSCF/d, TS). */
  dataAnalysisGasRateStd: Maybe<TimeSeries>;
  /** Total liquid rate from data-driven analysis / ML models (stb/d, TS). */
  dataAnalysisLiquidRateStd: Maybe<TimeSeries>;
  /** Oil rate from data-driven analysis / ML models (stb/d, TS). */
  dataAnalysisOilRateStd: Maybe<TimeSeries>;
  /** Water rate from data-driven analysis / ML models (stb/d, TS). */
  dataAnalysisWaterRateStd: Maybe<TimeSeries>;
  /** Flowing BHP used for IPR curve lookup (psi, TS). */
  iprAnalysisFbhp: Maybe<TimeSeries>;
  /** Gas rate from IPR curve analysis (MSCF/d, TS). */
  iprAnalysisGasRateStd: Maybe<TimeSeries>;
  /** Total liquid rate from IPR curve. Represents reservoir deliverability potential (stb/d, TS). */
  iprAnalysisLiquidRateStd: Maybe<TimeSeries>;
  /** Oil rate from IPR curve at current reservoir/flowing conditions (stb/d, TS). */
  iprAnalysisOilRateStd: Maybe<TimeSeries>;
  /** Water rate from IPR curve analysis (stb/d, TS). */
  iprAnalysisWaterRateStd: Maybe<TimeSeries>;
  /** Source of the BHP value. Values: MEASURED (downhole gauge), CALCULATED (from WHP traverse), ESTIMATED (correlation). */
  pressureSource: Maybe<TimeSeries>;
  /** Best-available flowing bottom-hole pressure from the priority method (psi, TS). */
  priorityFbhp: Maybe<TimeSeries>;
  /** Best-available estimated gas rate from the priority analysis method (MSCF/d, TS). */
  priorityGasRateStd: Maybe<TimeSeries>;
  /** Best-available estimated total liquid rate, oil + water (stb/d, TS). */
  priorityLiquidRateStd: Maybe<TimeSeries>;
  /** Analysis method that produced the priority rates. Values: SYSTEM_ANALYSIS, CHOKE_ANALYSIS, ALLOCATION, WELL_TEST, DATA_ANALYSIS. */
  priorityMethod: Maybe<TimeSeries>;
  /** Best-available estimated oil rate from the priority analysis method (stb/d, TS). */
  priorityOilRateStd: Maybe<TimeSeries>;
  /** Best-available estimated water rate from the priority analysis method (stb/d, TS). */
  priorityWaterRateStd: Maybe<TimeSeries>;
  /** Current reservoir pressure at datum depth (psi, TS). */
  reservoirPressureDatum: Maybe<TimeSeries>;
  /** Reservoir pressure corrected to mid-perforation depth. Used directly in IPR calculations (psi, TS). */
  reservoirPressureMidPerforation: Maybe<TimeSeries>;
  /** Flowing bottom-hole pressure from system analysis (psi, TS). */
  systemAnalysisFbhp: Maybe<TimeSeries>;
  /** Gas rate from IPR/VLP system analysis (MSCF/d, TS). */
  systemAnalysisGasRateStd: Maybe<TimeSeries>;
  /** Total liquid rate from IPR/VLP system analysis, oil + water (stb/d, TS). */
  systemAnalysisLiquidRateStd: Maybe<TimeSeries>;
  /** Oil rate from IPR/VLP system analysis (stb/d, TS). */
  systemAnalysisOilRateStd: Maybe<TimeSeries>;
  /** System analysis calculation status. Values: SUCCESS, FAILED, NO_INTERSECTION, INVALID_INPUT. */
  systemAnalysisStatus: Maybe<TimeSeries>;
  /** Water rate from IPR/VLP system analysis (stb/d, TS). */
  systemAnalysisWaterRateStd: Maybe<TimeSeries>;
  /** Flowing BHP from VLP curve at current rate and WHP (psi, TS). */
  vlpAnalysisFbhp: Maybe<TimeSeries>;
  /** Gas rate from VLP curve analysis (MSCF/d, TS). */
  vlpAnalysisGasRateStd: Maybe<TimeSeries>;
  /** Total liquid rate from VLP curve. Represents tubing hydraulic capacity (stb/d, TS). */
  vlpAnalysisLiquidRateStd: Maybe<TimeSeries>;
  /** Oil rate from VLP curve at current tubing/separator conditions (stb/d, TS). */
  vlpAnalysisOilRateStd: Maybe<TimeSeries>;
  /** Water rate from VLP curve analysis (stb/d, TS). */
  vlpAnalysisWaterRateStd: Maybe<TimeSeries>;
  /** Well string identifier. */
  wellString: Maybe<StringAsset>;
};

/** View 'Events_String' in the iPSO production optimization solution data model. */
export type EventsString = {
  /** Reference to a time series for 'bottomholePressure' in this 'Events_String' view. */
  bottomholePressure: Maybe<TimeSeries>;
  /** Reference to a time series for 'bottomholeTemperature' in this 'Events_String' view. */
  bottomholeTemperature: Maybe<TimeSeries>;
  /** Reference to a time series for 'casingPressure' in this 'Events_String' view. */
  casingPressure: Maybe<TimeSeries>;
  /** Reference to a time series for 'chokeSize' in this 'Events_String' view. */
  chokeSize: Maybe<TimeSeries>;
  /** Reference to a time series for 'chokeSizePct' in this 'Events_String' view. */
  chokeSizePct: Maybe<TimeSeries>;
  /** Reference to a time series for 'currentStatus' in this 'Events_String' view. */
  currentStatus: Maybe<TimeSeries>;
  /** Reference to a time series for 'downType' in this 'Events_String' view. */
  downType: Maybe<TimeSeries>;
  /** Reference to the related 'String_asset' entity for this 'Events_String' row. */
  entityName: Maybe<StringAsset>;
  /** Reference to a time series for 'eventDesc' in this 'Events_String' view. */
  eventDesc: Maybe<TimeSeries>;
  /** Reference to a time series for 'eventReason' in this 'Events_String' view. */
  eventReason: Maybe<TimeSeries>;
  /** Reference to a time series for 'eventStartDateTime' in this 'Events_String' view. */
  eventStartDateTime: Maybe<TimeSeries>;
  /** Reference to a time series for 'gasInjRate' in this 'Events_String' view. */
  gasInjRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'gasRate' in this 'Events_String' view. */
  gasRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'gor' in this 'Events_String' view. */
  gor: Maybe<TimeSeries>;
  /** Reference to a time series for 'oilRate' in this 'Events_String' view. */
  oilRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'producingMethod' in this 'Events_String' view. */
  producingMethod: Maybe<TimeSeries>;
  /** Reference to a time series for 'producingMethodDesc' in this 'Events_String' view. */
  producingMethodDesc: Maybe<TimeSeries>;
  /** Reference to a time series for 'producingStatus' in this 'Events_String' view. */
  producingStatus: Maybe<TimeSeries>;
  /** Reference to a time series for 'producingStatusDesc' in this 'Events_String' view. */
  producingStatusDesc: Maybe<TimeSeries>;
  /** Reference to a time series for 'remarks' in this 'Events_String' view. */
  remarks: Maybe<TimeSeries>;
  /** Reference to a time series for 'statusCode' in this 'Events_String' view. */
  statusCode: Maybe<TimeSeries>;
  /** Reference to a time series for 'stringFunction' in this 'Events_String' view. */
  stringFunction: Maybe<TimeSeries>;
  /** Reference to a time series for 'waterCut' in this 'Events_String' view. */
  waterCut: Maybe<TimeSeries>;
  /** Reference to a time series for 'waterInjRate' in this 'Events_String' view. */
  waterInjRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellheadPressure' in this 'Events_String' view. */
  wellheadPressure: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellheadTemperature' in this 'Events_String' view. */
  wellheadTemperature: Maybe<TimeSeries>;
};

/** Typed view over 'Entity' showing fields only (where 'entityType' = 'field'). Use this view to identify a field by name, then navigate to its wells or strings through the 'FlatHierarchy' and 'SectorHierarchy' navigation views. */
export type Field = {
  /** Timestamp 'endDateTime' associated with this 'Field' row. */
  endDateTime: Maybe<Scalars['Timestamp']['output']>;
  /** Text attribute 'entityType' for this 'Field' row. */
  entityType: Maybe<Scalars['String']['output']>;
  /** Name of the field. To retrieve all wells in a field, find the field here and filter 'FlatHierarchy' on this field while reading the 'well' property. */
  name: Maybe<Scalars['String']['output']>;
  /** Timestamp 'startDateTime' associated with this 'Field' row. */
  startDateTime: Maybe<Scalars['Timestamp']['output']>;
};

/** View 'FieldFormation' in the iPSO production optimization solution data model. */
export type FieldFormation = {
  /** Numeric value 'datumDepth' (floating point) for this 'FieldFormation' row. */
  datumDepth: Maybe<Scalars['Float32']['output']>;
  /** Reference to the related 'Field' entity for this 'FieldFormation' row. */
  field: Maybe<Field>;
  /** Numeric value 'gasGradient' (floating point) for this 'FieldFormation' row. */
  gasGradient: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'gasOilContact' (floating point) for this 'FieldFormation' row. */
  gasOilContact: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'gaswaterContact' (floating point) for this 'FieldFormation' row. */
  gaswaterContact: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'oilGradient' (floating point) for this 'FieldFormation' row. */
  oilGradient: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'oilWaterContact' (floating point) for this 'FieldFormation' row. */
  oilWaterContact: Maybe<Scalars['Float32']['output']>;
  /** Reference to the related 'Reservoir' entity for this 'FieldFormation' row. */
  reservoir: Maybe<Reservoir>;
  /** Text attribute 'reservoirType' for this 'FieldFormation' row. */
  reservoirType: Maybe<Scalars['String']['output']>;
  /** Numeric value 'rw' (floating point) for this 'FieldFormation' row. */
  rw: Maybe<Scalars['Float32']['output']>;
  /** Timestamp 'startDateTime' associated with this 'FieldFormation' row. */
  startDateTime: Maybe<Scalars['Timestamp']['output']>;
  /** Timestamp 'stopDateTime' associated with this 'FieldFormation' row. */
  stopDateTime: Maybe<Scalars['Timestamp']['output']>;
  /** Numeric value 'waterGradient' (floating point) for this 'FieldFormation' row. */
  waterGradient: Maybe<Scalars['Float32']['output']>;
};

/** View 'FieldInputs' in the iPSO production optimization solution data model. */
export type FieldInputs = {
  /** Reference to a time series for 'actualGasInjection' in this 'FieldInputs' view. */
  actualGasInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'actualGasInjectionRate' in this 'FieldInputs' view. */
  actualGasInjectionRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'actualGasProduction' in this 'FieldInputs' view. */
  actualGasProduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'actualGasProductionRate' in this 'FieldInputs' view. */
  actualGasProductionRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'actualOilProduction' in this 'FieldInputs' view. */
  actualOilProduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'actualOilProductionRate' in this 'FieldInputs' view. */
  actualOilProductionRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'actualWaterInjection' in this 'FieldInputs' view. */
  actualWaterInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'actualWaterInjectionRate' in this 'FieldInputs' view. */
  actualWaterInjectionRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'actualWaterProduction' in this 'FieldInputs' view. */
  actualWaterProduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'actualWaterProductionRate' in this 'FieldInputs' view. */
  actualWaterProductionRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'ambientTemperature' in this 'FieldInputs' view. */
  ambientTemperature: Maybe<TimeSeries>;
  /** Reference to a time series for 'associatedGasProduction' in this 'FieldInputs' view. */
  associatedGasProduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'associatedGasProductionRate' in this 'FieldInputs' view. */
  associatedGasProductionRate: Maybe<TimeSeries>;
  /** Reference to the related 'Field' entity for this 'FieldInputs' row. */
  entityName: Maybe<Field>;
  /** Reference to a time series for 'nonASRGasInjection' in this 'FieldInputs' view. */
  nonASRGasInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'nonASRGasInjectionRate' in this 'FieldInputs' view. */
  nonASRGasInjectionRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'nonAssociatedGasProduction' in this 'FieldInputs' view. */
  nonAssociatedGasProduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'nonAssociatedGasProductionRate' in this 'FieldInputs' view. */
  nonAssociatedGasProductionRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'potentialGasInjection' in this 'FieldInputs' view. */
  potentialGasInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'potentialGasProduction' in this 'FieldInputs' view. */
  potentialGasProduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'potentialOilProduction' in this 'FieldInputs' view. */
  potentialOilProduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'potentialWaterInjection' in this 'FieldInputs' view. */
  potentialWaterInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'potentialWaterProduction' in this 'FieldInputs' view. */
  potentialWaterProduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'realTimeTotalOilProduction' in this 'FieldInputs' view. */
  realTimeTotalOilProduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'targetGasInjection' in this 'FieldInputs' view. */
  targetGasInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'targetGasProduction' in this 'FieldInputs' view. */
  targetGasProduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'targetOilProduction' in this 'FieldInputs' view. */
  targetOilProduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'targetWaterInjection' in this 'FieldInputs' view. */
  targetWaterInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'targetWaterProduction' in this 'FieldInputs' view. */
  targetWaterProduction: Maybe<TimeSeries>;
};

/**
 * Field-level input conditions for GAP network runs (WF7/WF8).
 *
 * Measured and target oil/water/gas production rates and facility constraints
 * (separator pressures, temperatures) used as inputs to the GAP simulation per
 * field. Use to understand what the model assumed for a field on a given run
 * and to diagnose input-driven discrepancies. Excludes simulation outputs (see
 * FieldOutputs_Agent and NetworkOutputs_Field_Agent) and historical trends.
 *
 * Use for: Network Surveillance (WF7), Network Model Validation (WF8).
 *
 * @name Field Inputs (Agent)
 */
export type FieldInputsAgent = {
  /** Actual gas injection volume (TS). */
  actualGasInjection: Maybe<TimeSeries>;
  /** Actual gas injection rate (TS). */
  actualGasInjectionRate: Maybe<TimeSeries>;
  /** Actual gas production volume (TS). */
  actualGasProduction: Maybe<TimeSeries>;
  /** Actual gas production rate (TS). */
  actualGasProductionRate: Maybe<TimeSeries>;
  /** Actual oil production volume for this field (TS). */
  actualOilProduction: Maybe<TimeSeries>;
  /** Actual oil production rate (TS). */
  actualOilProductionRate: Maybe<TimeSeries>;
  /** Actual water injection volume (TS). */
  actualWaterInjection: Maybe<TimeSeries>;
  /** Actual water injection rate (TS). */
  actualWaterInjectionRate: Maybe<TimeSeries>;
  /** Actual water production volume (TS). */
  actualWaterProduction: Maybe<TimeSeries>;
  /** Actual water production rate (TS). */
  actualWaterProductionRate: Maybe<TimeSeries>;
  /** Ambient temperature at field location (TS). */
  ambientTemperature: Maybe<TimeSeries>;
  /** Associated gas production volume (TS). Gas produced with oil. */
  associatedGasProduction: Maybe<TimeSeries>;
  /** Associated gas production rate (TS). */
  associatedGasProductionRate: Maybe<TimeSeries>;
  /** Reference to field. Join to FlatHierarchy_Agent for reservoir/sector context. */
  fieldEntity: Maybe<Field>;
  /** Non-associated gas injection volume (TS). */
  nonASRGasInjection: Maybe<TimeSeries>;
  /** Non-associated gas injection rate (TS). */
  nonASRGasInjectionRate: Maybe<TimeSeries>;
  /** Non-associated gas production volume (TS). Gas from gas cap or gas reservoir. */
  nonAssociatedGasProduction: Maybe<TimeSeries>;
  /** Non-associated gas production rate (TS). */
  nonAssociatedGasProductionRate: Maybe<TimeSeries>;
  /** Unconstrained gas injection potential (TS). */
  potentialGasInjection: Maybe<TimeSeries>;
  /** Unconstrained gas production potential (TS). */
  potentialGasProduction: Maybe<TimeSeries>;
  /** Unconstrained oil production potential (TS). Maximum achievable without system limits. */
  potentialOilProduction: Maybe<TimeSeries>;
  /** Unconstrained water injection potential (TS). */
  potentialWaterInjection: Maybe<TimeSeries>;
  /** Unconstrained water production potential (TS). */
  potentialWaterProduction: Maybe<TimeSeries>;
  /** Target gas injection volume (TS). */
  targetGasInjection: Maybe<TimeSeries>;
  /** Target gas production volume (TS). */
  targetGasProduction: Maybe<TimeSeries>;
  /** Target oil production volume for this field (TS). */
  targetOilProduction: Maybe<TimeSeries>;
  /** Target water injection volume (TS). */
  targetWaterInjection: Maybe<TimeSeries>;
  /** Target water production volume (TS). */
  targetWaterProduction: Maybe<TimeSeries>;
};

/** Aggregated field-level outputs including counts of active and inactive wells by lift type and service (producers, gas injectors, water injectors, WAG wells) used for monitoring field performance and optimization decisions. */
export type FieldOutputs = {
  /** Name of the field for which aggregated well status and performance outputs are reported in this view. */
  entityName: Maybe<Field>;
  /** Time series of the number of active gas injector wells (GI) in the field. */
  wellsActiveGi: Maybe<TimeSeries>;
  /** Time series of the number of active producer wells flowing to gas plant (GP) or similar grouping while on natural flow (NF) in the field. */
  wellsActiveGpNf: Maybe<TimeSeries>;
  /** Time series of the number of active producer wells on ESP (electric submersible pump) lift in the field. */
  wellsActiveOpEsp: Maybe<TimeSeries>;
  /** Time series of the number of active producer wells on gas lift (GL) in the field. */
  wellsActiveOpGl: Maybe<TimeSeries>;
  /** Time series of the number of active producer wells on natural flow (NF) in the field. */
  wellsActiveOpNf: Maybe<TimeSeries>;
  /** Time series of the number of active WAG (water-alternating-gas) wells in the field. */
  wellsActiveWAG: Maybe<TimeSeries>;
  /** Time series of the number of active water injector wells (WI) in the field. */
  wellsActiveWi: Maybe<TimeSeries>;
  /** Time series of the number of inactive gas injector wells (GI) in the field. */
  wellsInActiveGi: Maybe<TimeSeries>;
  /** Time series of the number of inactive producer wells flowing to gas plant (GP) or similar grouping while on natural flow (NF) in the field. */
  wellsInActiveGpNf: Maybe<TimeSeries>;
  /** Time series of the number of inactive producer wells on ESP lift in the field. */
  wellsInActiveOpEsp: Maybe<TimeSeries>;
  /** Time series of the number of inactive producer wells on gas lift (GL) in the field. */
  wellsInActiveOpGl: Maybe<TimeSeries>;
  /** Time series of the number of inactive producer wells on natural flow (NF) in the field. */
  wellsInActiveOpNf: Maybe<TimeSeries>;
  /** Time series of the number of inactive water injector wells (WI) in the field. */
  wellsInActiveWi: Maybe<TimeSeries>;
  /** Time series of the number of inactive WAG (water-alternating-gas) wells in the field. */
  wellsInactiveWAG: Maybe<TimeSeries>;
};

/**
 * Field-level calculated outputs from WF7 GAP network model (WF7).
 *
 * Total oil/gas/water rates, GOR, water cut, and active/inactive well counts
 * per field derived from the GAP simulation. Use for field-level performance,
 * resource utilization, and efficiency questions. For scenario and optimization
 * field outputs see NetworkOutputs_Field_Agent. Excludes historical trends and wellbore
 * details.
 *
 * Use for: Network Surveillance (WF7).
 *
 * @name Field Outputs (Agent)
 */
export type FieldOutputsAgent = {
  /** Reference to field. Join to FlatHierarchy_Agent for reservoir/sector context. */
  fieldEntity: Maybe<Field>;
  /** Count of active gas injectors (TS). */
  wellsActiveGi: Maybe<TimeSeries>;
  /** Count of active gas producers on natural flow (TS). */
  wellsActiveGpNf: Maybe<TimeSeries>;
  /** Count of active oil producers on ESP lift (TS). */
  wellsActiveOpEsp: Maybe<TimeSeries>;
  /** Count of active oil producers on gas lift (TS). */
  wellsActiveOpGl: Maybe<TimeSeries>;
  /** Count of active oil producers on natural flow (TS). */
  wellsActiveOpNf: Maybe<TimeSeries>;
  /** Count of active WAG (Water Alternating Gas) injectors (TS). */
  wellsActiveWAG: Maybe<TimeSeries>;
  /** Count of active water injectors (TS). */
  wellsActiveWi: Maybe<TimeSeries>;
  /** Count of inactive gas injectors (TS). */
  wellsInActiveGi: Maybe<TimeSeries>;
  /** Count of inactive gas producers on natural flow (TS). */
  wellsInActiveGpNf: Maybe<TimeSeries>;
  /** Count of inactive oil producers on ESP lift (TS). */
  wellsInActiveOpEsp: Maybe<TimeSeries>;
  /** Count of inactive oil producers on gas lift (TS). */
  wellsInActiveOpGl: Maybe<TimeSeries>;
  /** Count of inactive oil producers on natural flow (TS). */
  wellsInActiveOpNf: Maybe<TimeSeries>;
  /** Count of inactive water injectors (TS). */
  wellsInActiveWi: Maybe<TimeSeries>;
  /** Count of inactive WAG (Water Alternating Gas) injectors (TS). */
  wellsInactiveWAG: Maybe<TimeSeries>;
};

/**
 * DENORMALIZED HIERARCHY LOOKUP TABLE - Primary view for navigating the asset hierarchy.
 *
 * STRUCTURE: Each row = one String (completion) with all its parent entities pre-joined.
 * Hierarchy: Company â†’ Asset â†’ Field â†’ Reservoir/Location â†’ Well â†’ String
 *
 * WHY USE THIS: Avoids complex multi-hop joins. Query ANY hierarchy relationship in a single step.
 *
 * QUERY PATTERNS:
 * - Find wells in a field: Filter field.name = 'X', select well
 * - Find strings in a reservoir: Filter reservoir.name = 'Y', select string
 * - Find fields in an asset: Filter asset.name = 'A', select DISTINCT field
 * - Find parent of any entity: Filter on child, select parent property
 *
 * KEY BEHAVIORS:
 * - One row per string means parent entities repeat (use DISTINCT for unique parents)
 * - References return full entity objects - access .name, .externalId, etc.
 * - Use startDateTime/endDateTime for historical hierarchy lookups
 */
export type FlatHierarchy = {
  /** Operating concession or business unit. Groups multiple fields. Filter here to scope queries to a specific asset. */
  asset: Maybe<Asset>;
  /** Top-level parent entity (e.g., ADNOC ONSHORE, ADNOC OFFSHORE). Access company.name for the company name. */
  company: Maybe<Company>;
  /** When this hierarchy relationship ended. NULL = currently active. For current hierarchy only, filter where endDateTime is null. */
  endDateTime: Maybe<Scalars['Timestamp']['output']>;
  /** Oil/gas field containing the well. Common filter target for field-level queries. Each field contains multiple wells and reservoirs. */
  field: Maybe<Field>;
  /** Surface infrastructure where the well connects (platform, manifold, drilling island, or onshore facility). Filter here to find all wells at a specific location. */
  location: Maybe<Location>;
  /** Subsurface reservoir formation the string produces from. Multiple strings can target the same reservoir. Filter here to analyze reservoir-level production. */
  reservoir: Maybe<Reservoir>;
  /** When this hierarchy relationship became effective. Used for temporal queries when hierarchy changes over time (e.g., well transferred between fields). */
  startDateTime: Maybe<Scalars['Timestamp']['output']>;
  /** Completion/producing interval within the well. The LEAF ENTITY of this view - each row represents exactly one string. This is the entity that has production data (oil, gas, water rates). Use string.name for string identifier. */
  string: Maybe<StringAsset>;
  /** Physical wellbore containing this string. A well may have multiple strings (completions). Use well.name for well identifier. Filter here to find all strings in a specific well. */
  well: Maybe<Well>;
};

/**
 * Flattened company → asset → field → reservoir → location → well → string
 * hierarchy, scoped to in-scope assets.
 *
 * One row per string with its full ancestry across the production hierarchy
 * and the effective date range of that relationship. Sourced from the base
 * FlatHierarchy and refined via the in_scope_asset_node_refs configuration.
 * Excludes operational or measurement data.
 *
 * @name FlatHierarchy (Agent Scoped)
 */
export type FlatHierarchyAgent = {
  /** Operating concession or business unit. */
  asset: Maybe<Asset>;
  /** Top-level parent entity, e.g. ADNOC ONSHORE, ADNOC OFFSHORE. */
  company: Maybe<Company>;
  /** Timestamp at which this hierarchy relationship ended. */
  endDateTime: Maybe<Scalars['Timestamp']['output']>;
  /** Oil or gas field containing the well. */
  field: Maybe<Field>;
  /** Surface infrastructure where the well connects, such as cluster, platform, manifold, drilling island, or onshore facility. */
  location: Maybe<Location>;
  /** Subsurface reservoir formation the string produces from. */
  reservoir: Maybe<Reservoir>;
  /** Timestamp at which this hierarchy relationship became effective. */
  startDateTime: Maybe<Scalars['Timestamp']['output']>;
  /** Completion or producing interval within the well. Leaf entity of this view; one row per string. */
  string: Maybe<StringAsset>;
  /** Physical wellbore. A well may contain multiple strings. */
  well: Maybe<Well>;
};

/**
 * Flow assurance detection and mitigation alarms with medium or high priority.
 *
 * Contains flow assurance alarms, medium or high priority, sourced from
 * operational monitoring systems within petroleum production environments.
 * Answers questions on the frequency, duration, and types of alarms triggered,
 * to assess mitigation and prioritize responses. Excludes low-priority or non-WF20 alarms.
 *
 * Use for: Flow Assurance Detection and Mitigation (WF20), Real-Time Surveillance (WF18).
 *
 * @name Flow Assurance Alarms (Agent)
 */
export type FlowAssuranceAlarmsAgent = {
  alarmCategory: Maybe<Scalars['String']['output']>;
  alarmCode: Maybe<Scalars['JSONObject']['output']>;
  alarmCodeExternalId: Maybe<Scalars['String']['output']>;
  alarmCriticality: Maybe<Scalars['String']['output']>;
  alarmFlags: Maybe<Scalars['String']['output']>;
  alarmName: Maybe<Scalars['String']['output']>;
  alarmPriority: Maybe<Scalars['String']['output']>;
  customWorkflowAlarmMessage: Maybe<Scalars['String']['output']>;
  endDateTime: Maybe<Scalars['Timestamp']['output']>;
  entityExternalId: Scalars['String']['output'];
  entityName: Scalars['String']['output'];
  entityType: Scalars['String']['output'];
  startDateTime: Scalars['Timestamp']['output'];
  subCategory: Maybe<Scalars['String']['output']>;
  subWorkflowName: Maybe<Scalars['String']['output']>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString: Maybe<StringAsset>;
  workflowCode: Maybe<Scalars['String']['output']>;
  workflowName: Maybe<Scalars['String']['output']>;
};

/**
 * Flowline-level outputs from GAP network simulation (WF20).
 *
 * Pressure drops, flow rates, erosion/corrosion metrics per flowline. Use for
 * flowline performance, constraints, and failure points. Excludes historical or real-time time-series.
 *
 * Use for: Flow Assurance Detection and Mitigation (WF20).
 *
 * @name Flowline Outputs - Network (Agent)
 */
export type FlowlineOutputsNetworkAgent = {
  /** Connected manifold for gas injection path. */
  connectedManifoldIdGI: Maybe<TimeSeries>;
  /** Connected manifold for water injection path. */
  connectedManifoldIdWI: Maybe<TimeSeries>;
  /** Flowline entity name. */
  entityName: Maybe<Scalars['JSONObject']['output']>;
  /** Estimated pressure drop across flowline (TS). */
  estimatedFlowlineDeltaP: Maybe<TimeSeries>;
  /** Reference to parent network model. */
  network: Maybe<Network>;
  /** Above erosion velocity threshold (0/1, TS). */
  nmvAboveErosionVelocity: Maybe<TimeSeries>;
  /** Asphaltene deposition risk (0/1, TS). */
  nmvAsphalteneFlag: Maybe<TimeSeries>;
  /** Flowline identified as production bottleneck (0/1, TS). */
  nmvBottleneckFlag: Maybe<TimeSeries>;
  /** C-factor for inflow performance (TS). */
  nmvCFactor: Maybe<TimeSeries>;
  /** Condensate-gas ratio (TS). */
  nmvCgr: Maybe<TimeSeries>;
  /** ID of connected production manifold/junction. */
  nmvConnectedManifoldId: Maybe<TimeSeries>;
  /** Differential pressure across flowline (TS). */
  nmvDp: Maybe<TimeSeries>;
  /** Erosion velocity ratio (TS). >1 = exceeds erosion limit. */
  nmvErosionVelocity: Maybe<TimeSeries>;
  /** Erosional velocity limit flag (0/1, TS). */
  nmvErosionalVelocityFlag: Maybe<TimeSeries>;
  /** Simulated flowline outlet pressure (TS). */
  nmvFlowlinePressure: Maybe<TimeSeries>;
  /** Gas flow rate through flowline (TS). */
  nmvGasRate: Maybe<TimeSeries>;
  /** Gas-liquid ratio (TS). */
  nmvGlr: Maybe<TimeSeries>;
  /** Gas-oil ratio (TS). */
  nmvGor: Maybe<TimeSeries>;
  /** Hydrate formation risk (0/1, TS). */
  nmvHydrateFlag: Maybe<TimeSeries>;
  /** Gas injection flow rate through flowline (TS). */
  nmvInjectionGasRate: Maybe<TimeSeries>;
  /** Water injection flow rate through flowline (TS). */
  nmvInjectionWaterRate: Maybe<TimeSeries>;
  /** Total liquid flow rate through flowline (TS). */
  nmvLiquidRate: Maybe<TimeSeries>;
  /** Measured flowline pressure for comparison to simulated (TS). */
  nmvMeasuredFlowlinePressure: Maybe<TimeSeries>;
  /** Mixture velocity in flowline (TS). */
  nmvMixtureVelocity: Maybe<TimeSeries>;
  /** Oil flow rate through flowline (TS). */
  nmvOilRate: Maybe<TimeSeries>;
  /** PE5 flow stability indicator (0/1, TS). 1 = stable. */
  nmvPe5StabilityFlag: Maybe<TimeSeries>;
  /** Pressure at flowline node (TS). */
  nmvPressure: Maybe<TimeSeries>;
  /** Pressure match quality (0-1, TS). 1 = perfect match between simulated and measured. */
  nmvPressureMatchIndex: Maybe<TimeSeries>;
  /** Flowline-specific pressure match quality (0-1, TS). */
  nmvPressureMatchIndexFLP: Maybe<TimeSeries>;
  /** Scale formation risk (0/1, TS). */
  nmvScaleFlag: Maybe<TimeSeries>;
  /** Temperature at flowline node (TS). */
  nmvTemperature: Maybe<TimeSeries>;
  /** Unstable flow detected (0/1, TS). */
  nmvUnstableFlag: Maybe<TimeSeries>;
  /** Operating outside defined constraints (0/1, TS). */
  nmvViolatingConstraintsFlag: Maybe<TimeSeries>;
  /** Water cut fraction (TS). */
  nmvWaterCut: Maybe<TimeSeries>;
  /** Water flow rate through flowline (TS). */
  nmvWaterRate: Maybe<TimeSeries>;
  /** Wax deposition risk (0/1, TS). */
  nmvWaxFlag: Maybe<TimeSeries>;
  /** Water-gas ratio (TS). */
  nmvWgr: Maybe<TimeSeries>;
  /** Flowline entity name. */
  pipelineEntity: Maybe<Entity>;
};

/** View 'FluidComposition' in the iPSO production optimization solution data model. */
export type FluidComposition = {
  /** Reference to a time series for 'c1' in this 'FluidComposition' view. */
  c1: Maybe<TimeSeries>;
  /** Reference to a time series for 'c2' in this 'FluidComposition' view. */
  c2: Maybe<TimeSeries>;
  /** Reference to a time series for 'c3' in this 'FluidComposition' view. */
  c3: Maybe<TimeSeries>;
  /** Reference to a time series for 'c6' in this 'FluidComposition' view. */
  c6: Maybe<TimeSeries>;
  /** Reference to a time series for 'c7c14' in this 'FluidComposition' view. */
  c7c14: Maybe<TimeSeries>;
  /** Reference to a time series for 'c15c25' in this 'FluidComposition' view. */
  c15c25: Maybe<TimeSeries>;
  /** Reference to a time series for 'c26c80' in this 'FluidComposition' view. */
  c26c80: Maybe<TimeSeries>;
  /** Reference to a time series for 'cgr' in this 'FluidComposition' view. */
  cgr: Maybe<TimeSeries>;
  /** Reference to a time series for 'co2' in this 'FluidComposition' view. */
  co2: Maybe<TimeSeries>;
  /** Reference to a time series for 'condensateGravity' in this 'FluidComposition' view. */
  condensateGravity: Maybe<TimeSeries>;
  /** Reference to the related 'Field' entity for this 'FluidComposition' row. */
  entityName: Maybe<Field>;
  /** Reference to a time series for 'h2s' in this 'FluidComposition' view. */
  h2s: Maybe<TimeSeries>;
  /** Reference to a time series for 'iC4' in this 'FluidComposition' view. */
  iC4: Maybe<TimeSeries>;
  /** Reference to a time series for 'iC5' in this 'FluidComposition' view. */
  iC5: Maybe<TimeSeries>;
  /** Reference to a time series for 'n2' in this 'FluidComposition' view. */
  n2: Maybe<TimeSeries>;
  /** Reference to a time series for 'nC4' in this 'FluidComposition' view. */
  nC4: Maybe<TimeSeries>;
  /** Reference to a time series for 'nC5' in this 'FluidComposition' view. */
  nC5: Maybe<TimeSeries>;
  /** Reference to a time series for 'specificGasGravity' in this 'FluidComposition' view. */
  specificGasGravity: Maybe<TimeSeries>;
  /** Reference to a time series for 'waterSalinity' in this 'FluidComposition' view. */
  waterSalinity: Maybe<TimeSeries>;
  /** Reference to a time series for 'wgr' in this 'FluidComposition' view. */
  wgr: Maybe<TimeSeries>;
};

/** View 'Formation_Volume_Factor' in the iPSO production optimization solution data model. */
export type FormationVolumeFactor = {
  /** Numeric value 'bCO2' (floating point) for this 'Formation_Volume_Factor' row. */
  bCO2: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'bGas' (floating point) for this 'Formation_Volume_Factor' row. */
  bGas: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'bGasInjector' (floating point) for this 'Formation_Volume_Factor' row. */
  bGasInjector: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'bOil' (floating point) for this 'Formation_Volume_Factor' row. */
  bOil: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'bWater' (floating point) for this 'Formation_Volume_Factor' row. */
  bWater: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'bWaterInjector' (floating point) for this 'Formation_Volume_Factor' row. */
  bWaterInjector: Maybe<Scalars['Float32']['output']>;
  /** Timestamp 'effectiveDate' associated with this 'Formation_Volume_Factor' row. */
  effectiveDate: Maybe<Scalars['Timestamp']['output']>;
  /** Reference to the related 'String_asset' entity for this 'Formation_Volume_Factor' row. */
  entityName: Maybe<StringAsset>;
  /** Numeric value 'pb' (floating point) for this 'Formation_Volume_Factor' row. */
  pb: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'pressure' (floating point) for this 'Formation_Volume_Factor' row. */
  pressure: Maybe<Scalars['Float32']['output']>;
  /** Reference to the related 'Reservoir' entity for this 'Formation_Volume_Factor' row. */
  reservoir: Maybe<Reservoir>;
  /** Numeric value 'rs' (floating point) for this 'Formation_Volume_Factor' row. */
  rs: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'temperature' (floating point) for this 'Formation_Volume_Factor' row. */
  temperature: Maybe<Scalars['Float32']['output']>;
};

/** View 'GL_Valve_Data' in the iPSO production optimization solution data model. */
export type GlValveData = {
  /** Numeric value 'domePressure' (floating point) for this 'GL_Valve_Data' row. */
  domePressure: Maybe<Scalars['Float32']['output']>;
  /** Reference to the related 'String_asset' entity for this 'GL_Valve_Data' row. */
  entityName: Maybe<StringAsset>;
  /** Reference to the related 'Field' entity for this 'GL_Valve_Data' row. */
  field: Maybe<Field>;
  /** Numeric value 'gasLiftMandrel' (integer) for this 'GL_Valve_Data' row. */
  gasLiftMandrel: Maybe<Scalars['Int']['output']>;
  /** Numeric value 'glPortSize' (integer) for this 'GL_Valve_Data' row. */
  glPortSize: Maybe<Scalars['Int']['output']>;
  /** Text attribute 'glValveMaterial' for this 'GL_Valve_Data' row. */
  glValveMaterial: Maybe<Scalars['String']['output']>;
  /** Text attribute 'glValveOrificeSeries' for this 'GL_Valve_Data' row. */
  glValveOrificeSeries: Maybe<Scalars['String']['output']>;
  /** Numeric value 'glValveSize' (floating point) for this 'GL_Valve_Data' row. */
  glValveSize: Maybe<Scalars['Float32']['output']>;
  /** Timestamp 'installationDate' associated with this 'GL_Valve_Data' row. */
  installationDate: Maybe<Scalars['Timestamp']['output']>;
  /** Numeric value 'measuredDepth' (floating point) for this 'GL_Valve_Data' row. */
  measuredDepth: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'rValue' (floating point) for this 'GL_Valve_Data' row. */
  rValue: Maybe<Scalars['Float']['output']>;
  /** Numeric value 'testRackOpeningPressure' (floating point) for this 'GL_Valve_Data' row. */
  testRackOpeningPressure: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'trueVerticalDepth' (floating point) for this 'GL_Valve_Data' row. */
  trueVerticalDepth: Maybe<Scalars['Float32']['output']>;
  /** Text attribute 'type' for this 'GL_Valve_Data' row. */
  type: Maybe<Scalars['String']['output']>;
};

/**
 * Gas lift troubleshooting and diagnostic alarms with medium or high priority.
 *
 * Contains diagnostic alarms, gas lift operations, focusing on those with medium
 * or high priority. Sourced from operational monitoring systems that track alarm
 * events, to analyze alarm occurrences and their implications on gas lift
 * performance. It answers analytical questions such as the frequency of high-
 * priority alarms and troubleshooting effectiveness. Excludes low-priority or non-WF14 alarms.
 *
 * Use for: Gas Lift Troubleshooting and Diagnostics (WF14), Real-Time Surveillance (WF18).
 *
 * @name Gas Lift Diagnostic Alarms (Agent)
 */
export type GasLiftAlarmsAgent = {
  alarmCategory: Maybe<Scalars['String']['output']>;
  alarmCode: Maybe<Scalars['JSONObject']['output']>;
  alarmCodeExternalId: Maybe<Scalars['String']['output']>;
  /** Number of consecutive occurrences of this alarm. */
  alarmCounter: Maybe<Scalars['Int']['output']>;
  alarmCriticality: Maybe<Scalars['String']['output']>;
  alarmFlags: Maybe<Scalars['String']['output']>;
  alarmName: Maybe<Scalars['String']['output']>;
  alarmPriority: Maybe<Scalars['String']['output']>;
  customWorkflowAlarmMessage: Maybe<Scalars['String']['output']>;
  endDateTime: Maybe<Scalars['Timestamp']['output']>;
  entityExternalId: Scalars['String']['output'];
  entityName: Scalars['String']['output'];
  entityType: Scalars['String']['output'];
  startDateTime: Scalars['Timestamp']['output'];
  /** Alarm sub-category for domain filtering. */
  subCategory: Maybe<Scalars['String']['output']>;
  /** Sub-workflow that generated the alarm. */
  subWorkflowName: Maybe<Scalars['String']['output']>;
  /** Associated ticket/action ID if alarm has been acknowledged. */
  ticketId: Maybe<Scalars['String']['output']>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString: Maybe<StringAsset>;
  workflowCode: Maybe<Scalars['String']['output']>;
  workflowName: Maybe<Scalars['String']['output']>;
};

/**
 * Model-calculated gas lift outputs per well string (WF14).
 *
 * GLIR variants (measured, network, choke, allocated, priority), GL analysis status,
 * choke parameters. Use glirSelected for best-available GLIR. Use with GasLiftMeasurements_String_Agent and GasLiftLimits_String_Agent.
 *
 * Use for: Gas Lift Troubleshooting and Diagnostics (WF14).
 *
 * @name Gas Lift Calculations - Well String (Agent)
 */
export type GasLiftCalculationsStringAgent = {
  /**
   * Calculated GL choke discharge coefficient (Cd, TS). Deviations from
   * typical values may indicate erosion or plugging.
   */
  glChokeCdCalc: Maybe<TimeSeries>;
  /**
   * Calculated GL choke size required to achieve current GLIR given upstream
   * pressure conditions (64ths inch, TS).
   */
  glChokeSizeCalc: Maybe<TimeSeries>;
  /** Allocated gas lift injection rate from daily allocation (MSCF/d, TS). */
  glirAllocated: Maybe<TimeSeries>;
  /** Gas lift injection rate calculated from GL choke equation (MSCF/d, TS). */
  glirChokeEquation: Maybe<TimeSeries>;
  /** Measured gas lift injection rate from flow meter (MSCF/d, TS). */
  glirMeasured: Maybe<TimeSeries>;
  /** Gas lift injection rate from network simulation model (MSCF/d, TS). */
  glirNetworkSimulation: Maybe<TimeSeries>;
  /**
   * Selected/priority gas lift injection rate (MSCF/d, TS). The most reliable
   * GLIR value — use for optimization and surveillance.
   */
  glirSelected: Maybe<TimeSeries>;
  /** Source of selected GLIR. Values: MEASURED, NETWORK_SIMULATION, CHOKE_EQUATION, ALLOCATED. */
  glirSelectedType: Maybe<TimeSeries>;
  /** Status of gas lift rate calculation. Values: SUCCESS, FAILED, NO_DATA. */
  glqlAnalysisStatus: Maybe<TimeSeries>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString: Maybe<StringAsset>;
};

/**
 * Gas lift operating limit thresholds per well string (WF14).
 *
 * Engineering limits: casing/wellhead pressures, manifold pressure, BHP target,
 * temperature, rate limits (liquid, oil, GOR), monitoring flags. Compare against GasLiftMeasurements_String_Agent for exceedances. For ESP use ESPLimits_String_Agent.
 *
 * Use for: Gas Lift Troubleshooting and Diagnostics (WF14).
 *
 * @name Gas Lift Operating Limits - Well String (Agent)
 */
export type GasLiftLimitsStringAgent = {
  /** Asphaltene deposition risk flag or score for this well string. */
  asphalteneRisk: Maybe<Scalars['Boolean']['output']>;
  /** Fluid velocity limit or reference value (ft/s, TS). Used for erosion and flow assurance checks. */
  fluidVelocity: Maybe<Scalars['Boolean']['output']>;
  /** Maximum allowable casing head pressure (psia, TS). Exceeding may damage casing or cause valve malfunction. */
  glMaxCasingHeadPressure: Maybe<TimeSeries>;
  /** Boolean flag — glMaxCasingHeadPressure limit is actively monitored for alarms. */
  glMaxCasingHeadPressure_active: Maybe<TimeSeries>;
  /** Maximum temperature drop across gas lift choke (°F, TS). Excessive cooling may cause hydrate formation. */
  glMaxLiftChokeDeltaTemp: Maybe<TimeSeries>;
  /** Maximum manifold pressure limit (psia, TS). High manifold pressure reduces available lift gas differential. */
  glMaxManifoldPressure: Maybe<TimeSeries>;
  /** Maximum wellhead temperature limit (°F, TS). */
  glMaxWellHeadTemp: Maybe<TimeSeries>;
  /** Minimum bottomhole pressure target (psia, TS). Gas lift should achieve this BHP for optimal production. */
  glMinBHP: Maybe<TimeSeries>;
  /** Minimum casing head pressure for stable injection (psia, TS). Below this, may not reach operating valve depth. */
  glMinCasingHeadPressure: Maybe<TimeSeries>;
  /** Boolean flag — glMinCasingHeadPressure limit is actively monitored for alarms. */
  glMinCasingHeadPressure_active: Maybe<TimeSeries>;
  /** Minimum manifold pressure limit (psia, TS). Below this may cause unstable flow. */
  glMinManifolddPressure: Maybe<TimeSeries>;
  /** Minimum wellhead pressure for stable flow (psia, TS). Below may cause heading. */
  glMinWellHeadPressure: Maybe<TimeSeries>;
  /** Hydrate formation risk flag or score for this well string. */
  hydrateRisk: Maybe<Scalars['Boolean']['output']>;
  /** Maximum GOR limit (scf/stb, TS). High GOR may indicate gas breakthrough or lift issues. */
  maxGOR: Maybe<TimeSeries>;
  /** Maximum liquid rate limit (stb/d, TS). Facility or well capacity constraint. */
  maxLiquidRate: Maybe<TimeSeries>;
  /** Maximum oil rate limit (stb/d, TS). Allocation or facility constraint. */
  maxOilRate: Maybe<TimeSeries>;
  /** Maximum wellhead pressure limit (psia, TS). Equipment rating limit. */
  maxWellHeadPressure: Maybe<TimeSeries>;
  /** PE5 flow stability criteria threshold for this well string. */
  pe5StabilityCriteria: Maybe<Scalars['Boolean']['output']>;
  /** Wax deposition risk flag or score for this well string. */
  waxRisk: Maybe<Scalars['Boolean']['output']>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString: Maybe<StringAsset>;
};

/**
 * Real-time gas lift sensor readings per well string (WF14).
 *
 * Live measurements: injection rate, CV inlet pressure/temperature, CV size,
 * casing/wellhead pressures and temperatures, annulus pressure, choke settings,
 * downhole BHP/BHT. Compare against GasLiftLimits_String_Agent. For calculated outputs see GasLiftCalculations_String_Agent.
 *
 * Use for: Gas Lift Troubleshooting and Diagnostics (WF14).
 *
 * @name Gas Lift Measurements - Well String (Agent)
 */
export type GasLiftMeasurementsStringAgent = {
  /** Annulus pressure (psia, TS). Difference from casingHeadPress can indicate tubing leaks. */
  annulusPress: Maybe<TimeSeries>;
  /** Bottom-hole flowing pressure (psia, TS). Compare to glMinBHP target for GL efficiency. */
  bottomHolePress: Maybe<TimeSeries>;
  /** Bottom-hole temperature (°F, TS). Important for PVT calculations. */
  bottomHoleTemp: Maybe<TimeSeries>;
  /**
   * Casing head pressure (psia, TS). Critical for gas lift operation — affects
   * injection depth and valve opening. Oscillations indicate instability/multipointing.
   */
  casingHeadPress: Maybe<TimeSeries>;
  /** Production choke opening (% or 64ths, TS). Affects backpressure on well. */
  chokeOpening: Maybe<TimeSeries>;
  /** Surface choke size setting (TS). Used for choke performance calculations. */
  chokeSize: Maybe<TimeSeries>;
  /** Downstream flowline pressure (psia, TS). High flowline pressure reduces well deliverability. */
  flowLinePress: Maybe<TimeSeries>;
  /** Flowline temperature (°F, TS). Used for hydrate risk assessment. */
  flowLineTemp: Maybe<TimeSeries>;
  /**
   * Inlet pressure at the gas lift flow control valve (psia, TS). Used to
   * calculate injection differential and optimize gas allocation.
   */
  gasLiftFlowCVInletPress: Maybe<TimeSeries>;
  /** Effective orifice/trim size of the gas lift flow control valve (TS). */
  gasLiftFlowCVSize: Maybe<TimeSeries>;
  /**
   * Current gas lift injection rate (Mscf/d, TS). Compare to design rate and
   * limits. Higher than expected may indicate multipointing.
   */
  gasLiftInjRate: Maybe<TimeSeries>;
  /** Gas lift injection temperature (°F, TS). Important for hydrate risk assessment. */
  gasLiftInjTemp: Maybe<TimeSeries>;
  /** Artificial lift type (TS). Confirm value = GAS_LIFT before querying GL-specific diagnostics. */
  liftType: Maybe<TimeSeries>;
  /** Flowing wellhead pressure (psia, TS). Combined with casing pressure indicates lift efficiency. */
  wellHeadPress: Maybe<TimeSeries>;
  /** Flowing wellhead temperature (°F, TS). Temperature differential helps diagnose flow issues. */
  wellHeadTemp: Maybe<TimeSeries>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString: Maybe<StringAsset>;
};

/**
 * Long-term well string inactivity with reasons and downtime start dates (WF25/WF18).
 *
 * Strings classified INACTIVE (extended/indefinite offline). Distinct from
 * WellStatus_String_Agent (real-time flowing/shut-in). Use for inactive well
 * aging, downtime impact, workover candidate screening, well availability.
 *
 * Use for: Well Status Detection (WF25), Real-Time Surveillance (WF18).
 */
export type InactiveStringAgent = {
  /**
   * Date when the string became inactive. Used to calculate downtime duration
   * and track inactive well aging.
   */
  downtimeStartDate: Maybe<TimeSeries>;
  /**
   * Category of inactivity explaining why the string is inactive, e.g.,
   * 'MECHANICAL_FAILURE', 'AWAITING_WORKOVER', 'LOW_PRODUCTIVITY', 'ABANDONED'.
   */
  inactiveCategory: Maybe<TimeSeries>;
  /**
   * Activity status of the string: 'ACTIVE' or 'INACTIVE'. Active strings are
   * available for production/injection. Inactive strings are temporarily or
   * permanently offline (awaiting workover, abandoned, etc.).
   */
  stringStatus: Maybe<TimeSeries>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString: Maybe<StringAsset>;
};

/** View 'Inactive_String' in the iPSO production optimization solution data model. */
export type InactiveString = {
  /** Reference to a time series for 'actionDate' in this 'Inactive_String' view. */
  actionDate: Maybe<TimeSeries>;
  /** Reference to a time series for 'actionStatus' in this 'Inactive_String' view. */
  actionStatus: Maybe<TimeSeries>;
  /** Reference to a time series for 'categoryCode' in this 'Inactive_String' view. */
  categoryCode: Maybe<TimeSeries>;
  /** Reference to a time series for 'downtimeStartDate' in this 'Inactive_String' view. */
  downtimeStartDate: Maybe<TimeSeries>;
  /** Reference to a time series for 'duration' in this 'Inactive_String' view. */
  duration: Maybe<TimeSeries>;
  /** Reference to the related 'String_asset' entity for this 'Inactive_String' row. */
  entityName: Maybe<StringAsset>;
  /** Reference to a time series for 'expectedRate' in this 'Inactive_String' view. */
  expectedRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'inactiveCategory' in this 'Inactive_String' view. */
  inactiveCategory: Maybe<TimeSeries>;
  /** Reference to a time series for 'problemName' in this 'Inactive_String' view. */
  problemName: Maybe<TimeSeries>;
  /** Reference to a time series for 'stringStatus' in this 'Inactive_String' view. */
  stringStatus: Maybe<TimeSeries>;
  /** Reference to a time series for 'stringStatusAll' in this 'Inactive_String' view. */
  stringStatusAll: Maybe<TimeSeries>;
};

/** View 'InjPressGuideline_String' in the iPSO production optimization solution data model. */
export type InjPressGuidelineString = {
  /** Reference to the related 'String_asset' entity for this 'InjPressGuideline_String' row. */
  entityName: Maybe<StringAsset>;
  /** Numeric value 'giMaxBHIP' (floating point) for this 'InjPressGuideline_String' row. */
  giMaxBHIP: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'giMaxInjRate' (floating point) for this 'InjPressGuideline_String' row. */
  giMaxInjRate: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'giMaxWHIP' (floating point) for this 'InjPressGuideline_String' row. */
  giMaxWHIP: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'wiMaxBHIP' (floating point) for this 'InjPressGuideline_String' row. */
  wiMaxBHIP: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'wiMaxInjRate' (floating point) for this 'InjPressGuideline_String' row. */
  wiMaxInjRate: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'wiMaxWHIP' (floating point) for this 'InjPressGuideline_String' row. */
  wiMaxWHIP: Maybe<Scalars['Float32']['output']>;
};

/**
 * Injection pressure guidelines and operating limits per well string (WF15).
 *
 * Max WHP, min BHP, fracture gradient, operating pressure bands. Use for safe
 * injection practices, optimal pressure settings, over-pressurization risk. For
 * performance trends see InjectionPerformance_String_Agent.
 *
 * Use for: Water or Gas Injection Monitoring (WF15).
 *
 * @name Injection Pressure Guidelines - String (Agent)
 */
export type InjPressGuidelineStringAgent = {
  giMaxBHIP: Maybe<Scalars['Float32']['output']>;
  giMaxInjRate: Maybe<Scalars['Float32']['output']>;
  giMaxWHIP: Maybe<Scalars['Float32']['output']>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString: Maybe<StringAsset>;
  wiMaxBHIP: Maybe<Scalars['Float32']['output']>;
  wiMaxInjRate: Maybe<Scalars['Float32']['output']>;
  wiMaxWHIP: Maybe<Scalars['Float32']['output']>;
};

/**
 * Injection monitoring and VRR alarms with medium or high priority.
 *
 * The Injection Monitoring Alarms (Agent) view contains data related to medium
 * and high-priority alarms associated with water or gas injection and VRR
 * (Volume Reduction Ratio) monitoring. This data is sourced from operational
 * workflows focused on injection monitoring and includes alarm codes,
 * priorities, and timestamps, allowing for the analysis of alarm occurrences and
 * their implications on operational efficiency. It can answer questions
 * regarding frequency, criticality, and duration of injection/VRR alarms. Excludes low-priority alarms.
 *
 * Use for: Water or Gas Injection Monitoring (WF15), VRR (WF16/WF17), Real-Time Surveillance (WF18).
 *
 * @name Injection Monitoring Alarms (Agent)
 */
export type InjectionAlarmsAgent = {
  alarmCategory: Maybe<Scalars['String']['output']>;
  alarmCode: Maybe<Scalars['JSONObject']['output']>;
  alarmCodeExternalId: Maybe<Scalars['String']['output']>;
  /** Number of consecutive occurrences of this alarm. */
  alarmCounter: Maybe<Scalars['Int']['output']>;
  alarmCriticality: Maybe<Scalars['String']['output']>;
  alarmFlags: Maybe<Scalars['String']['output']>;
  alarmName: Maybe<Scalars['String']['output']>;
  alarmPriority: Maybe<Scalars['String']['output']>;
  customWorkflowAlarmMessage: Maybe<Scalars['String']['output']>;
  endDateTime: Maybe<Scalars['Timestamp']['output']>;
  entityExternalId: Scalars['String']['output'];
  entityName: Scalars['String']['output'];
  entityType: Scalars['String']['output'];
  startDateTime: Scalars['Timestamp']['output'];
  /** Alarm sub-category for domain filtering. */
  subCategory: Maybe<Scalars['String']['output']>;
  /** Sub-workflow that generated the alarm. */
  subWorkflowName: Maybe<Scalars['String']['output']>;
  /** Associated ticket/action ID if alarm has been acknowledged. */
  ticketId: Maybe<Scalars['String']['output']>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString: Maybe<StringAsset>;
  workflowCode: Maybe<Scalars['String']['output']>;
  workflowName: Maybe<Scalars['String']['output']>;
};

/** View 'InjectionHeader' in the iPSO production optimization solution data model. */
export type InjectionHeader = {
  /** Timestamp 'endDateTime' associated with this 'InjectionHeader' row. */
  endDateTime: Maybe<Scalars['Timestamp']['output']>;
  /** Text attribute 'entityType' for this 'InjectionHeader' row. */
  entityType: Maybe<Scalars['String']['output']>;
  /** Text attribute 'name' for this 'InjectionHeader' row. */
  name: Maybe<Scalars['String']['output']>;
  /** Timestamp 'startDateTime' associated with this 'InjectionHeader' row. */
  startDateTime: Maybe<Scalars['Timestamp']['output']>;
};

/**
 * Injection header outputs from WF7 GAP network simulation (WF7).
 *
 * Measured and estimated water and gas injection rates, pressures, and
 * temperatures per injection header/branch. Use for injection-network
 * performance, operational-limit checks, and identification of header
 * bottlenecks across branches and wells. Excludes historical time series and
 * well-level injection diagnostics (see InjectionPerformance_String_Agent).
 *
 * Use for: Network Surveillance (WF7), Injection Monitoring (WF14).
 *
 * @name Injection Header Outputs - Network (Agent)
 */
export type InjectionHeaderOutputsNetworkAgent = {
  /** Injection header entity name. */
  entityName: Maybe<Entity>;
  /** Reference to parent network model. */
  network: Maybe<Network>;
  /** Estimated gas injection pressure (TS). */
  nmvEstimatedGasInjPressure: Maybe<TimeSeries>;
  /** Estimated gas injection rate (TS). */
  nmvEstimatedGasInjRate: Maybe<TimeSeries>;
  /** Estimated gas injection temperature (TS). */
  nmvEstimatedGasInjTemperature: Maybe<TimeSeries>;
  /** Estimated water injection pressure (TS). */
  nmvEstimatedWaterInjPressure: Maybe<TimeSeries>;
  /** Estimated water injection rate (TS). */
  nmvEstimatedWaterInjRate: Maybe<TimeSeries>;
  /** Estimated water injection temperature (TS). */
  nmvEstimatedWaterInjTemperature: Maybe<TimeSeries>;
  /** Gas injection facility max intake utilization (%, TS). */
  nmvGasInjectionFmi: Maybe<TimeSeries>;
  /** Measured gas injection pressure (TS). */
  nmvMeasuredGasInjPressure: Maybe<TimeSeries>;
  /** Measured gas injection rate (TS). */
  nmvMeasuredGasInjRate: Maybe<TimeSeries>;
  /** Measured gas injection temperature (TS). */
  nmvMeasuredGasInjTemperature: Maybe<TimeSeries>;
  /** Measured water injection pressure (TS). */
  nmvMeasuredWaterInjPressure: Maybe<TimeSeries>;
  /** Measured water injection rate (TS). */
  nmvMeasuredWaterInjRate: Maybe<TimeSeries>;
  /** Measured water injection temperature (TS). */
  nmvMeasuredWaterInjTemperature: Maybe<TimeSeries>;
  /** Water injection facility max intake utilization (%, TS). */
  nmvWaterInjectionFmi: Maybe<TimeSeries>;
};

/**
 * Injection well performance metrics at string level (WF15).
 *
 * Gas and water injection rates, pressures, efficiency, Hall plot. Use for
 * effectiveness of injection strategies, injectivity trends, compliance with
 * targets, and Hall plot diagnostics. Excludes surface facility or reservoir views.
 *
 * Use for: Water or Gas Injection Monitoring (WF15).
 *
 * @name Injection Performance - String Level (Agent)
 */
export type InjectionPerformanceStringAgent = {
  /** Average WHP during cumulative gas injection period (psi, TS). */
  cumulativeGasInjPress: Maybe<TimeSeries>;
  /** Cumulative gas injection volume (MSCF, TS). Used for voidage tracking. */
  cumulativeGasInjVol: Maybe<TimeSeries>;
  /** Average WHP during cumulative water injection period (psi, TS). */
  cumulativeWaterInjPress: Maybe<TimeSeries>;
  /** Cumulative water injection volume (stb, TS). Used for voidage tracking. */
  cumulativeWaterInjVol: Maybe<TimeSeries>;
  /** Cumulative gas injection at reservoir conditions (rb, TS). */
  downholeGasInjectionVolume: Maybe<TimeSeries>;
  /**
   * Cumulative water injection at reservoir conditions (rb, TS). Used for
   * VRR and material balance calculations.
   */
  downholeWaterInjectionVolume: Maybe<TimeSeries>;
  /**
   * Bottom-hole pressure during gas injection (psi, TS). Measured if
   * instrumented, otherwise calculated from WHP.
   */
  giBHP: Maybe<TimeSeries>;
  /**
   * Current gas injection rate (MSCF/d, TS). Real-time from flow meter
   * or calculated from operating conditions.
   */
  giRate: Maybe<TimeSeries>;
  /**
   * Target gas injection rate (MSCF/d, TS) from production plan or optimization.
   * Compare to giRate to assess injection compliance.
   */
  giTargetRate: Maybe<TimeSeries>;
  /**
   * Maximum technically achievable gas injection rate (MSCF/d, TS) given
   * current well and facility constraints.
   */
  giTechnicalRate: Maybe<TimeSeries>;
  /** Wellhead pressure during gas injection (psi, TS). */
  giWHP: Maybe<TimeSeries>;
  /**
   * Hall plot trend interpretation: 'STABLE', 'IMPROVING', 'DECLINING',
   * 'STIMULATION_NEEDED'. Key diagnostic for injection well surveillance.
   */
  hallInterpretation: Maybe<TimeSeries>;
  /**
   * Hall plot cumulative value or slope (TS). Trend changes indicate
   * injectivity changes over time.
   */
  hallLine: Maybe<TimeSeries>;
  /**
   * Injection efficiency (%, TS). Actual rate / target rate. 100% = fully
   * meeting target.
   */
  injectionEfficiency: Maybe<TimeSeries>;
  /** Flag: 1 = below efficiency threshold (needs attention), 0 = acceptable. */
  injectionEfficiencyFlag: Maybe<TimeSeries>;
  /** Rank among all injectors (1 = best, TS). Use to identify worst performers. */
  injectionEfficiencyRank: Maybe<TimeSeries>;
  /**
   * Injectivity index (stb/d/psi, TS). Rate of injection per unit
   * pressure increase. Key metric for injection well health.
   */
  injectivityIndex: Maybe<TimeSeries>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString: Maybe<StringAsset>;
  /** Bottom-hole pressure during water injection (psi, TS). */
  wiBHP: Maybe<TimeSeries>;
  /** Current water injection rate (stb/d, TS). Real-time from flow meter. */
  wiRate: Maybe<TimeSeries>;
  /** Target water injection rate (stb/d, TS) from production plan or optimization. */
  wiTargetRate: Maybe<TimeSeries>;
  /** Maximum technically achievable water injection rate (stb/d, TS). */
  wiTechnicalRate: Maybe<TimeSeries>;
  /** Wellhead pressure during water injection (psi, TS). */
  wiWHP: Maybe<TimeSeries>;
};

/** View 'Injection_Allocation_Factor' in the iPSO production optimization solution data model. */
export type InjectionAllocationFactor = {
  /** Numeric value 'allocationFactor' (floating point) for this 'Injection_Allocation_Factor' row. */
  allocationFactor: Maybe<Scalars['Float32']['output']>;
  /** Timestamp 'effectiveDate' associated with this 'Injection_Allocation_Factor' row. */
  effectiveDate: Maybe<Scalars['Timestamp']['output']>;
  /** Timestamp 'executionDate' associated with this 'Injection_Allocation_Factor' row. */
  executionDate: Maybe<Scalars['Timestamp']['output']>;
  /** Reference to the related 'Field' entity for this 'Injection_Allocation_Factor' row. */
  field: Maybe<Field>;
  /** Reference to the related 'String_asset' entity for this 'Injection_Allocation_Factor' row. */
  injectorString: Maybe<StringAsset>;
  /** Reference to the related 'String_asset' entity for this 'Injection_Allocation_Factor' row. */
  producerString: Maybe<StringAsset>;
  /** Reference to the related 'Reservoir' entity for this 'Injection_Allocation_Factor' row. */
  reservoir: Maybe<Reservoir>;
  /** Text attribute 'source' for this 'Injection_Allocation_Factor' row. */
  source: Maybe<Scalars['String']['output']>;
};

/** View 'Joint' in the iPSO production optimization solution data model. */
export type Joint = {
  /** Timestamp 'endDateTime' associated with this 'Joint' row. */
  endDateTime: Maybe<Scalars['Timestamp']['output']>;
  /** Text attribute 'entityType' for this 'Joint' row. */
  entityType: Maybe<Scalars['String']['output']>;
  /** Text attribute 'name' for this 'Joint' row. */
  name: Maybe<Scalars['String']['output']>;
  /** Timestamp 'startDateTime' associated with this 'Joint' row. */
  startDateTime: Maybe<Scalars['Timestamp']['output']>;
};

/**
 * Junction and node-level outputs from WF7 GAP network simulation (WF7/WF20).
 *
 * Pressures, temperatures, and oil/gas/liquid flow rates at network junctions
 * and nodes. Use to trace fluid behavior through the network, identify
 * bottlenecks, and analyze how upstream parameter changes propagate to
 * downstream nodes. Excludes historical time series and
 * system-level aggregates.
 *
 * Use for: Network Surveillance (WF7), Flow Assurance Detection and Mitigation (WF20).
 *
 * @name Joint Outputs - Network (Agent)
 */
export type JointOutputsNetworkAgent = {
  /** Junction/manifold entity name. */
  entityName: Maybe<Scalars['JSONObject']['output']>;
  /** Reference to junction/manifold entity. */
  jointEntity: Maybe<Entity>;
  /** Reference to parent network model. */
  network: Maybe<Network>;
  /** Condensate-gas ratio at junction (TS). */
  nmvCgr: Maybe<TimeSeries>;
  /** Differential pressure at junction (TS). */
  nmvDp: Maybe<TimeSeries>;
  /** Gas-liquid ratio at junction (TS). */
  nmvGlr: Maybe<TimeSeries>;
  /** Gas-oil ratio at junction (TS). */
  nmvGor: Maybe<TimeSeries>;
  /** Gas injection rate at junction (TS). */
  nmvInjectionGasRate: Maybe<TimeSeries>;
  /** Water injection rate at junction (TS). */
  nmvInjectionWaterRate: Maybe<TimeSeries>;
  /** CO2 content at junction (TS). */
  nmvJointCO2: Maybe<TimeSeries>;
  /** Gas rate at junction (TS). */
  nmvJointGasRate: Maybe<TimeSeries>;
  /** H2S content at junction (TS). */
  nmvJointH2S: Maybe<TimeSeries>;
  /** Liquid rate at junction (TS). */
  nmvJointLiquidRate: Maybe<TimeSeries>;
  /** N2 content at junction (TS). */
  nmvJointN2: Maybe<TimeSeries>;
  /** Oil rate at junction (TS). */
  nmvJointOilRate: Maybe<TimeSeries>;
  /** Pressure at junction (TS). */
  nmvJointPressure: Maybe<TimeSeries>;
  /** Temperature at junction (TS). */
  nmvJointTemperature: Maybe<TimeSeries>;
  /** Junction operating outside constraints (0/1, TS). */
  nmvJointViolatingConstraintsFlag: Maybe<TimeSeries>;
  /** Downstream pressure (TS). */
  nmvPdown: Maybe<TimeSeries>;
  /** Downstream temperature (TS). */
  nmvTdown: Maybe<TimeSeries>;
  /** Water cut at junction (TS). */
  nmvWaterCut: Maybe<TimeSeries>;
  /** Water rate at junction (TS). */
  nmvWaterRate: Maybe<TimeSeries>;
  /** Water-gas ratio at junction (TS). */
  nmvWgr: Maybe<TimeSeries>;
};

/** View 'LiftTypeParameter_String' in the iPSO production optimization solution data model. */
export type LiftTypeParameterString = {
  /** Reference to a time series for 'amorphousFeS' in this 'LiftTypeParameter_String' view. */
  amorphousFeS: Maybe<TimeSeries>;
  /** Reference to a time series for 'amorphousSilica' in this 'LiftTypeParameter_String' view. */
  amorphousSilica: Maybe<TimeSeries>;
  /** Reference to a time series for 'anhydrite' in this 'LiftTypeParameter_String' view. */
  anhydrite: Maybe<TimeSeries>;
  /** Numeric value 'asphalteneMaxLimit' (floating point) for this 'LiftTypeParameter_String' row. */
  asphalteneMaxLimit: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'asphalteneMinLimit' (floating point) for this 'LiftTypeParameter_String' row. */
  asphalteneMinLimit: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'asphalteneRelativeWT' (floating point) for this 'LiftTypeParameter_String' row. */
  asphalteneRelativeWT: Maybe<Scalars['Float32']['output']>;
  /** Boolean flag 'asphalteneRisk' for this 'LiftTypeParameter_String' row. */
  asphalteneRisk: Maybe<Scalars['Boolean']['output']>;
  /** Reference to a time series for 'baCO3' in this 'LiftTypeParameter_String' view. */
  baCO3: Maybe<TimeSeries>;
  /** Reference to a time series for 'barite' in this 'LiftTypeParameter_String' view. */
  barite: Maybe<TimeSeries>;
  /** Reference to a time series for 'caF2' in this 'LiftTypeParameter_String' view. */
  caF2: Maybe<TimeSeries>;
  /** Reference to a time series for 'caOH2Portlandite' in this 'LiftTypeParameter_String' view. */
  caOH2Portlandite: Maybe<TimeSeries>;
  /** Reference to a time series for 'calcite' in this 'LiftTypeParameter_String' view. */
  calcite: Maybe<TimeSeries>;
  /** Reference to a time series for 'calestite' in this 'LiftTypeParameter_String' view. */
  calestite: Maybe<TimeSeries>;
  /** Reference to a time series for 'chrysotile' in this 'LiftTypeParameter_String' view. */
  chrysotile: Maybe<TimeSeries>;
  /** Numeric value 'corrosionMaxLimit' (floating point) for this 'LiftTypeParameter_String' row. */
  corrosionMaxLimit: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'corrosionMinLimit' (floating point) for this 'LiftTypeParameter_String' row. */
  corrosionMinLimit: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'corrosionRelativeWT' (floating point) for this 'LiftTypeParameter_String' row. */
  corrosionRelativeWT: Maybe<Scalars['Float32']['output']>;
  /** Reference to a time series for 'diopside' in this 'LiftTypeParameter_String' view. */
  diopside: Maybe<TimeSeries>;
  /** Reference to the related 'String_asset' entity for this 'LiftTypeParameter_String' row. */
  entityName: Maybe<StringAsset>;
  /** Numeric value 'erosionMaxLimit' (floating point) for this 'LiftTypeParameter_String' row. */
  erosionMaxLimit: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'erosionMinLimit' (floating point) for this 'LiftTypeParameter_String' row. */
  erosionMinLimit: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'erosionRelativeWT' (floating point) for this 'LiftTypeParameter_String' row. */
  erosionRelativeWT: Maybe<Scalars['Float32']['output']>;
  /** Reference to a time series for 'espMaxDischargePressure' in this 'LiftTypeParameter_String' view. */
  espMaxDischargePressure: Maybe<TimeSeries>;
  /** Boolean flag 'espMaxDischargePressure_active' for this 'LiftTypeParameter_String' row. */
  espMaxDischargePressure_active: Maybe<TimeSeries>;
  /** Reference to a time series for 'espMaxFluidRate' in this 'LiftTypeParameter_String' view. */
  espMaxFluidRate: Maybe<TimeSeries>;
  /** Boolean flag 'espMaxFluidRate_active' for this 'LiftTypeParameter_String' row. */
  espMaxFluidRate_active: Maybe<TimeSeries>;
  /** Reference to a time series for 'espMaxFreeGasInPump' in this 'LiftTypeParameter_String' view. */
  espMaxFreeGasInPump: Maybe<TimeSeries>;
  /** Boolean flag 'espMaxFreeGasInPump_active' for this 'LiftTypeParameter_String' row. */
  espMaxFreeGasInPump_active: Maybe<TimeSeries>;
  /** Reference to a time series for 'espMaxHead' in this 'LiftTypeParameter_String' view. */
  espMaxHead: Maybe<TimeSeries>;
  /** Boolean flag 'espMaxHead_active' for this 'LiftTypeParameter_String' row. */
  espMaxHead_active: Maybe<TimeSeries>;
  /** Reference to a time series for 'espMaxMotorAmps' in this 'LiftTypeParameter_String' view. */
  espMaxMotorAmps: Maybe<TimeSeries>;
  /** Boolean flag 'espMaxMotorAmps_active' for this 'LiftTypeParameter_String' row. */
  espMaxMotorAmps_active: Maybe<TimeSeries>;
  /** Reference to a time series for 'espMaxMotorEfficiency' in this 'LiftTypeParameter_String' view. */
  espMaxMotorEfficiency: Maybe<TimeSeries>;
  /** Boolean flag 'espMaxMotorEfficiency_active' for this 'LiftTypeParameter_String' row. */
  espMaxMotorEfficiency_active: Maybe<TimeSeries>;
  /** Reference to a time series for 'espMaxMotorLoadPermissible' in this 'LiftTypeParameter_String' view. */
  espMaxMotorLoadPermissible: Maybe<TimeSeries>;
  /** Boolean flag 'espMaxMotorLoadPermissible_active' for this 'LiftTypeParameter_String' row. */
  espMaxMotorLoadPermissible_active: Maybe<TimeSeries>;
  /** Reference to a time series for 'espMaxMotorPwr' in this 'LiftTypeParameter_String' view. */
  espMaxMotorPwr: Maybe<TimeSeries>;
  /** Boolean flag 'espMaxMotorPwr_active' for this 'LiftTypeParameter_String' row. */
  espMaxMotorPwr_active: Maybe<TimeSeries>;
  /** Reference to a time series for 'espMaxMotorSpeed_InductorType' in this 'LiftTypeParameter_String' view. */
  espMaxMotorSpeed_InductorType: Maybe<TimeSeries>;
  /** Boolean flag 'espMaxMotorSpeed_InductorType_active' for this 'LiftTypeParameter_String' row. */
  espMaxMotorSpeed_InductorType_active: Maybe<TimeSeries>;
  /** Reference to a time series for 'espMaxMotorSpeed_PmmType' in this 'LiftTypeParameter_String' view. */
  espMaxMotorSpeed_PmmType: Maybe<TimeSeries>;
  /** Boolean flag 'espMaxMotorSpeed_PmmType_active' for this 'LiftTypeParameter_String' row. */
  espMaxMotorSpeed_PmmType_active: Maybe<TimeSeries>;
  /** Reference to a time series for 'espMaxMotorTemp' in this 'LiftTypeParameter_String' view. */
  espMaxMotorTemp: Maybe<TimeSeries>;
  /** Boolean flag 'espMaxMotorTemp_active' for this 'LiftTypeParameter_String' row. */
  espMaxMotorTemp_active: Maybe<TimeSeries>;
  /** Reference to a time series for 'espMaxPumpDeltaTemp' in this 'LiftTypeParameter_String' view. */
  espMaxPumpDeltaTemp: Maybe<TimeSeries>;
  /** Boolean flag 'espMaxPumpDeltaTemp_active' for this 'LiftTypeParameter_String' row. */
  espMaxPumpDeltaTemp_active: Maybe<TimeSeries>;
  /** Reference to a time series for 'espMaxPumpFluidVelocity' in this 'LiftTypeParameter_String' view. */
  espMaxPumpFluidVelocity: Maybe<TimeSeries>;
  /** Boolean flag 'espMaxPumpFluidVelocity_active' for this 'LiftTypeParameter_String' row. */
  espMaxPumpFluidVelocity_active: Maybe<TimeSeries>;
  /** Reference to a time series for 'espMaxPwrAvail_Generated' in this 'LiftTypeParameter_String' view. */
  espMaxPwrAvail_Generated: Maybe<TimeSeries>;
  /** Boolean flag 'espMaxPwrAvail_Generated_active' for this 'LiftTypeParameter_String' row. */
  espMaxPwrAvail_Generated_active: Maybe<TimeSeries>;
  /** Reference to a time series for 'espMaxSurfaceKva' in this 'LiftTypeParameter_String' view. */
  espMaxSurfaceKva: Maybe<TimeSeries>;
  /** Boolean flag 'espMaxSurfaceKva_active' for this 'LiftTypeParameter_String' row. */
  espMaxSurfaceKva_active: Maybe<TimeSeries>;
  /** Reference to a time series for 'espMaxTrqOnShaft' in this 'LiftTypeParameter_String' view. */
  espMaxTrqOnShaft: Maybe<TimeSeries>;
  /** Boolean flag 'espMaxTrqOnShaft_active' for this 'LiftTypeParameter_String' row. */
  espMaxTrqOnShaft_active: Maybe<TimeSeries>;
  /** Reference to a time series for 'espMaxVoltageDropAlongCable' in this 'LiftTypeParameter_String' view. */
  espMaxVoltageDropAlongCable: Maybe<TimeSeries>;
  /** Boolean flag 'espMaxVoltageDropAlongCable_active' for this 'LiftTypeParameter_String' row. */
  espMaxVoltageDropAlongCable_active: Maybe<TimeSeries>;
  /** Reference to a time series for 'espMinFluidRate' in this 'LiftTypeParameter_String' view. */
  espMinFluidRate: Maybe<TimeSeries>;
  /** Boolean flag 'espMinFluidRate_active' for this 'LiftTypeParameter_String' row. */
  espMinFluidRate_active: Maybe<TimeSeries>;
  /** Reference to a time series for 'espMinIntakePressure' in this 'LiftTypeParameter_String' view. */
  espMinIntakePressure: Maybe<TimeSeries>;
  /** Boolean flag 'espMinIntakePressure_active' for this 'LiftTypeParameter_String' row. */
  espMinIntakePressure_active: Maybe<TimeSeries>;
  /** Reference to a time series for 'espMinIntakeTemperature' in this 'LiftTypeParameter_String' view. */
  espMinIntakeTemperature: Maybe<TimeSeries>;
  /** Boolean flag 'espMinIntakeTemperature_active' for this 'LiftTypeParameter_String' row. */
  espMinIntakeTemperature_active: Maybe<TimeSeries>;
  /** Reference to a time series for 'espMinMotorPowerFactor' in this 'LiftTypeParameter_String' view. */
  espMinMotorPowerFactor: Maybe<TimeSeries>;
  /** Boolean flag 'espMinMotorPowerFactor_active' for this 'LiftTypeParameter_String' row. */
  espMinMotorPowerFactor_active: Maybe<TimeSeries>;
  /** Reference to a time series for 'espMinPumpFluidVelocity' in this 'LiftTypeParameter_String' view. */
  espMinPumpFluidVelocity: Maybe<TimeSeries>;
  /** Boolean flag 'espMinPumpFluidVelocity_active' for this 'LiftTypeParameter_String' row. */
  espMinPumpFluidVelocity_active: Maybe<TimeSeries>;
  /** Reference to a time series for 'espPdpThreshold' in this 'LiftTypeParameter_String' view. */
  espPdpThreshold: Maybe<TimeSeries>;
  /** Reference to a time series for 'espPipThreshold' in this 'LiftTypeParameter_String' view. */
  espPipThreshold: Maybe<TimeSeries>;
  /** Reference to a time series for 'feCO3' in this 'LiftTypeParameter_String' view. */
  feCO3: Maybe<TimeSeries>;
  /** Boolean flag 'fluidVelocity' for this 'LiftTypeParameter_String' row. */
  fluidVelocity: Maybe<Scalars['Boolean']['output']>;
  /** Reference to a time series for 'fluidVelocityStatus' in this 'LiftTypeParameter_String' view. */
  fluidVelocityStatus: Maybe<TimeSeries>;
  /** Reference to a time series for 'fourCalcOptions' in this 'LiftTypeParameter_String' view. */
  fourCalcOptions: Maybe<TimeSeries>;
  /** Reference to a time series for 'glMaxCasingHeadPressure' in this 'LiftTypeParameter_String' view. */
  glMaxCasingHeadPressure: Maybe<TimeSeries>;
  /** Boolean flag 'glMaxCasingHeadPressure_active' for this 'LiftTypeParameter_String' row. */
  glMaxCasingHeadPressure_active: Maybe<TimeSeries>;
  /** Reference to a time series for 'glMaxLiftChokeDeltaTemp' in this 'LiftTypeParameter_String' view. */
  glMaxLiftChokeDeltaTemp: Maybe<TimeSeries>;
  /** Boolean flag 'glMaxLiftChokeDeltaTemp_active' for this 'LiftTypeParameter_String' row. */
  glMaxLiftChokeDeltaTemp_active: Maybe<TimeSeries>;
  /** Reference to a time series for 'glMaxManifoldPressure' in this 'LiftTypeParameter_String' view. */
  glMaxManifoldPressure: Maybe<TimeSeries>;
  /** Boolean flag 'glMaxManifoldPressure_active' for this 'LiftTypeParameter_String' row. */
  glMaxManifoldPressure_active: Maybe<TimeSeries>;
  /** Reference to a time series for 'glMaxWellHeadTemp' in this 'LiftTypeParameter_String' view. */
  glMaxWellHeadTemp: Maybe<TimeSeries>;
  /** Boolean flag 'glMaxWellHeadTemp_active' for this 'LiftTypeParameter_String' row. */
  glMaxWellHeadTemp_active: Maybe<TimeSeries>;
  /** Reference to a time series for 'glMinBHP' in this 'LiftTypeParameter_String' view. */
  glMinBHP: Maybe<TimeSeries>;
  /** Boolean flag 'glMinBHP_active' for this 'LiftTypeParameter_String' row. */
  glMinBHP_active: Maybe<TimeSeries>;
  /** Reference to a time series for 'glMinCasingHeadPressure' in this 'LiftTypeParameter_String' view. */
  glMinCasingHeadPressure: Maybe<TimeSeries>;
  /** Boolean flag 'glMinCasingHeadPressure_active' for this 'LiftTypeParameter_String' row. */
  glMinCasingHeadPressure_active: Maybe<TimeSeries>;
  /** Reference to a time series for 'glMinManifolddPressure' in this 'LiftTypeParameter_String' view. */
  glMinManifolddPressure: Maybe<TimeSeries>;
  /** Boolean flag 'glMinManifolddPressure_active' for this 'LiftTypeParameter_String' row. */
  glMinManifolddPressure_active: Maybe<TimeSeries>;
  /** Reference to a time series for 'glMinWellHeadPressure' in this 'LiftTypeParameter_String' view. */
  glMinWellHeadPressure: Maybe<TimeSeries>;
  /** Boolean flag 'glMinWellHeadPressure_active' for this 'LiftTypeParameter_String' row. */
  glMinWellHeadPressure_active: Maybe<TimeSeries>;
  /** Reference to a time series for 'greenalite' in this 'LiftTypeParameter_String' view. */
  greenalite: Maybe<TimeSeries>;
  /** Reference to a time series for 'gypsum' in this 'LiftTypeParameter_String' view. */
  gypsum: Maybe<TimeSeries>;
  /** Reference to a time series for 'halite' in this 'LiftTypeParameter_String' view. */
  halite: Maybe<TimeSeries>;
  /** Reference to a time series for 'hemihydrate' in this 'LiftTypeParameter_String' view. */
  hemihydrate: Maybe<TimeSeries>;
  /** Numeric value 'hydrateMaxLimit' (floating point) for this 'LiftTypeParameter_String' row. */
  hydrateMaxLimit: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'hydrateMinLimit' (floating point) for this 'LiftTypeParameter_String' row. */
  hydrateMinLimit: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'hydrateRelativeWT' (floating point) for this 'LiftTypeParameter_String' row. */
  hydrateRelativeWT: Maybe<Scalars['Float32']['output']>;
  /** Boolean flag 'hydrateRisk' for this 'LiftTypeParameter_String' row. */
  hydrateRisk: Maybe<Scalars['Boolean']['output']>;
  /** Numeric value 'liquidLoadingMaxLimit' (floating point) for this 'LiftTypeParameter_String' row. */
  liquidLoadingMaxLimit: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'liquidLoadingMinLimit' (floating point) for this 'LiftTypeParameter_String' row. */
  liquidLoadingMinLimit: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'liquidLoadingRelativeWT' (floating point) for this 'LiftTypeParameter_String' row. */
  liquidLoadingRelativeWT: Maybe<Scalars['Float32']['output']>;
  /** Reference to a time series for 'mackinawite' in this 'LiftTypeParameter_String' view. */
  mackinawite: Maybe<TimeSeries>;
  /** Reference to a time series for 'maxGOR' in this 'LiftTypeParameter_String' view. */
  maxGOR: Maybe<TimeSeries>;
  /** Boolean flag 'maxGOR_active' for this 'LiftTypeParameter_String' row. */
  maxGOR_active: Maybe<TimeSeries>;
  /** Reference to a time series for 'maxLiquidRate' in this 'LiftTypeParameter_String' view. */
  maxLiquidRate: Maybe<TimeSeries>;
  /** Boolean flag 'maxLiquidRate_active' for this 'LiftTypeParameter_String' row. */
  maxLiquidRate_active: Maybe<TimeSeries>;
  /** Reference to a time series for 'maxOilRate' in this 'LiftTypeParameter_String' view. */
  maxOilRate: Maybe<TimeSeries>;
  /** Boolean flag 'maxOilRate_active' for this 'LiftTypeParameter_String' row. */
  maxOilRate_active: Maybe<TimeSeries>;
  /** Reference to a time series for 'maxWellHeadPressure' in this 'LiftTypeParameter_String' view. */
  maxWellHeadPressure: Maybe<TimeSeries>;
  /** Boolean flag 'maxWellHeadPressure_active' for this 'LiftTypeParameter_String' row. */
  maxWellHeadPressure_active: Maybe<TimeSeries>;
  /** Reference to a time series for 'mgOH2Brucite' in this 'LiftTypeParameter_String' view. */
  mgOH2Brucite: Maybe<TimeSeries>;
  /** Reference to a time series for 'pbSGalena' in this 'LiftTypeParameter_String' view. */
  pbSGalena: Maybe<TimeSeries>;
  /** Numeric value 'pe5MaxLimit' (floating point) for this 'LiftTypeParameter_String' row. */
  pe5MaxLimit: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'pe5MinLimit' (floating point) for this 'LiftTypeParameter_String' row. */
  pe5MinLimit: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'pe5RelativeWT' (floating point) for this 'LiftTypeParameter_String' row. */
  pe5RelativeWT: Maybe<Scalars['Float32']['output']>;
  /** Boolean flag 'pe5StabilityCriteria' for this 'LiftTypeParameter_String' row. */
  pe5StabilityCriteria: Maybe<Scalars['Boolean']['output']>;
  /** Reference to a time series for 'pe5StabilityCriteriaStatus' in this 'LiftTypeParameter_String' view. */
  pe5StabilityCriteriaStatus: Maybe<TimeSeries>;
  /** Reference to a time series for 'quartz' in this 'LiftTypeParameter_String' view. */
  quartz: Maybe<TimeSeries>;
  /** Reference to a time series for 'srCO3' in this 'LiftTypeParameter_String' view. */
  srCO3: Maybe<TimeSeries>;
  /** Reference to a time series for 'troilitePyrrhotite' in this 'LiftTypeParameter_String' view. */
  troilitePyrrhotite: Maybe<TimeSeries>;
  /** Reference to a time series for 'usePhTuning' in this 'LiftTypeParameter_String' view. */
  usePhTuning: Maybe<TimeSeries>;
  /** Numeric value 'waxMaxLimit' (floating point) for this 'LiftTypeParameter_String' row. */
  waxMaxLimit: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'waxMinLimit' (floating point) for this 'LiftTypeParameter_String' row. */
  waxMinLimit: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'waxRelativeWT' (floating point) for this 'LiftTypeParameter_String' row. */
  waxRelativeWT: Maybe<Scalars['Float32']['output']>;
  /** Boolean flag 'waxRisk' for this 'LiftTypeParameter_String' row. */
  waxRisk: Maybe<Scalars['Boolean']['output']>;
  /** Reference to a time series for 'znCO3' in this 'LiftTypeParameter_String' view. */
  znCO3: Maybe<TimeSeries>;
  /** Reference to a time series for 'znS' in this 'LiftTypeParameter_String' view. */
  znS: Maybe<TimeSeries>;
};

/** View 'Location' in the iPSO production optimization solution data model. */
export type Location = {
  /** Timestamp 'endDateTime' associated with this 'Location' row. */
  endDateTime: Maybe<Scalars['Timestamp']['output']>;
  /** Text attribute 'entityType' for this 'Location' row. */
  entityType: Maybe<Scalars['String']['output']>;
  /** Text attribute 'name' for this 'Location' row. */
  name: Maybe<Scalars['String']['output']>;
  /** Timestamp 'startDateTime' associated with this 'Location' row. */
  startDateTime: Maybe<Scalars['Timestamp']['output']>;
};

/** View 'LocationInputs' in the iPSO production optimization solution data model. */
export type LocationInputs = {
  /** Reference to the related 'Location' entity for this 'LocationInputs' row. */
  entityName: Maybe<Location>;
  /** Reference to a time series for 'flowLinePressure' in this 'LocationInputs' view. */
  flowLinePressure: Maybe<TimeSeries>;
  /** Reference to a time series for 'waterHeaderPressure' in this 'LocationInputs' view. */
  waterHeaderPressure: Maybe<TimeSeries>;
  /** Reference to a time series for 'waterHeaderTemperature' in this 'LocationInputs' view. */
  waterHeaderTemperature: Maybe<TimeSeries>;
};

/** View 'ManifoldInputs' in the iPSO production optimization solution data model. */
export type ManifoldInputs = {
  /** Reference to the related 'Manifold' entity for this 'ManifoldInputs' row. */
  entityName: Maybe<Entity>;
  manifoldGasInjPressure: Maybe<TimeSeries>;
  manifoldGasInjRate: Maybe<TimeSeries>;
  manifoldGasInjTemperature: Maybe<TimeSeries>;
  manifoldWaterInjPressure: Maybe<TimeSeries>;
  manifoldWaterInjRate: Maybe<TimeSeries>;
  manifoldWaterInjTemperature: Maybe<TimeSeries>;
};

/** View 'MapGrid_Mapping' in the iPSO production optimization solution data model. */
export type MapGridMapping = {
  /** Text attribute 'createdBy' for this 'MapGrid_Mapping' row. */
  createdBy: Maybe<Scalars['String']['output']>;
  /** Timestamp 'date' associated with this 'MapGrid_Mapping' row. */
  date: Maybe<Scalars['Timestamp']['output']>;
  /** Text attribute 'fieldName' for this 'MapGrid_Mapping' row. */
  fieldName: Maybe<Scalars['String']['output']>;
  /** Text attribute 'flowUnitName' for this 'MapGrid_Mapping' row. */
  flowUnitName: Maybe<Scalars['String']['output']>;
  /** Text attribute 'isOfficial' for this 'MapGrid_Mapping' row. */
  isOfficial: Maybe<Scalars['String']['output']>;
  /** Numeric value 'lat' (floating point) for this 'MapGrid_Mapping' row. */
  lat: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'long' (floating point) for this 'MapGrid_Mapping' row. */
  long: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'p10' (floating point) for this 'MapGrid_Mapping' row. */
  p10: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'p50' (floating point) for this 'MapGrid_Mapping' row. */
  p50: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'p90' (floating point) for this 'MapGrid_Mapping' row. */
  p90: Maybe<Scalars['Float32']['output']>;
  /** Text attribute 'reservoirName' for this 'MapGrid_Mapping' row. */
  reservoirName: Maybe<Scalars['String']['output']>;
  /** Numeric value 'reservoirPressureMapGrid' (floating point) for this 'MapGrid_Mapping' row. */
  reservoirPressureMapGrid: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'reservoirPressureRMSError' (floating point) for this 'MapGrid_Mapping' row. */
  reservoirPressureRMSError: Maybe<Scalars['Float32']['output']>;
  /** Timestamp 'runDate' associated with this 'MapGrid_Mapping' row. */
  runDate: Maybe<Scalars['Timestamp']['output']>;
  /** Numeric value 'x' (floating point) for this 'MapGrid_Mapping' row. */
  x: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'y' (floating point) for this 'MapGrid_Mapping' row. */
  y: Maybe<Scalars['Float32']['output']>;
};

/**
 * Measured injection rates from wellhead meters per well string (WF15).
 *
 * Real-time gas and water injection from wellhead meters; no allocation. Use for
 * actual injection rates, trends, and well-string comparisons. For allocated volumes see AllocatedInjection_String_Agent.
 *
 * Use for: Water or Gas Injection Monitoring (WF15).
 */
export type MeasuredInjectionStringAgent = {
  /** Gas injection choke opening (TS). Controls gas injection rate at wellhead. */
  gasInjChokeOpening: Maybe<TimeSeries>;
  /**
   * Measured gas injection rate (MSCF/d) from wellhead flow meter. This is the
   * direct measurement, not an allocated value. Use for real-time injection
   * monitoring and comparison with allocated volumes.
   */
  gasInjRate: Maybe<TimeSeries>;
  /** Gas injection wellhead pressure (psia, TS). From wellhead meter; indicates line pressure and injectivity. */
  gasInjWellheadPress: Maybe<TimeSeries>;
  /** Water injection choke opening (TS). Controls water injection rate at wellhead. */
  waterInjChokeOpening: Maybe<TimeSeries>;
  /**
   * Measured water injection rate (stb/d) from wellhead flow meter. This is the
   * direct measurement, not an allocated value. Use for real-time injection
   * monitoring and comparison with allocated volumes.
   */
  waterInjRate: Maybe<TimeSeries>;
  /** Water injection wellhead pressure (psia, TS). From wellhead meter; indicates line pressure and injectivity. */
  waterInjWellheadPress: Maybe<TimeSeries>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString: Maybe<StringAsset>;
};

/**
 * Well test measured rates per well string from separator measurements.
 *
 * Contains comprehensive measurements from well tests, separator-measured rates
 * of oil, gas, and water at standard conditions, along with pertinent metadata
 * such as test dates and allocation approval flags. Sourced from actual well
 * tests conducted in the field, providing a reliable basis for production rate
 * calibration and validation of network models. It can address analytical
 * questions regarding the latest well test results, approved tests, and specific
 * ratios like gas-to-oil and water-cut metrics. Excludes simulated or estimated
 * rates, which may be present in other views, ensuring that users are working
 * with verified physical measurements.
 *
 * @name Measured Rates - Well Test (Agent)
 */
export type MeasuredRatesWellTestStringAgent = {
  /** Condensate-gas ratio at live/local conditions (stb/MMscf, TS). */
  cgrLC: Maybe<TimeSeries>;
  /** Formation/reservoir gas-oil ratio (scf/stb, TS). */
  formationGOR: Maybe<TimeSeries>;
  /** Well string identifier. */
  wellString: Maybe<StringAsset>;
  /**
   * Well test allocation approval status (TS). Values: 'Accepted', 'Rejected'.
   * @name isApproved
   */
  wellTestApprovedAllocationFlag: Maybe<TimeSeries>;
  /**
   * Condensate-gas ratio at standard conditions (stb/MMscf, TS).
   * @name condensateGasRatio
   */
  wellTestCGR: Maybe<TimeSeries>;
  /** Separator gas-oil ratio from well test (scf/stb, TS). */
  wellTestGOR: Maybe<TimeSeries>;
  /**
   * Measured gas production rate at standard conditions (MMscfd, TS).
   * @name gasRateStd
   */
  wellTestGasRateStd: Maybe<TimeSeries>;
  /**
   * Gas-oil ratio at downhole/insitu conditions (scf/stb, TS).
   * @name gorInsitu
   */
  wellTestGorInsitu: Maybe<TimeSeries>;
  /**
   * Gas-oil ratio at PTS conditions (scf/stb, TS).
   * @name gorPts
   */
  wellTestGorPts: Maybe<TimeSeries>;
  /**
   * Total liquid rate (oil + water) at PTS conditions (stb/d, TS).
   * @name liquidRatePts
   */
  wellTestLiquidRatePts: Maybe<TimeSeries>;
  /**
   * Measured oil production rate at standard conditions (stb/d, TS).
   * @name oilRateStd
   */
  wellTestOilRateStd: Maybe<TimeSeries>;
  /**
   * Well test start date (TS).
   * @name testDate
   */
  wellTestStartDate: Maybe<TimeSeries>;
  /**
   * Total gas-oil ratio at standard conditions (scf/stb, TS).
   * @name totalGorStd
   */
  wellTestTotalGorStd: Maybe<TimeSeries>;
  /**
   * Water-gas ratio at standard conditions (stb/MMscf, TS).
   * @name waterGasRatio
   */
  wellTestWGR: Maybe<TimeSeries>;
  /**
   * Water cut at standard conditions: water / (oil + water) * 100 (%, TS).
   * @name waterCut
   */
  wellTestWaterCut: Maybe<TimeSeries>;
  /**
   * Water cut at downhole/insitu conditions (%, TS).
   * @name waterCutInsitu
   */
  wellTestWaterCutInsitu: Maybe<TimeSeries>;
  /**
   * Water cut at PTS conditions (%, TS).
   * @name waterCutPts
   */
  wellTestWaterCutPts: Maybe<TimeSeries>;
  /**
   * Measured water production rate at standard conditions (stb/d, TS).
   * @name waterRateStd
   */
  wellTestWaterRateStd: Maybe<TimeSeries>;
  /** Water-gas ratio at live/local conditions (stb/MMscf, TS). */
  wgrLC: Maybe<TimeSeries>;
};

/**
 * Model management alarms with medium or high priority.
 *
 * Contains alarms generated during the model management processes, those with
 * medium or high priority. Sourced from the workflows associated with well and
 * network model updates and calibrations, allowing users to analyze alarm
 * occurrences and their implications on model performance. It can answer
 * questions regarding the frequency and types of alarms triggered, their impact
 * on operations and entities affected. Excludes low-priority or non-WF9 alarms.
 *
 * Use for: Well and Network Model Update and Management (WF9), Real-Time Surveillance (WF18).
 *
 * @name Model Management Alarms (Agent)
 */
export type ModelManagementAlarmsAgent = {
  alarmCategory: Maybe<Scalars['String']['output']>;
  alarmCode: Maybe<Scalars['JSONObject']['output']>;
  alarmCodeExternalId: Maybe<Scalars['String']['output']>;
  alarmCriticality: Maybe<Scalars['String']['output']>;
  alarmFlags: Maybe<Scalars['String']['output']>;
  alarmName: Maybe<Scalars['String']['output']>;
  alarmPriority: Maybe<Scalars['String']['output']>;
  customWorkflowAlarmMessage: Maybe<Scalars['String']['output']>;
  endDateTime: Maybe<Scalars['Timestamp']['output']>;
  entityExternalId: Scalars['String']['output'];
  entityName: Scalars['String']['output'];
  entityType: Scalars['String']['output'];
  startDateTime: Scalars['Timestamp']['output'];
  subCategory: Maybe<Scalars['String']['output']>;
  subWorkflowName: Maybe<Scalars['String']['output']>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString: Maybe<StringAsset>;
  workflowCode: Maybe<Scalars['String']['output']>;
  workflowName: Maybe<Scalars['String']['output']>;
};

/**
 * Model-matched rates from Prosper well model calibration per well string.
 *
 * Contains model-matched rates generated by the Prosper well model, which are
 * aligned with well test data, including oil, gas, water, liquid rates, and
 * bottom hole pressure (BHP). Sourced from calibrated Prosper models and is used
 * to evaluate the accuracy of the model against actual measurements, answering
 * questions related to model performance and well efficiency. It excludes raw
 * well test data or uncalibrated model outputs, distinguishing it from other
 * views that may focus on unprocessed measurements. Use cases: assessing model
 * quality through alarm flags that highlight deviations from both measured data
 * and historical performance trends.
 *
 * @name Model-Matched Rates - String (Agent)
 */
export type ModelMatchedRatesStringAgent = {
  /** Model-matched condensate-gas ratio at live/local conditions (stb/MMscf, TS). */
  cgrLC: Maybe<TimeSeries>;
  /** Model-matched condensate-gas ratio at standard conditions (stb/MMscf, TS). */
  cgrSC: Maybe<TimeSeries>;
  /**
   * Choke model validation alarm (TS). 1 = pass, 0 = fail.
   * @name chokeCheckStatus
   */
  chokeAlarms: Maybe<TimeSeries>;
  /**
   * Choke equation gas rate (MMscfd, TS).
   * @name chokeCalculatedGasRate
   */
  chokeMatchedgasRate: Maybe<TimeSeries>;
  /**
   * Choke equation liquid rate (stb/d, TS).
   * @name chokeCalculatedLiquidRate
   */
  chokeMatchedliquidRate: Maybe<TimeSeries>;
  /**
   * Measured gas rate at standard conditions (MMscfd, TS).
   * @name measuredGasRate
   */
  gasRateSC: Maybe<TimeSeries>;
  /** Model-matched gas-oil ratio at live/local conditions (scf/stb, TS). */
  gorLC: Maybe<TimeSeries>;
  /**
   * Historical trend validation alarm (TS). 1 = pass, 0 = fail.
   * @name historyCheckStatus
   */
  historicalAlarms: Maybe<TimeSeries>;
  /**
   * Prosper model validation alarm (TS). 1 = pass, 0 = fail.
   * @name modelCheckStatus
   */
  modelAlarms: Maybe<TimeSeries>;
  /** Prosper model-matched flowing bottom-hole pressure (psi, TS). */
  modelMatchedBHP: Maybe<TimeSeries>;
  /**
   * Prosper model-matched gas rate (MMscfd, TS).
   * @name modelMatchedGasRate
   */
  modelMatchedgasRate: Maybe<TimeSeries>;
  /**
   * Prosper model-matched total liquid rate (stb/d, TS).
   * @name modelMatchedLiquidRate
   */
  modelMatchedliquidRate: Maybe<TimeSeries>;
  /**
   * Prosper model-matched oil rate (stb/d, TS).
   * @name modelMatchedOilRate
   */
  modelMatchedoilRate: Maybe<TimeSeries>;
  /**
   * Prosper model-matched water rate (stb/d, TS).
   * @name modelMatchedWaterRate
   */
  modelMatchedwaterRate: Maybe<TimeSeries>;
  /**
   * Measured oil rate at standard conditions (stb/d, TS).
   * @name measuredOilRate
   */
  oilRateSC: Maybe<TimeSeries>;
  /**
   * PVT validation alarm (TS). 1 = pass, 0 = fail.
   * @name pvtCheckStatus
   */
  pvtAlarms: Maybe<TimeSeries>;
  /** Model-matched total gas-oil ratio at standard conditions (scf/stb, TS). */
  totalGorSC: Maybe<TimeSeries>;
  /** Model-matched water cut at live/local conditions (fraction, TS). */
  waterCutLC: Maybe<TimeSeries>;
  /** Model-matched water cut at standard conditions (fraction, TS). */
  waterCutSC: Maybe<TimeSeries>;
  /** Well string identifier. */
  wellString: Maybe<StringAsset>;
  /** Model-matched water-gas ratio at live/local conditions (stb/MMscf, TS). */
  wgrLC: Maybe<TimeSeries>;
  /** Model-matched water-gas ratio at standard conditions (stb/MMscf, TS). */
  wgrSC: Maybe<TimeSeries>;
};

/** View 'Mpfm' in the iPSO production optimization solution data model. */
export type Mpfm = {
  /** Timestamp 'endDateTime' associated with this 'Mpfm' row. */
  endDateTime: Maybe<Scalars['Timestamp']['output']>;
  /** Text attribute 'entityType' for this 'Mpfm' row. */
  entityType: Maybe<Scalars['String']['output']>;
  /** Reference to the related 'Location' entity for this 'Mpfm' row. */
  location: Maybe<Location>;
  /** Text attribute 'modelName' for this 'Mpfm' row. */
  modelName: Maybe<Scalars['String']['output']>;
  /** Text attribute 'name' for this 'Mpfm' row. */
  name: Maybe<Scalars['String']['output']>;
  /** Timestamp 'startDateTime' associated with this 'Mpfm' row. */
  startDateTime: Maybe<Scalars['Timestamp']['output']>;
};

/** View 'MpfmInputs' in the iPSO production optimization solution data model. */
export type MpfmInputs = {
  /** Reference to the related 'Mpfm' entity for this 'MpfmInputs' row. */
  entityName: Maybe<Mpfm>;
  /** Reference to a time series for 'mpfmBSWMaxRange' in this 'MpfmInputs' view. */
  mpfmBSWMaxRange: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmBSWMinRange' in this 'MpfmInputs' view. */
  mpfmBSWMinRange: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmCalcCGRInSitu' in this 'MpfmInputs' view. */
  mpfmCalcCGRInSitu: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmCalcCGRStd' in this 'MpfmInputs' view. */
  mpfmCalcCGRStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmCalcGORInsitu' in this 'MpfmInputs' view. */
  mpfmCalcGORInsitu: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmCalcGORStd' in this 'MpfmInputs' view. */
  mpfmCalcGORStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmCalcGasDensityInSitu' in this 'MpfmInputs' view. */
  mpfmCalcGasDensityInSitu: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmCalcLiquidRateInSitu' in this 'MpfmInputs' view. */
  mpfmCalcLiquidRateInSitu: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmCalcLiquidRateStd' in this 'MpfmInputs' view. */
  mpfmCalcLiquidRateStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmCalcOilDensityInSitu' in this 'MpfmInputs' view. */
  mpfmCalcOilDensityInSitu: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmCalcWGRInSitu' in this 'MpfmInputs' view. */
  mpfmCalcWGRInSitu: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmCalcWGRStd' in this 'MpfmInputs' view. */
  mpfmCalcWGRStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmCalcWLRInSitu' in this 'MpfmInputs' view. */
  mpfmCalcWLRInSitu: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmCalcWaterDensityInSitu' in this 'MpfmInputs' view. */
  mpfmCalcWaterDensityInSitu: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmCumGasVolInSitu' in this 'MpfmInputs' view. */
  mpfmCumGasVolInSitu: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmCumGasVolStd' in this 'MpfmInputs' view. */
  mpfmCumGasVolStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmCumLiquidVolInSitu' in this 'MpfmInputs' view. */
  mpfmCumLiquidVolInSitu: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmCumLiquidVolStd' in this 'MpfmInputs' view. */
  mpfmCumLiquidVolStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmDeltaPressMaxRange' in this 'MpfmInputs' view. */
  mpfmDeltaPressMaxRange: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmDeltaPressMinRange' in this 'MpfmInputs' view. */
  mpfmDeltaPressMinRange: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmDifferentialPress' in this 'MpfmInputs' view. */
  mpfmDifferentialPress: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmFlagOnTest' in this 'MpfmInputs' view. */
  mpfmFlagOnTest: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmGORLCMaxRange' in this 'MpfmInputs' view. */
  mpfmGORLCMaxRange: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmGORLCMinRange' in this 'MpfmInputs' view. */
  mpfmGORLCMinRange: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmGORSTB' in this 'MpfmInputs' view. */
  mpfmGORSTB: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmGVFInSitu' in this 'MpfmInputs' view. */
  mpfmGVFInSitu: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmGVFMaxRange' in this 'MpfmInputs' view. */
  mpfmGVFMaxRange: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmGVFMinRange' in this 'MpfmInputs' view. */
  mpfmGVFMinRange: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmGasDensityInSitu' in this 'MpfmInputs' view. */
  mpfmGasDensityInSitu: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmGasDensityMaxRange' in this 'MpfmInputs' view. */
  mpfmGasDensityMaxRange: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmGasDensityMinRange' in this 'MpfmInputs' view. */
  mpfmGasDensityMinRange: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmGasDensityStd' in this 'MpfmInputs' view. */
  mpfmGasDensityStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmGasMassFlowInSitu' in this 'MpfmInputs' view. */
  mpfmGasMassFlowInSitu: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmGasMassFlowRateMaxRange' in this 'MpfmInputs' view. */
  mpfmGasMassFlowRateMaxRange: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmGasMassFlowRateMinRange' in this 'MpfmInputs' view. */
  mpfmGasMassFlowRateMinRange: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmGasMassFlowStd' in this 'MpfmInputs' view. */
  mpfmGasMassFlowStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmGasMaxRange' in this 'MpfmInputs' view. */
  mpfmGasMaxRange: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmGasMinRange' in this 'MpfmInputs' view. */
  mpfmGasMinRange: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmGasRateInSitu' in this 'MpfmInputs' view. */
  mpfmGasRateInSitu: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmGasRateStd' in this 'MpfmInputs' view. */
  mpfmGasRateStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmLinePress' in this 'MpfmInputs' view. */
  mpfmLinePress: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmLineTemp' in this 'MpfmInputs' view. */
  mpfmLineTemp: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmLiqMaxRange' in this 'MpfmInputs' view. */
  mpfmLiqMaxRange: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmLiqMinRange' in this 'MpfmInputs' view. */
  mpfmLiqMinRange: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmLiquidRateInSitu' in this 'MpfmInputs' view. */
  mpfmLiquidRateInSitu: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmLiquidRateSTB' in this 'MpfmInputs' view. */
  mpfmLiquidRateSTB: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmOVFMaxRange' in this 'MpfmInputs' view. */
  mpfmOVFMaxRange: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmOVFMinRange' in this 'MpfmInputs' view. */
  mpfmOVFMinRange: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmOilDensityInSitu' in this 'MpfmInputs' view. */
  mpfmOilDensityInSitu: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmOilDensityMaxRange' in this 'MpfmInputs' view. */
  mpfmOilDensityMaxRange: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmOilDensityMinRange' in this 'MpfmInputs' view. */
  mpfmOilDensityMinRange: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmOilDensityStd' in this 'MpfmInputs' view. */
  mpfmOilDensityStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmOilMassFlowInSitu' in this 'MpfmInputs' view. */
  mpfmOilMassFlowInSitu: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmOilMassFlowRateMaxRange' in this 'MpfmInputs' view. */
  mpfmOilMassFlowRateMaxRange: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmOilMassFlowRateMinRange' in this 'MpfmInputs' view. */
  mpfmOilMassFlowRateMinRange: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmOilMassFlowStd' in this 'MpfmInputs' view. */
  mpfmOilMassFlowStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmOilMaxRange' in this 'MpfmInputs' view. */
  mpfmOilMaxRange: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmOilMinRange' in this 'MpfmInputs' view. */
  mpfmOilMinRange: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmOilRateInSitu' in this 'MpfmInputs' view. */
  mpfmOilRateInSitu: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmOilRateStd' in this 'MpfmInputs' view. */
  mpfmOilRateStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmOilVolFractionInSitu' in this 'MpfmInputs' view. */
  mpfmOilVolFractionInSitu: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmPressMaxRange' in this 'MpfmInputs' view. */
  mpfmPressMaxRange: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmPressMinRange' in this 'MpfmInputs' view. */
  mpfmPressMinRange: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmStatus' in this 'MpfmInputs' view. */
  mpfmStatus: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmTempMaxRange' in this 'MpfmInputs' view. */
  mpfmTempMaxRange: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmTempMinRange' in this 'MpfmInputs' view. */
  mpfmTempMinRange: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmTotalGORSCMaxRange' in this 'MpfmInputs' view. */
  mpfmTotalGORSCMaxRange: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmTotalGORSCMinRange' in this 'MpfmInputs' view. */
  mpfmTotalGORSCMinRange: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmTotalMassFlow' in this 'MpfmInputs' view. */
  mpfmTotalMassFlow: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmWLRMaxRange' in this 'MpfmInputs' view. */
  mpfmWLRMaxRange: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmWLRMinRange' in this 'MpfmInputs' view. */
  mpfmWLRMinRange: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmWVFMaxRange' in this 'MpfmInputs' view. */
  mpfmWVFMaxRange: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmWVFMinRange' in this 'MpfmInputs' view. */
  mpfmWVFMinRange: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmWaterCutInSitu' in this 'MpfmInputs' view. */
  mpfmWaterCutInSitu: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmWaterCutSTB' in this 'MpfmInputs' view. */
  mpfmWaterCutSTB: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmWaterDensityInSitu' in this 'MpfmInputs' view. */
  mpfmWaterDensityInSitu: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmWaterDensityMaxRange' in this 'MpfmInputs' view. */
  mpfmWaterDensityMaxRange: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmWaterDensityMinRange' in this 'MpfmInputs' view. */
  mpfmWaterDensityMinRange: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmWaterDensityStd' in this 'MpfmInputs' view. */
  mpfmWaterDensityStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmWaterMassFlowInSitu' in this 'MpfmInputs' view. */
  mpfmWaterMassFlowInSitu: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmWaterMassFlowRateMaxRange' in this 'MpfmInputs' view. */
  mpfmWaterMassFlowRateMaxRange: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmWaterMassFlowRateMinRange' in this 'MpfmInputs' view. */
  mpfmWaterMassFlowRateMinRange: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmWaterMassFlowStd' in this 'MpfmInputs' view. */
  mpfmWaterMassFlowStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmWaterMaxRange' in this 'MpfmInputs' view. */
  mpfmWaterMaxRange: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmWaterMinRange' in this 'MpfmInputs' view. */
  mpfmWaterMinRange: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmWaterRateInSitu' in this 'MpfmInputs' view. */
  mpfmWaterRateInSitu: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmWaterRateStd' in this 'MpfmInputs' view. */
  mpfmWaterRateStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmWaterSalinity' in this 'MpfmInputs' view. */
  mpfmWaterSalinity: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmWaterVolumeFractionInSitu' in this 'MpfmInputs' view. */
  mpfmWaterVolumeFractionInSitu: Maybe<TimeSeries>;
};

/** View 'MpfmOutputs' in the iPSO production optimization solution data model. */
export type MpfmOutputs = {
  /** Reference to a time series for 'cgrLC' in this 'MpfmOutputs' view. */
  cgrLC: Maybe<TimeSeries>;
  /** Reference to a time series for 'chokeAlarms' in this 'MpfmOutputs' view. */
  chokeAlarms: Maybe<TimeSeries>;
  /** Reference to a time series for 'chokeAlarmsCode' in this 'MpfmOutputs' view. */
  chokeAlarmsCode: Maybe<TimeSeries>;
  /** Reference to a time series for 'chokeMatchedliquidRate' in this 'MpfmOutputs' view. */
  chokeMatchedliquidRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'comments' in this 'MpfmOutputs' view. */
  comments: Maybe<TimeSeries>;
  /** Reference to a time series for 'composition' in this 'MpfmOutputs' view. */
  composition: Maybe<TimeSeries>;
  /** Reference to the related 'String_asset' entity for this 'MpfmOutputs' row. */
  entityName: Maybe<StringAsset>;
  /** Reference to a time series for 'espwear' in this 'MpfmOutputs' view. */
  espwear: Maybe<TimeSeries>;
  /** Reference to a time series for 'fluidProperties' in this 'MpfmOutputs' view. */
  fluidProperties: Maybe<TimeSeries>;
  /** Reference to a time series for 'formationGOR' in this 'MpfmOutputs' view. */
  formationGOR: Maybe<TimeSeries>;
  /** Reference to a time series for 'gasDensityLC' in this 'MpfmOutputs' view. */
  gasDensityLC: Maybe<TimeSeries>;
  /** Reference to a time series for 'gasDensitySC' in this 'MpfmOutputs' view. */
  gasDensitySC: Maybe<TimeSeries>;
  /** Reference to a time series for 'gasMassFlowRateLC' in this 'MpfmOutputs' view. */
  gasMassFlowRateLC: Maybe<TimeSeries>;
  /** Reference to a time series for 'gasMassFlowRateSC' in this 'MpfmOutputs' view. */
  gasMassFlowRateSC: Maybe<TimeSeries>;
  /** Reference to a time series for 'gasVolumeFractionLC' in this 'MpfmOutputs' view. */
  gasVolumeFractionLC: Maybe<TimeSeries>;
  /** Reference to a time series for 'glFcvOutletTemp' in this 'MpfmOutputs' view. */
  glFcvOutletTemp: Maybe<TimeSeries>;
  /** Reference to a time series for 'glinjectionRate' in this 'MpfmOutputs' view. */
  glinjectionRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'historicalAlarms' in this 'MpfmOutputs' view. */
  historicalAlarms: Maybe<TimeSeries>;
  /** Reference to a time series for 'historicalAlarmsCode' in this 'MpfmOutputs' view. */
  historicalAlarmsCode: Maybe<TimeSeries>;
  /** Reference to a time series for 'liquidRateLc' in this 'MpfmOutputs' view. */
  liquidRateLc: Maybe<TimeSeries>;
  /** Reference to a time series for 'liquidRateSc' in this 'MpfmOutputs' view. */
  liquidRateSc: Maybe<TimeSeries>;
  /** Reference to a time series for 'modelAlarms' in this 'MpfmOutputs' view. */
  modelAlarms: Maybe<TimeSeries>;
  /** Reference to a time series for 'modelAlarmsCode' in this 'MpfmOutputs' view. */
  modelAlarmsCode: Maybe<TimeSeries>;
  /** Reference to a time series for 'modelComposition' in this 'MpfmOutputs' view. */
  modelComposition: Maybe<TimeSeries>;
  /** Reference to a time series for 'modelMatchedBHP' in this 'MpfmOutputs' view. */
  modelMatchedBHP: Maybe<TimeSeries>;
  /** Reference to a time series for 'modelMatchedgasRate' in this 'MpfmOutputs' view. */
  modelMatchedgasRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'modelMatchedliquidRate' in this 'MpfmOutputs' view. */
  modelMatchedliquidRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'modelMatchedoilRate' in this 'MpfmOutputs' view. */
  modelMatchedoilRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'modelMatchedwaterRate' in this 'MpfmOutputs' view. */
  modelMatchedwaterRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'modelMinStableRate' in this 'MpfmOutputs' view. */
  modelMinStableRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'modelProductivityIndex' in this 'MpfmOutputs' view. */
  modelProductivityIndex: Maybe<TimeSeries>;
  /** Reference to a time series for 'modelReservoirModel' in this 'MpfmOutputs' view. */
  modelReservoirModel: Maybe<TimeSeries>;
  /** Reference to a time series for 'modelReservoirPressure' in this 'MpfmOutputs' view. */
  modelReservoirPressure: Maybe<TimeSeries>;
  /** Reference to a time series for 'modelStabilityFlag' in this 'MpfmOutputs' view. */
  modelStabilityFlag: Maybe<TimeSeries>;
  /** Reference to a time series for 'modelVlpModel' in this 'MpfmOutputs' view. */
  modelVlpModel: Maybe<TimeSeries>;
  /** Reference to a time series for 'modelWellTestTimestamp' in this 'MpfmOutputs' view. */
  modelWellTestTimestamp: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmAlarms' in this 'MpfmOutputs' view. */
  mpfmAlarms: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmDifferentialPressure' in this 'MpfmOutputs' view. */
  mpfmDifferentialPressure: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmLinePressure' in this 'MpfmOutputs' view. */
  mpfmLinePressure: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmLineTemperature' in this 'MpfmOutputs' view. */
  mpfmLineTemperature: Maybe<TimeSeries>;
  /** Reference to a time series for 'oilDensityLC' in this 'MpfmOutputs' view. */
  oilDensityLC: Maybe<TimeSeries>;
  /** Reference to a time series for 'oilDensitySC' in this 'MpfmOutputs' view. */
  oilDensitySC: Maybe<TimeSeries>;
  /** Reference to a time series for 'oilMassFlowRateLC' in this 'MpfmOutputs' view. */
  oilMassFlowRateLC: Maybe<TimeSeries>;
  /** Reference to a time series for 'oilMassFlowRateSC' in this 'MpfmOutputs' view. */
  oilMassFlowRateSC: Maybe<TimeSeries>;
  /** Reference to a time series for 'oilVolumeFractionLC' in this 'MpfmOutputs' view. */
  oilVolumeFractionLC: Maybe<TimeSeries>;
  /** Reference to a time series for 'ptsDateTime' in this 'MpfmOutputs' view. */
  ptsDateTime: Maybe<TimeSeries>;
  /** Reference to a time series for 'pumpDischargeTemp' in this 'MpfmOutputs' view. */
  pumpDischargeTemp: Maybe<TimeSeries>;
  /** Reference to a time series for 'pumpMotorTemp' in this 'MpfmOutputs' view. */
  pumpMotorTemp: Maybe<TimeSeries>;
  /** Reference to a time series for 'pumpPower' in this 'MpfmOutputs' view. */
  pumpPower: Maybe<TimeSeries>;
  /** Reference to a time series for 'pumpVibration' in this 'MpfmOutputs' view. */
  pumpVibration: Maybe<TimeSeries>;
  /** Reference to a time series for 'pvtAlarms' in this 'MpfmOutputs' view. */
  pvtAlarms: Maybe<TimeSeries>;
  /** Reference to a time series for 'sampleDateTime' in this 'MpfmOutputs' view. */
  sampleDateTime: Maybe<TimeSeries>;
  /** Reference to a time series for 'stablePeriodEndDate' in this 'MpfmOutputs' view. */
  stablePeriodEndDate: Maybe<TimeSeries>;
  /** Reference to a time series for 'stablePeriodStartDate' in this 'MpfmOutputs' view. */
  stablePeriodStartDate: Maybe<TimeSeries>;
  /** Reference to a time series for 'validatedBy' in this 'MpfmOutputs' view. */
  validatedBy: Maybe<TimeSeries>;
  /** Reference to a time series for 'waterDensityLC' in this 'MpfmOutputs' view. */
  waterDensityLC: Maybe<TimeSeries>;
  /** Reference to a time series for 'waterDensitySC' in this 'MpfmOutputs' view. */
  waterDensitySC: Maybe<TimeSeries>;
  /** Reference to a time series for 'waterMassFlowRateLC' in this 'MpfmOutputs' view. */
  waterMassFlowRateLC: Maybe<TimeSeries>;
  /** Reference to a time series for 'waterMassFlowRateSC' in this 'MpfmOutputs' view. */
  waterMassFlowRateSC: Maybe<TimeSeries>;
  /** Reference to a time series for 'waterVolumeFractionLC' in this 'MpfmOutputs' view. */
  waterVolumeFractionLC: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestApprovedAllocationFlag' in this 'MpfmOutputs' view. */
  wellTestApprovedAllocationFlag: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestArtificialLiftType' in this 'MpfmOutputs' view. */
  wellTestArtificialLiftType: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestBottomHolePressure' in this 'MpfmOutputs' view. */
  wellTestBottomHolePressure: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestBottomHoleTemperature' in this 'MpfmOutputs' view. */
  wellTestBottomHoleTemperature: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestCGR' in this 'MpfmOutputs' view. */
  wellTestCGR: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestCasingHeadPressure' in this 'MpfmOutputs' view. */
  wellTestCasingHeadPressure: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestCasingHeadTemperature' in this 'MpfmOutputs' view. */
  wellTestCasingHeadTemperature: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestChokeOpening' in this 'MpfmOutputs' view. */
  wellTestChokeOpening: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestChokeSize' in this 'MpfmOutputs' view. */
  wellTestChokeSize: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestDuration' in this 'MpfmOutputs' view. */
  wellTestDuration: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestEgorVendorStdGasRate' in this 'MpfmOutputs' view. */
  wellTestEgorVendorStdGasRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestEgorVendorStdOilRate' in this 'MpfmOutputs' view. */
  wellTestEgorVendorStdOilRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestEgorVendorStdWaterRate' in this 'MpfmOutputs' view. */
  wellTestEgorVendorStdWaterRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestEndDate' in this 'MpfmOutputs' view. */
  wellTestEndDate: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestEspMotorCurrent' in this 'MpfmOutputs' view. */
  wellTestEspMotorCurrent: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestEspMotorPower' in this 'MpfmOutputs' view. */
  wellTestEspMotorPower: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestEspMotorVoltage' in this 'MpfmOutputs' view. */
  wellTestEspMotorVoltage: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestEspPumpDischargePressure' in this 'MpfmOutputs' view. */
  wellTestEspPumpDischargePressure: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestEspPumpFrequency' in this 'MpfmOutputs' view. */
  wellTestEspPumpFrequency: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestEspPumpIntakePressure' in this 'MpfmOutputs' view. */
  wellTestEspPumpIntakePressure: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestEspPumpIntakeTemperature' in this 'MpfmOutputs' view. */
  wellTestEspPumpIntakeTemperature: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestFlowlinePressure' in this 'MpfmOutputs' view. */
  wellTestFlowlinePressure: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestFlowlineTemperature' in this 'MpfmOutputs' view. */
  wellTestFlowlineTemperature: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGOR' in this 'MpfmOutputs' view. */
  wellTestGOR: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGasDensityInSitu' in this 'MpfmOutputs' view. */
  wellTestGasDensityInSitu: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGasLiftVolume' in this 'MpfmOutputs' view. */
  wellTestGasLiftVolume: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGasRateInsitu' in this 'MpfmOutputs' view. */
  wellTestGasRateInsitu: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGasRatePts' in this 'MpfmOutputs' view. */
  wellTestGasRatePts: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGasRateStd' in this 'MpfmOutputs' view. */
  wellTestGasRateStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGlFlControlValvOutletPres' in this 'MpfmOutputs' view. */
  wellTestGlFlControlValvOutletPres: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGlFlControlValveInletPres' in this 'MpfmOutputs' view. */
  wellTestGlFlControlValveInletPres: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGlFlControlValveInletTemp' in this 'MpfmOutputs' view. */
  wellTestGlFlControlValveInletTemp: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGlInjectionChokeOpening' in this 'MpfmOutputs' view. */
  wellTestGlInjectionChokeOpening: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGorInsitu' in this 'MpfmOutputs' view. */
  wellTestGorInsitu: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGorPts' in this 'MpfmOutputs' view. */
  wellTestGorPts: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestLiquidRatePts' in this 'MpfmOutputs' view. */
  wellTestLiquidRatePts: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestMpfmName' in this 'MpfmOutputs' view. */
  wellTestMpfmName: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestOilDensityInSitu' in this 'MpfmOutputs' view. */
  wellTestOilDensityInSitu: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestOilRateInsitu' in this 'MpfmOutputs' view. */
  wellTestOilRateInsitu: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestOilRatePts' in this 'MpfmOutputs' view. */
  wellTestOilRatePts: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestOilRateStd' in this 'MpfmOutputs' view. */
  wellTestOilRateStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestStartDate' in this 'MpfmOutputs' view. */
  wellTestStartDate: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestStartDateDH' in this 'MpfmOutputs' view. */
  wellTestStartDateDH: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestStringFunction' in this 'MpfmOutputs' view. */
  wellTestStringFunction: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestTestMethod' in this 'MpfmOutputs' view. */
  wellTestTestMethod: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestTestSeparatorLinePressure' in this 'MpfmOutputs' view. */
  wellTestTestSeparatorLinePressure: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestTestSeparatorLineTemperature' in this 'MpfmOutputs' view. */
  wellTestTestSeparatorLineTemperature: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestTestType' in this 'MpfmOutputs' view. */
  wellTestTestType: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestTestTypeDesc' in this 'MpfmOutputs' view. */
  wellTestTestTypeDesc: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestTotalGorStd' in this 'MpfmOutputs' view. */
  wellTestTotalGorStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestTotalMassFlowRateGas' in this 'MpfmOutputs' view. */
  wellTestTotalMassFlowRateGas: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestTotalMassFlowRateOil' in this 'MpfmOutputs' view. */
  wellTestTotalMassFlowRateOil: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestTotalMassFlowRateWater' in this 'MpfmOutputs' view. */
  wellTestTotalMassFlowRateWater: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestValidationFlag' in this 'MpfmOutputs' view. */
  wellTestValidationFlag: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestWGR' in this 'MpfmOutputs' view. */
  wellTestWGR: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestWaterCut' in this 'MpfmOutputs' view. */
  wellTestWaterCut: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestWaterCutInsitu' in this 'MpfmOutputs' view. */
  wellTestWaterCutInsitu: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestWaterCutPts' in this 'MpfmOutputs' view. */
  wellTestWaterCutPts: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestWaterRateInsitu' in this 'MpfmOutputs' view. */
  wellTestWaterRateInsitu: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestWaterRatePts' in this 'MpfmOutputs' view. */
  wellTestWaterRatePts: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestWaterRateStd' in this 'MpfmOutputs' view. */
  wellTestWaterRateStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestWellheadPressure' in this 'MpfmOutputs' view. */
  wellTestWellheadPressure: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestWellheadTemperature' in this 'MpfmOutputs' view. */
  wellTestWellheadTemperature: Maybe<TimeSeries>;
  /** Reference to a time series for 'wgrLC' in this 'MpfmOutputs' view. */
  wgrLC: Maybe<TimeSeries>;
  /** Reference to a time series for 'wlrLC' in this 'MpfmOutputs' view. */
  wlrLC: Maybe<TimeSeries>;
};

/** View 'MpfmWellTestOutputs' in the iPSO production optimization solution data model. */
export type MpfmWellTestOutputs = {
  /** Numeric value 'alarmCount' (integer) for this 'MpfmWellTestOutputs' row. */
  alarmCount: Maybe<Scalars['Int']['output']>;
  /** Reference to the related 'Mpfm' entity for this 'MpfmWellTestOutputs' row. */
  entityName: Maybe<Mpfm>;
  /** Reference to the related 'Field' entity for this 'MpfmWellTestOutputs' row. */
  field: Maybe<Field>;
  /** Text attribute 'process1Flag' for this 'MpfmWellTestOutputs' row. */
  process1Flag: Maybe<Scalars['String']['output']>;
  /** Text attribute 'process2Flag' for this 'MpfmWellTestOutputs' row. */
  process2Flag: Maybe<Scalars['String']['output']>;
  /** Text attribute 'process3Flag' for this 'MpfmWellTestOutputs' row. */
  process3Flag: Maybe<Scalars['String']['output']>;
  /** Text attribute 'process4Flag' for this 'MpfmWellTestOutputs' row. */
  process4Flag: Maybe<Scalars['String']['output']>;
  /** Text attribute 'singlePointWellTestFlag' for this 'MpfmWellTestOutputs' row. */
  singlePointWellTestFlag: Maybe<Scalars['String']['output']>;
  /** Timestamp 'stablePeriodEndDateTime' associated with this 'MpfmWellTestOutputs' row. */
  stablePeriodEndDateTime: Maybe<Scalars['Timestamp']['output']>;
  /** Text attribute 'stablePeriodFlag' for this 'MpfmWellTestOutputs' row. */
  stablePeriodFlag: Maybe<Scalars['String']['output']>;
  /** Timestamp 'stablePeriodStartDateTime' associated with this 'MpfmWellTestOutputs' row. */
  stablePeriodStartDateTime: Maybe<Scalars['Timestamp']['output']>;
  /** Timestamp 'startDateTime' associated with this 'MpfmWellTestOutputs' row. */
  startDateTime: Maybe<Scalars['Timestamp']['output']>;
  /** Reference to the related 'String_asset' entity for this 'MpfmWellTestOutputs' row. */
  stringOnTest: Maybe<StringAsset>;
  /** Reference to the related 'Well' entity for this 'MpfmWellTestOutputs' row. */
  wellOnTest: Maybe<Well>;
  /** Timestamp 'wellTestDateTime' associated with this 'MpfmWellTestOutputs' row. */
  wellTestDateTime: Maybe<Scalars['Timestamp']['output']>;
};

/** View 'Network' in the iPSO production optimization solution data model. */
export type Network = {
  /** Reference to the related 'Field' entity for this 'Network' row. */
  connectedFields: Maybe<Maybe<Field>[]>;
  /** Timestamp 'endDateTime' associated with this 'Network' row. */
  endDateTime: Maybe<Scalars['Timestamp']['output']>;
  /** Text attribute 'entityType' for this 'Network' row. */
  entityType: Maybe<Scalars['String']['output']>;
  /** Property 'field' for this 'Network' row. */
  field: Maybe<Maybe<Field>[]>;
  /** Reference to the related 'Field' entity for this 'Network' row. */
  fieldName: Maybe<Field>;
  /** Direct relation property 'linkedField' for this 'Network' row. */
  linkedField: Maybe<Maybe<Scalars['JSONObject']['output']>[]>;
  /** Text attribute 'name' for this 'Network' row. */
  name: Maybe<Scalars['String']['output']>;
  /** Text attribute 'networkType' for this 'Network' row. */
  networkType: Maybe<Scalars['String']['output']>;
  /** Text attribute 'primaryFluid' for this 'Network' row. */
  primaryFluid: Maybe<Scalars['String']['output']>;
  /** Timestamp 'startDateTime' associated with this 'Network' row. */
  startDateTime: Maybe<Scalars['Timestamp']['output']>;
};

/**
 * Network optimization alarms with medium or high priority.
 *
 * The Network Optimization Alarms (Agent) view contains data related to alarms
 * generated during network surveillance and optimization processes, medium and
 * high-priority alerts. This data is derived from various workflows, including
 * network surveillance, model validations, and production optimization
 * scenarios, ensuring relevance to operational efficiency. Answers questions on
 * frequency, types, and impact on network performance. Excludes low-priority alarms.
 *
 * Use for: Network Surveillance (WF7), Network Model Validation (WF8), Production Optimization Scenarios (WF11).
 *
 * @name Network Optimization Alarms (Agent)
 */
export type NetworkAlarmsAgent = {
  alarmCategory: Maybe<Scalars['String']['output']>;
  alarmCode: Maybe<Scalars['JSONObject']['output']>;
  alarmCodeExternalId: Maybe<Scalars['String']['output']>;
  /** Number of consecutive occurrences of this alarm. */
  alarmCounter: Maybe<Scalars['Int']['output']>;
  alarmCriticality: Maybe<Scalars['String']['output']>;
  alarmFlags: Maybe<Scalars['String']['output']>;
  alarmName: Maybe<Scalars['String']['output']>;
  alarmPriority: Maybe<Scalars['String']['output']>;
  customWorkflowAlarmMessage: Maybe<Scalars['String']['output']>;
  endDateTime: Maybe<Scalars['Timestamp']['output']>;
  entityExternalId: Scalars['String']['output'];
  entityName: Scalars['String']['output'];
  entityType: Scalars['String']['output'];
  startDateTime: Scalars['Timestamp']['output'];
  /** Alarm sub-category for domain filtering. */
  subCategory: Maybe<Scalars['String']['output']>;
  /** Sub-workflow that generated the alarm. */
  subWorkflowName: Maybe<Scalars['String']['output']>;
  /** Associated ticket/action ID if alarm has been acknowledged. */
  ticketId: Maybe<Scalars['String']['output']>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString: Maybe<StringAsset>;
  workflowCode: Maybe<Scalars['String']['output']>;
  workflowName: Maybe<Scalars['String']['output']>;
};

/** View 'NetworkInputs' in the iPSO production optimization solution data model. */
export type NetworkInputs = {
  /** Reference to a time series for 'asphalteneTable' in this 'NetworkInputs' view. */
  asphalteneTable: Maybe<TimeSeries>;
  /** Reference to a time series for 'availableGLRate' in this 'NetworkInputs' view. */
  availableGLRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'availablePower' in this 'NetworkInputs' view. */
  availablePower: Maybe<TimeSeries>;
  /** Reference to a time series for 'capacityGasRate' in this 'NetworkInputs' view. */
  capacityGasRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'capacityOilRate' in this 'NetworkInputs' view. */
  capacityOilRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'capacityWaterRate' in this 'NetworkInputs' view. */
  capacityWaterRate: Maybe<TimeSeries>;
  /** Reference to the related 'Network' entity for this 'NetworkInputs' row. */
  entityName: Maybe<Network>;
  /** Reference to a time series for 'flowlineMaxCFactor' in this 'NetworkInputs' view. */
  flowlineMaxCFactor: Maybe<TimeSeries>;
  /** Reference to a time series for 'flowlineMaxLinePressure' in this 'NetworkInputs' view. */
  flowlineMaxLinePressure: Maybe<TimeSeries>;
  /** Reference to a time series for 'flowlineMaxMixtureVelocity' in this 'NetworkInputs' view. */
  flowlineMaxMixtureVelocity: Maybe<TimeSeries>;
  /** Reference to a time series for 'gasBarrelOfOilEquivalent' in this 'NetworkInputs' view. */
  gasBarrelOfOilEquivalent: Maybe<TimeSeries>;
  /** Reference to a time series for 'gasPrice' in this 'NetworkInputs' view. */
  gasPrice: Maybe<TimeSeries>;
  /** Reference to a time series for 'gasProcessingCost' in this 'NetworkInputs' view. */
  gasProcessingCost: Maybe<TimeSeries>;
  /** Reference to a time series for 'hydrateTable' in this 'NetworkInputs' view. */
  hydrateTable: Maybe<TimeSeries>;
  /** Reference to a time series for 'jointMaxCO2' in this 'NetworkInputs' view. */
  jointMaxCO2: Maybe<TimeSeries>;
  /** Reference to a time series for 'jointMaxGasRate' in this 'NetworkInputs' view. */
  jointMaxGasRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'jointMaxH2S' in this 'NetworkInputs' view. */
  jointMaxH2S: Maybe<TimeSeries>;
  /** Reference to a time series for 'jointMaxLiquidRate' in this 'NetworkInputs' view. */
  jointMaxLiquidRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'jointMaxN2' in this 'NetworkInputs' view. */
  jointMaxN2: Maybe<TimeSeries>;
  /** Reference to a time series for 'jointMaxOilRate' in this 'NetworkInputs' view. */
  jointMaxOilRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'jointMaxPressure' in this 'NetworkInputs' view. */
  jointMaxPressure: Maybe<TimeSeries>;
  /** Reference to a time series for 'jointMinPressure' in this 'NetworkInputs' view. */
  jointMinPressure: Maybe<TimeSeries>;
  /** Reference to a time series for 'liftCost' in this 'NetworkInputs' view. */
  liftCost: Maybe<TimeSeries>;
  /** Reference to a time series for 'manifoldPress' in this 'NetworkInputs' view. */
  manifoldPress: Maybe<TimeSeries>;
  /** Reference to a time series for 'manifoldTemp' in this 'NetworkInputs' view. */
  manifoldTemp: Maybe<TimeSeries>;
  /** Reference to a time series for 'oilPrice' in this 'NetworkInputs' view. */
  oilPrice: Maybe<TimeSeries>;
  /** Reference to a time series for 'oilProcessingCost' in this 'NetworkInputs' view. */
  oilProcessingCost: Maybe<TimeSeries>;
  /** Reference to a time series for 'plannedFacilityDowntime' in this 'NetworkInputs' view. */
  plannedFacilityDowntime: Maybe<TimeSeries>;
  /** Reference to a time series for 'scaleTable' in this 'NetworkInputs' view. */
  scaleTable: Maybe<TimeSeries>;
  /** Reference to a time series for 'separatorGasRate' in this 'NetworkInputs' view. */
  separatorGasRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'separatorMaxGasRate' in this 'NetworkInputs' view. */
  separatorMaxGasRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'separatorMaxOilRate' in this 'NetworkInputs' view. */
  separatorMaxOilRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'separatorMaxWaterRate' in this 'NetworkInputs' view. */
  separatorMaxWaterRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'separatorOilRate' in this 'NetworkInputs' view. */
  separatorOilRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'separatorPressure' in this 'NetworkInputs' view. */
  separatorPressure: Maybe<TimeSeries>;
  /** Reference to a time series for 'separatorTemperature' in this 'NetworkInputs' view. */
  separatorTemperature: Maybe<TimeSeries>;
  /** Reference to a time series for 'separatorWaterRate' in this 'NetworkInputs' view. */
  separatorWaterRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'surfacePumpMaxLiquidRate' in this 'NetworkInputs' view. */
  surfacePumpMaxLiquidRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'waterDisposalCost' in this 'NetworkInputs' view. */
  waterDisposalCost: Maybe<TimeSeries>;
  /** Reference to a time series for 'waxTable' in this 'NetworkInputs' view. */
  waxTable: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellMaxGOR' in this 'NetworkInputs' view. */
  wellMaxGOR: Maybe<TimeSeries>;
};

/**
 * Network-level input conditions for the WF7 GAP network model (WF7).
 *
 * Operating constraints and facility-level input parameters (separator
 * conditions, compressor settings, targets) applied to the network as a whole
 * on a given run. Use to understand the assumptions behind a network-level
 * simulation and to compare input sets across runs. For results see
 * NetworkOutputs_Field_Agent and NetworkOutputs_String_Agent.
 *
 * Use for: Network Surveillance (WF7), Network Model Validation (WF8).
 *
 * @name Network Inputs (Agent)
 */
export type NetworkInputsAgent = {
  availableGLRate: Maybe<TimeSeries>;
  availablePower: Maybe<TimeSeries>;
  capacityGasRate: Maybe<TimeSeries>;
  capacityOilRate: Maybe<TimeSeries>;
  capacityWaterRate: Maybe<TimeSeries>;
  flowlineMaxCFactor: Maybe<TimeSeries>;
  flowlineMaxLinePressure: Maybe<TimeSeries>;
  flowlineMaxMixtureVelocity: Maybe<TimeSeries>;
  gasBarrelOfOilEquivalent: Maybe<TimeSeries>;
  gasPrice: Maybe<TimeSeries>;
  gasProcessingCost: Maybe<TimeSeries>;
  jointMaxCO2: Maybe<TimeSeries>;
  jointMaxGasRate: Maybe<TimeSeries>;
  jointMaxH2S: Maybe<TimeSeries>;
  jointMaxLiquidRate: Maybe<TimeSeries>;
  jointMaxN2: Maybe<TimeSeries>;
  jointMaxOilRate: Maybe<TimeSeries>;
  jointMaxPressure: Maybe<TimeSeries>;
  jointMinPressure: Maybe<TimeSeries>;
  liftCost: Maybe<TimeSeries>;
  manifoldPress: Maybe<TimeSeries>;
  manifoldTemp: Maybe<TimeSeries>;
  /** Reference to the network model entity. */
  networkName: Maybe<Network>;
  oilPrice: Maybe<TimeSeries>;
  oilProcessingCost: Maybe<TimeSeries>;
  plannedFacilityDowntime: Maybe<TimeSeries>;
  separatorGasRate: Maybe<TimeSeries>;
  separatorMaxGasRate: Maybe<TimeSeries>;
  separatorMaxOilRate: Maybe<TimeSeries>;
  separatorMaxWaterRate: Maybe<TimeSeries>;
  separatorOilRate: Maybe<TimeSeries>;
  separatorPressure: Maybe<TimeSeries>;
  separatorTemperature: Maybe<TimeSeries>;
  separatorWaterRate: Maybe<TimeSeries>;
  surfacePumpMaxLiquidRate: Maybe<TimeSeries>;
  waterDisposalCost: Maybe<TimeSeries>;
  wellMaxGOR: Maybe<TimeSeries>;
};

/** View 'NetworkModel' in the iPSO production optimization solution data model. */
export type NetworkModel = {
  /** asphaltene curve for the network */
  asphalteneCurve: Maybe<Scalars['JSONObject']['output']>;
  azureBlobUrl: Maybe<Scalars['String']['output']>;
  /** Text attribute 'changeDetails' for this 'NetworkModel' row. */
  changeDetails: Maybe<Scalars['String']['output']>;
  /** Reference to the related 'Field' entity for this 'NetworkModel' row. */
  connectedFields: Maybe<Maybe<Field>[]>;
  /** Text attribute 'description' for this 'NetworkModel' row. */
  description: Maybe<Scalars['String']['output']>;
  estimatedGasRate: Maybe<Scalars['Float']['output']>;
  estimatedLiquidRate: Maybe<Scalars['Float']['output']>;
  estimatedOilRate: Maybe<Scalars['Float']['output']>;
  /** Name of the Petroleum Experts GAP file. */
  gapFileName: Maybe<Scalars['String']['output']>;
  /** Text attribute 'garFileName' for this 'NetworkModel' row. */
  garFileName: Maybe<Scalars['String']['output']>;
  /** hydrate curve for the network */
  hydrateCurve: Maybe<Scalars['JSONObject']['output']>;
  inputModel: Maybe<NetworkModel>;
  /** Text attribute 'legacyGapFileExternalId' for this 'NetworkModel' row. */
  legacyGapFileExternalId: Maybe<Scalars['String']['output']>;
  /** Numeric value 'legacyGapFileId' (integer) for this 'NetworkModel' row. */
  legacyGapFileId: Maybe<Scalars['Int64']['output']>;
  /** Text attribute 'legacyGarFileExternalId' for this 'NetworkModel' row. */
  legacyGarFileExternalId: Maybe<Scalars['String']['output']>;
  /** Numeric value 'legacyGarFileId' (integer) for this 'NetworkModel' row. */
  legacyGarFileId: Maybe<Scalars['Int64']['output']>;
  /** Numeric value 'legacyInputGapFileId' (integer) for this 'NetworkModel' */
  legacyInputGapFileId: Maybe<Scalars['Int64']['output']>;
  /** Numeric value 'legacyInputGarFileId' (integer) for this 'NetworkModel' */
  legacyInputGarFileId: Maybe<Scalars['Int64']['output']>;
  measuredGasRate: Maybe<Scalars['Float']['output']>;
  measuredLiquidRate: Maybe<Scalars['Float']['output']>;
  measuredOilRate: Maybe<Scalars['Float']['output']>;
  /** Property 'modelConfig' for this 'NetworkModel' row. */
  modelConfig: Maybe<Scalars['JSONObject']['output']>;
  /** Text attribute 'modelConfigLegacyFileExternalId' for this 'NetworkModel' row. */
  modelConfigLegacyFileExternalId: Maybe<Scalars['String']['output']>;
  /** Timestamp 'modelEffectiveTime' associated with this 'NetworkModel' row. */
  modelEffectiveTime: Maybe<Scalars['Timestamp']['output']>;
  modelSimIntConfig: Maybe<Scalars['JSONObject']['output']>;
  /** Text attribute 'modelSimIntRevisionConfigLegacyFileExternalId' for this 'NetworkModel' row. */
  modelSimIntRevisionConfigLegacyFileExternalId: Maybe<Scalars['String']['output']>;
  /** Text attribute 'modelUpdatedBy' for this 'NetworkModel' row. */
  modelUpdatedBy: Maybe<Scalars['String']['output']>;
  /** Timestamp 'modelUpdatedTime' associated with this 'NetworkModel' row. */
  modelUpdatedTime: Maybe<Scalars['Timestamp']['output']>;
  /** Text attribute 'modelUploadedBy' for this 'NetworkModel' row. */
  modelUploadedBy: Maybe<Scalars['String']['output']>;
  /** Timestamp 'modelUploadedTime' associated with this 'NetworkModel' row. */
  modelUploadedTime: Maybe<Scalars['Timestamp']['output']>;
  /** Reference to the related 'Network' entity for this 'NetworkModel' row. */
  network: Maybe<Network>;
  /** Source file type. For example gap or gar */
  networkSourceFileType: Maybe<Scalars['String']['output']>;
  /** Text attribute 'networkType' for this 'NetworkModel' row. */
  networkType: Maybe<Scalars['String']['output']>;
  /** OpenServer commands used to modify the network */
  openServerCommandsLegacyFileId: Maybe<Scalars['Int64']['output']>;
  /** Text attribute 'originalGarFileName' for this 'NetworkModel' row. */
  originalGarFileName: Maybe<Scalars['String']['output']>;
  /** Numeric value 'pressureMatchedWellModels' (integer) for this 'NetworkModel' row. */
  pressureMatchedWellModels: Maybe<Scalars['Int']['output']>;
  /** Property 'productivityIndexDifferencePercentage' for this 'NetworkModel' row. */
  productivityIndexDifferencePercentage: Maybe<Scalars['JSONObject']['output']>;
  /** Text attribute 'simIntExternalId' for this 'NetworkModel' row. */
  simIntExternalId: Maybe<Scalars['String']['output']>;
  /** Text attribute 'simIntModelExternalId' for this 'NetworkModel' row. */
  simIntModelExternalId: Maybe<Scalars['String']['output']>;
  /** Timestamp 'simIntModelRevisionCreatedTime' associated with this 'NetworkModel' row. */
  simIntModelRevisionCreatedTime: Maybe<Scalars['Timestamp']['output']>;
  /** Text attribute 'simIntModelRevisionDescription' for this 'NetworkModel' row. */
  simIntModelRevisionDescription: Maybe<Scalars['String']['output']>;
  /** Text attribute 'simIntModelRevisionExternalId' for this 'NetworkModel' row. */
  simIntModelRevisionExternalId: Maybe<Scalars['String']['output']>;
  /** Text attribute 'simIntModelRevisionId' for this 'NetworkModel' row. */
  simIntModelRevisionId: Maybe<Scalars['String']['output']>;
  /** Text attribute 'simIntModelRevisionLogId' for this 'NetworkModel' row. */
  simIntModelRevisionLogId: Maybe<Scalars['String']['output']>;
  /** Text attribute 'simIntModelRevisionStatus' for this 'NetworkModel' row. */
  simIntModelRevisionStatus: Maybe<Scalars['String']['output']>;
  /** Text attribute 'simIntModelRevisionStatusMessage' for this 'NetworkModel' row. */
  simIntModelRevisionStatusMessage: Maybe<Scalars['String']['output']>;
  /** Timestamp 'simIntModelRevisionUpdatedTime' associated with this 'NetworkModel' row. */
  simIntModelRevisionUpdatedTime: Maybe<Scalars['Timestamp']['output']>;
  /** Numeric value 'simIntModelRevisionVersionId' (integer) for this 'NetworkModel' row. */
  simIntModelRevisionVersionId: Maybe<Scalars['Int']['output']>;
  /** Text attribute 'source' for this 'NetworkModel' row. */
  source: Maybe<Scalars['String']['output']>;
  /** Text attribute 'status' for this 'NetworkModel' row. */
  status: Maybe<Scalars['String']['output']>;
  /** Numeric value 'totalWellModels' (integer) for this 'NetworkModel' row. */
  totalWellModels: Maybe<Scalars['Int']['output']>;
  /** wax curve for the network */
  waxCurve: Maybe<Scalars['JSONObject']['output']>;
  /** Boolean flag 'wf8Processed' for this 'NetworkModel' row. */
  wf8Processed: Maybe<Scalars['Boolean']['output']>;
  /** True means this network model was consumed by network model management workflow. */
  wf9Consumed: Maybe<Scalars['Boolean']['output']>;
  wf9GarFileId: Maybe<Scalars['Int64']['output']>;
  /** Boolean flag 'wf9Processed' for this 'NetworkModel' row. */
  wf9Processed: Maybe<Scalars['Boolean']['output']>;
};

/**
 * GAP network model configuration, metadata, and calibration status (WF7/WF8).
 *
 * Per-network metadata: model version, last upload and calibration dates,
 * connected fields, and simulation/solver settings for each GAP network
 * instance. Use to check which GAP model is active, when it was last
 * calibrated, and which fields it covers. Excludes simulation outputs and
 * production metrics (see NetworkOutputs_Field_Agent and NetworkOutputs_String_Agent).
 *
 * Use for: Network Surveillance (WF7).
 *
 * @name Network Model (Agent)
 */
export type NetworkModelAgent = {
  /** Description of changes made in latest model update. */
  changeDetails: Maybe<Scalars['String']['output']>;
  /** Fields connected to this network model. */
  connectedFields: Maybe<Maybe<Field>[]>;
  /** Model description and engineering notes. */
  description: Maybe<Scalars['String']['output']>;
  /** GAP model file name (current version). */
  garFileName: Maybe<Scalars['String']['output']>;
  /** Model configuration parameters. */
  modelConfig: Maybe<Scalars['JSONObject']['output']>;
  /** When this model version became effective. */
  modelEffectiveTime: Maybe<Scalars['Timestamp']['output']>;
  /** User who last updated the model. */
  modelUpdatedBy: Maybe<Scalars['String']['output']>;
  /** Timestamp of last model update. */
  modelUpdatedTime: Maybe<Scalars['Timestamp']['output']>;
  /** User who uploaded the model. */
  modelUploadedBy: Maybe<Scalars['String']['output']>;
  /** Timestamp of model upload. */
  modelUploadedTime: Maybe<Scalars['Timestamp']['output']>;
  /** Reference to parent network entity. */
  network: Maybe<Network>;
  /** Type of network model. */
  networkType: Maybe<Scalars['String']['output']>;
  /** Original GAP model file name before modifications. */
  originalGarFileName: Maybe<Scalars['String']['output']>;
  /** Count of well models with successful pressure match. */
  pressureMatchedWellModels: Maybe<Scalars['Int']['output']>;
  /** PI difference between model and well test (%). */
  productivityIndexDifferencePercentage: Maybe<Scalars['JSONObject']['output']>;
  /** Origin of the model. */
  source: Maybe<Scalars['String']['output']>;
  /** Model status (e.g., Valid, Invalid, Draft). */
  status: Maybe<Scalars['String']['output']>;
  /** Total number of well models in this network. */
  totalWellModels: Maybe<Scalars['Int']['output']>;
  /** Whether WF-9 model management has processed this model (0/1). */
  wf9Consumed: Maybe<Scalars['Boolean']['output']>;
};

/** View 'NetworkOutputs_Field' in the iPSO production optimization solution data model. */
export type NetworkOutputsField = {
  adHocOptimization1Comment: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocOptimization1ExecutedBy' in this 'NetworkOutputs_Field' view. */
  adHocOptimization1ExecutedBy: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocOptimization1GasRate' in this 'NetworkOutputs_Field' view. */
  adHocOptimization1GasRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocOptimization1OilRate' in this 'NetworkOutputs_Field' view. */
  adHocOptimization1OilRate: Maybe<TimeSeries>;
  adHocOptimization1RunID: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocOptimization1WaterRate' in this 'NetworkOutputs_Field' view. */
  adHocOptimization1WaterRate: Maybe<TimeSeries>;
  adHocOptimization2Comment: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocOptimization2ExecutedBy' in this 'NetworkOutputs_Field' view. */
  adHocOptimization2ExecutedBy: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocOptimization2GasRate' in this 'NetworkOutputs_Field' view. */
  adHocOptimization2GasRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocOptimization2OilRate' in this 'NetworkOutputs_Field' view. */
  adHocOptimization2OilRate: Maybe<TimeSeries>;
  adHocOptimization2RunID: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocOptimization2WaterRate' in this 'NetworkOutputs_Field' view. */
  adHocOptimization2WaterRate: Maybe<TimeSeries>;
  adHocSimulation1Comment: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocSimulation1ExecutedBy' in this 'NetworkOutputs_Field' view. */
  adHocSimulation1ExecutedBy: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocSimulation1GasRate' in this 'NetworkOutputs_Field' view. */
  adHocSimulation1GasRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocSimulation1OilRate' in this 'NetworkOutputs_Field' view. */
  adHocSimulation1OilRate: Maybe<TimeSeries>;
  adHocSimulation1RunID: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocSimulation1WaterRate' in this 'NetworkOutputs_Field' view. */
  adHocSimulation1WaterRate: Maybe<TimeSeries>;
  adHocSimulation2Comment: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocSimulation2ExecutedBy' in this 'NetworkOutputs_Field' view. */
  adHocSimulation2ExecutedBy: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocSimulation2GasRate' in this 'NetworkOutputs_Field' view. */
  adHocSimulation2GasRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocSimulation2OilRate' in this 'NetworkOutputs_Field' view. */
  adHocSimulation2OilRate: Maybe<TimeSeries>;
  adHocSimulation2RunID: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocSimulation2WaterRate' in this 'NetworkOutputs_Field' view. */
  adHocSimulation2WaterRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'calcualtedSeparatorGasRate' in this 'NetworkOutputs_Field' view. */
  calcualtedSeparatorGasRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'calculatedFlowLinePressure' in this 'NetworkOutputs_Field' view. */
  calculatedFlowLinePressure: Maybe<TimeSeries>;
  /** Reference to a time series for 'calculatedJointCo2' in this 'NetworkOutputs_Field' view. */
  calculatedJointCo2: Maybe<TimeSeries>;
  /** Reference to a time series for 'calculatedJointGasRate' in this 'NetworkOutputs_Field' view. */
  calculatedJointGasRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'calculatedJointH2S' in this 'NetworkOutputs_Field' view. */
  calculatedJointH2S: Maybe<TimeSeries>;
  /** Reference to a time series for 'calculatedJointLiquidRate' in this 'NetworkOutputs_Field' view. */
  calculatedJointLiquidRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'calculatedJointN2' in this 'NetworkOutputs_Field' view. */
  calculatedJointN2: Maybe<TimeSeries>;
  /** Reference to a time series for 'calculatedJointOilRate' in this 'NetworkOutputs_Field' view. */
  calculatedJointOilRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'calculatedJointPressure' in this 'NetworkOutputs_Field' view. */
  calculatedJointPressure: Maybe<TimeSeries>;
  /** Reference to a time series for 'calculatedPressureMatchIndex' in this 'NetworkOutputs_Field' view. */
  calculatedPressureMatchIndex: Maybe<TimeSeries>;
  /** Reference to a time series for 'calculatedSeparatorOilRate' in this 'NetworkOutputs_Field' view. */
  calculatedSeparatorOilRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'calculatedSepratorWaterRate' in this 'NetworkOutputs_Field' view. */
  calculatedSepratorWaterRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'calculatedTotalGasRate' in this 'NetworkOutputs_Field' view. */
  calculatedTotalGasRate: Maybe<TimeSeries>;
  calculatedTotalGasRateGI: Maybe<TimeSeries>;
  /** Reference to a time series for 'calculatedTotalLiquidRate' in this 'NetworkOutputs_Field' view. */
  calculatedTotalLiquidRate: Maybe<TimeSeries>;
  calculatedTotalLiquidRateWI: Maybe<TimeSeries>;
  /** Reference to a time series for 'calculatedTotalOilRate' in this 'NetworkOutputs_Field' view. */
  calculatedTotalOilRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'calculatedTotalWaterRate' in this 'NetworkOutputs_Field' view. */
  calculatedTotalWaterRate: Maybe<TimeSeries>;
  calculatedTotalWaterRateWI: Maybe<TimeSeries>;
  /** Reference to the related 'Field' entity for this 'NetworkOutputs_Field' row. */
  entityName: Maybe<Field>;
  /** Reference to a time series for 'estimatedFlowlineUnstableflowFlag' in this 'NetworkOutputs_Field' view. */
  estimatedFlowlineUnstableflowFlag: Maybe<TimeSeries>;
  /** Reference to a time series for 'estimatedFlowlineflowassuranceflag' in this 'NetworkOutputs_Field' view. */
  estimatedFlowlineflowassuranceflag: Maybe<TimeSeries>;
  /** Reference to a time series for 'fsoprGasRate' in this 'NetworkOutputs_Field' view. */
  fsoprGasRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'fsoprOilRate' in this 'NetworkOutputs_Field' view. */
  fsoprOilRate: Maybe<TimeSeries>;
  fsoprRunID: Maybe<TimeSeries>;
  /** Reference to a time series for 'fsoprWaterRate' in this 'NetworkOutputs_Field' view. */
  fsoprWaterRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'hydraulicGasRate' in this 'NetworkOutputs_Field' view. */
  hydraulicGasRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'hydraulicOilRate' in this 'NetworkOutputs_Field' view. */
  hydraulicOilRate: Maybe<TimeSeries>;
  hydraulicRunID: Maybe<TimeSeries>;
  /** Reference to a time series for 'hydraulicWaterRate' in this 'NetworkOutputs_Field' view. */
  hydraulicWaterRate: Maybe<TimeSeries>;
  prpFileId: Maybe<TimeSeries>;
  systemOptimizedChokeGasLiftRate: Maybe<TimeSeries>;
  systemOptimizedChokeGasRate: Maybe<TimeSeries>;
  systemOptimizedChokeOilRate: Maybe<TimeSeries>;
  systemOptimizedChokePower: Maybe<TimeSeries>;
  systemOptimizedChokeRunID: Maybe<TimeSeries>;
  systemOptimizedChokeWaterRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'systemOptimizedGasLiftRate' in this 'NetworkOutputs_Field' view. */
  systemOptimizedGasLiftRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'systemOptimizedGasRate' in this 'NetworkOutputs_Field' view. */
  systemOptimizedGasRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'systemOptimizedOilRate' in this 'NetworkOutputs_Field' view. */
  systemOptimizedOilRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'systemOptimizedPower' in this 'NetworkOutputs_Field' view. */
  systemOptimizedPower: Maybe<TimeSeries>;
  systemOptimizedRunID: Maybe<TimeSeries>;
  /** Reference to a time series for 'systemOptimizedWaterRate' in this 'NetworkOutputs_Field' view. */
  systemOptimizedWaterRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'technicalGasRate' in this 'NetworkOutputs_Field' view. */
  technicalGasRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'technicalOilRate' in this 'NetworkOutputs_Field' view. */
  technicalOilRate: Maybe<TimeSeries>;
  technicalRunID: Maybe<TimeSeries>;
  /** Reference to a time series for 'technicalWaterRate' in this 'NetworkOutputs_Field' view. */
  technicalWaterRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellSolverEstimatedTotalGasRate' in this 'NetworkOutputs_Field' view. */
  wellSolverEstimatedTotalGasRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellSolverEstimatedTotalLiquidRate' in this 'NetworkOutputs_Field' view. */
  wellSolverEstimatedTotalLiquidRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellSolverEstimatedTotalOilRate' in this 'NetworkOutputs_Field' view. */
  wellSolverEstimatedTotalOilRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellSolverEstimatedTotalWaterRate' in this 'NetworkOutputs_Field' view. */
  wellSolverEstimatedTotalWaterRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellSolverGasDeviation' in this 'NetworkOutputs_Field' view. */
  wellSolverGasDeviation: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellSolverGasDifference' in this 'NetworkOutputs_Field' view. */
  wellSolverGasDifference: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellSolverGasFlowMatchIndex' in this 'NetworkOutputs_Field' view. */
  wellSolverGasFlowMatchIndex: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellSolverGasFlowMatchIndexTolerance' in this 'NetworkOutputs_Field' view. */
  wellSolverGasFlowMatchIndexTolerance: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellSolverLiquidDifference' in this 'NetworkOutputs_Field' view. */
  wellSolverLiquidDifference: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellSolverMeasuredTotalGasRate' in this 'NetworkOutputs_Field' view. */
  wellSolverMeasuredTotalGasRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellSolverMeasuredTotalLiquidRate' in this 'NetworkOutputs_Field' view. */
  wellSolverMeasuredTotalLiquidRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellSolverMeasuredTotalOilRate' in this 'NetworkOutputs_Field' view. */
  wellSolverMeasuredTotalOilRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellSolverMeasuredTotalWaterRate' in this 'NetworkOutputs_Field' view. */
  wellSolverMeasuredTotalWaterRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellSolverOilDeviation' in this 'NetworkOutputs_Field' view. */
  wellSolverOilDeviation: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellSolverOilDifference' in this 'NetworkOutputs_Field' view. */
  wellSolverOilDifference: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellSolverOilFlowMatchIndex' in this 'NetworkOutputs_Field' view. */
  wellSolverOilFlowMatchIndex: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellSolverOilFlowMatchIndexTolerance' in this 'NetworkOutputs_Field' view. */
  wellSolverOilFlowMatchIndexTolerance: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellSolverWaterDeviation' in this 'NetworkOutputs_Field' view. */
  wellSolverWaterDeviation: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellSolverWaterDifference' in this 'NetworkOutputs_Field' view. */
  wellSolverWaterDifference: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellSolverWaterFlowMatchIndex' in this 'NetworkOutputs_Field' view. */
  wellSolverWaterFlowMatchIndex: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellSolverWaterFlowMatchIndexTolerance' in this 'NetworkOutputs_Field' view. */
  wellSolverWaterFlowMatchIndexTolerance: Maybe<TimeSeries>;
};

/**
 * Field-level scenario and optimization outputs from the solution data model (WF7/WF11).
 *
 * Field-rolled-up production and injection metrics (oil/gas/water rates,
 * pressures, facility utilization) including scenario and optimization variants.
 * Use for field-level what-if and optimization comparison. For WF7 field
 * rollups from GAP see FieldOutputs_Agent. Excludes well-level and historical data.
 *
 * Use for: Network Surveillance (WF7), Network Model Validation (WF8),
 * Production Optimization (WF11).
 *
 * @name Network Outputs - Field (Agent)
 */
export type NetworkOutputsFieldAgent = {
  /** adHocOptimization1Comment from GAP network optimization (TS) for the field. */
  adHocOptimization1Comment: Maybe<TimeSeries>;
  /** adHocOptimization1ExecutedBy from GAP network optimization (TS) for the field. */
  adHocOptimization1ExecutedBy: Maybe<TimeSeries>;
  adHocOptimization1GasRate: Maybe<TimeSeries>;
  adHocOptimization1OilRate: Maybe<TimeSeries>;
  adHocOptimization1WaterRate: Maybe<TimeSeries>;
  /** adHocOptimization2Comment from GAP network optimization (TS) for the field. */
  adHocOptimization2Comment: Maybe<TimeSeries>;
  /** adHocOptimization2ExecutedBy from GAP network optimization (TS) for the field. */
  adHocOptimization2ExecutedBy: Maybe<TimeSeries>;
  adHocOptimization2GasRate: Maybe<TimeSeries>;
  adHocOptimization2OilRate: Maybe<TimeSeries>;
  adHocOptimization2WaterRate: Maybe<TimeSeries>;
  /** adHocSimulation1Comment from GAP network optimization (TS) for the field. */
  adHocSimulation1Comment: Maybe<TimeSeries>;
  /** adHocSimulation1ExecutedBy from GAP network optimization (TS) for the field. */
  adHocSimulation1ExecutedBy: Maybe<TimeSeries>;
  adHocSimulation1GasRate: Maybe<TimeSeries>;
  adHocSimulation1OilRate: Maybe<TimeSeries>;
  adHocSimulation1WaterRate: Maybe<TimeSeries>;
  /** adHocSimulation2Comment from GAP network optimization (TS) for the field. */
  adHocSimulation2Comment: Maybe<TimeSeries>;
  /** adHocSimulation2ExecutedBy from GAP network optimization (TS) for the field. */
  adHocSimulation2ExecutedBy: Maybe<TimeSeries>;
  adHocSimulation2GasRate: Maybe<TimeSeries>;
  adHocSimulation2OilRate: Maybe<TimeSeries>;
  adHocSimulation2WaterRate: Maybe<TimeSeries>;
  calcualtedSeparatorGasRate: Maybe<TimeSeries>;
  calculatedFlowLinePressure: Maybe<TimeSeries>;
  calculatedJointCo2: Maybe<TimeSeries>;
  calculatedJointGasRate: Maybe<TimeSeries>;
  calculatedJointH2S: Maybe<TimeSeries>;
  calculatedJointLiquidRate: Maybe<TimeSeries>;
  calculatedJointN2: Maybe<TimeSeries>;
  calculatedJointOilRate: Maybe<TimeSeries>;
  calculatedJointPressure: Maybe<TimeSeries>;
  calculatedPressureMatchIndex: Maybe<TimeSeries>;
  calculatedSeparatorOilRate: Maybe<TimeSeries>;
  calculatedSepratorWaterRate: Maybe<TimeSeries>;
  calculatedTotalGasRate: Maybe<TimeSeries>;
  calculatedTotalGasRateGI: Maybe<TimeSeries>;
  calculatedTotalLiquidRate: Maybe<TimeSeries>;
  calculatedTotalLiquidRateWI: Maybe<TimeSeries>;
  calculatedTotalOilRate: Maybe<TimeSeries>;
  calculatedTotalWaterRate: Maybe<TimeSeries>;
  calculatedTotalWaterRateWI: Maybe<TimeSeries>;
  estimatedFlowlineUnstableflowFlag: Maybe<TimeSeries>;
  estimatedFlowlineflowassuranceflag: Maybe<TimeSeries>;
  /** Reference to field. Join to FlatHierarchy_Agent for reservoir/sector context. */
  fieldEntity: Maybe<Field>;
  fsoprGasRate: Maybe<TimeSeries>;
  fsoprOilRate: Maybe<TimeSeries>;
  fsoprWaterRate: Maybe<TimeSeries>;
  hydraulicGasRate: Maybe<TimeSeries>;
  hydraulicOilRate: Maybe<TimeSeries>;
  hydraulicWaterRate: Maybe<TimeSeries>;
  systemOptimizedGasLiftRate: Maybe<TimeSeries>;
  systemOptimizedGasRate: Maybe<TimeSeries>;
  systemOptimizedOilRate: Maybe<TimeSeries>;
  systemOptimizedPower: Maybe<TimeSeries>;
  systemOptimizedWaterRate: Maybe<TimeSeries>;
  technicalGasRate: Maybe<TimeSeries>;
  technicalOilRate: Maybe<TimeSeries>;
  technicalWaterRate: Maybe<TimeSeries>;
  wellSolverEstimatedTotalGasRate: Maybe<TimeSeries>;
  wellSolverEstimatedTotalLiquidRate: Maybe<TimeSeries>;
  wellSolverEstimatedTotalOilRate: Maybe<TimeSeries>;
  wellSolverEstimatedTotalWaterRate: Maybe<TimeSeries>;
  wellSolverGasDifference: Maybe<TimeSeries>;
  wellSolverGasFlowMatchIndex: Maybe<TimeSeries>;
  wellSolverLiquidDifference: Maybe<TimeSeries>;
  wellSolverMeasuredTotalGasRate: Maybe<TimeSeries>;
  wellSolverMeasuredTotalLiquidRate: Maybe<TimeSeries>;
  wellSolverMeasuredTotalOilRate: Maybe<TimeSeries>;
  wellSolverMeasuredTotalWaterRate: Maybe<TimeSeries>;
  wellSolverOilDifference: Maybe<TimeSeries>;
  wellSolverOilFlowMatchIndex: Maybe<TimeSeries>;
  wellSolverWaterDifference: Maybe<TimeSeries>;
  wellSolverWaterFlowMatchIndex: Maybe<TimeSeries>;
};

/** View 'NetworkOutputs_Field_Validated' in the iPSO production optimization solution data model. */
export type NetworkOutputsFieldValidated = {
  adHocOptimization1ValidatedGasLiftRate: Maybe<TimeSeries>;
  adHocOptimization1ValidatedGasRate: Maybe<TimeSeries>;
  adHocOptimization1ValidatedModelFileId: Maybe<TimeSeries>;
  adHocOptimization1ValidatedOilRate: Maybe<TimeSeries>;
  adHocOptimization1ValidatedPower: Maybe<TimeSeries>;
  adHocOptimization1ValidatedRunDateTime: Maybe<TimeSeries>;
  adHocOptimization1ValidatedRunStatus: Maybe<TimeSeries>;
  adHocOptimization1ValidatedWaterRate: Maybe<TimeSeries>;
  adHocOptimization2ValidatedGasLiftRate: Maybe<TimeSeries>;
  adHocOptimization2ValidatedGasRate: Maybe<TimeSeries>;
  adHocOptimization2ValidatedModelFileId: Maybe<TimeSeries>;
  adHocOptimization2ValidatedOilRate: Maybe<TimeSeries>;
  adHocOptimization2ValidatedPower: Maybe<TimeSeries>;
  adHocOptimization2ValidatedRunDateTime: Maybe<TimeSeries>;
  adHocOptimization2ValidatedRunStatus: Maybe<TimeSeries>;
  adHocOptimization2ValidatedWaterRate: Maybe<TimeSeries>;
  /** Reference to the related 'Field' entity for this 'NetworkOutputs_Field_Validated' row. */
  entityName: Maybe<Field>;
  systemOptimizedChokeValidatedGasLiftRate: Maybe<TimeSeries>;
  systemOptimizedChokeValidatedGasRate: Maybe<TimeSeries>;
  systemOptimizedChokeValidatedModelFileId: Maybe<TimeSeries>;
  systemOptimizedChokeValidatedOilRate: Maybe<TimeSeries>;
  systemOptimizedChokeValidatedPower: Maybe<TimeSeries>;
  systemOptimizedChokeValidatedRunDateTime: Maybe<TimeSeries>;
  systemOptimizedChokeValidatedRunStatus: Maybe<TimeSeries>;
  systemOptimizedChokeValidatedTop5GasLiftRate: Maybe<TimeSeries>;
  systemOptimizedChokeValidatedTop5GasRate: Maybe<TimeSeries>;
  systemOptimizedChokeValidatedTop5OilRate: Maybe<TimeSeries>;
  systemOptimizedChokeValidatedTop5Power: Maybe<TimeSeries>;
  systemOptimizedChokeValidatedTop5WaterRate: Maybe<TimeSeries>;
  systemOptimizedChokeValidatedTop10GasLiftRate: Maybe<TimeSeries>;
  systemOptimizedChokeValidatedTop10GasRate: Maybe<TimeSeries>;
  systemOptimizedChokeValidatedTop10OilRate: Maybe<TimeSeries>;
  systemOptimizedChokeValidatedTop10Power: Maybe<TimeSeries>;
  systemOptimizedChokeValidatedTop10WaterRate: Maybe<TimeSeries>;
  systemOptimizedChokeValidatedTop20GasLiftRate: Maybe<TimeSeries>;
  systemOptimizedChokeValidatedTop20GasRate: Maybe<TimeSeries>;
  systemOptimizedChokeValidatedTop20OilRate: Maybe<TimeSeries>;
  systemOptimizedChokeValidatedTop20Power: Maybe<TimeSeries>;
  systemOptimizedChokeValidatedTop20WaterRate: Maybe<TimeSeries>;
  systemOptimizedChokeValidatedWaterRate: Maybe<TimeSeries>;
  systemOptimizedValidatedGasLiftRate: Maybe<TimeSeries>;
  systemOptimizedValidatedGasRate: Maybe<TimeSeries>;
  systemOptimizedValidatedModelFileId: Maybe<TimeSeries>;
  systemOptimizedValidatedOilRate: Maybe<TimeSeries>;
  systemOptimizedValidatedPower: Maybe<TimeSeries>;
  systemOptimizedValidatedRunDateTime: Maybe<TimeSeries>;
  systemOptimizedValidatedRunStatus: Maybe<TimeSeries>;
  systemOptimizedValidatedTop5BeforeOilRate: Maybe<TimeSeries>;
  systemOptimizedValidatedTop5BeforeWaterRate: Maybe<TimeSeries>;
  systemOptimizedValidatedTop5GasLiftRate: Maybe<TimeSeries>;
  systemOptimizedValidatedTop5GasRate: Maybe<TimeSeries>;
  systemOptimizedValidatedTop5OilRate: Maybe<TimeSeries>;
  systemOptimizedValidatedTop5Power: Maybe<TimeSeries>;
  systemOptimizedValidatedTop5WaterRate: Maybe<TimeSeries>;
  systemOptimizedValidatedTop10BeforeOilRate: Maybe<TimeSeries>;
  systemOptimizedValidatedTop10BeforeWaterRate: Maybe<TimeSeries>;
  systemOptimizedValidatedTop10GasLiftRate: Maybe<TimeSeries>;
  systemOptimizedValidatedTop10GasRate: Maybe<TimeSeries>;
  systemOptimizedValidatedTop10OilRate: Maybe<TimeSeries>;
  systemOptimizedValidatedTop10Power: Maybe<TimeSeries>;
  systemOptimizedValidatedTop10WaterRate: Maybe<TimeSeries>;
  systemOptimizedValidatedTop20BeforeOilRate: Maybe<TimeSeries>;
  systemOptimizedValidatedTop20BeforeWaterRate: Maybe<TimeSeries>;
  systemOptimizedValidatedTop20GasLiftRate: Maybe<TimeSeries>;
  systemOptimizedValidatedTop20GasRate: Maybe<TimeSeries>;
  systemOptimizedValidatedTop20OilRate: Maybe<TimeSeries>;
  systemOptimizedValidatedTop20Power: Maybe<TimeSeries>;
  systemOptimizedValidatedTop20WaterRate: Maybe<TimeSeries>;
  systemOptimizedValidatedWaterRate: Maybe<TimeSeries>;
};

/** View 'NetworkOutputs_Reservoir' in the iPSO production optimization solution data model. */
export type NetworkOutputsReservoir = {
  /** Reference to a time series for 'adHocOptimization1GasRate' in this 'NetworkOutputs_Reservoir' view. */
  adHocOptimization1GasRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocOptimization1OilRate' in this 'NetworkOutputs_Reservoir' view. */
  adHocOptimization1OilRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocOptimization1RunID' in this 'NetworkOutputs_Reservoir' view. */
  adHocOptimization1RunID: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocOptimization1WaterRate' in this 'NetworkOutputs_Reservoir' view. */
  adHocOptimization1WaterRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocOptimization2GasRate' in this 'NetworkOutputs_Reservoir' view. */
  adHocOptimization2GasRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocOptimization2OilRate' in this 'NetworkOutputs_Reservoir' view. */
  adHocOptimization2OilRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocOptimization2RunID' in this 'NetworkOutputs_Reservoir' view. */
  adHocOptimization2RunID: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocOptimization2WaterRate' in this 'NetworkOutputs_Reservoir' view. */
  adHocOptimization2WaterRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocSimulation1GasRate' in this 'NetworkOutputs_Reservoir' view. */
  adHocSimulation1GasRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocSimulation1OilRate' in this 'NetworkOutputs_Reservoir' view. */
  adHocSimulation1OilRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocSimulation1RunID' in this 'NetworkOutputs_Reservoir' view. */
  adHocSimulation1RunID: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocSimulation1WaterRate' in this 'NetworkOutputs_Reservoir' view. */
  adHocSimulation1WaterRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocSimulation2GasRate' in this 'NetworkOutputs_Reservoir' view. */
  adHocSimulation2GasRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocSimulation2OilRate' in this 'NetworkOutputs_Reservoir' view. */
  adHocSimulation2OilRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocSimulation2RunID' in this 'NetworkOutputs_Reservoir' view. */
  adHocSimulation2RunID: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocSimulation2WaterRate' in this 'NetworkOutputs_Reservoir' view. */
  adHocSimulation2WaterRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'calculatedTotalGasRate' in this 'NetworkOutputs_Reservoir' view. */
  calculatedTotalGasRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'calculatedTotalLiquidRate' in this 'NetworkOutputs_Reservoir' view. */
  calculatedTotalLiquidRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'calculatedTotalOilRate' in this 'NetworkOutputs_Reservoir' view. */
  calculatedTotalOilRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'calculatedTotalWaterRate' in this 'NetworkOutputs_Reservoir' view. */
  calculatedTotalWaterRate: Maybe<TimeSeries>;
  /** Reference to the related 'Reservoir' entity for this 'NetworkOutputs_Reservoir' row. */
  entityName: Maybe<Reservoir>;
  /** Reference to a time series for 'fsoprGasRate' in this 'NetworkOutputs_Reservoir' view. */
  fsoprGasRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'fsoprOilRate' in this 'NetworkOutputs_Reservoir' view. */
  fsoprOilRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'fsoprRunID' in this 'NetworkOutputs_Reservoir' view. */
  fsoprRunID: Maybe<TimeSeries>;
  /** Reference to a time series for 'fsoprWaterRate' in this 'NetworkOutputs_Reservoir' view. */
  fsoprWaterRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'hydraulicGasRate' in this 'NetworkOutputs_Reservoir' view. */
  hydraulicGasRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'hydraulicOilRate' in this 'NetworkOutputs_Reservoir' view. */
  hydraulicOilRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'hydraulicRunID' in this 'NetworkOutputs_Reservoir' view. */
  hydraulicRunID: Maybe<TimeSeries>;
  /** Reference to a time series for 'hydraulicWaterRate' in this 'NetworkOutputs_Reservoir' view. */
  hydraulicWaterRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'systemOptimizedChokeGasRate' in this 'NetworkOutputs_Reservoir' view. */
  systemOptimizedChokeGasRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'systemOptimizedChokeOilRate' in this 'NetworkOutputs_Reservoir' view. */
  systemOptimizedChokeOilRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'systemOptimizedChokeRunID' in this 'NetworkOutputs_Reservoir' view. */
  systemOptimizedChokeRunID: Maybe<TimeSeries>;
  /** Reference to a time series for 'systemOptimizedChokeWaterRate' in this 'NetworkOutputs_Reservoir' view. */
  systemOptimizedChokeWaterRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'systemOptimizedGasRate' in this 'NetworkOutputs_Reservoir' view. */
  systemOptimizedGasRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'systemOptimizedOilRate' in this 'NetworkOutputs_Reservoir' view. */
  systemOptimizedOilRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'systemOptimizedRunID' in this 'NetworkOutputs_Reservoir' view. */
  systemOptimizedRunID: Maybe<TimeSeries>;
  /** Reference to a time series for 'systemOptimizedWaterRate' in this 'NetworkOutputs_Reservoir' view. */
  systemOptimizedWaterRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'technicalGasRate' in this 'NetworkOutputs_Reservoir' view. */
  technicalGasRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'technicalOilRate' in this 'NetworkOutputs_Reservoir' view. */
  technicalOilRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'technicalRunID' in this 'NetworkOutputs_Reservoir' view. */
  technicalRunID: Maybe<TimeSeries>;
  /** Reference to a time series for 'technicalWaterRate' in this 'NetworkOutputs_Reservoir' view. */
  technicalWaterRate: Maybe<TimeSeries>;
};

/** View 'NetworkOutputs_Runs' in the iPSO production optimization solution data model. */
export type NetworkOutputsRuns = {
  /** Reference to a time series for 'comment' in this 'NetworkOutputs_Runs' view. */
  comment: Maybe<Scalars['String']['output']>;
  /** Reference to a time series for 'createdBy' in this 'NetworkOutputs_Runs' view. */
  createdBy: Maybe<TimeSeries>;
  /** Reference to the related 'Network' entity for this 'NetworkOutputs_Runs' row. */
  entityName: Maybe<Network>;
  /** Reference to a time series for 'executedBy' in this 'NetworkOutputs_Runs' view. */
  executedBy: Maybe<Scalars['String']['output']>;
  /** Reference to a time series for 'executionDate' in this 'NetworkOutputs_Runs' view. */
  executionDate: Maybe<Scalars['Timestamp']['output']>;
  /** Reference to a time series for 'runId' in this 'NetworkOutputs_Runs' view. */
  runId: Scalars['String']['output'];
  /** Reference to a time series for 'scenarioType' in this 'NetworkOutputs_Runs' view. */
  scenarioType: Scalars['String']['output'];
  /** Reference to a time series for 'status' in this 'NetworkOutputs_Runs' view. */
  status: Scalars['String']['output'];
};

/** View 'NetworkOutputs_String' in the iPSO production optimization solution data model. */
export type NetworkOutputsString = {
  /** Reference to a time series for 'adHocOptimization1ChokeBeanSize' in this 'NetworkOutputs_String' view. */
  adHocOptimization1ChokeBeanSize: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocOptimization1ChokeOpening' in this 'NetworkOutputs_String' view. */
  adHocOptimization1ChokeOpening: Maybe<TimeSeries>;
  adHocOptimization1Comment: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocOptimization1EspFrequency' in this 'NetworkOutputs_String' view. */
  adHocOptimization1EspFrequency: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocOptimization1ExecutedBy' in this 'NetworkOutputs_String' view. */
  adHocOptimization1ExecutedBy: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocOptimization1FBHP' in this 'NetworkOutputs_String' view. */
  adHocOptimization1FBHP: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocOptimization1FWHP' in this 'NetworkOutputs_String' view. */
  adHocOptimization1FWHP: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocOptimization1GasLiftRate' in this 'NetworkOutputs_String' view. */
  adHocOptimization1GasLiftRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocOptimization1GasRate' in this 'NetworkOutputs_String' view. */
  adHocOptimization1GasRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocOptimization1OilRate' in this 'NetworkOutputs_String' view. */
  adHocOptimization1OilRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocOptimization1OptimizedParameter' in this 'NetworkOutputs_String' view. */
  adHocOptimization1OptimizedParameter: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocOptimization1Power' in this 'NetworkOutputs_String' view. */
  adHocOptimization1Power: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocOptimization1RunID' in this 'NetworkOutputs_String' view. */
  adHocOptimization1RunID: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocOptimization1WaterRate' in this 'NetworkOutputs_String' view. */
  adHocOptimization1WaterRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocOptimization2ChokeBeanSize' in this 'NetworkOutputs_String' view. */
  adHocOptimization2ChokeBeanSize: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocOptimization2ChokeOpening' in this 'NetworkOutputs_String' view. */
  adHocOptimization2ChokeOpening: Maybe<TimeSeries>;
  adHocOptimization2Comment: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocOptimization2EspFrequency' in this 'NetworkOutputs_String' view. */
  adHocOptimization2EspFrequency: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocOptimization2ExecutedBy' in this 'NetworkOutputs_String' view. */
  adHocOptimization2ExecutedBy: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocOptimization2FBHP' in this 'NetworkOutputs_String' view. */
  adHocOptimization2FBHP: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocOptimization2FWHP' in this 'NetworkOutputs_String' view. */
  adHocOptimization2FWHP: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocOptimization2GasLiftRate' in this 'NetworkOutputs_String' view. */
  adHocOptimization2GasLiftRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocOptimization2GasRate' in this 'NetworkOutputs_String' view. */
  adHocOptimization2GasRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocOptimization2OilRate' in this 'NetworkOutputs_String' view. */
  adHocOptimization2OilRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocOptimization2OptimizedParameter' in this 'NetworkOutputs_String' view. */
  adHocOptimization2OptimizedParameter: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocOptimization2Power' in this 'NetworkOutputs_String' view. */
  adHocOptimization2Power: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocOptimization2RunID' in this 'NetworkOutputs_String' view. */
  adHocOptimization2RunID: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocOptimization2WaterRate' in this 'NetworkOutputs_String' view. */
  adHocOptimization2WaterRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocSimulation1ChokeBeanSize' in this 'NetworkOutputs_String' view. */
  adHocSimulation1ChokeBeanSize: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocSimulation1ChokeOpening' in this 'NetworkOutputs_String' view. */
  adHocSimulation1ChokeOpening: Maybe<TimeSeries>;
  adHocSimulation1Comment: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocSimulation1EspFrequency' in this 'NetworkOutputs_String' view. */
  adHocSimulation1EspFrequency: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocSimulation1ExecutedBy' in this 'NetworkOutputs_String' view. */
  adHocSimulation1ExecutedBy: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocSimulation1FBHP' in this 'NetworkOutputs_String' view. */
  adHocSimulation1FBHP: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocSimulation1FWHP' in this 'NetworkOutputs_String' view. */
  adHocSimulation1FWHP: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocSimulation1GasLiftRate' in this 'NetworkOutputs_String' view. */
  adHocSimulation1GasLiftRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocSimulation1GasRate' in this 'NetworkOutputs_String' view. */
  adHocSimulation1GasRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocSimulation1OilRate' in this 'NetworkOutputs_String' view. */
  adHocSimulation1OilRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocSimulation1OptimizedParameter' in this 'NetworkOutputs_String' view. */
  adHocSimulation1OptimizedParameter: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocSimulation1Power' in this 'NetworkOutputs_String' view. */
  adHocSimulation1Power: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocSimulation1RunID' in this 'NetworkOutputs_String' view. */
  adHocSimulation1RunID: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocSimulation1WaterRate' in this 'NetworkOutputs_String' view. */
  adHocSimulation1WaterRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocSimulation2ChokeBeanSize' in this 'NetworkOutputs_String' view. */
  adHocSimulation2ChokeBeanSize: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocSimulation2ChokeOpening' in this 'NetworkOutputs_String' view. */
  adHocSimulation2ChokeOpening: Maybe<TimeSeries>;
  adHocSimulation2Comment: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocSimulation2EspFrequency' in this 'NetworkOutputs_String' view. */
  adHocSimulation2EspFrequency: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocSimulation2ExecutedBy' in this 'NetworkOutputs_String' view. */
  adHocSimulation2ExecutedBy: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocSimulation2FBHP' in this 'NetworkOutputs_String' view. */
  adHocSimulation2FBHP: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocSimulation2FWHP' in this 'NetworkOutputs_String' view. */
  adHocSimulation2FWHP: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocSimulation2GasLiftRate' in this 'NetworkOutputs_String' view. */
  adHocSimulation2GasLiftRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocSimulation2GasRate' in this 'NetworkOutputs_String' view. */
  adHocSimulation2GasRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocSimulation2OilRate' in this 'NetworkOutputs_String' view. */
  adHocSimulation2OilRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocSimulation2OptimizedParameter' in this 'NetworkOutputs_String' view. */
  adHocSimulation2OptimizedParameter: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocSimulation2Power' in this 'NetworkOutputs_String' view. */
  adHocSimulation2Power: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocSimulation2RunID' in this 'NetworkOutputs_String' view. */
  adHocSimulation2RunID: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocSimulation2WaterRate' in this 'NetworkOutputs_String' view. */
  adHocSimulation2WaterRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'asphalteneFlag_well' in this 'NetworkOutputs_String' view. */
  asphalteneFlag_well: Maybe<TimeSeries>;
  /** Reference to a time series for 'calculatedChokeBeanSize' in this 'NetworkOutputs_String' view. */
  calculatedChokeBeanSize: Maybe<TimeSeries>;
  calculatedChokeBeanSizeGI: Maybe<TimeSeries>;
  calculatedChokeBeanSizeWI: Maybe<TimeSeries>;
  /** Reference to a time series for 'calculatedChokeOpening' in this 'NetworkOutputs_String' view. */
  calculatedChokeOpening: Maybe<TimeSeries>;
  /** Reference to a time series for 'calculatedEspFrequency' in this 'NetworkOutputs_String' view. */
  calculatedEspFrequency: Maybe<TimeSeries>;
  /** Reference to a time series for 'calculatedGasLiftRate' in this 'NetworkOutputs_String' view. */
  calculatedGasLiftRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'calculatedGasRateMatchIndex' in this 'NetworkOutputs_String' view. */
  calculatedGasRateMatchIndex: Maybe<TimeSeries>;
  /** Reference to a time series for 'calculatedOilRateMatchIndex' in this 'NetworkOutputs_String' view. */
  calculatedOilRateMatchIndex: Maybe<TimeSeries>;
  /** Reference to a time series for 'calculatedPower' in this 'NetworkOutputs_String' view. */
  calculatedPower: Maybe<TimeSeries>;
  /** Reference to a time series for 'calculatedPumpLquidRate' in this 'NetworkOutputs_String' view. */
  calculatedPumpLquidRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'calculatedWaterRateMatchIndex' in this 'NetworkOutputs_String' view. */
  calculatedWaterRateMatchIndex: Maybe<TimeSeries>;
  /** Reference to a time series for 'calculatedWellBHP' in this 'NetworkOutputs_String' view. */
  calculatedWellBHP: Maybe<TimeSeries>;
  calculatedWellBHPGI: Maybe<TimeSeries>;
  calculatedWellBHPWI: Maybe<TimeSeries>;
  /** Reference to a time series for 'calculatedWellESPMotorLoad' in this 'NetworkOutputs_String' view. */
  calculatedWellESPMotorLoad: Maybe<TimeSeries>;
  /** Reference to a time series for 'calculatedWellFBHP' in this 'NetworkOutputs_String' view. */
  calculatedWellFBHP: Maybe<TimeSeries>;
  /** Reference to a time series for 'calculatedWellFWHP' in this 'NetworkOutputs_String' view. */
  calculatedWellFWHP: Maybe<TimeSeries>;
  /** Reference to a time series for 'calculatedWellGasRate' in this 'NetworkOutputs_String' view. */
  calculatedWellGasRate: Maybe<TimeSeries>;
  calculatedWellGasRateGI: Maybe<TimeSeries>;
  /** Reference to a time series for 'calculatedWellLiquidRate' in this 'NetworkOutputs_String' view. */
  calculatedWellLiquidRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'calculatedWellOilRate' in this 'NetworkOutputs_String' view. */
  calculatedWellOilRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'calculatedWellWaterRate' in this 'NetworkOutputs_String' view. */
  calculatedWellWaterRate: Maybe<TimeSeries>;
  calculatedWellWaterRateWI: Maybe<TimeSeries>;
  /** Reference to a time series for 'chokeDP' in this 'NetworkOutputs_String' view. */
  chokeDP: Maybe<TimeSeries>;
  /** Reference to a time series for 'constraintFlag_well' in this 'NetworkOutputs_String' view. */
  constraintFlag_well: Maybe<TimeSeries>;
  /** Reference to the related 'String_asset' entity for this 'NetworkOutputs_String' row. */
  entityName: Maybe<StringAsset>;
  /** Reference to a time series for 'espEfficiency' in this 'NetworkOutputs_String' view. */
  espEfficiency: Maybe<TimeSeries>;
  /** Reference to a time series for 'formationWellGasOilRatio' in this 'NetworkOutputs_String' view. */
  formationWellGasOilRatio: Maybe<TimeSeries>;
  /** Reference to a time series for 'fsoprChokeBeanSize' in this 'NetworkOutputs_String' view. */
  fsoprChokeBeanSize: Maybe<TimeSeries>;
  /** Reference to a time series for 'fsoprChokeOpening' in this 'NetworkOutputs_String' view. */
  fsoprChokeOpening: Maybe<TimeSeries>;
  /** Reference to a time series for 'fsoprEspFrequency' in this 'NetworkOutputs_String' view. */
  fsoprEspFrequency: Maybe<TimeSeries>;
  /** Reference to a time series for 'fsoprFBHP' in this 'NetworkOutputs_String' view. */
  fsoprFBHP: Maybe<TimeSeries>;
  /** Reference to a time series for 'fsoprFWHP' in this 'NetworkOutputs_String' view. */
  fsoprFWHP: Maybe<TimeSeries>;
  /** Reference to a time series for 'fsoprGasLiftRate' in this 'NetworkOutputs_String' view. */
  fsoprGasLiftRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'fsoprGasRate' in this 'NetworkOutputs_String' view. */
  fsoprGasRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'fsoprOilRate' in this 'NetworkOutputs_String' view. */
  fsoprOilRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'fsoprOptimizedParameter' in this 'NetworkOutputs_String' view. */
  fsoprOptimizedParameter: Maybe<TimeSeries>;
  /** Reference to a time series for 'fsoprPower' in this 'NetworkOutputs_String' view. */
  fsoprPower: Maybe<TimeSeries>;
  /** Reference to a time series for 'fsoprRunID' in this 'NetworkOutputs_String' view. */
  fsoprRunID: Maybe<TimeSeries>;
  /** Reference to a time series for 'fsoprWaterRate' in this 'NetworkOutputs_String' view. */
  fsoprWaterRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'gapOptimizedParameter' in this 'NetworkOutputs_String' view. */
  gapOptimizedParameter: Maybe<TimeSeries>;
  /** Text attribute 'gapWellName' for this 'NetworkOutputs_String' row. */
  gapWellName: Maybe<Scalars['String']['output']>;
  /** Reference to a time series for 'gapWellNameHistorical' in this 'NetworkOutputs_String' view. */
  gapWellNameHistorical: Maybe<TimeSeries>;
  /** Reference to a time series for 'gasLiftInjection' in this 'NetworkOutputs_String' view. */
  gasLiftInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'gasLiftInjectionPress' in this 'NetworkOutputs_String' view. */
  gasLiftInjectionPress: Maybe<TimeSeries>;
  /** Reference to a time series for 'hydrateFlag_well' in this 'NetworkOutputs_String' view. */
  hydrateFlag_well: Maybe<TimeSeries>;
  /** Reference to a time series for 'hydraulicChokeBeanSize' in this 'NetworkOutputs_String' view. */
  hydraulicChokeBeanSize: Maybe<TimeSeries>;
  /** Reference to a time series for 'hydraulicChokeOpening' in this 'NetworkOutputs_String' view. */
  hydraulicChokeOpening: Maybe<TimeSeries>;
  /** Reference to a time series for 'hydraulicEspFrequency' in this 'NetworkOutputs_String' view. */
  hydraulicEspFrequency: Maybe<TimeSeries>;
  /** Reference to a time series for 'hydraulicFBHP' in this 'NetworkOutputs_String' view. */
  hydraulicFBHP: Maybe<TimeSeries>;
  /** Reference to a time series for 'hydraulicFWHP' in this 'NetworkOutputs_String' view. */
  hydraulicFWHP: Maybe<TimeSeries>;
  /** Reference to a time series for 'hydraulicGasLiftRate' in this 'NetworkOutputs_String' view. */
  hydraulicGasLiftRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'hydraulicGasRate' in this 'NetworkOutputs_String' view. */
  hydraulicGasRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'hydraulicOilRate' in this 'NetworkOutputs_String' view. */
  hydraulicOilRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'hydraulicOptimizedParameter' in this 'NetworkOutputs_String' view. */
  hydraulicOptimizedParameter: Maybe<TimeSeries>;
  /** Reference to a time series for 'hydraulicPower' in this 'NetworkOutputs_String' view. */
  hydraulicPower: Maybe<TimeSeries>;
  /** Reference to a time series for 'hydraulicRunID' in this 'NetworkOutputs_String' view. */
  hydraulicRunID: Maybe<TimeSeries>;
  /** Reference to a time series for 'hydraulicWaterRate' in this 'NetworkOutputs_String' view. */
  hydraulicWaterRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'pe5StabilityFlag_well' in this 'NetworkOutputs_String' view. */
  pe5StabilityFlag_well: Maybe<TimeSeries>;
  /** Reference to a time series for 'scaleFlag_well' in this 'NetworkOutputs_String' view. */
  scaleFlag_well: Maybe<TimeSeries>;
  /** Reference to a time series for 'systemOptimizedChokeBeanSize' in this 'NetworkOutputs_String' view. */
  systemOptimizedChokeBeanSize: Maybe<TimeSeries>;
  systemOptimizedChokeChokeBeanSize: Maybe<TimeSeries>;
  systemOptimizedChokeChokeOpening: Maybe<TimeSeries>;
  systemOptimizedChokeEspFrequency: Maybe<TimeSeries>;
  systemOptimizedChokeFBHP: Maybe<TimeSeries>;
  systemOptimizedChokeFWHP: Maybe<TimeSeries>;
  systemOptimizedChokeGasLiftRate: Maybe<TimeSeries>;
  systemOptimizedChokeGasRate: Maybe<TimeSeries>;
  systemOptimizedChokeOilRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'systemOptimizedChokeOpening' in this 'NetworkOutputs_String' view. */
  systemOptimizedChokeOpening: Maybe<TimeSeries>;
  systemOptimizedChokeOptimizedParameter: Maybe<TimeSeries>;
  systemOptimizedChokePower: Maybe<TimeSeries>;
  systemOptimizedChokeRunID: Maybe<TimeSeries>;
  systemOptimizedChokeWaterRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'systemOptimizedEspFrequency' in this 'NetworkOutputs_String' view. */
  systemOptimizedEspFrequency: Maybe<TimeSeries>;
  /** Reference to a time series for 'systemOptimizedFBHP' in this 'NetworkOutputs_String' view. */
  systemOptimizedFBHP: Maybe<TimeSeries>;
  /** Reference to a time series for 'systemOptimizedFWHP' in this 'NetworkOutputs_String' view. */
  systemOptimizedFWHP: Maybe<TimeSeries>;
  /** Reference to a time series for 'systemOptimizedGasLiftRate' in this 'NetworkOutputs_String' view. */
  systemOptimizedGasLiftRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'systemOptimizedGasRate' in this 'NetworkOutputs_String' view. */
  systemOptimizedGasRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'systemOptimizedOilRate' in this 'NetworkOutputs_String' view. */
  systemOptimizedOilRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'systemOptimizedOptimizedParameter' in this 'NetworkOutputs_String' view. */
  systemOptimizedOptimizedParameter: Maybe<TimeSeries>;
  /** Reference to a time series for 'systemOptimizedPower' in this 'NetworkOutputs_String' view. */
  systemOptimizedPower: Maybe<TimeSeries>;
  /** Reference to a time series for 'systemOptimizedRunID' in this 'NetworkOutputs_String' view. */
  systemOptimizedRunID: Maybe<TimeSeries>;
  /** Reference to a time series for 'systemOptimizedWaterRate' in this 'NetworkOutputs_String' view. */
  systemOptimizedWaterRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'technicalChokeBeanSize' in this 'NetworkOutputs_String' view. */
  technicalChokeBeanSize: Maybe<TimeSeries>;
  /** Reference to a time series for 'technicalChokeOpening' in this 'NetworkOutputs_String' view. */
  technicalChokeOpening: Maybe<TimeSeries>;
  /** Reference to a time series for 'technicalEspFrequency' in this 'NetworkOutputs_String' view. */
  technicalEspFrequency: Maybe<TimeSeries>;
  /** Reference to a time series for 'technicalFBHP' in this 'NetworkOutputs_String' view. */
  technicalFBHP: Maybe<TimeSeries>;
  /** Reference to a time series for 'technicalFWHP' in this 'NetworkOutputs_String' view. */
  technicalFWHP: Maybe<TimeSeries>;
  /** Reference to a time series for 'technicalGasLiftRate' in this 'NetworkOutputs_String' view. */
  technicalGasLiftRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'technicalGasRate' in this 'NetworkOutputs_String' view. */
  technicalGasRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'technicalOilRate' in this 'NetworkOutputs_String' view. */
  technicalOilRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'technicalOptimizedParameter' in this 'NetworkOutputs_String' view. */
  technicalOptimizedParameter: Maybe<TimeSeries>;
  /** Reference to a time series for 'technicalPower' in this 'NetworkOutputs_String' view. */
  technicalPower: Maybe<TimeSeries>;
  /** Reference to a time series for 'technicalRunID' in this 'NetworkOutputs_String' view. */
  technicalRunID: Maybe<TimeSeries>;
  /** Reference to a time series for 'technicalWaterRate' in this 'NetworkOutputs_String' view. */
  technicalWaterRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'waxFlag_well' in this 'NetworkOutputs_String' view. */
  waxFlag_well: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellSolverDifference' in this 'NetworkOutputs_String' view. */
  wellSolverDifference: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellSolverEstimatedOilRate' in this 'NetworkOutputs_String' view. */
  wellSolverEstimatedOilRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellSolverMeasuredOilRate' in this 'NetworkOutputs_String' view. */
  wellSolverMeasuredOilRate: Maybe<TimeSeries>;
};

/**
 * Current-state network string outputs and flow-assurance flags (WF7/WF8/WF20).
 *
 * Calculated production rates, match indices, well-solver calibration, current-
 * state equipment setpoints, injection rates, and per-string flow-assurance
 * flags from the GAP network model. Excludes optimization scenario rates and
 * setpoints (see OptimizedRates_Network_String_Agent) and per-network matched
 * nmv* outputs (see StringOutputs_Network_Agent).
 *
 * Use for: Network Surveillance (WF7), Network Model Validation (WF8),
 * Flow Assurance (WF20). WF8: match indices and well-solver vs measured.
 *
 * @name Network String Outputs (Agent)
 */
export type NetworkOutputsStringAgent = {
  /** Asphaltene risk flag at well (TS). */
  asphalteneFlag_well: Maybe<TimeSeries>;
  /** Calculated choke bean size from network solve (TS). */
  calculatedChokeBeanSize: Maybe<TimeSeries>;
  /** Calculated choke opening from network solve (TS). */
  calculatedChokeOpening: Maybe<TimeSeries>;
  /** Calculated ESP frequency from network solve (Hz, TS). */
  calculatedEspFrequency: Maybe<TimeSeries>;
  /** Calculated gas lift rate from network solve (MSCF/d, TS). */
  calculatedGasLiftRate: Maybe<TimeSeries>;
  /** Gas rate match index, calculated vs measured (0-1 scale, TS). */
  calculatedGasRateMatchIndex: Maybe<TimeSeries>;
  /** Oil rate match index, calculated vs measured (0-1 scale, TS). */
  calculatedOilRateMatchIndex: Maybe<TimeSeries>;
  /** Calculated power from network solve (TS). */
  calculatedPower: Maybe<TimeSeries>;
  /** Pump liquid rate from network solve (stb/d, TS). */
  calculatedPumpLquidRate: Maybe<TimeSeries>;
  /** Water rate match index, calculated vs measured (0-1 scale, TS). */
  calculatedWaterRateMatchIndex: Maybe<TimeSeries>;
  /** Network-calculated bottomhole pressure (psi, TS). */
  calculatedWellBHP: Maybe<TimeSeries>;
  /** Gas injection BHP from network solve (psi, TS). */
  calculatedWellBHPGI: Maybe<TimeSeries>;
  /** Water injection BHP from network solve (psi, TS). */
  calculatedWellBHPWI: Maybe<TimeSeries>;
  /** ESP motor load from network solve (TS). */
  calculatedWellESPMotorLoad: Maybe<TimeSeries>;
  /** Network-calculated flowing BHP (psi, TS). */
  calculatedWellFBHP: Maybe<TimeSeries>;
  /** Network-calculated flowing wellhead pressure (psi, TS). */
  calculatedWellFWHP: Maybe<TimeSeries>;
  /** Network-solved gas production rate (MSCF/d, TS). */
  calculatedWellGasRate: Maybe<TimeSeries>;
  /** Gas injection rate from network solve (MSCF/d, TS). */
  calculatedWellGasRateGI: Maybe<TimeSeries>;
  /** Network-solved total liquid rate (stb/d, TS). */
  calculatedWellLiquidRate: Maybe<TimeSeries>;
  /** Network-solved oil production rate (stb/d, TS). */
  calculatedWellOilRate: Maybe<TimeSeries>;
  /** Network-solved water production rate (stb/d, TS). */
  calculatedWellWaterRate: Maybe<TimeSeries>;
  /** Water injection rate from network solve (stb/d, TS). */
  calculatedWellWaterRateWI: Maybe<TimeSeries>;
  /** Choke pressure drop from network solve (psi, TS). */
  chokeDP: Maybe<TimeSeries>;
  /** Operating constraint flag at well (TS). */
  constraintFlag_well: Maybe<TimeSeries>;
  /** ESP efficiency from network solve (TS). */
  espEfficiency: Maybe<TimeSeries>;
  /** Formation gas-oil ratio input to GAP network model (scf/stb, TS). */
  formationGOR: Maybe<TimeSeries>;
  /** GAP model well name mapping. */
  gapWellName: Maybe<Scalars['String']['output']>;
  /** Gas lift injection rate from network solve (MSCF/d, TS). */
  gasLiftInjection: Maybe<TimeSeries>;
  /** Gas lift injection pressure (psi, TS). */
  gasLiftInjectionPress: Maybe<TimeSeries>;
  /** Hydrate risk flag at well (TS). */
  hydrateFlag_well: Maybe<TimeSeries>;
  /** PE5 stability flag at well (TS). */
  pe5StabilityFlag_well: Maybe<TimeSeries>;
  /** Scale risk flag at well (TS). */
  scaleFlag_well: Maybe<TimeSeries>;
  /** Wax deposition flag at well (TS). */
  waxFlag_well: Maybe<TimeSeries>;
  /** Difference between well solver estimated and measured oil rates (TS). */
  wellSolverDifference: Maybe<TimeSeries>;
  /** Well solver estimated oil rate input (stb/d, TS). */
  wellSolverEstimatedOilRate: Maybe<TimeSeries>;
  /** Well solver measured oil rate input (stb/d, TS). */
  wellSolverMeasuredOilRate: Maybe<TimeSeries>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString: Maybe<StringAsset>;
};

/** View 'NetworkOutputs_String_Validated' in the iPSO production optimization solution data model. */
export type NetworkOutputsStringValidated = {
  adHocOptimization1ValidatedChokeBeanSize: Maybe<TimeSeries>;
  adHocOptimization1ValidatedChokeOpening: Maybe<TimeSeries>;
  adHocOptimization1ValidatedEspFrequency: Maybe<TimeSeries>;
  adHocOptimization1ValidatedFBHP: Maybe<TimeSeries>;
  adHocOptimization1ValidatedFWHP: Maybe<TimeSeries>;
  adHocOptimization1ValidatedGasLiftRate: Maybe<TimeSeries>;
  adHocOptimization1ValidatedGasRate: Maybe<TimeSeries>;
  adHocOptimization1ValidatedOilRate: Maybe<TimeSeries>;
  adHocOptimization1ValidatedOptimizedParameter: Maybe<TimeSeries>;
  adHocOptimization1ValidatedPower: Maybe<TimeSeries>;
  adHocOptimization1ValidatedRunID: Maybe<TimeSeries>;
  adHocOptimization1ValidatedWaterRate: Maybe<TimeSeries>;
  adHocOptimization2ValidatedChokeBeanSize: Maybe<TimeSeries>;
  adHocOptimization2ValidatedChokeOpening: Maybe<TimeSeries>;
  adHocOptimization2ValidatedEspFrequency: Maybe<TimeSeries>;
  adHocOptimization2ValidatedFBHP: Maybe<TimeSeries>;
  adHocOptimization2ValidatedFWHP: Maybe<TimeSeries>;
  adHocOptimization2ValidatedGasLiftRate: Maybe<TimeSeries>;
  adHocOptimization2ValidatedGasRate: Maybe<TimeSeries>;
  adHocOptimization2ValidatedOilRate: Maybe<TimeSeries>;
  adHocOptimization2ValidatedOptimizedParameter: Maybe<TimeSeries>;
  adHocOptimization2ValidatedPower: Maybe<TimeSeries>;
  adHocOptimization2ValidatedRunID: Maybe<TimeSeries>;
  adHocOptimization2ValidatedWaterRate: Maybe<TimeSeries>;
  entityName: Maybe<StringAsset>;
  systemOptimizedChokeValidatedChokeBeanSize: Maybe<TimeSeries>;
  systemOptimizedChokeValidatedChokeOpening: Maybe<TimeSeries>;
  systemOptimizedChokeValidatedEspFrequency: Maybe<TimeSeries>;
  systemOptimizedChokeValidatedFBHP: Maybe<TimeSeries>;
  systemOptimizedChokeValidatedFWHP: Maybe<TimeSeries>;
  systemOptimizedChokeValidatedGasLiftRate: Maybe<TimeSeries>;
  systemOptimizedChokeValidatedGasRate: Maybe<TimeSeries>;
  systemOptimizedChokeValidatedOilRate: Maybe<TimeSeries>;
  systemOptimizedChokeValidatedOptimizedParameter: Maybe<TimeSeries>;
  systemOptimizedChokeValidatedPower: Maybe<TimeSeries>;
  systemOptimizedChokeValidatedRunID: Maybe<TimeSeries>;
  systemOptimizedChokeValidatedWaterRate: Maybe<TimeSeries>;
  systemOptimizedValidatedChokeBeanSize: Maybe<TimeSeries>;
  systemOptimizedValidatedChokeOpening: Maybe<TimeSeries>;
  systemOptimizedValidatedEspFrequency: Maybe<TimeSeries>;
  systemOptimizedValidatedFBHP: Maybe<TimeSeries>;
  systemOptimizedValidatedFWHP: Maybe<TimeSeries>;
  systemOptimizedValidatedGasLiftRate: Maybe<TimeSeries>;
  systemOptimizedValidatedGasRate: Maybe<TimeSeries>;
  systemOptimizedValidatedOilRate: Maybe<TimeSeries>;
  systemOptimizedValidatedOptimizedParameter: Maybe<TimeSeries>;
  systemOptimizedValidatedPower: Maybe<TimeSeries>;
  systemOptimizedValidatedRunID: Maybe<TimeSeries>;
  systemOptimizedValidatedTop5BeforeOilRate: Maybe<TimeSeries>;
  systemOptimizedValidatedTop5BeforeWaterRate: Maybe<TimeSeries>;
  systemOptimizedValidatedTop5OilRate: Maybe<TimeSeries>;
  systemOptimizedValidatedTop5WaterRate: Maybe<TimeSeries>;
  systemOptimizedValidatedTop10BeforeOilRate: Maybe<TimeSeries>;
  systemOptimizedValidatedTop10BeforeWaterRate: Maybe<TimeSeries>;
  systemOptimizedValidatedTop10OilRate: Maybe<TimeSeries>;
  systemOptimizedValidatedTop10WaterRate: Maybe<TimeSeries>;
  systemOptimizedValidatedTop20BeforeOilRate: Maybe<TimeSeries>;
  systemOptimizedValidatedTop20BeforeWaterRate: Maybe<TimeSeries>;
  systemOptimizedValidatedTop20OilRate: Maybe<TimeSeries>;
  systemOptimizedValidatedTop20WaterRate: Maybe<TimeSeries>;
  systemOptimizedValidatedWaterRate: Maybe<TimeSeries>;
};

/**
 * Current-state flow assurance risk per pipeline/flowline entity (WF20).
 *
 * Risk scores and categories for pipeline network components from the GAP network
 * model. Filtered to instances whose externalId starts with pipeline: (iPSO
 * entity naming convention). Query by pipelineEntity. For well-string risk see
 * NetworkRiskString_Agent; for per-scenario risk see
 * NetworkRiskPipeline_OptimizationScenarios_Agent.
 *
 * Use for: Flow Assurance Detection and Mitigation (WF20).
 *
 * @name Network Risk - Pipeline (Agent)
 */
export type NetworkRiskPipelineAgent = {
  /** Overall aggregated flow assurance risk level (TS). */
  aggregatedRisk: Maybe<TimeSeries>;
  /** Maximum asphaltene onset temperature delta (TS). */
  asphalteneDTMax: Maybe<TimeSeries>;
  /** Asphaltene risk level (TS). */
  asphalteneRisk: Maybe<TimeSeries>;
  /** Maximum corrosion rate across entity (TS). */
  corrosionRateMax: Maybe<TimeSeries>;
  /** Corrosion risk level (TS). */
  corrosionRisk: Maybe<TimeSeries>;
  /** Maximum erosion rate (TS). */
  erosionMax: Maybe<TimeSeries>;
  /** Erosion risk level (TS). */
  erosionRisk: Maybe<TimeSeries>;
  /** Maximum erosion velocity ratio (TS). >1 = exceeds limit. */
  evrMax: Maybe<TimeSeries>;
  /** Erosion velocity risk level (TS). */
  evrRisk: Maybe<TimeSeries>;
  /** Maximum hydrate temperature delta (TS). Negative = above hydrate curve. */
  hydrateDTMax: Maybe<TimeSeries>;
  /** Hydrate formation risk level (TS). */
  hydrateRisk: Maybe<TimeSeries>;
  /** Reference to parent network model. */
  network: Maybe<Network>;
  /** Maximum PE5 stability indicator (TS). */
  pe5StabilityMax: Maybe<TimeSeries>;
  /** PE5 stability risk level (TS). */
  pe5StabilityRisk: Maybe<TimeSeries>;
  /** Pipeline/flowline entity identifier. */
  pipelineEntity: Maybe<Pipeline>;
  /** Maximum scale saturation index (TS). >1 = scaling likely. */
  scaleSIMax: Maybe<TimeSeries>;
  /** Scale risk level (TS). */
  scaleSIRisk: Maybe<TimeSeries>;
  /** Maximum wax deposition temperature delta (TS). Negative = below WAT. */
  waxDTMax: Maybe<TimeSeries>;
  /** Wax deposition risk level (TS). */
  waxRisk: Maybe<TimeSeries>;
};

/**
 * Per-scenario flow assurance risk per pipeline/flowline entity (WF11/WF20).
 *
 * Risk scores for each optimization scenario on pipeline network components.
 * Filtered to instances whose externalId starts with pipeline:. Query by
 * pipelineEntity and scenarioName. For current-state pipeline risk see
 * NetworkRiskPipeline_Agent; for string scenarios see
 * NetworkRiskString_OptimizationScenarios_Agent.
 *
 * Use for: Production Optimization Scenarios (WF11), Flow Assurance Detection and Mitigation (WF20).
 *
 * @name Network Risk - Pipeline Optimization Scenarios (Agent)
 */
export type NetworkRiskPipelineOptimizationScenariosAgent = {
  /** Overall aggregated risk level for this scenario (TS). */
  aggregatedRisk: Maybe<TimeSeries>;
  /** Maximum asphaltene delta-T for this scenario (TS). */
  asphalteneDTMax: Maybe<TimeSeries>;
  /** Asphaltene risk level for this scenario (TS). */
  asphalteneRisk: Maybe<TimeSeries>;
  /** Maximum corrosion rate for this scenario (TS). */
  corrosionRateMax: Maybe<TimeSeries>;
  /** Corrosion risk level for this scenario (TS). */
  corrosionRisk: Maybe<TimeSeries>;
  /** Maximum erosion rate for this scenario (TS). */
  erosionMax: Maybe<TimeSeries>;
  /** Erosion risk level for this scenario (TS). */
  erosionRisk: Maybe<TimeSeries>;
  /** Maximum erosion velocity ratio for this scenario (TS). */
  evrMax: Maybe<TimeSeries>;
  /** Erosion velocity risk level for this scenario (TS). */
  evrRisk: Maybe<TimeSeries>;
  /** Maximum hydrate delta-T for this scenario (TS). */
  hydrateDTMax: Maybe<TimeSeries>;
  /** Hydrate risk level for this scenario (TS). */
  hydrateRisk: Maybe<TimeSeries>;
  /** Reference to parent network model. */
  network: Maybe<Network>;
  /** Maximum PE5 stability for this scenario (TS). */
  pe5StabilityMax: Maybe<TimeSeries>;
  /** PE5 stability risk level for this scenario (TS). */
  pe5StabilityRisk: Maybe<TimeSeries>;
  /** Pipeline/flowline entity identifier. */
  pipelineEntity: Maybe<Pipeline>;
  /** Unique identifier for this optimization run. */
  runID: Maybe<TimeSeries>;
  /** Maximum scale saturation index for this scenario (TS). */
  scaleSIMax: Maybe<TimeSeries>;
  /** Scale risk level for this scenario (TS). */
  scaleSIRisk: Maybe<TimeSeries>;
  /** Name of the optimization scenario. */
  scenarioName: Maybe<Scalars['String']['output']>;
  /** Maximum wax delta-T for this scenario (TS). */
  waxDTMax: Maybe<TimeSeries>;
  /** Wax risk level for this scenario (TS). */
  waxRisk: Maybe<TimeSeries>;
};

/**
 * Current-state flow assurance risk per well string (WF20).
 *
 * Risk scores and categories for well strings from the GAP network model.
 * Filtered to instances whose externalId starts with string: (iPSO entity
 * naming convention). Query by wellString. For pipeline/flowline risk see
 * NetworkRiskPipeline_Agent; for per-scenario risk see
 * NetworkRiskString_OptimizationScenarios_Agent.
 *
 * Use for: Flow Assurance Detection and Mitigation (WF20).
 *
 * @name Network Risk - String (Agent)
 */
export type NetworkRiskStringAgent = {
  /** Overall aggregated flow assurance risk level (TS). */
  aggregatedRisk: Maybe<TimeSeries>;
  /** Maximum asphaltene onset temperature delta (TS). */
  asphalteneDTMax: Maybe<TimeSeries>;
  /** Asphaltene risk level (TS). */
  asphalteneRisk: Maybe<TimeSeries>;
  /** Maximum corrosion rate across entity (TS). */
  corrosionRateMax: Maybe<TimeSeries>;
  /** Corrosion risk level (TS). */
  corrosionRisk: Maybe<TimeSeries>;
  /** Maximum erosion rate (TS). */
  erosionMax: Maybe<TimeSeries>;
  /** Erosion risk level (TS). */
  erosionRisk: Maybe<TimeSeries>;
  /** Maximum erosion velocity ratio (TS). >1 = exceeds limit. */
  evrMax: Maybe<TimeSeries>;
  /** Erosion velocity risk level (TS). */
  evrRisk: Maybe<TimeSeries>;
  /** Maximum hydrate temperature delta (TS). Negative = above hydrate curve. */
  hydrateDTMax: Maybe<TimeSeries>;
  /** Hydrate formation risk level (TS). */
  hydrateRisk: Maybe<TimeSeries>;
  /** Reference to parent network model. */
  network: Maybe<Network>;
  /** Maximum PE5 stability indicator (TS). */
  pe5StabilityMax: Maybe<TimeSeries>;
  /** PE5 stability risk level (TS). */
  pe5StabilityRisk: Maybe<TimeSeries>;
  /** Maximum scale saturation index (TS). >1 = scaling likely. */
  scaleSIMax: Maybe<TimeSeries>;
  /** Scale risk level (TS). */
  scaleSIRisk: Maybe<TimeSeries>;
  /** Maximum wax deposition temperature delta (TS). Negative = below WAT. */
  waxDTMax: Maybe<TimeSeries>;
  /** Wax deposition risk level (TS). */
  waxRisk: Maybe<TimeSeries>;
  /** Well string identifier. */
  wellString: Maybe<StringAsset>;
};

/**
 * Per-scenario flow assurance risk per well string (WF11/WF20).
 *
 * Risk scores for each optimization scenario on well strings, evaluated against a
 * current-state baseline. Filtered to instances whose externalId starts with
 * string:. Query by wellString and scenarioName. For current-state string risk
 * see NetworkRiskString_Agent; for pipeline scenarios see
 * NetworkRiskPipeline_OptimizationScenarios_Agent.
 *
 * Use for: Production Optimization Scenarios (WF11), Flow Assurance Detection and Mitigation (WF20).
 *
 * @name Network Risk - String Optimization Scenarios (Agent)
 */
export type NetworkRiskStringOptimizationScenariosAgent = {
  /** Overall aggregated risk level for this scenario (TS). */
  aggregatedRisk: Maybe<TimeSeries>;
  /** Maximum asphaltene delta-T for this scenario (TS). */
  asphalteneDTMax: Maybe<TimeSeries>;
  /** Asphaltene risk level for this scenario (TS). */
  asphalteneRisk: Maybe<TimeSeries>;
  /** Maximum corrosion rate for this scenario (TS). */
  corrosionRateMax: Maybe<TimeSeries>;
  /** Corrosion risk level for this scenario (TS). */
  corrosionRisk: Maybe<TimeSeries>;
  /** Maximum erosion rate for this scenario (TS). */
  erosionMax: Maybe<TimeSeries>;
  /** Erosion risk level for this scenario (TS). */
  erosionRisk: Maybe<TimeSeries>;
  /** Maximum erosion velocity ratio for this scenario (TS). */
  evrMax: Maybe<TimeSeries>;
  /** Erosion velocity risk level for this scenario (TS). */
  evrRisk: Maybe<TimeSeries>;
  /** Maximum hydrate delta-T for this scenario (TS). */
  hydrateDTMax: Maybe<TimeSeries>;
  /** Hydrate risk level for this scenario (TS). */
  hydrateRisk: Maybe<TimeSeries>;
  /** Reference to parent network model. */
  network: Maybe<Network>;
  /** Maximum PE5 stability for this scenario (TS). */
  pe5StabilityMax: Maybe<TimeSeries>;
  /** PE5 stability risk level for this scenario (TS). */
  pe5StabilityRisk: Maybe<TimeSeries>;
  /** Unique identifier for this optimization run. */
  runID: Maybe<TimeSeries>;
  /** Maximum scale saturation index for this scenario (TS). */
  scaleSIMax: Maybe<TimeSeries>;
  /** Scale risk level for this scenario (TS). */
  scaleSIRisk: Maybe<TimeSeries>;
  /** Name of the optimization scenario. */
  scenarioName: Maybe<Scalars['String']['output']>;
  /** Maximum wax delta-T for this scenario (TS). */
  waxDTMax: Maybe<TimeSeries>;
  /** Wax risk level for this scenario (TS). */
  waxRisk: Maybe<TimeSeries>;
  /** Well string identifier. */
  wellString: Maybe<StringAsset>;
};

/** View 'NetworkRisk_OptimizationScenarios' in the iPSO production optimization solution data model. */
export type NetworkRiskOptimizationScenarios = {
  /** Reference to a time series for 'aggregatedRisk' in this 'NetworkRisk_OptimizationScenarios' view. */
  aggregatedRisk: Maybe<TimeSeries>;
  /** Reference to a time series for 'asphalteneDTMax' in this 'NetworkRisk_OptimizationScenarios' view. */
  asphalteneDTMax: Maybe<TimeSeries>;
  /** Reference to a time series for 'asphalteneRisk' in this 'NetworkRisk_OptimizationScenarios' view. */
  asphalteneRisk: Maybe<TimeSeries>;
  /** Reference to a time series for 'corrosionRateMax' in this 'NetworkRisk_OptimizationScenarios' view. */
  corrosionRateMax: Maybe<TimeSeries>;
  /** Reference to a time series for 'corrosionRisk' in this 'NetworkRisk_OptimizationScenarios' view. */
  corrosionRisk: Maybe<TimeSeries>;
  /** Reference to the related 'Entity' entity for this 'NetworkRisk_OptimizationScenarios' row. */
  entityName: Maybe<Entity>;
  /** Reference to a time series for 'erosionMax' in this 'NetworkRisk_OptimizationScenarios' view. */
  erosionMax: Maybe<TimeSeries>;
  /** Reference to a time series for 'erosionRisk' in this 'NetworkRisk_OptimizationScenarios' view. */
  erosionRisk: Maybe<TimeSeries>;
  /** Reference to a time series for 'evrMax' in this 'NetworkRisk_OptimizationScenarios' view. */
  evrMax: Maybe<TimeSeries>;
  /** Reference to a time series for 'evrRisk' in this 'NetworkRisk_OptimizationScenarios' view. */
  evrRisk: Maybe<TimeSeries>;
  /** Reference to a time series for 'hydrateDTMax' in this 'NetworkRisk_OptimizationScenarios' view. */
  hydrateDTMax: Maybe<TimeSeries>;
  /** Reference to a time series for 'hydrateRisk' in this 'NetworkRisk_OptimizationScenarios' view. */
  hydrateRisk: Maybe<TimeSeries>;
  /** Reference to the related 'Network' entity for this 'NetworkRisk_OptimizationScenarios' row. */
  network: Maybe<Network>;
  /** Reference to a time series for 'pe5StabilityMax' in this 'NetworkRisk_OptimizationScenarios' view. */
  pe5StabilityMax: Maybe<TimeSeries>;
  /** Reference to a time series for 'pe5StabilityRisk' in this 'NetworkRisk_OptimizationScenarios' view. */
  pe5StabilityRisk: Maybe<TimeSeries>;
  /** Reference to a time series for 'runID' in this 'NetworkRisk_OptimizationScenarios' view. */
  runID: Maybe<TimeSeries>;
  /** Reference to a time series for 'scaleSIMax' in this 'NetworkRisk_OptimizationScenarios' view. */
  scaleSIMax: Maybe<TimeSeries>;
  /** Reference to a time series for 'scaleSIRisk' in this 'NetworkRisk_OptimizationScenarios' view. */
  scaleSIRisk: Maybe<TimeSeries>;
  /** Text attribute 'scenarioName' for this 'NetworkRisk_OptimizationScenarios' row. */
  scenarioName: Maybe<Scalars['String']['output']>;
  /** Reference to a time series for 'waxDTMax' in this 'NetworkRisk_OptimizationScenarios' view. */
  waxDTMax: Maybe<TimeSeries>;
  /** Reference to a time series for 'waxRisk' in this 'NetworkRisk_OptimizationScenarios' view. */
  waxRisk: Maybe<TimeSeries>;
};

/**
 * Production optimization opportunities tracking potential gains from well
 * interventions.
 *
 * Contains data related to production optimization opportunities tracking
 * potential gains from well interventions. This view aggregates information from
 * operational databases and historical performance metrics, to analyze the
 * effectiveness of various well interventions. It answers analytical questions
 * such as the potential oil gain from specific opportunities, the status of open
 * or closed interventions, and the validation status of pending opportunities.
 * Excludes detailed financial metrics or external market conditions (see other
 * related views focused on economic analysis).
 */
export type OpportunityAgent = {
  /** Actual date when intervention was executed. */
  actualExecutionDate: Maybe<Scalars['Date']['output']>;
  /** Current gas production rate before intervention (Mscf/d). */
  baselineGasRate: Maybe<Scalars['Float']['output']>;
  /** Current oil production rate before intervention (stb/d). Baseline for gain calculation. */
  baselineOilRate: Maybe<Scalars['Float']['output']>;
  /** Current water production rate before intervention (stb/d). */
  baselineWaterRate: Maybe<Scalars['Float']['output']>;
  /** Date when opportunity was identified and created. */
  createdDate: Maybe<Scalars['Date']['output']>;
  /** Cumulative oil production gained since execution (stb). Tracks realized value. */
  cumulativeOilGain: Maybe<Scalars['Float']['output']>;
  /** Detailed description of the opportunity, including technical rationale. */
  description: Maybe<Scalars['String']['output']>;
  /** Predicted gas rate after intervention (Mscf/d). */
  estimatedGasRate: Maybe<Scalars['Float']['output']>;
  /** Predicted oil rate after intervention (stb/d). Expected gain = estimated - baseline. */
  estimatedOilRate: Maybe<Scalars['Float']['output']>;
  /** Predicted water rate after intervention (stb/d). */
  estimatedWaterRate: Maybe<Scalars['Float']['output']>;
  /** Type of intervention required (e.g., WORKOVER, CHOKE_CHANGE, STIMULATION). */
  interventionActivity: Maybe<Scalars['String']['output']>;
  /** Person responsible for driving this opportunity to execution. */
  owner: Maybe<Scalars['String']['output']>;
  /** Scheduled date for intervention execution. */
  plannedExecutionDate: Maybe<Scalars['Date']['output']>;
  /** Origin of opportunity identification (e.g., SURVEILLANCE, WORKFLOW, MANUAL). */
  source: Maybe<Scalars['String']['output']>;
  /**
   * Current opportunity status: OPEN, VALIDATED, PLANNED, EXECUTED, CLOSED.
   * Use to track lifecycle progress.
   */
  status: Maybe<Scalars['String']['output']>;
  /** Brief summary of the production opportunity. Use for quick identification. */
  summary: Maybe<Scalars['String']['output']>;
  /** Link to associated ticket in TicketRegistry. Use to join for full ticket details. */
  ticketExternalID: Maybe<Scalars['String']['output']>;
  /** Type of opportunity (e.g., CHOKE_ADJUSTMENT, RECOMPLETION, GAS_LIFT_OPT). */
  type: Maybe<Scalars['String']['output']>;
  /** Comments from validation review, including technical justification. */
  validationComments: Maybe<Scalars['String']['output']>;
  /** Validation status: PENDING, VALIDATED, REJECTED. Indicates engineering review state. */
  validationStatus: Maybe<Scalars['String']['output']>;
  /** Date when value tracking ended for this opportunity. */
  valueTrackingEndDate: Maybe<Scalars['Date']['output']>;
  /** Reason for ending value tracking (e.g., RATE_DECLINE, NEW_INTERVENTION). */
  valueTrackingEndReason: Maybe<Scalars['String']['output']>;
  /** Status of value tracking: ACTIVE, COMPLETED, NOT_STARTED. */
  valueTrackingStatus: Maybe<Scalars['String']['output']>;
  /** Name of the well this opportunity applies to. Primary filter for well-based queries. */
  wellName: Maybe<Scalars['String']['output']>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString: Maybe<StringAsset>;
  /** Well type classification (PRODUCER, INJECTOR, etc.). */
  wellType: Maybe<Scalars['String']['output']>;
};

/**
 * Optimization scenario rates, setpoints, and metadata per well string (WF7/WF11).
 *
 * Single agent view for all optimization property families from the GAP network
 * optimizer: systemOptimized*, technical*, hydraulic*, fsopr*, and adHoc*
 * scenarios including rates, choke/ESP/power/gas-lift setpoints, pressures,
 * run IDs, and optimized parameters. For current-state string outputs and flow-
 * assurance flags see NetworkOutputs_String_Agent; for per-network matched
 * snapshot see StringOutputs_Network_Agent.
 *
 * Use for: Network Surveillance (WF7), Production Optimization Scenarios (WF11).
 *
 * @name Optimized Rates - Network Scenarios (Agent)
 */
export type OptimizedRatesNetworkStringAgent = {
  /** adHocOptimization1ChokeBeanSize from GAP network optimization (TS). */
  adHocOptimization1ChokeBeanSize: Maybe<TimeSeries>;
  /** adHocOptimization1ChokeOpening from GAP network optimization (TS). */
  adHocOptimization1ChokeOpening: Maybe<TimeSeries>;
  /** adHocOptimization1Comment from GAP network optimization (TS). */
  adHocOptimization1Comment: Maybe<TimeSeries>;
  /** adHocOptimization1EspFrequency from GAP network optimization (TS). */
  adHocOptimization1EspFrequency: Maybe<TimeSeries>;
  /** adHocOptimization1ExecutedBy from GAP network optimization (TS). */
  adHocOptimization1ExecutedBy: Maybe<TimeSeries>;
  /** adHocOptimization1FBHP from GAP network optimization (TS). */
  adHocOptimization1FBHP: Maybe<TimeSeries>;
  /** adHocOptimization1FWHP from GAP network optimization (TS). */
  adHocOptimization1FWHP: Maybe<TimeSeries>;
  /** adHocOptimization1GasLiftRate from GAP network optimization (TS). */
  adHocOptimization1GasLiftRate: Maybe<TimeSeries>;
  /** adHocOptimization1GasRate from GAP network optimization (TS). */
  adHocOptimization1GasRate: Maybe<TimeSeries>;
  /** adHocOptimization1OilRate from GAP network optimization (TS). */
  adHocOptimization1OilRate: Maybe<TimeSeries>;
  /** adHocOptimization1OptimizedParameter from GAP network optimization (TS). */
  adHocOptimization1OptimizedParameter: Maybe<TimeSeries>;
  /** adHocOptimization1Power from GAP network optimization (TS). */
  adHocOptimization1Power: Maybe<TimeSeries>;
  /** adHocOptimization1RunID from GAP network optimization (TS). */
  adHocOptimization1RunID: Maybe<TimeSeries>;
  /** adHocOptimization1WaterRate from GAP network optimization (TS). */
  adHocOptimization1WaterRate: Maybe<TimeSeries>;
  /** adHocOptimization2ChokeBeanSize from GAP network optimization (TS). */
  adHocOptimization2ChokeBeanSize: Maybe<TimeSeries>;
  /** adHocOptimization2ChokeOpening from GAP network optimization (TS). */
  adHocOptimization2ChokeOpening: Maybe<TimeSeries>;
  /** adHocOptimization2Comment from GAP network optimization (TS). */
  adHocOptimization2Comment: Maybe<TimeSeries>;
  /** adHocOptimization2EspFrequency from GAP network optimization (TS). */
  adHocOptimization2EspFrequency: Maybe<TimeSeries>;
  /** adHocOptimization2ExecutedBy from GAP network optimization (TS). */
  adHocOptimization2ExecutedBy: Maybe<TimeSeries>;
  /** adHocOptimization2FBHP from GAP network optimization (TS). */
  adHocOptimization2FBHP: Maybe<TimeSeries>;
  /** adHocOptimization2FWHP from GAP network optimization (TS). */
  adHocOptimization2FWHP: Maybe<TimeSeries>;
  /** adHocOptimization2GasLiftRate from GAP network optimization (TS). */
  adHocOptimization2GasLiftRate: Maybe<TimeSeries>;
  /** adHocOptimization2GasRate from GAP network optimization (TS). */
  adHocOptimization2GasRate: Maybe<TimeSeries>;
  /** adHocOptimization2OilRate from GAP network optimization (TS). */
  adHocOptimization2OilRate: Maybe<TimeSeries>;
  /** adHocOptimization2OptimizedParameter from GAP network optimization (TS). */
  adHocOptimization2OptimizedParameter: Maybe<TimeSeries>;
  /** adHocOptimization2Power from GAP network optimization (TS). */
  adHocOptimization2Power: Maybe<TimeSeries>;
  /** adHocOptimization2RunID from GAP network optimization (TS). */
  adHocOptimization2RunID: Maybe<TimeSeries>;
  /** adHocOptimization2WaterRate from GAP network optimization (TS). */
  adHocOptimization2WaterRate: Maybe<TimeSeries>;
  /** adHocSimulation1ChokeBeanSize from GAP network optimization (TS). */
  adHocSimulation1ChokeBeanSize: Maybe<TimeSeries>;
  /** adHocSimulation1ChokeOpening from GAP network optimization (TS). */
  adHocSimulation1ChokeOpening: Maybe<TimeSeries>;
  /** adHocSimulation1Comment from GAP network optimization (TS). */
  adHocSimulation1Comment: Maybe<TimeSeries>;
  /** adHocSimulation1EspFrequency from GAP network optimization (TS). */
  adHocSimulation1EspFrequency: Maybe<TimeSeries>;
  /** adHocSimulation1ExecutedBy from GAP network optimization (TS). */
  adHocSimulation1ExecutedBy: Maybe<TimeSeries>;
  /** adHocSimulation1FBHP from GAP network optimization (TS). */
  adHocSimulation1FBHP: Maybe<TimeSeries>;
  /** adHocSimulation1FWHP from GAP network optimization (TS). */
  adHocSimulation1FWHP: Maybe<TimeSeries>;
  /** adHocSimulation1GasLiftRate from GAP network optimization (TS). */
  adHocSimulation1GasLiftRate: Maybe<TimeSeries>;
  /** adHocSimulation1GasRate from GAP network optimization (TS). */
  adHocSimulation1GasRate: Maybe<TimeSeries>;
  /** adHocSimulation1OilRate from GAP network optimization (TS). */
  adHocSimulation1OilRate: Maybe<TimeSeries>;
  /** adHocSimulation1OptimizedParameter from GAP network optimization (TS). */
  adHocSimulation1OptimizedParameter: Maybe<TimeSeries>;
  /** adHocSimulation1Power from GAP network optimization (TS). */
  adHocSimulation1Power: Maybe<TimeSeries>;
  /** adHocSimulation1RunID from GAP network optimization (TS). */
  adHocSimulation1RunID: Maybe<TimeSeries>;
  /** adHocSimulation1WaterRate from GAP network optimization (TS). */
  adHocSimulation1WaterRate: Maybe<TimeSeries>;
  /** adHocSimulation2ChokeBeanSize from GAP network optimization (TS). */
  adHocSimulation2ChokeBeanSize: Maybe<TimeSeries>;
  /** adHocSimulation2ChokeOpening from GAP network optimization (TS). */
  adHocSimulation2ChokeOpening: Maybe<TimeSeries>;
  /** adHocSimulation2Comment from GAP network optimization (TS). */
  adHocSimulation2Comment: Maybe<TimeSeries>;
  /** adHocSimulation2EspFrequency from GAP network optimization (TS). */
  adHocSimulation2EspFrequency: Maybe<TimeSeries>;
  /** adHocSimulation2ExecutedBy from GAP network optimization (TS). */
  adHocSimulation2ExecutedBy: Maybe<TimeSeries>;
  /** adHocSimulation2FBHP from GAP network optimization (TS). */
  adHocSimulation2FBHP: Maybe<TimeSeries>;
  /** adHocSimulation2FWHP from GAP network optimization (TS). */
  adHocSimulation2FWHP: Maybe<TimeSeries>;
  /** adHocSimulation2GasLiftRate from GAP network optimization (TS). */
  adHocSimulation2GasLiftRate: Maybe<TimeSeries>;
  /** adHocSimulation2GasRate from GAP network optimization (TS). */
  adHocSimulation2GasRate: Maybe<TimeSeries>;
  /** adHocSimulation2OilRate from GAP network optimization (TS). */
  adHocSimulation2OilRate: Maybe<TimeSeries>;
  /** adHocSimulation2OptimizedParameter from GAP network optimization (TS). */
  adHocSimulation2OptimizedParameter: Maybe<TimeSeries>;
  /** adHocSimulation2Power from GAP network optimization (TS). */
  adHocSimulation2Power: Maybe<TimeSeries>;
  /** adHocSimulation2RunID from GAP network optimization (TS). */
  adHocSimulation2RunID: Maybe<TimeSeries>;
  /** adHocSimulation2WaterRate from GAP network optimization (TS). */
  adHocSimulation2WaterRate: Maybe<TimeSeries>;
  /** fsoprChokeBeanSize from GAP network optimization (TS). */
  fsoprChokeBeanSize: Maybe<TimeSeries>;
  /** fsoprChokeOpening from GAP network optimization (TS). */
  fsoprChokeOpening: Maybe<TimeSeries>;
  /** fsoprEspFrequency from GAP network optimization (TS). */
  fsoprEspFrequency: Maybe<TimeSeries>;
  /** fsoprFBHP from GAP network optimization (TS). */
  fsoprFBHP: Maybe<TimeSeries>;
  /** fsoprFWHP from GAP network optimization (TS). */
  fsoprFWHP: Maybe<TimeSeries>;
  /** fsoprGasLiftRate from GAP network optimization (TS). */
  fsoprGasLiftRate: Maybe<TimeSeries>;
  /** fsoprGasRate from GAP network optimization (TS). */
  fsoprGasRate: Maybe<TimeSeries>;
  /** fsoprOilRate from GAP network optimization (TS). */
  fsoprOilRate: Maybe<TimeSeries>;
  /** fsoprOptimizedParameter from GAP network optimization (TS). */
  fsoprOptimizedParameter: Maybe<TimeSeries>;
  /** fsoprPower from GAP network optimization (TS). */
  fsoprPower: Maybe<TimeSeries>;
  /** fsoprRunID from GAP network optimization (TS). */
  fsoprRunID: Maybe<TimeSeries>;
  /** fsoprWaterRate from GAP network optimization (TS). */
  fsoprWaterRate: Maybe<TimeSeries>;
  /** hydraulicChokeBeanSize from GAP network optimization (TS). */
  hydraulicChokeBeanSize: Maybe<TimeSeries>;
  /** hydraulicChokeOpening from GAP network optimization (TS). */
  hydraulicChokeOpening: Maybe<TimeSeries>;
  /** hydraulicEspFrequency from GAP network optimization (TS). */
  hydraulicEspFrequency: Maybe<TimeSeries>;
  /** hydraulicFBHP from GAP network optimization (TS). */
  hydraulicFBHP: Maybe<TimeSeries>;
  /** hydraulicFWHP from GAP network optimization (TS). */
  hydraulicFWHP: Maybe<TimeSeries>;
  /** hydraulicGasLiftRate from GAP network optimization (TS). */
  hydraulicGasLiftRate: Maybe<TimeSeries>;
  /** hydraulicGasRate from GAP network optimization (TS). */
  hydraulicGasRate: Maybe<TimeSeries>;
  /** hydraulicOilRate from GAP network optimization (TS). */
  hydraulicOilRate: Maybe<TimeSeries>;
  /** hydraulicOptimizedParameter from GAP network optimization (TS). */
  hydraulicOptimizedParameter: Maybe<TimeSeries>;
  /** hydraulicPower from GAP network optimization (TS). */
  hydraulicPower: Maybe<TimeSeries>;
  /** hydraulicRunID from GAP network optimization (TS). */
  hydraulicRunID: Maybe<TimeSeries>;
  /** hydraulicWaterRate from GAP network optimization (TS). */
  hydraulicWaterRate: Maybe<TimeSeries>;
  /** systemOptimizedChokeBeanSize from GAP network optimization (TS). */
  systemOptimizedChokeBeanSize: Maybe<TimeSeries>;
  /** systemOptimizedChokeChokeBeanSize from GAP network optimization (TS). */
  systemOptimizedChokeChokeBeanSize: Maybe<TimeSeries>;
  /** systemOptimizedChokeChokeOpening from GAP network optimization (TS). */
  systemOptimizedChokeChokeOpening: Maybe<TimeSeries>;
  /** systemOptimizedChokeEspFrequency from GAP network optimization (TS). */
  systemOptimizedChokeEspFrequency: Maybe<TimeSeries>;
  /** systemOptimizedChokeFBHP from GAP network optimization (TS). */
  systemOptimizedChokeFBHP: Maybe<TimeSeries>;
  /** systemOptimizedChokeFWHP from GAP network optimization (TS). */
  systemOptimizedChokeFWHP: Maybe<TimeSeries>;
  /** systemOptimizedChokeGasLiftRate from GAP network optimization (TS). */
  systemOptimizedChokeGasLiftRate: Maybe<TimeSeries>;
  /** systemOptimizedChokeGasRate from GAP network optimization (TS). */
  systemOptimizedChokeGasRate: Maybe<TimeSeries>;
  /** systemOptimizedChokeOilRate from GAP network optimization (TS). */
  systemOptimizedChokeOilRate: Maybe<TimeSeries>;
  /** systemOptimizedChokeOpening from GAP network optimization (TS). */
  systemOptimizedChokeOpening: Maybe<TimeSeries>;
  /** systemOptimizedChokeOptimizedParameter from GAP network optimization (TS). */
  systemOptimizedChokeOptimizedParameter: Maybe<TimeSeries>;
  /** systemOptimizedChokePower from GAP network optimization (TS). */
  systemOptimizedChokePower: Maybe<TimeSeries>;
  /** systemOptimizedChokeRunID from GAP network optimization (TS). */
  systemOptimizedChokeRunID: Maybe<TimeSeries>;
  /** systemOptimizedChokeWaterRate from GAP network optimization (TS). */
  systemOptimizedChokeWaterRate: Maybe<TimeSeries>;
  /** systemOptimizedEspFrequency from GAP network optimization (TS). */
  systemOptimizedEspFrequency: Maybe<TimeSeries>;
  /** systemOptimizedFBHP from GAP network optimization (TS). */
  systemOptimizedFBHP: Maybe<TimeSeries>;
  /** systemOptimizedFWHP from GAP network optimization (TS). */
  systemOptimizedFWHP: Maybe<TimeSeries>;
  /** systemOptimizedGasLiftRate from GAP network optimization (TS). */
  systemOptimizedGasLiftRate: Maybe<TimeSeries>;
  /** systemOptimizedGasRate from GAP network optimization (TS). */
  systemOptimizedGasRate: Maybe<TimeSeries>;
  /** systemOptimizedOilRate from GAP network optimization (TS). */
  systemOptimizedOilRate: Maybe<TimeSeries>;
  /** systemOptimizedOptimizedParameter from GAP network optimization (TS). */
  systemOptimizedOptimizedParameter: Maybe<TimeSeries>;
  /** systemOptimizedPower from GAP network optimization (TS). */
  systemOptimizedPower: Maybe<TimeSeries>;
  /** systemOptimizedRunID from GAP network optimization (TS). */
  systemOptimizedRunID: Maybe<TimeSeries>;
  /** systemOptimizedWaterRate from GAP network optimization (TS). */
  systemOptimizedWaterRate: Maybe<TimeSeries>;
  /** technicalChokeBeanSize from GAP network optimization (TS). */
  technicalChokeBeanSize: Maybe<TimeSeries>;
  /** technicalChokeOpening from GAP network optimization (TS). */
  technicalChokeOpening: Maybe<TimeSeries>;
  /** technicalEspFrequency from GAP network optimization (TS). */
  technicalEspFrequency: Maybe<TimeSeries>;
  /** technicalFBHP from GAP network optimization (TS). */
  technicalFBHP: Maybe<TimeSeries>;
  /** technicalFWHP from GAP network optimization (TS). */
  technicalFWHP: Maybe<TimeSeries>;
  /** technicalGasLiftRate from GAP network optimization (TS). */
  technicalGasLiftRate: Maybe<TimeSeries>;
  /** technicalGasRate from GAP network optimization (TS). */
  technicalGasRate: Maybe<TimeSeries>;
  /** technicalOilRate from GAP network optimization (TS). */
  technicalOilRate: Maybe<TimeSeries>;
  /** technicalOptimizedParameter from GAP network optimization (TS). */
  technicalOptimizedParameter: Maybe<TimeSeries>;
  /** technicalPower from GAP network optimization (TS). */
  technicalPower: Maybe<TimeSeries>;
  /** technicalRunID from GAP network optimization (TS). */
  technicalRunID: Maybe<TimeSeries>;
  /** technicalWaterRate from GAP network optimization (TS). */
  technicalWaterRate: Maybe<TimeSeries>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString: Maybe<StringAsset>;
};

/**
 * SRM/GAP optimization results per well string (WF17).
 *
 * Optimized rates and setpoints from Sector Reservoir Model and GAP; well-string
 * performance across optimization scenarios. Use for optimal production rates and gas lift optimization potential.
 *
 * Use for: VRR Optimization (WF17).
 *
 * @name Optimized Rates - SRM (Agent)
 */
export type OptimizedRatesSrmStringAgent = {
  /** When this optimization scenario was executed (TS). */
  executionDate: Maybe<TimeSeries>;
  /**
   * Whether this is the official approved scenario (boolean flag).
   * 1 = approved for execution, 0 = exploratory/what-if scenario.
   */
  isOfficial: Maybe<TimeSeries>;
  /** SRM-optimized gas production rate (MSCF/d, TS). */
  optimizeGasRateSRM: Maybe<TimeSeries>;
  /** SRM-optimized water production rate (stb/d, TS). */
  optimizeWaterRateSRM: Maybe<TimeSeries>;
  /**
   * GAP-optimized bottomhole flowing pressure (psia, TS). Target drawdown
   * for production optimization.
   */
  optimizedBHFPGAP: Maybe<TimeSeries>;
  /**
   * GAP-optimized choke size setting (TS). Recommended choke opening
   * for production optimization.
   */
  optimizedChokeSizeGAP: Maybe<TimeSeries>;
  /**
   * GAP-optimized ESP pump frequency (Hz, TS). Recommended VSD frequency
   * for optimal pump performance.
   */
  optimizedESPFrequencyGAP: Maybe<TimeSeries>;
  /** GAP network-optimized gas injection rate (MSCF/d, TS). */
  optimizedGasInjRateGAP: Maybe<TimeSeries>;
  /**
   * SRM-optimized gas injection rate (MSCF/d, TS). Target injection rate
   * for VRR optimization.
   */
  optimizedGasInjRateSRM: Maybe<TimeSeries>;
  /**
   * GAP-optimized gas lift injection rate (MSCF/d, TS). Recommended GL
   * rate for maximum oil production with minimum gas usage.
   */
  optimizedGasLiftRateGAP: Maybe<TimeSeries>;
  /** GAP network-optimized gas production rate (MSCF/d, TS). */
  optimizedGasRateGAP: Maybe<TimeSeries>;
  /**
   * Optimized injection rate at reservoir conditions (rb/d, TS).
   * Used for VRR calculation at reservoir conditions.
   */
  optimizedInjRateResCond: Maybe<TimeSeries>;
  /**
   * GAP network-optimized oil production rate (stb/d, TS). Accounts for
   * network constraints (manifold pressure, pipeline capacity).
   */
  optimizedOilRateGAP: Maybe<TimeSeries>;
  /**
   * SRM-optimized oil production rate (stb/d, TS). Compare to current
   * production to identify uplift potential.
   */
  optimizedOilRateSRM: Maybe<TimeSeries>;
  /**
   * Optimized production rate at reservoir conditions (rb/d, TS).
   * Used for VRR calculation at reservoir conditions.
   */
  optimizedProdRateResCond: Maybe<TimeSeries>;
  /** Optimized wellhead pressure (psia, TS). */
  optimizedWHP: Maybe<TimeSeries>;
  /** GAP network-optimized water injection rate (stb/d, TS). */
  optimizedWaterInjRateGAP: Maybe<TimeSeries>;
  /**
   * SRM-optimized water injection rate (stb/d, TS). Target injection rate
   * for VRR optimization.
   */
  optimizedWaterInjRateSRM: Maybe<TimeSeries>;
  /** GAP network-optimized water production rate (stb/d, TS). */
  optimizedWaterRateGAP: Maybe<TimeSeries>;
  /**
   * Optimization scenario name/identifier (TS). Groups results from the
   * same optimization run.
   */
  scenario: Maybe<TimeSeries>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString: Maybe<StringAsset>;
};

/** View 'PTS_Reference_Conditions' in the iPSO production optimization solution data model. */
export type PtsReferenceConditions = {
  /** Timestamp 'date' associated with this 'PTS_Reference_Conditions' row. */
  date: Maybe<Scalars['Timestamp']['output']>;
  /** Text attribute 'fieldCode' for this 'PTS_Reference_Conditions' row. */
  fieldCode: Maybe<Scalars['String']['output']>;
  /** Reference to the related 'Field' entity for this 'PTS_Reference_Conditions' row. */
  fieldName: Maybe<Field>;
  /** Numeric value 'refStgPress1' (floating point) for this 'PTS_Reference_Conditions' row. */
  refStgPress1: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'refStgPress2' (floating point) for this 'PTS_Reference_Conditions' row. */
  refStgPress2: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'refStgPress3' (floating point) for this 'PTS_Reference_Conditions' row. */
  refStgPress3: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'refStgPress4' (floating point) for this 'PTS_Reference_Conditions' row. */
  refStgPress4: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'refStgPress5' (floating point) for this 'PTS_Reference_Conditions' row. */
  refStgPress5: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'refStgTemp1' (floating point) for this 'PTS_Reference_Conditions' row. */
  refStgTemp1: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'refStgTemp2' (floating point) for this 'PTS_Reference_Conditions' row. */
  refStgTemp2: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'refStgTemp3' (floating point) for this 'PTS_Reference_Conditions' row. */
  refStgTemp3: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'refStgTemp4' (floating point) for this 'PTS_Reference_Conditions' row. */
  refStgTemp4: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'refStgTemp5' (floating point) for this 'PTS_Reference_Conditions' row. */
  refStgTemp5: Maybe<Scalars['Float32']['output']>;
};

/** View 'PVTAnalysis_String' in the iPSO production optimization solution data model. */
export type PvtAnalysisString = {
  /** Reference to the related 'String_asset' entity for this 'PVTAnalysis_String' row. */
  entityName: Maybe<StringAsset>;
  /** Reference to a time series for 'salinity' in this 'PVTAnalysis_String' view. */
  salinity: Maybe<TimeSeries>;
  /** Reference to a time series for 'sampleDate' in this 'PVTAnalysis_String' view. */
  sampleDate: Maybe<TimeSeries>;
  /** Reference to a time series for 'sampleType' in this 'PVTAnalysis_String' view. */
  sampleType: Maybe<TimeSeries>;
  /** Reference to a time series for 'waterCut' in this 'PVTAnalysis_String' view. */
  waterCut: Maybe<TimeSeries>;
};

/**
 * PVT analysis results and fluid property measurements per well string.
 *
 * Contains PVT sample analysis reference data, fluid type, sample date, and
 * analysis quality indicators for each well string. Sourced from laboratory
 * analyses of fluid samples collected from wells, to address analytical
 * questions regarding fluid characteristics and behavior under varying
 * conditions. It excludes production data or reservoir performance metrics (see
 * other views). Use cases: evaluating fluid properties for reservoir simulations
 * and optimizing production strategies based on sample quality and composition.
 *
 * @name PVT Analysis - String (Agent)
 */
export type PvtAnalysisStringAgent = {
  salinity: Maybe<TimeSeries>;
  sampleDate: Maybe<TimeSeries>;
  sampleType: Maybe<TimeSeries>;
  waterCut: Maybe<TimeSeries>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString: Maybe<StringAsset>;
};

/** View 'Pipeline' in the iPSO production optimization solution data model. */
export type Pipeline = {
  /** Timestamp 'endDateTime' associated with this 'Pipeline' row. */
  endDateTime: Maybe<Scalars['Timestamp']['output']>;
  /** Text attribute 'entityType' for this 'Pipeline' row. */
  entityType: Maybe<Scalars['String']['output']>;
  /** Text attribute 'name' for this 'Pipeline' row. */
  name: Maybe<Scalars['String']['output']>;
  /** Timestamp 'startDateTime' associated with this 'Pipeline' row. */
  startDateTime: Maybe<Scalars['Timestamp']['output']>;
};

/**
 * Best-available rate and pressure estimates per well string — default for simple rate lookups.
 *
 * Priority (best-available) oil, gas, water, liquid rates, flowing BHP, and
 * source method. Use for "what is the current rate for well X?" or "show
 * production figures for field X". For method-comparison use EstimatedRates_String_Agent.
 *
 * Use for: Real-Time Well Rate and Pressure Estimation (WF10).
 *
 * @name Priority Rates - Best Available Estimates (Agent)
 */
export type PriorityRatesStringAgent = {
  /** Best-available flowing bottom-hole pressure (psi, TS). */
  priorityFbhp: Maybe<TimeSeries>;
  /** Best-available estimated gas rate (MSCF/d, TS). */
  priorityGasRateStd: Maybe<TimeSeries>;
  /** Best-available estimated total liquid rate, oil + water (stb/d, TS). */
  priorityLiquidRateStd: Maybe<TimeSeries>;
  /** Analysis method that produced the priority rates. Values: SYSTEM_ANALYSIS, CHOKE_ANALYSIS, ALLOCATION, WELL_TEST, DATA_ANALYSIS. */
  priorityMethod: Maybe<TimeSeries>;
  /** Best-available estimated oil rate (stb/d, TS). */
  priorityOilRateStd: Maybe<TimeSeries>;
  /** Best-available estimated water rate (stb/d, TS). */
  priorityWaterRateStd: Maybe<TimeSeries>;
  /** Well string identifier. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString: Maybe<StringAsset>;
};

/** View 'Prodplan_String' in the iPSO production optimization solution data model. */
export type ProdplanString = {
  /** Reference to the related 'String_asset' entity for this 'Prodplan_String' row. */
  entityName: Maybe<StringAsset>;
  /** Reference to a time series for 'fmoprContr' in this 'Prodplan_String' view. */
  fmoprContr: Maybe<TimeSeries>;
  /** Reference to a time series for 'fmoprWater' in this 'Prodplan_String' view. */
  fmoprWater: Maybe<TimeSeries>;
  /** Reference to a time series for 'giAllowableContr' in this 'Prodplan_String' view. */
  giAllowableContr: Maybe<TimeSeries>;
  /** Reference to a time series for 'giAllowableRate' in this 'Prodplan_String' view. */
  giAllowableRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'giAvailableContr' in this 'Prodplan_String' view. */
  giAvailableContr: Maybe<TimeSeries>;
  /** Reference to a time series for 'giSubmittedMonth' in this 'Prodplan_String' view. */
  giSubmittedMonth: Maybe<TimeSeries>;
  /** Reference to a time series for 'giSustainableContr' in this 'Prodplan_String' view. */
  giSustainableContr: Maybe<TimeSeries>;
  /** Reference to a time series for 'giSustainableRate' in this 'Prodplan_String' view. */
  giSustainableRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'giTechnicalRate' in this 'Prodplan_String' view. */
  giTechnicalRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'giWellAvailability' in this 'Prodplan_String' view. */
  giWellAvailability: Maybe<TimeSeries>;
  /** Reference to a time series for 'opBg' in this 'Prodplan_String' view. */
  opBg: Maybe<TimeSeries>;
  /** Reference to a time series for 'opBo' in this 'Prodplan_String' view. */
  opBo: Maybe<TimeSeries>;
  /** Reference to a time series for 'opBw' in this 'Prodplan_String' view. */
  opBw: Maybe<TimeSeries>;
  /** Reference to a time series for 'opRs' in this 'Prodplan_String' view. */
  opRs: Maybe<TimeSeries>;
  /** Reference to a time series for 'opSubmittedMonth' in this 'Prodplan_String' view. */
  opSubmittedMonth: Maybe<TimeSeries>;
  /** Reference to a time series for 'opVrrAdjustment' in this 'Prodplan_String' view. */
  opVrrAdjustment: Maybe<TimeSeries>;
  /** Reference to a time series for 'opWar' in this 'Prodplan_String' view. */
  opWar: Maybe<TimeSeries>;
  /** Reference to a time series for 'opWarVrr' in this 'Prodplan_String' view. */
  opWarVrr: Maybe<TimeSeries>;
  /** Reference to a time series for 'opWpr' in this 'Prodplan_String' view. */
  opWpr: Maybe<TimeSeries>;
  /** Reference to a time series for 'opWprFlowAssurance' in this 'Prodplan_String' view. */
  opWprFlowAssurance: Maybe<TimeSeries>;
  /** Reference to a time series for 'opWprIntegrity' in this 'Prodplan_String' view. */
  opWprIntegrity: Maybe<TimeSeries>;
  /** Reference to a time series for 'opWprManPress' in this 'Prodplan_String' view. */
  opWprManPress: Maybe<TimeSeries>;
  /** Reference to a time series for 'opWsopr' in this 'Prodplan_String' view. */
  opWsopr: Maybe<TimeSeries>;
  /** Reference to a time series for 'opWtr' in this 'Prodplan_String' view. */
  opWtr: Maybe<TimeSeries>;
  /** Reference to a time series for 'quotaContr' in this 'Prodplan_String' view. */
  quotaContr: Maybe<TimeSeries>;
  /** Reference to a time series for 'wiAllowableContr' in this 'Prodplan_String' view. */
  wiAllowableContr: Maybe<TimeSeries>;
  /** Reference to a time series for 'wiAllowableRate' in this 'Prodplan_String' view. */
  wiAllowableRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'wiAvailableContr' in this 'Prodplan_String' view. */
  wiAvailableContr: Maybe<TimeSeries>;
  /** Reference to a time series for 'wiSubmittedMonth' in this 'Prodplan_String' view. */
  wiSubmittedMonth: Maybe<TimeSeries>;
  /** Reference to a time series for 'wiSustainableContr' in this 'Prodplan_String' view. */
  wiSustainableContr: Maybe<TimeSeries>;
  /** Reference to a time series for 'wiSustainableRate' in this 'Prodplan_String' view. */
  wiSustainableRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'wiTechnicalRate' in this 'Prodplan_String' view. */
  wiTechnicalRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'wiWellAvailability' in this 'Prodplan_String' view. */
  wiWellAvailability: Maybe<TimeSeries>;
  /** Reference to a time series for 'wsoprTotalGas' in this 'Prodplan_String' view. */
  wsoprTotalGas: Maybe<TimeSeries>;
};

/**
 * IPSO production-plan allowable and technical rate time series per well string.
 *
 * Maps to solution Prodplan_String: oil/gas allowable (quota and gas totals), water/gas
 * injection allowable and technical limits, and technical oil rate (opWpr). Compare
 * against PriorityRates_String_Agent / EstimatedRates_String_Agent for underperformance.
 * For WellInputs unconstrained potentials use WellPotential_String_Agent.
 *
 * Use for: allowable vs estimated rate checks (WF10/WF19), complement to WF6 guidelines.
 *
 * @name Production Plan Limits — String (Agent)
 */
export type ProdplanStringAgent = {
  /** Allowable gas injection contribution share (TS). */
  giAllowableContr: Maybe<TimeSeries>;
  /** Allowable gas injection rate (MSCF/d or model units, TS). */
  giAllowableRate: Maybe<TimeSeries>;
  /** Technical gas injection rate limit (TS). */
  giTechnicalRate: Maybe<TimeSeries>;
  /** Technical oil rate / oil potential from production plan (stb/d, TS). IPSO mapping — technical oil rate. */
  opWpr: Maybe<TimeSeries>;
  /** Allowable oil-related quota / contribution limit (stb/d, TS). IPSO mapping — allowable oil rate context. */
  quotaContr: Maybe<TimeSeries>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString: Maybe<StringAsset>;
  /** Allowable water injection contribution share (TS). Use when allocation splits injection allowable. */
  wiAllowableContr: Maybe<TimeSeries>;
  /** Allowable water injection rate (stb/d, TS). */
  wiAllowableRate: Maybe<TimeSeries>;
  /** Technical water injection rate limit (stb/d, TS). */
  wiTechnicalRate: Maybe<TimeSeries>;
  /** Allowable total gas rate (WSOPR gas, TS). IPSO mapping — allowable gas rate. */
  wsoprTotalGas: Maybe<TimeSeries>;
};

/** View 'Prodplan_String_Reservoir_Sector' in the iPSO production optimization solution data model. */
export type ProdplanStringReservoirSector = {
  /** Reference to the related 'String_asset' entity for this 'Prodplan_String_Reservoir_Sector' row. */
  entityName: Maybe<StringAsset>;
  /** Reference to a time series for 'fmoprContr' in this 'Prodplan_String_Reservoir_Sector' view. */
  fmoprContr: Maybe<TimeSeries>;
  /** Reference to a time series for 'fmoprWater' in this 'Prodplan_String_Reservoir_Sector' view. */
  fmoprWater: Maybe<TimeSeries>;
  /** Reference to a time series for 'giAllowableContr' in this 'Prodplan_String_Reservoir_Sector' view. */
  giAllowableContr: Maybe<TimeSeries>;
  /** Reference to a time series for 'giAllowableRate' in this 'Prodplan_String_Reservoir_Sector' view. */
  giAllowableRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'giAvailableContr' in this 'Prodplan_String_Reservoir_Sector' view. */
  giAvailableContr: Maybe<TimeSeries>;
  /** Reference to a time series for 'giSubmittedMonth' in this 'Prodplan_String_Reservoir_Sector' view. */
  giSubmittedMonth: Maybe<TimeSeries>;
  /** Reference to a time series for 'giSustainableContr' in this 'Prodplan_String_Reservoir_Sector' view. */
  giSustainableContr: Maybe<TimeSeries>;
  /** Reference to a time series for 'giSustainableRate' in this 'Prodplan_String_Reservoir_Sector' view. */
  giSustainableRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'giTechnicalRate' in this 'Prodplan_String_Reservoir_Sector' view. */
  giTechnicalRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'giWellAvailability' in this 'Prodplan_String_Reservoir_Sector' view. */
  giWellAvailability: Maybe<TimeSeries>;
  /** Reference to a time series for 'opBg' in this 'Prodplan_String_Reservoir_Sector' view. */
  opBg: Maybe<TimeSeries>;
  /** Reference to a time series for 'opBo' in this 'Prodplan_String_Reservoir_Sector' view. */
  opBo: Maybe<TimeSeries>;
  /** Reference to a time series for 'opBw' in this 'Prodplan_String_Reservoir_Sector' view. */
  opBw: Maybe<TimeSeries>;
  /** Reference to a time series for 'opRs' in this 'Prodplan_String_Reservoir_Sector' view. */
  opRs: Maybe<TimeSeries>;
  /** Reference to a time series for 'opSubmittedMonth' in this 'Prodplan_String_Reservoir_Sector' view. */
  opSubmittedMonth: Maybe<TimeSeries>;
  /** Reference to a time series for 'opVrrAdjustment' in this 'Prodplan_String_Reservoir_Sector' view. */
  opVrrAdjustment: Maybe<TimeSeries>;
  /** Reference to a time series for 'opWar' in this 'Prodplan_String_Reservoir_Sector' view. */
  opWar: Maybe<TimeSeries>;
  /** Reference to a time series for 'opWarVrr' in this 'Prodplan_String_Reservoir_Sector' view. */
  opWarVrr: Maybe<TimeSeries>;
  /** Reference to a time series for 'opWpr' in this 'Prodplan_String_Reservoir_Sector' view. */
  opWpr: Maybe<TimeSeries>;
  /** Reference to a time series for 'opWprFlowAssurance' in this 'Prodplan_String_Reservoir_Sector' view. */
  opWprFlowAssurance: Maybe<TimeSeries>;
  /** Reference to a time series for 'opWprIntegrity' in this 'Prodplan_String_Reservoir_Sector' view. */
  opWprIntegrity: Maybe<TimeSeries>;
  /** Reference to a time series for 'opWprManPress' in this 'Prodplan_String_Reservoir_Sector' view. */
  opWprManPress: Maybe<TimeSeries>;
  /** Reference to a time series for 'opWsopr' in this 'Prodplan_String_Reservoir_Sector' view. */
  opWsopr: Maybe<TimeSeries>;
  /** Reference to a time series for 'opWtr' in this 'Prodplan_String_Reservoir_Sector' view. */
  opWtr: Maybe<TimeSeries>;
  /** Reference to a time series for 'quotaContr' in this 'Prodplan_String_Reservoir_Sector' view. */
  quotaContr: Maybe<TimeSeries>;
  /** Text attribute 'reservoirName' for this 'Prodplan_String_Reservoir_Sector' row. */
  reservoirName: Maybe<Scalars['String']['output']>;
  /** Text attribute 'sectorName' for this 'Prodplan_String_Reservoir_Sector' row. */
  sectorName: Maybe<Scalars['String']['output']>;
  /** Reference to a time series for 'wiAllowableContr' in this 'Prodplan_String_Reservoir_Sector' view. */
  wiAllowableContr: Maybe<TimeSeries>;
  /** Reference to a time series for 'wiAllowableRate' in this 'Prodplan_String_Reservoir_Sector' view. */
  wiAllowableRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'wiAvailableContr' in this 'Prodplan_String_Reservoir_Sector' view. */
  wiAvailableContr: Maybe<TimeSeries>;
  /** Reference to a time series for 'wiSubmittedMonth' in this 'Prodplan_String_Reservoir_Sector' view. */
  wiSubmittedMonth: Maybe<TimeSeries>;
  /** Reference to a time series for 'wiSustainableContr' in this 'Prodplan_String_Reservoir_Sector' view. */
  wiSustainableContr: Maybe<TimeSeries>;
  /** Reference to a time series for 'wiSustainableRate' in this 'Prodplan_String_Reservoir_Sector' view. */
  wiSustainableRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'wiTechnicalRate' in this 'Prodplan_String_Reservoir_Sector' view. */
  wiTechnicalRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'wiWellAvailability' in this 'Prodplan_String_Reservoir_Sector' view. */
  wiWellAvailability: Maybe<TimeSeries>;
  /** Reference to a time series for 'wsoprTotalGas' in this 'Prodplan_String_Reservoir_Sector' view. */
  wsoprTotalGas: Maybe<TimeSeries>;
};

/**
 * Reservoir management guidelines and operating limits for production strings (WF6).
 *
 * Max GOR, min BHP/WHP, max liquid/oil rates per string. Use to assess adherence
 * to guidelines, identify wells outside limits, and flag reservoir damage risk.
 * Excludes historical performance or detailed rates (see other views).
 *
 * Use for: Well Operating Envelope (WF6).
 */
export type ProducerGuidelinesStringAgent = {
  /**
   * Maximum allowed Gas-Oil Ratio (scf/stb) from reservoir management guidelines.
   * Wells with GOR above this limit are violating guidelines and may need
   * choke adjustment or investigation.
   */
  maxGOR: Maybe<Scalars['Float32']['output']>;
  /**
   * Maximum allowed liquid production rate (stb/d) from reservoir management
   * guidelines. Wells above this limit may need rate constraints.
   */
  maxLiquidRate: Maybe<Scalars['Float32']['output']>;
  /**
   * Maximum allowed oil production rate (stb/d) from reservoir management
   * guidelines. Used for rate constraint optimization.
   */
  maxOilRate: Maybe<Scalars['Float32']['output']>;
  /**
   * Minimum allowed Bottomhole Pressure (psia) from reservoir management guidelines.
   * Production wells operating below this BHP may be causing reservoir damage
   * or excessive drawdown.
   */
  minBHP: Maybe<Scalars['Float32']['output']>;
  /**
   * Minimum allowed Wellhead Pressure (psia) from reservoir management
   * guidelines. Wells operating below this WHP may indicate flow instability,
   * liquid loading, or insufficient reservoir energy.
   */
  minWHP: Maybe<Scalars['Float32']['output']>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString: Maybe<StringAsset>;
};

/**
 * Production allocation alarms with medium or high priority.
 *
 * Contains production allocation alarms, medium or high priority, derived from
 * workflows WF5 and WF13. Sourced from operational monitoring systems that track
 * alarm events, allowing users to analyze alarm occurrences, their severity, and
 * associated workflows. It can answer questions regarding the frequency and
 * types of alarms and impact on allocation. Excludes low-priority or non-WF5/WF13 alarms.
 *
 * Use for: Production Allocation (WF5), Gas Lift Estimation (WF13), Real-Time Surveillance (WF18).
 *
 * @name Production Allocation Alarms (Agent)
 */
export type ProductionAllocationAlarmsAgent = {
  alarmCategory: Maybe<Scalars['String']['output']>;
  alarmCode: Maybe<Scalars['JSONObject']['output']>;
  alarmCodeExternalId: Maybe<Scalars['String']['output']>;
  /** Number of consecutive occurrences of this alarm. */
  alarmCounter: Maybe<Scalars['Int']['output']>;
  alarmCriticality: Maybe<Scalars['String']['output']>;
  alarmFlags: Maybe<Scalars['String']['output']>;
  alarmName: Maybe<Scalars['String']['output']>;
  alarmPriority: Maybe<Scalars['String']['output']>;
  customWorkflowAlarmMessage: Maybe<Scalars['String']['output']>;
  endDateTime: Maybe<Scalars['Timestamp']['output']>;
  entityExternalId: Scalars['String']['output'];
  entityName: Scalars['String']['output'];
  entityType: Scalars['String']['output'];
  startDateTime: Scalars['Timestamp']['output'];
  /** Alarm sub-category for domain filtering. */
  subCategory: Maybe<Scalars['String']['output']>;
  /** Sub-workflow that generated the alarm. */
  subWorkflowName: Maybe<Scalars['String']['output']>;
  /** Associated ticket/action ID if alarm has been acknowledged. */
  ticketId: Maybe<Scalars['String']['output']>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString: Maybe<StringAsset>;
  workflowCode: Maybe<Scalars['String']['output']>;
  workflowName: Maybe<Scalars['String']['output']>;
};

/** View 'ProsperModel' in the iPSO production optimization solution data model. */
export type ProsperModel = {
  /** Property 'asphalteneCurve' for this 'ProsperModel' row. */
  asphalteneCurve: Maybe<Scalars['JSONObject']['output']>;
  /** Numeric value 'bottomPerforationDepth' (floating point) for this 'ProsperModel' row. */
  bottomPerforationDepth: Maybe<Scalars['Float']['output']>;
  /** Text attribute 'bottomPerforationDepthUnit' for this 'ProsperModel' row. */
  bottomPerforationDepthUnit: Maybe<Scalars['String']['output']>;
  /** Numeric value 'bottomTubingId' (floating point) for this 'ProsperModel' row. */
  bottomTubingId: Maybe<Scalars['Float']['output']>;
  /** Text attribute 'bottomTubingIdUnit' for this 'ProsperModel' row. */
  bottomTubingIdUnit: Maybe<Scalars['String']['output']>;
  /** Property 'bubblePoint' for this 'ProsperModel' row. */
  bubblePoint: Maybe<Scalars['JSONObject']['output']>;
  /** Numeric value 'cCoefficient' (floating point) for this 'ProsperModel' row. */
  cCoefficient: Maybe<Scalars['Float']['output']>;
  /** Text attribute 'cCoefficientUnit' for this 'ProsperModel' row. */
  cCoefficientUnit: Maybe<Scalars['String']['output']>;
  /** Numeric value 'calibrationWellTestRate' (floating point) for this 'ProsperModel' row. */
  calibrationWellTestRate: Maybe<Scalars['Float']['output']>;
  /** Text attribute 'calibrationWellTestRateUnit' for this 'ProsperModel' row. */
  calibrationWellTestRateUnit: Maybe<Scalars['String']['output']>;
  /** Timestamp 'calibrationWellTestTime' associated with this 'ProsperModel' row. */
  calibrationWellTestTime: Maybe<Scalars['Timestamp']['output']>;
  /** Text attribute 'changeDetails' for this 'ProsperModel' row. */
  changeDetails: Maybe<Scalars['String']['output']>;
  /** Property 'criticalPoint' for this 'ProsperModel' row. */
  criticalPoint: Maybe<Scalars['JSONObject']['output']>;
  /** Text attribute 'description' for this 'ProsperModel' row. */
  description: Maybe<Scalars['String']['output']>;
  /** Numeric value 'deviationSurveyRecordCount' (integer) for this 'ProsperModel' row. */
  deviationSurveyRecordCount: Maybe<Scalars['Int']['output']>;
  /** Text attribute 'espCurrentCable' for this 'ProsperModel' row. */
  espCurrentCable: Maybe<Scalars['String']['output']>;
  /** Text attribute 'espCurrentMotor' for this 'ProsperModel' row. */
  espCurrentMotor: Maybe<Scalars['String']['output']>;
  /** Numeric value 'espPumpDepth' (floating point) for this 'ProsperModel' row. */
  espPumpDepth: Maybe<Scalars['Float']['output']>;
  /** Text attribute 'espPumpDepthUnit' for this 'ProsperModel' row. */
  espPumpDepthUnit: Maybe<Scalars['String']['output']>;
  /** Text attribute 'espPumpModel' for this 'ProsperModel' row. */
  espPumpModel: Maybe<Scalars['String']['output']>;
  /** Numeric value 'espStages' (integer) for this 'ProsperModel' row. */
  espStages: Maybe<Scalars['Int']['output']>;
  /** Text attribute 'executeStatus' for this 'ProsperModel' row. */
  executeStatus: Maybe<Scalars['String']['output']>;
  /** Numeric value 'fbhpAtMinStableRate' (floating point) for this 'ProsperModel' row. */
  fbhpAtMinStableRate: Maybe<Scalars['Float']['output']>;
  /** Text attribute 'fbhpAtMinStableRateUnit' for this 'ProsperModel' row. */
  fbhpAtMinStableRateUnit: Maybe<Scalars['String']['output']>;
  /** Reference to the related 'Field' entity for this 'ProsperModel' row. */
  field: Maybe<Field>;
  /** Numeric value 'fileSize' (floating point) for this 'ProsperModel' row. */
  fileSize: Maybe<Scalars['Float']['output']>;
  /** Numeric value 'flowExponent' (floating point) for this 'ProsperModel' row. */
  flowExponent: Maybe<Scalars['Float']['output']>;
  /** Numeric value 'fluid' (integer) for this 'ProsperModel' row. */
  fluid: Maybe<Scalars['Int']['output']>;
  /** Frequency correction factor for ESP pump */
  frequencyCorrectionFactor: Maybe<Scalars['Float']['output']>;
  /** Numeric value 'geoThermalGradientRecordCount' (integer) for this 'ProsperModel' row. */
  geoThermalGradientRecordCount: Maybe<Scalars['Int']['output']>;
  /** Numeric value 'glInjectionDepth' (floating point) for this 'ProsperModel' row. */
  glInjectionDepth: Maybe<Scalars['Float']['output']>;
  /** Text attribute 'glInjectionDepthUnit' for this 'ProsperModel' row. */
  glInjectionDepthUnit: Maybe<Scalars['String']['output']>;
  /** Numeric value 'glMethod' (integer) for this 'ProsperModel' row. */
  glMethod: Maybe<Scalars['Int']['output']>;
  /** Numeric value 'glOrificeSize' (floating point) for this 'ProsperModel' row. */
  glOrificeSize: Maybe<Scalars['Float']['output']>;
  /** Text attribute 'glOrificeSizeUnit' for this 'ProsperModel' row. */
  glOrificeSizeUnit: Maybe<Scalars['String']['output']>;
  /** Numeric value 'glValveDepth' (floating point) for this 'ProsperModel' row. */
  glValveDepth: Maybe<Scalars['Float']['output']>;
  /** Text attribute 'glValveDepthUnit' for this 'ProsperModel' row. */
  glValveDepthUnit: Maybe<Scalars['String']['output']>;
  /** Property 'hydrateCurve' for this 'ProsperModel' row. */
  hydrateCurve: Maybe<Scalars['JSONObject']['output']>;
  /** Text attribute 'iprModel' for this 'ProsperModel' row. */
  iprModel: Maybe<Scalars['String']['output']>;
  /** Numeric value 'legacyDataSetId' (integer) for this 'ProsperModel' row. */
  legacyDataSetId: Maybe<Scalars['Int64']['output']>;
  /** Text attribute 'legacyFileExternalId' for this 'ProsperModel' row. */
  legacyFileExternalId: Maybe<Scalars['String']['output']>;
  /** Numeric value 'legacyFileId' (integer) for this 'ProsperModel' row. */
  legacyFileId: Maybe<Scalars['Int64']['output']>;
  /** Input file id if this model was created from another model */
  legacyInputFileId: Maybe<Scalars['Int64']['output']>;
  /** Numeric value 'liftMethod' (integer) for this 'ProsperModel' row. */
  liftMethod: Maybe<Scalars['Int']['output']>;
  /** Numeric value 'maxMeasuredDepth' (floating point) for this 'ProsperModel' row. */
  maxMeasuredDepth: Maybe<Scalars['Float']['output']>;
  /** Text attribute 'maxMeasuredDepthUnit' for this 'ProsperModel' row. */
  maxMeasuredDepthUnit: Maybe<Scalars['String']['output']>;
  /** Numeric value 'maxTrueVerticalDepth' (floating point) for this 'ProsperModel' row. */
  maxTrueVerticalDepth: Maybe<Scalars['Float']['output']>;
  /** Text attribute 'maxTrueVerticalDepthUnit' for this 'ProsperModel' row. */
  maxTrueVerticalDepthUnit: Maybe<Scalars['String']['output']>;
  /** Text attribute 'mimeType' for this 'ProsperModel' row. */
  mimeType: Maybe<Scalars['String']['output']>;
  /** Numeric value 'minStableRate' (floating point) for this 'ProsperModel' row. */
  minStableRate: Maybe<Scalars['Float']['output']>;
  /** Text attribute 'minStableRateUnit' for this 'ProsperModel' row. */
  minStableRateUnit: Maybe<Scalars['String']['output']>;
  /** Text attribute 'modelAcceptedBy' for this 'ProsperModel' row. */
  modelAcceptedBy: Maybe<Scalars['String']['output']>;
  /** Timestamp 'modelAcceptedTime' associated with this 'ProsperModel' row. */
  modelAcceptedTime: Maybe<Scalars['Timestamp']['output']>;
  /** Timestamp 'modelEffectiveTime' associated with this 'ProsperModel' row. */
  modelEffectiveTime: Maybe<Scalars['Timestamp']['output']>;
  /** Text attribute 'modelStatus' for this 'ProsperModel' row. */
  modelStatus: Maybe<Scalars['String']['output']>;
  /** Text attribute 'modelUpdatedBy' for this 'ProsperModel' row. */
  modelUpdatedBy: Maybe<Scalars['String']['output']>;
  /** Timestamp 'modelUpdatedTime' associated with this 'ProsperModel' row. */
  modelUpdatedTime: Maybe<Scalars['Timestamp']['output']>;
  /** Text attribute 'modelUploadedBy' for this 'ProsperModel' row. */
  modelUploadedBy: Maybe<Scalars['String']['output']>;
  /** Timestamp 'modelUploadedTime' associated with this 'ProsperModel' row. */
  modelUploadedTime: Maybe<Scalars['Timestamp']['output']>;
  /** Text attribute 'name' for this 'ProsperModel' row. */
  name: Maybe<Scalars['String']['output']>;
  /** Text attribute 'originalProsperFileName' for this 'ProsperModel' row. */
  originalProsperFileName: Maybe<Scalars['String']['output']>;
  /** Numeric value 'pE5Flag' (integer) for this 'ProsperModel' row. */
  pE5Flag: Maybe<Scalars['Int']['output']>;
  /** Property 'pendingModifications' for this 'ProsperModel' row. */
  pendingModifications: Maybe<Scalars['JSONObject']['output']>;
  /** Property 'phaseEnvelope' for this 'ProsperModel' row. */
  phaseEnvelope: Maybe<Scalars['JSONObject']['output']>;
  /** Numeric value 'pi' (floating point) for this 'ProsperModel' row. */
  pi: Maybe<Scalars['Float']['output']>;
  /** Text attribute 'piUnit' for this 'ProsperModel' row. */
  piUnit: Maybe<Scalars['String']['output']>;
  /** Text attribute 'platform' for this 'ProsperModel' row. */
  platform: Maybe<Scalars['String']['output']>;
  /** Text attribute 'prosperLocationName' for this 'ProsperModel' row. */
  prosperLocationName: Maybe<Scalars['String']['output']>;
  /** Text attribute 'prosperWellName' for this 'ProsperModel' row. */
  prosperWellName: Maybe<Scalars['String']['output']>;
  /** Numeric value 'pvt' (floating point) for this 'ProsperModel' row. */
  pvt: Maybe<Scalars['Float']['output']>;
  /** Text attribute 'pvtUnit' for this 'ProsperModel' row. */
  pvtUnit: Maybe<Scalars['String']['output']>;
  /** Numeric value 'rateDeviationPercentage' (floating point) for this 'ProsperModel' row. */
  rateDeviationPercentage: Maybe<Scalars['Float']['output']>;
  /** Reference to the related 'Reservoir' entity for this 'ProsperModel' row. */
  reservoir: Maybe<Maybe<Reservoir>[]>;
  /** Numeric value 'reservoirBubblePoint' (floating point) for this 'ProsperModel' row. */
  reservoirBubblePoint: Maybe<Scalars['Float']['output']>;
  /** Text attribute 'reservoirBubblePointUnit' for this 'ProsperModel' row. */
  reservoirBubblePointUnit: Maybe<Scalars['String']['output']>;
  /** Numeric value 'reservoirPressure' (floating point) for this 'ProsperModel' row. */
  reservoirPressure: Maybe<Scalars['Float']['output']>;
  /** Text attribute 'reservoirPressureUnit' for this 'ProsperModel' row. */
  reservoirPressureUnit: Maybe<Scalars['String']['output']>;
  /** Numeric value 'reservoirTemperature' (floating point) for this 'ProsperModel' row. */
  reservoirTemperature: Maybe<Scalars['Float']['output']>;
  /** Text attribute 'reservoirTemperatureUnit' for this 'ProsperModel' row. */
  reservoirTemperatureUnit: Maybe<Scalars['String']['output']>;
  /** Text attribute 'simIntExternalId' for this 'ProsperModel' row. */
  simIntExternalId: Maybe<Scalars['String']['output']>;
  /** Text attribute 'simIntModelExternalId' for this 'ProsperModel' row. */
  simIntModelExternalId: Maybe<Scalars['String']['output']>;
  /** Timestamp 'simIntModelRevisionCreatedTime' associated with this 'ProsperModel' row. */
  simIntModelRevisionCreatedTime: Maybe<Scalars['Timestamp']['output']>;
  /** Text attribute 'simIntModelRevisionDescription' for this 'ProsperModel' row. */
  simIntModelRevisionDescription: Maybe<Scalars['String']['output']>;
  /** Text attribute 'simIntModelRevisionExternalId' for this 'ProsperModel' row. */
  simIntModelRevisionExternalId: Maybe<Scalars['String']['output']>;
  /** Text attribute 'simIntModelRevisionId' for this 'ProsperModel' row. */
  simIntModelRevisionId: Maybe<Scalars['String']['output']>;
  /** Text attribute 'simIntModelRevisionLogId' for this 'ProsperModel' row. */
  simIntModelRevisionLogId: Maybe<Scalars['String']['output']>;
  /** Text attribute 'simIntModelRevisionStatus' for this 'ProsperModel' row. */
  simIntModelRevisionStatus: Maybe<Scalars['String']['output']>;
  /** Text attribute 'simIntModelRevisionStatusMessage' for this 'ProsperModel' row. */
  simIntModelRevisionStatusMessage: Maybe<Scalars['String']['output']>;
  /** Timestamp 'simIntModelRevisionUpdatedTime' associated with this 'ProsperModel' row. */
  simIntModelRevisionUpdatedTime: Maybe<Scalars['Timestamp']['output']>;
  /** Numeric value 'simIntModelRevisionVersionId' (integer) for this 'ProsperModel' row. */
  simIntModelRevisionVersionId: Maybe<Scalars['Int']['output']>;
  /** Text attribute 'source' for this 'ProsperModel' row. */
  source: Maybe<Scalars['String']['output']>;
  /** Text attribute 'sourceLocation' for this 'ProsperModel' row. */
  sourceLocation: Maybe<Scalars['String']['output']>;
  /** Reference to the related 'String_asset' entity for this 'ProsperModel' row. */
  string: Maybe<StringAsset>;
  /** Text attribute 'string_name' for this 'ProsperModel' row. */
  string_name: Maybe<Scalars['String']['output']>;
  /** Numeric value 'topPerforationDepth' (floating point) for this 'ProsperModel' row. */
  topPerforationDepth: Maybe<Scalars['Float']['output']>;
  /** Text attribute 'topPerforationDepthUnit' for this 'ProsperModel' row. */
  topPerforationDepthUnit: Maybe<Scalars['String']['output']>;
  /** Numeric value 'uVal' (floating point) for this 'ProsperModel' row. */
  uVal: Maybe<Scalars['Float']['output']>;
  /** Text attribute 'uValUnit' for this 'ProsperModel' row. */
  uValUnit: Maybe<Scalars['String']['output']>;
  /** Text attribute 'vlpModel' for this 'ProsperModel' row. */
  vlpModel: Maybe<Scalars['String']['output']>;
  /** Property 'waxCurve' for this 'ProsperModel' row. */
  waxCurve: Maybe<Scalars['JSONObject']['output']>;
  /** Numeric value 'wearFactor' (floating point) for this 'ProsperModel' row. */
  wearFactor: Maybe<Scalars['Float']['output']>;
  /** Reference to the related 'Well' entity for this 'ProsperModel' row. */
  well: Maybe<Well>;
  /** Numeric value 'wellCompletionRecordCount' (integer) for this 'ProsperModel' row. */
  wellCompletionRecordCount: Maybe<Scalars['Int']['output']>;
  /** Numeric value 'wellType' (integer) for this 'ProsperModel' row. */
  wellType: Maybe<Scalars['Int']['output']>;
  /** Numeric value 'wf2EstimatedRate' (floating point) for this 'ProsperModel' row. */
  wf2EstimatedRate: Maybe<Scalars['Float']['output']>;
  /** Text attribute 'wf2ModelMatchedStatus' for this 'ProsperModel' row. */
  wf2ModelMatchedStatus: Maybe<Scalars['String']['output']>;
  /** Text attribute 'wf2Processed' for this 'ProsperModel' row. */
  wf2Processed: Maybe<Scalars['String']['output']>;
  /** Numeric value 'wf3EstimatedRate' (floating point) for this 'ProsperModel' row. */
  wf3EstimatedRate: Maybe<Scalars['Float']['output']>;
  /** Text attribute 'wf3EstimatedRateUnit' for this 'ProsperModel' row. */
  wf3EstimatedRateUnit: Maybe<Scalars['String']['output']>;
  /** Text attribute 'wf3ModelMatchedStatus' for this 'ProsperModel' row. */
  wf3ModelMatchedStatus: Maybe<Scalars['String']['output']>;
};

/** View 'ProsperModelEventLog' in the iPSO production optimization solution data model. */
export type ProsperModelEventLog = {
  /** Text attribute 'modelAcceptedBy' for this 'ProsperModelEventLog' row. */
  modelAcceptedBy: Maybe<Scalars['String']['output']>;
  /** Timestamp 'modelAcceptedTime' associated with this 'ProsperModelEventLog' row. */
  modelAcceptedTime: Maybe<Scalars['Timestamp']['output']>;
  /** Text attribute 'modelStatus' for this 'ProsperModelEventLog' row. */
  modelStatus: Maybe<Scalars['String']['output']>;
  /** Text attribute 'modelUpdatedBy' for this 'ProsperModelEventLog' row. */
  modelUpdatedBy: Maybe<Scalars['String']['output']>;
  /** Timestamp 'modelUpdatedTime' associated with this 'ProsperModelEventLog' row. */
  modelUpdatedTime: Maybe<Scalars['Timestamp']['output']>;
  /** Reference to the related 'ProsperModel' entity for this 'ProsperModelEventLog' row. */
  prosperModel: Maybe<ProsperModel>;
  /** Text attribute 'wf3ModelMatchedStatus' for this 'ProsperModelEventLog' row. */
  wf3ModelMatchedStatus: Maybe<Scalars['String']['output']>;
};

/** View 'ProsperModelMetrics' in the iPSO production optimization solution data model. */
export type ProsperModelMetrics = {
  /** Reference to the related 'String_asset' entity for this 'ProsperModelMetrics' row. */
  entityName: Maybe<StringAsset>;
  /** Reference to the related 'Field' entity for this 'ProsperModelMetrics' row. */
  field: Maybe<Field>;
  /** Reference to a time series for 'modelAvailability' in this 'ProsperModelMetrics' view. */
  modelAvailability: Maybe<TimeSeries>;
};

/**
 * Prosper well model repository with calibration status, version, and model
 * metadata.
 *
 * Contains data on well models, including their calibration status, versioning,
 * associated metadata, and ESP equipment (pump model, current motor, current
 * cable), sourced from the Prosper modeling system. This view is designed to
 * address analytical questions related to model availability, calibration
 * success, performance metrics, and equipment type across various wells, to
 * assess the operational readiness of models in the field. Use cases: monitoring
 * model compliance, identifying wells requiring immediate attention, evaluating
 * the overall health of the modeling infrastructure, and statistical summaries
 * of efficiency or wear grouped by ESP type, pump model, motor, or cable.
 *
 * @name Prosper Model Status (Agent)
 */
export type ProsperModelAgent = {
  /** Current cable identifier/type from the Prosper model (e.g., cable type or model code). Use for grouping by cable type alongside pump and motor. */
  espCurrentCable: Maybe<Scalars['String']['output']>;
  /** Current motor identifier/model from the Prosper model (e.g., motor type or model code). Use for grouping by motor type alongside pump and cable. */
  espCurrentMotor: Maybe<Scalars['String']['output']>;
  /** ESP pump model/type from the Prosper model (e.g., manufacturer model code). Use for grouping or filtering by ESP type; supports statistical summaries by pump model and vendor. */
  espPumpModel: Maybe<Scalars['String']['output']>;
  /** Reference to Field. Use for field-level aggregations. DO NOT USE - THIS IS UNRELIABLE */
  field: Maybe<Field>;
  /** IPR model type (e.g., Vogel, Fetkovitch, Jones). */
  iprModel: Maybe<Scalars['String']['output']>;
  /** Artificial lift method. 0=Natural Flow, 1=ESP, 2=Gas Lift, 3=PCP, 4=Rod Pump. Use to filter by lift type. */
  liftMethod: Maybe<Scalars['Int']['output']>;
  /** Minimum stable flow rate from model (stb/d). */
  minStableRate: Maybe<Scalars['Float']['output']>;
  /** When the model became the active/effective model for the string. */
  modelEffectiveTime: Maybe<Scalars['Timestamp']['output']>;
  /** Overall model status. Values: ACCEPTED, PENDING, UNDER_REVIEW, NEEDS_UPDATE. Use to identify valid vs invalid models. */
  modelStatus: Maybe<Scalars['String']['output']>;
  /** When the model was last updated/recalibrated. */
  modelUpdatedTime: Maybe<Scalars['Timestamp']['output']>;
  /** When the Prosper model file was uploaded to iPSO. */
  modelUploadedTime: Maybe<Scalars['Timestamp']['output']>;
  /** Productivity index from Prosper model (stb/d/psi). */
  pi: Maybe<Scalars['Float']['output']>;
  /** Reservoir pressure used in Prosper model (psi). Compare across wells in same reservoir to identify outliers. */
  reservoirPressure: Maybe<Scalars['Float']['output']>;
  /** String name for display (e.g., LI001-L). */
  string_name: Maybe<Scalars['String']['output']>;
  /** VLP correlation used (e.g., Beggs and Brill, Hagedorn Brown). */
  vlpModel: Maybe<Scalars['String']['output']>;
  /** ESP wear factor (0-1). Values < 1 indicate pump degradation. */
  wearFactor: Maybe<Scalars['Float']['output']>;
  /** Reference to wellString. Use to join with hierarchy. */
  wellString: Maybe<StringAsset>;
  /** WF2 model matching status for rate estimation workflow. */
  wf2ModelMatchedStatus: Maybe<Scalars['String']['output']>;
  /** WF3 auto-calibration status. Values: MATCHED, NEEDS_CALIBRATION, NOT_MATCHED, UNDER_REVIEW. Use to find calibration failures. */
  wf3ModelMatchedStatus: Maybe<Scalars['String']['output']>;
};

/** View 'PseudoPressureTable' in the iPSO production optimization solution data model. */
export type PseudoPressureTable = {
  /** Numeric value 'pressure' (floating point) for this 'PseudoPressureTable' row. */
  pressure: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'pseudoPressure' (floating point) for this 'PseudoPressureTable' row. */
  pseudoPressure: Maybe<Scalars['Float32']['output']>;
};

/** View 'PtsOutputs_String' in the iPSO production optimization solution data model. */
export type PtsOutputsString = {
  /** Reference to a time series for 'anchoringFluid' in this 'PtsOutputs_String' view. */
  anchoringFluid: Maybe<TimeSeries>;
  /** Reference to a time series for 'bGLPts1' in this 'PtsOutputs_String' view. */
  bGLPts1: Maybe<TimeSeries>;
  /** Reference to a time series for 'bOil' in this 'PtsOutputs_String' view. */
  bOil: Maybe<TimeSeries>;
  /** Reference to a time series for 'bOilRs' in this 'PtsOutputs_String' view. */
  bOilRs: Maybe<TimeSeries>;
  /** Reference to a time series for 'bgPts1' in this 'PtsOutputs_String' view. */
  bgPts1: Maybe<TimeSeries>;
  /** Reference to a time series for 'blackOilPropModel' in this 'PtsOutputs_String' view. */
  blackOilPropModel: Maybe<TimeSeries>;
  /** Reference to a time series for 'blackOilPropModelFileId' in this 'PtsOutputs_String' view. */
  blackOilPropModelFileId: Maybe<TimeSeries>;
  /** Reference to a time series for 'boPts1' in this 'PtsOutputs_String' view. */
  boPts1: Maybe<TimeSeries>;
  /** Reference to a time series for 'bwPts1' in this 'PtsOutputs_String' view. */
  bwPts1: Maybe<TimeSeries>;
  /** Reference to a time series for 'cO2' in this 'PtsOutputs_String' view. */
  cO2: Maybe<TimeSeries>;
  /** Reference to a time series for 'cO2Rs' in this 'PtsOutputs_String' view. */
  cO2Rs: Maybe<TimeSeries>;
  /** Reference to a time series for 'calcSaturationPress' in this 'PtsOutputs_String' view. */
  calcSaturationPress: Maybe<TimeSeries>;
  /** Reference to a time series for 'calcTotalGORPvtRsPts2' in this 'PtsOutputs_String' view. */
  calcTotalGORPvtRsPts2: Maybe<TimeSeries>;
  /** Reference to a time series for 'calcWellTestGOR' in this 'PtsOutputs_String' view. */
  calcWellTestGOR: Maybe<TimeSeries>;
  /** Reference to a time series for 'calcWellTestGORInSitu' in this 'PtsOutputs_String' view. */
  calcWellTestGORInSitu: Maybe<TimeSeries>;
  /** Reference to a time series for 'calcWellTestTotalGOR' in this 'PtsOutputs_String' view. */
  calcWellTestTotalGOR: Maybe<TimeSeries>;
  /** Reference to a time series for 'cgrPts1' in this 'PtsOutputs_String' view. */
  cgrPts1: Maybe<TimeSeries>;
  /** Reference to a time series for 'composition' in this 'PtsOutputs_String' view. */
  composition: Maybe<TimeSeries>;
  /** Reference to the related 'String_asset' entity for this 'PtsOutputs_String' row. */
  entityName: Maybe<StringAsset>;
  /** Reference to a time series for 'estGasLiftInjectionRate' in this 'PtsOutputs_String' view. */
  estGasLiftInjectionRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'fieldGLToleranceUpdate' in this 'PtsOutputs_String' view. */
  fieldGLToleranceUpdate: Maybe<TimeSeries>;
  /** Reference to a time series for 'fluidCompModelPtsRef' in this 'PtsOutputs_String' view. */
  fluidCompModelPtsRef: Maybe<TimeSeries>;
  /** Reference to a time series for 'fluidCompModelPtsRefFileId' in this 'PtsOutputs_String' view. */
  fluidCompModelPtsRefFileId: Maybe<TimeSeries>;
  /** Reference to a time series for 'fluidCompModelPtsRefFreeGas' in this 'PtsOutputs_String' view. */
  fluidCompModelPtsRefFreeGas: Maybe<TimeSeries>;
  /** Reference to a time series for 'fluidCompModelPtsRefFreeGasFileId' in this 'PtsOutputs_String' view. */
  fluidCompModelPtsRefFreeGasFileId: Maybe<TimeSeries>;
  /** Reference to a time series for 'fluidCompModelPtsRefResult' in this 'PtsOutputs_String' view. */
  fluidCompModelPtsRefResult: Maybe<TimeSeries>;
  /** Reference to a time series for 'fluidCompModelPtsRefResultFileId' in this 'PtsOutputs_String' view. */
  fluidCompModelPtsRefResultFileId: Maybe<TimeSeries>;
  /** Reference to a time series for 'fluidCompModelWellTest' in this 'PtsOutputs_String' view. */
  fluidCompModelWellTest: Maybe<TimeSeries>;
  /** Reference to a time series for 'fluidCompModelWellTestFileId' in this 'PtsOutputs_String' view. */
  fluidCompModelWellTestFileId: Maybe<TimeSeries>;
  /** Reference to a time series for 'fluidCompositionPts1' in this 'PtsOutputs_String' view. */
  fluidCompositionPts1: Maybe<TimeSeries>;
  /** Reference to a time series for 'fluidCompositionPts1FileId' in this 'PtsOutputs_String' view. */
  fluidCompositionPts1FileId: Maybe<TimeSeries>;
  /** Reference to a time series for 'fluidCompositionPts1FreeGas' in this 'PtsOutputs_String' view. */
  fluidCompositionPts1FreeGas: Maybe<TimeSeries>;
  /** Reference to a time series for 'fluidCompositionPts1FreeGasFileId' in this 'PtsOutputs_String' view. */
  fluidCompositionPts1FreeGasFileId: Maybe<TimeSeries>;
  /** Reference to a time series for 'fluidProperties' in this 'PtsOutputs_String' view. */
  fluidProperties: Maybe<TimeSeries>;
  /** Reference to a time series for 'freeCGRPtsRef' in this 'PtsOutputs_String' view. */
  freeCGRPtsRef: Maybe<TimeSeries>;
  /** Reference to a time series for 'freeGORPtsRef' in this 'PtsOutputs_String' view. */
  freeGORPtsRef: Maybe<TimeSeries>;
  /** Reference to a time series for 'freeGORSC' in this 'PtsOutputs_String' view. */
  freeGORSC: Maybe<TimeSeries>;
  /** Reference to a time series for 'gasDensityPts1' in this 'PtsOutputs_String' view. */
  gasDensityPts1: Maybe<TimeSeries>;
  /** Reference to a time series for 'gasDensityPts2' in this 'PtsOutputs_String' view. */
  gasDensityPts2: Maybe<TimeSeries>;
  /** Reference to a time series for 'gasExpansionFactorPTS1toPTSRef' in this 'PtsOutputs_String' view. */
  gasExpansionFactorPTS1toPTSRef: Maybe<TimeSeries>;
  /** Reference to a time series for 'gasExpansionFactorPTS2toPTSRef' in this 'PtsOutputs_String' view. */
  gasExpansionFactorPTS2toPTSRef: Maybe<TimeSeries>;
  /** Reference to a time series for 'gasGravity' in this 'PtsOutputs_String' view. */
  gasGravity: Maybe<TimeSeries>;
  /** Reference to a time series for 'gasRatePVTRsPts1' in this 'PtsOutputs_String' view. */
  gasRatePVTRsPts1: Maybe<TimeSeries>;
  /** Reference to a time series for 'h2S' in this 'PtsOutputs_String' view. */
  h2S: Maybe<TimeSeries>;
  /** Reference to a time series for 'h2SRs' in this 'PtsOutputs_String' view. */
  h2SRs: Maybe<TimeSeries>;
  /** Reference to a time series for 'hydrateCurveTotalFluidPtsRef' in this 'PtsOutputs_String' view. */
  hydrateCurveTotalFluidPtsRef: Maybe<TimeSeries>;
  /** Reference to a time series for 'hydrateCurveTotalFluidPtsRefFileId' in this 'PtsOutputs_String' view. */
  hydrateCurveTotalFluidPtsRefFileId: Maybe<TimeSeries>;
  /** Reference to a time series for 'logPath' in this 'PtsOutputs_String' view. */
  logPath: Maybe<TimeSeries>;
  /** Reference to a time series for 'massFlowRatioPts1' in this 'PtsOutputs_String' view. */
  massFlowRatioPts1: Maybe<TimeSeries>;
  /** Reference to a time series for 'massFlowRatioPts2' in this 'PtsOutputs_String' view. */
  massFlowRatioPts2: Maybe<TimeSeries>;
  /** Reference to a time series for 'massGasPts1' in this 'PtsOutputs_String' view. */
  massGasPts1: Maybe<TimeSeries>;
  /** Reference to a time series for 'massGasPts2' in this 'PtsOutputs_String' view. */
  massGasPts2: Maybe<TimeSeries>;
  /** Reference to a time series for 'massOilPts1' in this 'PtsOutputs_String' view. */
  massOilPts1: Maybe<TimeSeries>;
  /** Reference to a time series for 'massOilPts2' in this 'PtsOutputs_String' view. */
  massOilPts2: Maybe<TimeSeries>;
  /** Reference to a time series for 'matchingMethod' in this 'PtsOutputs_String' view. */
  matchingMethod: Maybe<TimeSeries>;
  /** Reference to a time series for 'measuredMassFlowRatio' in this 'PtsOutputs_String' view. */
  measuredMassFlowRatio: Maybe<TimeSeries>;
  /** Reference to a time series for 'modelRevisionExternalId' in this 'PtsOutputs_String' view. */
  modelRevisionExternalId: Maybe<TimeSeries>;
  /** Reference to a time series for 'modelRevisionFileId' in this 'PtsOutputs_String' view. */
  modelRevisionFileId: Maybe<TimeSeries>;
  /** Reference to a time series for 'modelRevisionId' in this 'PtsOutputs_String' view. */
  modelRevisionId: Maybe<TimeSeries>;
  /** Reference to a time series for 'modelRevisionModelExternalId' in this 'PtsOutputs_String' view. */
  modelRevisionModelExternalId: Maybe<TimeSeries>;
  /** Reference to a time series for 'n2' in this 'PtsOutputs_String' view. */
  n2: Maybe<TimeSeries>;
  /** Reference to a time series for 'n2Rs' in this 'PtsOutputs_String' view. */
  n2Rs: Maybe<TimeSeries>;
  /** Reference to a time series for 'n2SRs' in this 'PtsOutputs_String' view. */
  n2SRs: Maybe<TimeSeries>;
  /** Reference to a time series for 'oilAPIPts1' in this 'PtsOutputs_String' view. */
  oilAPIPts1: Maybe<TimeSeries>;
  /** Reference to a time series for 'oilAPIPts2' in this 'PtsOutputs_String' view. */
  oilAPIPts2: Maybe<TimeSeries>;
  /** Reference to a time series for 'oilDensityPts1' in this 'PtsOutputs_String' view. */
  oilDensityPts1: Maybe<TimeSeries>;
  /** Reference to a time series for 'oilDensityPts2' in this 'PtsOutputs_String' view. */
  oilDensityPts2: Maybe<TimeSeries>;
  /** Reference to a time series for 'oilGravity' in this 'PtsOutputs_String' view. */
  oilGravity: Maybe<TimeSeries>;
  /** Reference to a time series for 'oilShrinkageFactorPTS1toPTSRef' in this 'PtsOutputs_String' view. */
  oilShrinkageFactorPTS1toPTSRef: Maybe<TimeSeries>;
  /** Reference to a time series for 'oilShrinkageFactorPTS2toPTSRef' in this 'PtsOutputs_String' view. */
  oilShrinkageFactorPTS2toPTSRef: Maybe<TimeSeries>;
  /** Reference to a time series for 'oilViscosity' in this 'PtsOutputs_String' view. */
  oilViscosity: Maybe<TimeSeries>;
  /** Reference to a time series for 'oilViscosityRs' in this 'PtsOutputs_String' view. */
  oilViscosityRs: Maybe<TimeSeries>;
  /** Reference to a time series for 'phaseEnvelopeConditionsModelPtsRef' in this 'PtsOutputs_String' view. */
  phaseEnvelopeConditionsModelPtsRef: Maybe<TimeSeries>;
  /** Reference to a time series for 'phaseEnvelopeConditionsModelPtsRefFileId' in this 'PtsOutputs_String' view. */
  phaseEnvelopeConditionsModelPtsRefFileId: Maybe<TimeSeries>;
  /** Reference to a time series for 'phaseEnvelopeConditionsModelPtsRefFreeGas' in this 'PtsOutputs_String' view. */
  phaseEnvelopeConditionsModelPtsRefFreeGas: Maybe<TimeSeries>;
  /** Reference to a time series for 'phaseEnvelopeConditionsModelPtsRefFreeGasFileId' in this 'PtsOutputs_String' view. */
  phaseEnvelopeConditionsModelPtsRefFreeGasFileId: Maybe<TimeSeries>;
  /** Reference to a time series for 'phaseEnvelopeConditionsModelPtsRefResult' in this 'PtsOutputs_String' view. */
  phaseEnvelopeConditionsModelPtsRefResult: Maybe<TimeSeries>;
  /** Reference to a time series for 'phaseEnvelopeConditionsModelPtsRefResultFileId' in this 'PtsOutputs_String' view. */
  phaseEnvelopeConditionsModelPtsRefResultFileId: Maybe<TimeSeries>;
  /** Reference to a time series for 'phaseEnvelopeConditionsModelPtsRs' in this 'PtsOutputs_String' view. */
  phaseEnvelopeConditionsModelPtsRs: Maybe<TimeSeries>;
  /** Reference to a time series for 'phaseEnvelopeConditionsModelPtsRsFileId' in this 'PtsOutputs_String' view. */
  phaseEnvelopeConditionsModelPtsRsFileId: Maybe<TimeSeries>;
  /** Reference to a time series for 'phaseEnvelopeConditionsModelWellTest' in this 'PtsOutputs_String' view. */
  phaseEnvelopeConditionsModelWellTest: Maybe<TimeSeries>;
  /** Reference to a time series for 'phaseEnvelopeConditionsModelWellTestFileId' in this 'PtsOutputs_String' view. */
  phaseEnvelopeConditionsModelWellTestFileId: Maybe<TimeSeries>;
  /** Reference to a time series for 'phaseEnvelopeRecordsModelPtsRef' in this 'PtsOutputs_String' view. */
  phaseEnvelopeRecordsModelPtsRef: Maybe<TimeSeries>;
  /** Reference to a time series for 'phaseEnvelopeRecordsModelPtsRefFileId' in this 'PtsOutputs_String' view. */
  phaseEnvelopeRecordsModelPtsRefFileId: Maybe<TimeSeries>;
  /** Reference to a time series for 'phaseEnvelopeRecordsModelPtsRefFreeGas' in this 'PtsOutputs_String' view. */
  phaseEnvelopeRecordsModelPtsRefFreeGas: Maybe<TimeSeries>;
  /** Reference to a time series for 'phaseEnvelopeRecordsModelPtsRefFreeGasFileId' in this 'PtsOutputs_String' view. */
  phaseEnvelopeRecordsModelPtsRefFreeGasFileId: Maybe<TimeSeries>;
  /** Reference to a time series for 'phaseEnvelopeRecordsModelPtsRefResult' in this 'PtsOutputs_String' view. */
  phaseEnvelopeRecordsModelPtsRefResult: Maybe<TimeSeries>;
  /** Reference to a time series for 'phaseEnvelopeRecordsModelPtsRefResultFileId' in this 'PtsOutputs_String' view. */
  phaseEnvelopeRecordsModelPtsRefResultFileId: Maybe<TimeSeries>;
  /** Reference to a time series for 'phaseEnvelopeRecordsModelPtsRefRs' in this 'PtsOutputs_String' view. */
  phaseEnvelopeRecordsModelPtsRefRs: Maybe<TimeSeries>;
  /** Reference to a time series for 'phaseEnvelopeRecordsModelPtsRefRsFileId' in this 'PtsOutputs_String' view. */
  phaseEnvelopeRecordsModelPtsRefRsFileId: Maybe<TimeSeries>;
  /** Reference to a time series for 'phaseEnvelopeRecordsModelWellTest' in this 'PtsOutputs_String' view. */
  phaseEnvelopeRecordsModelWellTest: Maybe<TimeSeries>;
  /** Reference to a time series for 'phaseEnvelopeRecordsModelWellTestFileId' in this 'PtsOutputs_String' view. */
  phaseEnvelopeRecordsModelWellTestFileId: Maybe<TimeSeries>;
  /** Reference to a time series for 'ptsExecutedBy' in this 'PtsOutputs_String' view. */
  ptsExecutedBy: Maybe<TimeSeries>;
  /** Reference to a time series for 'ptsExecutionDate' in this 'PtsOutputs_String' view. */
  ptsExecutionDate: Maybe<TimeSeries>;
  /** Reference to a time series for 'ptsExecutionStatus' in this 'PtsOutputs_String' view. */
  ptsExecutionStatus: Maybe<TimeSeries>;
  /** Text attribute 'pvtInfo' for this 'PtsOutputs_String' row. */
  pvtInfo: Maybe<Scalars['String']['output']>;
  /** Reference to a time series for 'pvtInfoFileId' in this 'PtsOutputs_String' view. */
  pvtInfoFileId: Maybe<TimeSeries>;
  /** Reference to a time series for 'sampleComposition' in this 'PtsOutputs_String' view. */
  sampleComposition: Maybe<TimeSeries>;
  /** Reference to a time series for 'sampleCompositionFileId' in this 'PtsOutputs_String' view. */
  sampleCompositionFileId: Maybe<TimeSeries>;
  /** Reference to a time series for 'sampleDateTime' in this 'PtsOutputs_String' view. */
  sampleDateTime: Maybe<TimeSeries>;
  /** Reference to a time series for 'saturationPressure' in this 'PtsOutputs_String' view. */
  saturationPressure: Maybe<TimeSeries>;
  /** Reference to a time series for 'saturationPressureRs' in this 'PtsOutputs_String' view. */
  saturationPressureRs: Maybe<TimeSeries>;
  /** Reference to a time series for 'solutionCGR' in this 'PtsOutputs_String' view. */
  solutionCGR: Maybe<TimeSeries>;
  /** Reference to a time series for 'solutionCGRPts1' in this 'PtsOutputs_String' view. */
  solutionCGRPts1: Maybe<TimeSeries>;
  /** Reference to a time series for 'solutionGOR' in this 'PtsOutputs_String' view. */
  solutionGOR: Maybe<TimeSeries>;
  /** Reference to a time series for 'solutionGORPts1' in this 'PtsOutputs_String' view. */
  solutionGORPts1: Maybe<TimeSeries>;
  /** Reference to a time series for 'solutionGORRs' in this 'PtsOutputs_String' view. */
  solutionGORRs: Maybe<TimeSeries>;
  /** Reference to a time series for 'solutionGORRsPts1' in this 'PtsOutputs_String' view. */
  solutionGORRsPts1: Maybe<TimeSeries>;
  /** Reference to a time series for 'solutionGORRsPts1scfbbl' in this 'PtsOutputs_String' view. */
  solutionGORRsPts1scfbbl: Maybe<TimeSeries>;
  /** Reference to a time series for 'specificGasGravityRs' in this 'PtsOutputs_String' view. */
  specificGasGravityRs: Maybe<TimeSeries>;
  /** Reference to a time series for 'specificGravityGasPts1' in this 'PtsOutputs_String' view. */
  specificGravityGasPts1: Maybe<TimeSeries>;
  /** Reference to a time series for 'specificGravityGasPts2' in this 'PtsOutputs_String' view. */
  specificGravityGasPts2: Maybe<TimeSeries>;
  /** Reference to a time series for 'specificGravityOilPts1' in this 'PtsOutputs_String' view. */
  specificGravityOilPts1: Maybe<TimeSeries>;
  /** Reference to a time series for 'specificGravityOilPts2' in this 'PtsOutputs_String' view. */
  specificGravityOilPts2: Maybe<TimeSeries>;
  /** Reference to a time series for 'specificOilGravityRs' in this 'PtsOutputs_String' view. */
  specificOilGravityRs: Maybe<TimeSeries>;
  /** Reference to a time series for 'totalCGRPts2' in this 'PtsOutputs_String' view. */
  totalCGRPts2: Maybe<TimeSeries>;
  /** Reference to a time series for 'totalGORPvtRsPts2' in this 'PtsOutputs_String' view. */
  totalGORPvtRsPts2: Maybe<TimeSeries>;
  /** Reference to a time series for 'triggeredWf02Status' in this 'PtsOutputs_String' view. */
  triggeredWf02Status: Maybe<TimeSeries>;
  /** Reference to a time series for 'triggeredWf03Status' in this 'PtsOutputs_String' view. */
  triggeredWf03Status: Maybe<TimeSeries>;
  /** Reference to a time series for 'triggeredWf04Status' in this 'PtsOutputs_String' view. */
  triggeredWf04Status: Maybe<TimeSeries>;
  /** Reference to a time series for 'usedGasLiftInjectionRate' in this 'PtsOutputs_String' view. */
  usedGasLiftInjectionRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'usedGasLiftInjectionRateLC' in this 'PtsOutputs_String' view. */
  usedGasLiftInjectionRateLC: Maybe<TimeSeries>;
  /** Reference to a time series for 'waterDensityPts1' in this 'PtsOutputs_String' view. */
  waterDensityPts1: Maybe<TimeSeries>;
  /** Reference to a time series for 'waterDensityPts2' in this 'PtsOutputs_String' view. */
  waterDensityPts2: Maybe<TimeSeries>;
  /** Reference to a time series for 'waterSalinity' in this 'PtsOutputs_String' view. */
  waterSalinity: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestApprovedAllocationFlag' in this 'PtsOutputs_String' view. */
  wellTestApprovedAllocationFlag: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestCGRPts' in this 'PtsOutputs_String' view. */
  wellTestCGRPts: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestCGRPts1' in this 'PtsOutputs_String' view. */
  wellTestCGRPts1: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestCGRPts2' in this 'PtsOutputs_String' view. */
  wellTestCGRPts2: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestCGRPtsRef' in this 'PtsOutputs_String' view. */
  wellTestCGRPtsRef: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestEstimatedGLRate' in this 'PtsOutputs_String' view. */
  wellTestEstimatedGLRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGLMassFlowRatePts1' in this 'PtsOutputs_String' view. */
  wellTestGLMassFlowRatePts1: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGLMassFlowRatePts2' in this 'PtsOutputs_String' view. */
  wellTestGLMassFlowRatePts2: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGOR' in this 'PtsOutputs_String' view. */
  wellTestGOR: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGORPts1' in this 'PtsOutputs_String' view. */
  wellTestGORPts1: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGasMassFlowRatePts1' in this 'PtsOutputs_String' view. */
  wellTestGasMassFlowRatePts1: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGasMassFlowRatePts2' in this 'PtsOutputs_String' view. */
  wellTestGasMassFlowRatePts2: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGasMassFlowRatePtsRef' in this 'PtsOutputs_String' view. */
  wellTestGasMassFlowRatePtsRef: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGasRatePts1' in this 'PtsOutputs_String' view. */
  wellTestGasRatePts1: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGasRatePts2' in this 'PtsOutputs_String' view. */
  wellTestGasRatePts2: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGasRatePtsRef' in this 'PtsOutputs_String' view. */
  wellTestGasRatePtsRef: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGorPts2' in this 'PtsOutputs_String' view. */
  wellTestGorPts2: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGorPtsRef' in this 'PtsOutputs_String' view. */
  wellTestGorPtsRef: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGorPtsRefWithUnitID' in this 'PtsOutputs_String' view. */
  wellTestGorPtsRefWithUnitID: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestHCMassFlowRatePts1' in this 'PtsOutputs_String' view. */
  wellTestHCMassFlowRatePts1: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestHCMassFlowRatePts2' in this 'PtsOutputs_String' view. */
  wellTestHCMassFlowRatePts2: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestHCMassFlowRatePtsRef' in this 'PtsOutputs_String' view. */
  wellTestHCMassFlowRatePtsRef: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestLiquidRatePts1' in this 'PtsOutputs_String' view. */
  wellTestLiquidRatePts1: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestLiquidRatePts2' in this 'PtsOutputs_String' view. */
  wellTestLiquidRatePts2: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestLiquidRatePtsRef' in this 'PtsOutputs_String' view. */
  wellTestLiquidRatePtsRef: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestOilMassFlowRatePts1' in this 'PtsOutputs_String' view. */
  wellTestOilMassFlowRatePts1: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestOilMassFlowRatePts2' in this 'PtsOutputs_String' view. */
  wellTestOilMassFlowRatePts2: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestOilMassFlowRatePtsRef' in this 'PtsOutputs_String' view. */
  wellTestOilMassFlowRatePtsRef: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestOilRatePts1' in this 'PtsOutputs_String' view. */
  wellTestOilRatePts1: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestOilRatePts2' in this 'PtsOutputs_String' view. */
  wellTestOilRatePts2: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestOilRatePtsRef' in this 'PtsOutputs_String' view. */
  wellTestOilRatePtsRef: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestSGVPts1' in this 'PtsOutputs_String' view. */
  wellTestSGVPts1: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestSGVPts2' in this 'PtsOutputs_String' view. */
  wellTestSGVPts2: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestSOVPts1' in this 'PtsOutputs_String' view. */
  wellTestSOVPts1: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestSOVPts2' in this 'PtsOutputs_String' view. */
  wellTestSOVPts2: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestTotalMassFlowRatePts1' in this 'PtsOutputs_String' view. */
  wellTestTotalMassFlowRatePts1: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestTotalMassFlowRatePts2' in this 'PtsOutputs_String' view. */
  wellTestTotalMassFlowRatePts2: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestTotalMassFlowRatePtsRef' in this 'PtsOutputs_String' view. */
  wellTestTotalMassFlowRatePtsRef: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestUsedGLRate' in this 'PtsOutputs_String' view. */
  wellTestUsedGLRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestWGRPts' in this 'PtsOutputs_String' view. */
  wellTestWGRPts: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestWGRPts1' in this 'PtsOutputs_String' view. */
  wellTestWGRPts1: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestWGRPts2' in this 'PtsOutputs_String' view. */
  wellTestWGRPts2: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestWGRPtsRef' in this 'PtsOutputs_String' view. */
  wellTestWGRPtsRef: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestWaterCutPts1' in this 'PtsOutputs_String' view. */
  wellTestWaterCutPts1: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestWaterCutPts2' in this 'PtsOutputs_String' view. */
  wellTestWaterCutPts2: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestWaterCutPtsRef' in this 'PtsOutputs_String' view. */
  wellTestWaterCutPtsRef: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestWaterMassFlowRatePts1' in this 'PtsOutputs_String' view. */
  wellTestWaterMassFlowRatePts1: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestWaterMassFlowRatePts2' in this 'PtsOutputs_String' view. */
  wellTestWaterMassFlowRatePts2: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestWaterMassFlowRatePtsRef' in this 'PtsOutputs_String' view. */
  wellTestWaterMassFlowRatePtsRef: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestWaterRatePts1' in this 'PtsOutputs_String' view. */
  wellTestWaterRatePts1: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestWaterRatePts2' in this 'PtsOutputs_String' view. */
  wellTestWaterRatePts2: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestWaterRatePtsRef' in this 'PtsOutputs_String' view. */
  wellTestWaterRatePtsRef: Maybe<TimeSeries>;
  /** Reference to a time series for 'wf01ReprocessFlag' in this 'PtsOutputs_String' view. */
  wf01ReprocessFlag: Maybe<TimeSeries>;
};

/**
 * Path-to-surface corrected rates, GOR, water cut at stock-tank conditions (WF10/WF19).
 *
 * Well performance from calibrated models and wellhead measurements. Use for well
 * efficiency, production optimization, reservoir performance, and production trends. Excludes historical or geological detail.
 *
 * Use for: Rate and Pressure Estimation (WF10), Reservoir Pressure and PI (WF19).
 *
 * @name PTS Outputs - String (Agent)
 */
export type PtsOutputsStringAgent = {
  /**
   *   Gas formation volume factor (Bg) from line conditions (PTS1/LC) to PTS reference conditions (TS).
   *   Also referred to as gasExpansionFactorPTS1toPTSRef.
   *
   * @name gasExpansionFactorPTS1toPTSRef
   */
  bgPts1: Maybe<TimeSeries>;
  /**
   *   Gas formation volume factor (Bg) from standard conditions (PTS2/SC) to PTS reference conditions (TS).
   *   Also referred to as gasExpansionFactorPTS2toPTSRef.
   *
   * @name gasExpansionFactorPTS2toPTSRef
   */
  bgPts2: Maybe<TimeSeries>;
  /**
   *   Oil formation volume factor (Bo) from line conditions (PTS1/LC) to PTS reference conditions (res bbl/stb, TS).
   *   Also referred to as oilShrinkageFactorPTS1toPTSRef.
   *
   * @name oilShrinkageFactorPTS1toPTSRef
   */
  boPts1: Maybe<TimeSeries>;
  /**
   *   Oil formation volume factor (Bo) from standard conditions (PTS2/SC) to PTS reference conditions (res bbl/stb, TS).
   *   Also referred to as oilShrinkageFactorPTS2toPTSRef.
   *
   * @name oilShrinkageFactorPTS2toPTSRef
   */
  boPts2: Maybe<TimeSeries>;
  cO2: Maybe<TimeSeries>;
  calcWellTestGOR: Maybe<TimeSeries>;
  calcWellTestGORInSitu: Maybe<TimeSeries>;
  /**
   * Calculated total GOR based on vendor-reported rates (scf/stb, TS).
   * Compare to wellTestGorPtsRef (WF01-transformed GOR at PTS reference conditions) to assess correction magnitude.
   */
  calcWellTestTotalGOR: Maybe<TimeSeries>;
  composition: Maybe<TimeSeries>;
  estGasLiftInjectionRate: Maybe<TimeSeries>;
  fluidCompositionPts1: Maybe<TimeSeries>;
  freeCGRPtsRef: Maybe<TimeSeries>;
  freeGORPtsRef: Maybe<TimeSeries>;
  freeGORSC: Maybe<TimeSeries>;
  /** Gas density at PTS1 / line conditions (LC) (kg/m3, TS). */
  gasDensityPts1: Maybe<TimeSeries>;
  /** Gas density at PTS2 / standard conditions (SC) (kg/m3, TS). */
  gasDensityPts2: Maybe<TimeSeries>;
  /** Gas gravity at PTS reference conditions (relative to air, TS). */
  gasGravity: Maybe<TimeSeries>;
  h2S: Maybe<TimeSeries>;
  n2: Maybe<TimeSeries>;
  /** Oil density at PTS1 / line conditions (LC) (kg/m3, TS). */
  oilDensityPts1: Maybe<TimeSeries>;
  /** Oil density at PTS2 / standard conditions (SC) (kg/m3, TS). */
  oilDensityPts2: Maybe<TimeSeries>;
  sampleDateTime: Maybe<TimeSeries>;
  saturationPressure: Maybe<TimeSeries>;
  solutionCGR: Maybe<TimeSeries>;
  solutionCGRPts1: Maybe<TimeSeries>;
  solutionGOR: Maybe<TimeSeries>;
  solutionGORPts1: Maybe<TimeSeries>;
  /** Specific gravity of gas at PTS1 / line conditions (LC) (TS). */
  specificGravityGasPts1: Maybe<TimeSeries>;
  /** Specific gravity of gas at PTS2 / standard conditions (SC) (TS). */
  specificGravityGasPts2: Maybe<TimeSeries>;
  usedGasLiftInjectionRate: Maybe<TimeSeries>;
  /** Water density at PTS1 / line conditions (LC) (kg/m3, TS). */
  waterDensityPts1: Maybe<TimeSeries>;
  /** Water density at PTS2 / standard conditions (SC) (kg/m3, TS). */
  waterDensityPts2: Maybe<TimeSeries>;
  waterSalinity: Maybe<TimeSeries>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString: Maybe<StringAsset>;
  /** Condensate-gas ratio at PTS reference conditions (stb/MMscf, TS). */
  wellTestCGRPtsRef: Maybe<TimeSeries>;
  wellTestEstimatedGLRate: Maybe<TimeSeries>;
  wellTestGOR: Maybe<TimeSeries>;
  wellTestGORPts1: Maybe<TimeSeries>;
  wellTestGasRatePts1: Maybe<TimeSeries>;
  /** Gas rate at PTS2 / standard conditions (MMscfd, TS). */
  wellTestGasRatePts2: Maybe<TimeSeries>;
  /**
   * GOR at PTS2 / standard conditions (scf/stb, TS).
   * Compare to wellTestTotalGorStd (vendor) and calcWellTestTotalGOR (calculated) for validation.
   */
  wellTestGorPts2: Maybe<TimeSeries>;
  /**
   * GOR transformed by WF01 to PTS reference conditions (scf/stb, TS).
   * Use together with calcWellTestTotalGOR (measured GOR based on vendor-reported rates) for comparison.
   * Use to list wells above/below a GOR limit or above maxGOR from producer guidelines.
   */
  wellTestGorPtsRef: Maybe<TimeSeries>;
  wellTestLiquidRatePts1: Maybe<TimeSeries>;
  /** Liquid rate at PTS2 / standard conditions (stb/d, TS). */
  wellTestLiquidRatePts2: Maybe<TimeSeries>;
  /** Total liquid rate at PTS reference conditions (stb/d, TS). */
  wellTestLiquidRatePtsRef: Maybe<TimeSeries>;
  wellTestOilRatePts1: Maybe<TimeSeries>;
  /** Oil rate at PTS2 / standard conditions (stb/d, TS). */
  wellTestOilRatePts2: Maybe<TimeSeries>;
  /**
   * PTS-corrected oil rate at reference conditions (stb/d, TS).
   * Compare to wellTestOilRateStd (vendor-reported standard rate) to assess PTS correction impact.
   */
  wellTestOilRatePtsRef: Maybe<TimeSeries>;
  wellTestUsedGLRate: Maybe<TimeSeries>;
  wellTestWGRPts1: Maybe<TimeSeries>;
  wellTestWaterCutPts1: Maybe<TimeSeries>;
  /**
   * Water cut at PTS2 / standard conditions (%, TS).
   * Compare to wellTestWaterCut (vendor-reported) to validate PTS calculation.
   */
  wellTestWaterCutPts2: Maybe<TimeSeries>;
  /**
   * Water cut at PTS reference conditions (%, TS).
   * Use to list wells above a water cut threshold or to track change between consecutive accepted well tests.
   */
  wellTestWaterCutPtsRef: Maybe<TimeSeries>;
  wellTestWaterRatePts1: Maybe<TimeSeries>;
  /** Water rate at PTS2 / standard conditions (stb/d, TS). */
  wellTestWaterRatePts2: Maybe<TimeSeries>;
};

/**
 * Pump-level outputs from WF7 GAP network simulation (WF7).
 *
 * Simulated pump operating conditions: differential pressure, power draw, and
 * throughput per pump. Use to evaluate pump performance, flag constraint
 * violations, and compare across runs. Excludes historical performance data and
 * pump maintenance records.
 *
 * Use for: Network Surveillance (WF7).
 *
 * @name Pump Outputs - Network (Agent)
 */
export type PumpOutputsNetworkAgent = {
  /** Pump entity name. */
  entityName: Maybe<Entity>;
  /** Reference to parent network model. */
  network: Maybe<Network>;
  /** Liquid rate through pump (TS). */
  nmvPumpLiquidRate: Maybe<TimeSeries>;
  /** Pump operating outside constraints (0/1, TS). */
  nmvPumpViolatingConsraintsFlag: Maybe<TimeSeries>;
};

/**
 * Well performance scores, rate-change metrics, analysis status, choke/GL parameters per string.
 *
 * Diagnostic metadata about the estimation process (not rate values). Use for:
 * well performance vs potential, ESP/GL/GRD analysis success, rate change, or
 * implied choke size. For rate estimates use EstimatedRates_String_Agent; for
 * data-driven rates use DataDrivenRates_String_Agent.
 *
 * Use for: performance scores and analysis status (WF10).
 *
 * @name Rate Diagnostics - Well Performance and Analysis Status (Agent)
 */
export type RateDiagnosticsStringAgent = {
  /** Calculated production choke discharge coefficient (Cd, TS). Typical range 0.6–0.9; deviations indicate restriction or erosion. */
  chokeCdCalc: Maybe<TimeSeries>;
  /** Calculated production choke size implied by current rate and pressure conditions (64ths inch, TS). */
  chokeSizeCalc: Maybe<TimeSeries>;
  /** Status of Gas Rate Decline analysis. Values: SUCCESS, FAILED, INSUFFICIENT_DATA. */
  grdAnalysisStatus: Maybe<TimeSeries>;
  /**
   * Difference between current and reference liquid rate (stb/d, TS).
   * Positive = above reference, negative = below. Used for rate-change
   * monitoring and alarm triggering.
   */
  qliqDelta: Maybe<TimeSeries>;
  /**
   * Well performance indicator (dimensionless). Composite efficiency or
   * health score vs theoretical potential.
   */
  wellPerformance: Maybe<TimeSeries>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString: Maybe<StringAsset>;
};

/** Typed view over 'Entity' showing reservoirs only (where 'entityType' = 'reservoir'). Use this view to identify a reservoir by name, then navigate to its wells or strings through the 'FlatHierarchy' and 'SectorHierarchy' navigation views. */
export type Reservoir = {
  /** Timestamp 'endDateTime' associated with this 'Reservoir' row. */
  endDateTime: Maybe<Scalars['Timestamp']['output']>;
  /** Text attribute 'entityType' for this 'Reservoir' row. */
  entityType: Maybe<Scalars['String']['output']>;
  /** Name of the reservoir. To retrieve all wells in a reservoir, find the reservoir here and filter 'FlatHierarchy' or 'SectorHierarchy' on this reservoir while reading the 'well' property. */
  name: Maybe<Scalars['String']['output']>;
  /** Timestamp 'startDateTime' associated with this 'Reservoir' row. */
  startDateTime: Maybe<Scalars['Timestamp']['output']>;
};

export type ReservoirInputs = {
  entityName: Maybe<Reservoir>;
  reservoirInjectionAllocationFactor: Maybe<TimeSeries>;
  reservoirInjectionAllocationGasFactor: Maybe<TimeSeries>;
  reservoirInjectionAllocationOilFactor: Maybe<TimeSeries>;
  reservoirInjectionAllocationWaterFactor: Maybe<TimeSeries>;
  reservoirProductionAllocationFactor: Maybe<TimeSeries>;
  reservoirProductionAllocationGasFactor: Maybe<TimeSeries>;
  reservoirProductionAllocationOilFactor: Maybe<TimeSeries>;
  reservoirProductionAllocationWaterFactor: Maybe<TimeSeries>;
};

/**
 * Reservoir-level allocation factors for production and injection (WF16).
 *
 * How production and injection from facilities are distributed among reservoirs.
 * Use for allocation share per reservoir and which reservoir has highest allocation. Excludes well connectivity or performance detail.
 *
 * Use for: VRR Monitoring and Surveillance (WF16).
 *
 * @name Reservoir Inputs - Allocation Factors (Agent)
 */
export type ReservoirInputsAgent = {
  /** Reference to reservoir. */
  reservoir: Maybe<Reservoir>;
  /**
   * Combined injection allocation factor for this reservoir (fraction, TS).
   * Overall share of total facility injection attributed to this reservoir.
   */
  reservoirInjectionAllocationFactor: Maybe<TimeSeries>;
  /**
   * Gas injection allocation factor for this reservoir (fraction, TS).
   * Share of facility gas injection attributed to this reservoir.
   */
  reservoirInjectionAllocationGasFactor: Maybe<TimeSeries>;
  /**
   * Oil injection allocation factor for this reservoir (fraction, TS).
   * Used in WAG (Water-Alternating-Gas) injection schemes.
   */
  reservoirInjectionAllocationOilFactor: Maybe<TimeSeries>;
  /**
   * Water injection allocation factor for this reservoir (fraction, TS).
   * Share of facility water injection attributed to this reservoir.
   */
  reservoirInjectionAllocationWaterFactor: Maybe<TimeSeries>;
  /**
   * Combined production allocation factor for this reservoir (fraction, TS).
   * Overall share of total facility production attributed to this reservoir.
   */
  reservoirProductionAllocationFactor: Maybe<TimeSeries>;
  /**
   * Gas production allocation factor for this reservoir (fraction, TS).
   * Share of facility gas production attributed to this reservoir.
   */
  reservoirProductionAllocationGasFactor: Maybe<TimeSeries>;
  /**
   * Oil production allocation factor for this reservoir (fraction, TS).
   * Share of facility oil production attributed to this reservoir.
   */
  reservoirProductionAllocationOilFactor: Maybe<TimeSeries>;
  /**
   * Water production allocation factor for this reservoir (fraction, TS).
   * Share of facility water production attributed to this reservoir.
   */
  reservoirProductionAllocationWaterFactor: Maybe<TimeSeries>;
};

/** Aggregated reservoir-level outputs including counts of active and inactive wells, injection rates and downhole production/injection volumes, as well as voidage replacement ratio (VRR) and pressure compliance metrics for reservoir management and optimization. */
export type ReservoirOutputs = {
  /** Reference to a time series for 'downholeGasInjectionVolume' in this 'ReservoirOutputs' view. */
  downholeGasInjectionVolume: Maybe<TimeSeries>;
  /** Reference to a time series for 'downholeGasProductionVolume' in this 'ReservoirOutputs' view. */
  downholeGasProductionVolume: Maybe<TimeSeries>;
  /** Reference to a time series for 'downholeOilProductionVolume' in this 'ReservoirOutputs' view. */
  downholeOilProductionVolume: Maybe<TimeSeries>;
  /** Reference to a time series for 'downholeWaterInjectionVolume' in this 'ReservoirOutputs' view. */
  downholeWaterInjectionVolume: Maybe<TimeSeries>;
  /** Reference to a time series for 'downholeWaterProductionVolume' in this 'ReservoirOutputs' view. */
  downholeWaterProductionVolume: Maybe<TimeSeries>;
  /** Name of the reservoir for which aggregated well status, injection and voidage replacement outputs are reported in this view. */
  entityName: Maybe<Reservoir>;
  /** Reference to the field in which this reservoir is located. */
  field: Maybe<Field>;
  /** Time series of total gas injection rate into the reservoir from all GI wells. */
  giRate: Maybe<TimeSeries>;
  /** Time series of target gas injection rate for the reservoir. */
  giTargetRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'giTargetRateCompliance' in this 'ReservoirOutputs' view. */
  giTargetRateCompliance: Maybe<TimeSeries>;
  /** Reference to a time series for 'mtdVRR' in this 'ReservoirOutputs' view. */
  mtdVRR: Maybe<TimeSeries>;
  /** Reference to a time series for 'mtdVRRCompliance' in this 'ReservoirOutputs' view. */
  mtdVRRCompliance: Maybe<TimeSeries>;
  /** Reference to a time series for 'pressureCompliance' in this 'ReservoirOutputs' view. */
  pressureCompliance: Maybe<TimeSeries>;
  /** Reference to a time series for 'regionPressure' in this 'ReservoirOutputs' view. */
  regionPressure: Maybe<TimeSeries>;
  /** Reference to a time series for 'vrr' in this 'ReservoirOutputs' view. */
  vrr: Maybe<TimeSeries>;
  /** Reference to a time series for 'vrrCompliance' in this 'ReservoirOutputs' view. */
  vrrCompliance: Maybe<TimeSeries>;
  /** Time series of the number of active gas injector wells (GI) targeting the reservoir. */
  wellsActiveGi: Maybe<TimeSeries>;
  /** Time series of the number of active producer wells flowing to gas plant (GP) or similar grouping while on natural flow (NF) in the reservoir. */
  wellsActiveGpNf: Maybe<TimeSeries>;
  /** Time series of the number of active producer wells on ESP lift completed in the reservoir. */
  wellsActiveOpEsp: Maybe<TimeSeries>;
  /** Time series of the number of active producer wells on gas lift (GL) completed in the reservoir. */
  wellsActiveOpGl: Maybe<TimeSeries>;
  /** Time series of the number of active producer wells on natural flow (NF) completed in the reservoir. */
  wellsActiveOpNf: Maybe<TimeSeries>;
  /** Time series of the number of active water injector wells (WI) targeting the reservoir. */
  wellsActiveWi: Maybe<TimeSeries>;
  /** Time series of the number of inactive gas injector wells (GI) targeting the reservoir. */
  wellsInActiveGi: Maybe<TimeSeries>;
  /** Time series of the number of inactive producer wells flowing to gas plant (GP) or similar grouping while on natural flow (NF) in the reservoir. */
  wellsInActiveGpNf: Maybe<TimeSeries>;
  /** Time series of the number of inactive producer wells on ESP lift completed in the reservoir. */
  wellsInActiveOpEsp: Maybe<TimeSeries>;
  /** Time series of the number of inactive producer wells on gas lift (GL) completed in the reservoir. */
  wellsInActiveOpGl: Maybe<TimeSeries>;
  /** Time series of the number of inactive producer wells on natural flow (NF) completed in the reservoir. */
  wellsInActiveOpNf: Maybe<TimeSeries>;
  /** Time series of the number of inactive water injector wells (WI) targeting the reservoir. */
  wellsInActiveWi: Maybe<TimeSeries>;
  /** Time series of total water injection rate into the reservoir from all WI wells. */
  wiRate: Maybe<TimeSeries>;
  /** Time series of target water injection rate for the reservoir. */
  wiTargetRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'wiTargetRateCompliance' in this 'ReservoirOutputs' view. */
  wiTargetRateCompliance: Maybe<TimeSeries>;
  /** Reference to a time series for 'ytdVRR' in this 'ReservoirOutputs' view. */
  ytdVRR: Maybe<TimeSeries>;
  /** Reference to a time series for 'ytdVRRCompliance' in this 'ReservoirOutputs' view. */
  ytdVRRCompliance: Maybe<TimeSeries>;
};

/**
 * Reservoir-level VRR metrics, compliance ratios, injection balance (WF16).
 *
 * Reservoir output metrics for VRR compliance, injection strategies, well activity.
 * Use to assess reservoir health and injection-related risks. Excludes geological or historical detail.
 *
 * Use for: VRR Monitoring and Surveillance (WF16).
 *
 * @name Reservoir Outputs (Agent)
 */
export type ReservoirOutputsAgent = {
  /**
   * Downhole gas injection volume at reservoir conditions (rb, TS).
   * Used in VRR numerator calculation.
   */
  downholeGasInjectionVolume: Maybe<TimeSeries>;
  /**
   * Downhole gas production volume at reservoir conditions (rb, TS).
   * Used in VRR denominator calculation.
   */
  downholeGasProductionVolume: Maybe<TimeSeries>;
  /**
   * Downhole oil production volume at reservoir conditions (rb, TS).
   * Used in VRR denominator calculation.
   */
  downholeOilProductionVolume: Maybe<TimeSeries>;
  /**
   * Downhole water injection volume at reservoir conditions (rb, TS).
   * Used in VRR numerator calculation.
   */
  downholeWaterInjectionVolume: Maybe<TimeSeries>;
  /**
   * Downhole water production volume at reservoir conditions (rb, TS).
   * Used in VRR denominator calculation.
   */
  downholeWaterProductionVolume: Maybe<TimeSeries>;
  /** Parent field containing this reservoir. Use for field-level aggregation. */
  field: Maybe<Field>;
  /** Aggregated gas injection rate for the reservoir (MSCF/d, TS). */
  giRate: Maybe<TimeSeries>;
  /**
   * Gas injection target rate from planning/optimization (MSCF/d, TS).
   * Compare to giRate for performance gap.
   */
  giTargetRate: Maybe<TimeSeries>;
  /** Gas injection target rate compliance flag (TS). 1 = giRate meets target. */
  giTargetRateCompliance: Maybe<TimeSeries>;
  /**
   * Month-to-date VRR (TS). Cumulative VRR from start of current month.
   * Use for monthly trend vs daily VRR.
   */
  mtdVRR: Maybe<TimeSeries>;
  /** Month-to-date VRR compliance flag (TS). 1 = within target band for the month. */
  mtdVRRCompliance: Maybe<TimeSeries>;
  /**
   * Reservoir pressure compliance flag (TS). 1 = within expected range from
   * Reservoir_Guideline.expectedReservoirPressure.
   */
  pressureCompliance: Maybe<TimeSeries>;
  /**
   * Average reservoir region pressure (psi, TS). Compare to
   * Reservoir_Guideline.expectedReservoirPressure for compliance.
   */
  regionPressure: Maybe<TimeSeries>;
  /** Reference to reservoir. */
  reservoir: Maybe<Reservoir>;
  /**
   * Daily voidage replacement ratio (TS). Ratio of injected volume to produced
   * volume at reservoir conditions. Target typically ~1.0 for pressure maintenance.
   */
  vrr: Maybe<TimeSeries>;
  /** Daily VRR compliance flag (TS). 1 = within target band, 0 = out of compliance. */
  vrrCompliance: Maybe<TimeSeries>;
  /** Count of active gas injector wells (TS). */
  wellsActiveGi: Maybe<TimeSeries>;
  /** Count of active gas producer wells on natural flow (TS). */
  wellsActiveGpNf: Maybe<TimeSeries>;
  /** Count of active oil producer wells on ESP (TS). */
  wellsActiveOpEsp: Maybe<TimeSeries>;
  /** Count of active oil producer wells on gas lift (TS). */
  wellsActiveOpGl: Maybe<TimeSeries>;
  /** Count of active oil producer wells on natural flow (TS). */
  wellsActiveOpNf: Maybe<TimeSeries>;
  /** Count of active water injector wells (TS). */
  wellsActiveWi: Maybe<TimeSeries>;
  /** Count of inactive gas injector wells (TS). */
  wellsInActiveGi: Maybe<TimeSeries>;
  /** Count of inactive gas producer wells on natural flow (TS). */
  wellsInActiveGpNf: Maybe<TimeSeries>;
  /** Count of inactive oil producer wells on ESP (TS). */
  wellsInActiveOpEsp: Maybe<TimeSeries>;
  /** Count of inactive oil producer wells on gas lift (TS). */
  wellsInActiveOpGl: Maybe<TimeSeries>;
  /** Count of inactive oil producer wells on natural flow (TS). */
  wellsInActiveOpNf: Maybe<TimeSeries>;
  /** Count of inactive water injector wells (TS). */
  wellsInActiveWi: Maybe<TimeSeries>;
  /** Aggregated water injection rate for the reservoir (stb/d, TS). */
  wiRate: Maybe<TimeSeries>;
  /**
   * Water injection target rate from planning/optimization (stb/d, TS).
   * Compare to wiRate for performance gap.
   */
  wiTargetRate: Maybe<TimeSeries>;
  /** Water injection target rate compliance flag (TS). 1 = wiRate meets target. */
  wiTargetRateCompliance: Maybe<TimeSeries>;
  /**
   * Year-to-date VRR (TS). Cumulative VRR from start of current year.
   * Use for long-term reservoir management assessment.
   */
  ytdVRR: Maybe<TimeSeries>;
  /** Year-to-date VRR compliance flag (TS). 1 = within target band for the year. */
  ytdVRRCompliance: Maybe<TimeSeries>;
};

/** View 'Reservoir_Guideline' in the iPSO production optimization solution data model. */
export type ReservoirGuideline = {
  /** Timestamp 'effectiveDate' associated with this 'Reservoir_Guideline' row. */
  effectiveDate: Maybe<Scalars['Timestamp']['output']>;
  /** Numeric value 'expectedReservoirPressure' (floating point) for this 'Reservoir_Guideline' row. */
  expectedReservoirPressure: Maybe<Scalars['Float32']['output']>;
  /** Reference to the related 'Field' entity for this 'Reservoir_Guideline' row. */
  field: Maybe<Field>;
  /** Reference to the related 'Reservoir' entity for this 'Reservoir_Guideline' row. */
  reservoir: Maybe<Reservoir>;
  /** Numeric value 'reservoirAllowableRate' (floating point) for this 'Reservoir_Guideline' row. */
  reservoirAllowableRate: Maybe<Scalars['Float32']['output']>;
  /** Reference to the related 'Sector' entity for this 'Reservoir_Guideline' row. */
  sector: Maybe<Sector>;
  /** Numeric value 'technicalGasRate' (floating point) for this 'Reservoir_Guideline' row. */
  technicalGasRate: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'technicalOilRate' (floating point) for this 'Reservoir_Guideline' row. */
  technicalOilRate: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'vrrRequirement' (floating point) for this 'Reservoir_Guideline' row. */
  vrrRequirement: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'vrrTarget' (floating point) for this 'Reservoir_Guideline' row. */
  vrrTarget: Maybe<Scalars['Float32']['output']>;
};

/** View 'Reservoir_Prodplan' in the iPSO production optimization solution data model. */
export type ReservoirProdplan = {
  /** Timestamp 'effectiveDate' associated with this 'Reservoir_Prodplan' row. */
  effectiveDate: Maybe<Scalars['Timestamp']['output']>;
  /** Reference to the related 'Field' entity for this 'Reservoir_Prodplan' row. */
  field: Maybe<Field>;
  /** Numeric value 'prodTarget' (floating point) for this 'Reservoir_Prodplan' row. */
  prodTarget: Maybe<Scalars['Float32']['output']>;
  /** Reference to the related 'Reservoir' entity for this 'Reservoir_Prodplan' row. */
  reservoir: Maybe<Reservoir>;
  /** Timestamp 'submittedMonth' associated with this 'Reservoir_Prodplan' row. */
  submittedMonth: Maybe<Scalars['Timestamp']['output']>;
  /** Numeric value 'vrrTarget' (floating point) for this 'Reservoir_Prodplan' row. */
  vrrTarget: Maybe<Scalars['Float32']['output']>;
};

/** View 'SHG_INJECTION' in the iPSO production optimization solution data model. */
export type ShgInjection = {
  /** Reference to the related 'String_asset' entity for this 'SHG_INJECTION' row. */
  entityName: Maybe<StringAsset>;
  /** Reference to a time series 'giMaxBHIP' for this 'SHG_INJECTION' row. */
  giMaxBHIP: Maybe<TimeSeries>;
  /** Reference to a time series 'giMaxInjRate'  for this 'SHG_INJECTION' row. */
  giMaxInjRate: Maybe<TimeSeries>;
  /** Reference to a time series 'giMaxWHIP' for this 'SHG_INJECTION' row. */
  giMaxWHIP: Maybe<TimeSeries>;
  /** Reference to a time series 'wiMaxBHIP' for this 'SHG_INJECTION' row. */
  wiMaxBHIP: Maybe<TimeSeries>;
  /** Reference to a time series 'wiMaxInjRate' for this 'SHG_INJECTION' row. */
  wiMaxInjRate: Maybe<TimeSeries>;
  /** Reference to a time series 'wiMaxWHIP' for this 'SHG_INJECTION' row. */
  wiMaxWHIP: Maybe<TimeSeries>;
};

/** View 'SHG_PRODUCTION' in the iPSO production optimization solution data model. */
export type ShgProduction = {
  /** Reference to the related 'String_asset' entity for this 'SHG_PRODUCTION' row. */
  entityName: Maybe<StringAsset>;
  /** Reference to a time series 'maxGOR' for this 'SHG_PRODUCTION' row. */
  maxGOR: Maybe<TimeSeries>;
  /** Reference to a time series 'maxLiquidRate' for this 'SHG_PRODUCTION' row. */
  maxLiquidRate: Maybe<TimeSeries>;
  /** Reference to a time series 'maxOilRate' for this 'SHG_PRODUCTION' row. */
  maxOilRate: Maybe<TimeSeries>;
  /** Reference to a time series 'minBHP' for this 'SHG_PRODUCTION' row. */
  minBHP: Maybe<TimeSeries>;
  /** Reference to a time series 'minWHP' for this 'SHG_PRODUCTION' row. */
  minWHP: Maybe<TimeSeries>;
};

/** View 'SHG_Producer_Guideline' in the iPSO production optimization solution data model. */
export type ShgProducerGuideline = {
  /** Reference to the related 'String_asset' entity for this 'SHG_Producer_Guideline' row. */
  entityName: Maybe<StringAsset>;
  /** Numeric value 'maxGOR' (floating point) for this 'SHG_Producer_Guideline' row. */
  maxGOR: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'maxLiquidRate' (floating point) for this 'SHG_Producer_Guideline' row. */
  maxLiquidRate: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'maxOilRate' (floating point) for this 'SHG_Producer_Guideline' row. */
  maxOilRate: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'minBHP' (floating point) for this 'SHG_Producer_Guideline' row. */
  minBHP: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'minWHP' (floating point) for this 'SHG_Producer_Guideline' row. */
  minWHP: Maybe<Scalars['Float32']['output']>;
};

/** View 'SPressSettings' in the iPSO production optimization solution data model. */
export type SPressSettings = {
  /** Timestamp 'dateTime' associated with this 'SPressSettings' row. */
  dateTime: Maybe<Scalars['Timestamp']['output']>;
  /** Reference to the related 'Entity' entity for this 'SPressSettings' row. */
  entityName: Maybe<Entity>;
  /** Numeric value 'maxReservoirPressure' (floating point) for this 'SPressSettings' row. */
  maxReservoirPressure: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'minNumberShutInPressures' (integer) for this 'SPressSettings' row. */
  minNumberShutInPressures: Maybe<Scalars['Int']['output']>;
  /** Numeric value 'minReservoirPressure' (floating point) for this 'SPressSettings' row. */
  minReservoirPressure: Maybe<Scalars['Float32']['output']>;
};

/** View 'SRMOutputs_All_Entities' in the iPSO production optimization solution data model. */
export type SrmOutputsAllEntities = {
  adHocOptimizedGasInjRateGAPRes: Maybe<TimeSeries>;
  adHocOptimizedProdRateGAPRes: Maybe<TimeSeries>;
  adHocOptimizedVRRGAP: Maybe<TimeSeries>;
  adHocOptimizedVRRSRM: Maybe<TimeSeries>;
  adHocOptimizedWatInjRateGAPRes: Maybe<TimeSeries>;
  allocFactorType: Maybe<TimeSeries>;
  allocFactorVersion: Maybe<TimeSeries>;
  /** Reference to a time series for 'createdDate' in this 'SRMOutputs_All_Entities' view. */
  createdDate: Maybe<TimeSeries>;
  /** Reference to the related 'Entity' entity for this 'SRMOutputs_All_Entities' row. */
  entityName: Maybe<Entity>;
  /** Reference to a time series for 'entityType' in this 'SRMOutputs_All_Entities' view. */
  entityType: Maybe<TimeSeries>;
  /** Reference to a time series for 'executionBy' in this 'SRMOutputs_All_Entities' view. */
  executionBy: Maybe<TimeSeries>;
  /** Reference to a time series for 'executionDate' in this 'SRMOutputs_All_Entities' view. */
  executionDate: Maybe<TimeSeries>;
  /** Reference to a time series for 'gasInjCapacity' in this 'SRMOutputs_All_Entities' view. */
  gasInjCapacity: Maybe<TimeSeries>;
  gasInjWeight: Maybe<TimeSeries>;
  gasLiftAvailability: Maybe<TimeSeries>;
  gasProdCapacity: Maybe<TimeSeries>;
  gasProdWeight: Maybe<TimeSeries>;
  injRateOpt: Maybe<TimeSeries>;
  /** Reference to a time series for 'isOfficial' in this 'SRMOutputs_All_Entities' view. */
  isOfficial: Maybe<TimeSeries>;
  /** Reference to a time series for 'lastUpdatedDate' in this 'SRMOutputs_All_Entities' view. */
  lastUpdatedDate: Maybe<TimeSeries>;
  maxIterations: Maybe<TimeSeries>;
  minProdRateRatio: Maybe<TimeSeries>;
  oilProdCapacity: Maybe<TimeSeries>;
  /** Reference to a time series for 'oilRateQuota' in this 'SRMOutputs_All_Entities' view. */
  oilRateQuota: Maybe<TimeSeries>;
  optimizedCO2InjRateResCondSRM: Maybe<TimeSeries>;
  optimizedCO2InjRateSRM: Maybe<TimeSeries>;
  /** Reference to a time series for 'optimizedGasInjRateGAP' in this 'SRMOutputs_All_Entities' view. */
  optimizedGasInjRateGAP: Maybe<TimeSeries>;
  optimizedGasInjRateGAPRes: Maybe<TimeSeries>;
  optimizedGasInjRateResCondSRM: Maybe<TimeSeries>;
  optimizedGasInjRateSRM: Maybe<TimeSeries>;
  /** Reference to a time series for 'optimizedGasRateGAP' in this 'SRMOutputs_All_Entities' view. */
  optimizedGasRateGAP: Maybe<TimeSeries>;
  optimizedGasRateSRM: Maybe<TimeSeries>;
  /** Reference to a time series for 'optimizedOilRateGAP' in this 'SRMOutputs_All_Entities' view. */
  optimizedOilRateGAP: Maybe<TimeSeries>;
  optimizedOilRateSRM: Maybe<TimeSeries>;
  optimizedProdRateGAPRes: Maybe<TimeSeries>;
  optimizedProdRateResCondSRM: Maybe<TimeSeries>;
  optimizedVRRGAP: Maybe<TimeSeries>;
  optimizedVRRSRM: Maybe<TimeSeries>;
  optimizedWatInjRateGAPRes: Maybe<TimeSeries>;
  /** Reference to a time series for 'optimizedWaterInjRateGAP' in this 'SRMOutputs_All_Entities' view. */
  optimizedWaterInjRateGAP: Maybe<TimeSeries>;
  optimizedWaterInjRateResCondSRM: Maybe<TimeSeries>;
  optimizedWaterInjRateSRM: Maybe<TimeSeries>;
  /** Reference to a time series for 'optimizedWaterRateGAP' in this 'SRMOutputs_All_Entities' view. */
  optimizedWaterRateGAP: Maybe<TimeSeries>;
  optimizedWaterRateSRM: Maybe<TimeSeries>;
  prodRateOpt: Maybe<TimeSeries>;
  /** Reference to a time series for 'scenario' in this 'SRMOutputs_All_Entities' view. */
  scenario: Maybe<TimeSeries>;
  /** Reference to a time series for 'scenaroID' in this 'SRMOutputs_All_Entities' view. */
  scenaroID: Maybe<TimeSeries>;
  /** Reference to a time series for 'vrrTarget' in this 'SRMOutputs_All_Entities' view. */
  vrrTarget: Maybe<TimeSeries>;
  vrrWeight: Maybe<TimeSeries>;
  /** Reference to a time series for 'waterInjCapacity' in this 'SRMOutputs_All_Entities' view. */
  waterInjCapacity: Maybe<TimeSeries>;
  waterInjWeight: Maybe<TimeSeries>;
  waterProdCapacity: Maybe<TimeSeries>;
  waterProdWeight: Maybe<TimeSeries>;
};

/** View 'SRMOutputs_String' in the iPSO production optimization solution data model. */
export type SrmOutputsString = {
  adHocGasInjRateFlag: Maybe<TimeSeries>;
  adHocOilRateFlag: Maybe<TimeSeries>;
  adHocOptimizedAllocInjRateGAPRes: Maybe<TimeSeries>;
  adHocOptimizedGasInjRateGAPRes: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocOptimizedGasInjRateResCond' in this 'SRMOutputs_String' view. */
  adHocOptimizedGasInjRateResCond: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocOptimizedGasInjRateSRM' in this 'SRMOutputs_String' view. */
  adHocOptimizedGasInjRateSRM: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocOptimizedGasRateSRM' in this 'SRMOutputs_String' view. */
  adHocOptimizedGasRateSRM: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocOptimizedInjRateResCond' in this 'SRMOutputs_String' view. */
  adHocOptimizedInjRateResCond: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocOptimizedOilRateSRM' in this 'SRMOutputs_String' view. */
  adHocOptimizedOilRateSRM: Maybe<TimeSeries>;
  adHocOptimizedPE5Flag: Maybe<TimeSeries>;
  adHocOptimizedProdRateGAPRes: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocOptimizedProdRateResCond' in this 'SRMOutputs_String' view. */
  adHocOptimizedProdRateResCond: Maybe<TimeSeries>;
  adHocOptimizedWHP: Maybe<TimeSeries>;
  adHocOptimizedWatInjRateGAPRes: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocOptimizedWaterInjRateResCond' in this 'SRMOutputs_String' view. */
  adHocOptimizedWaterInjRateResCond: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocOptimizedWaterInjRateSRM' in this 'SRMOutputs_String' view. */
  adHocOptimizedWaterInjRateSRM: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocOptimizedWaterRateSRM' in this 'SRMOutputs_String' view. */
  adHocOptimizedWaterRateSRM: Maybe<TimeSeries>;
  adHocWaterInjRateFlag: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocoptimizedBHFPGAP' in this 'SRMOutputs_String' view. */
  adHocoptimizedBHFPGAP: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocoptimizedChokeSizeGAP' in this 'SRMOutputs_String' view. */
  adHocoptimizedChokeSizeGAP: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocoptimizedESPFrequencyGAP' in this 'SRMOutputs_String' view. */
  adHocoptimizedESPFrequencyGAP: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocoptimizedGasInjRateGAP' in this 'SRMOutputs_String' view. */
  adHocoptimizedGasInjRateGAP: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocoptimizedGasLiftRateGAP' in this 'SRMOutputs_String' view. */
  adHocoptimizedGasLiftRateGAP: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocoptimizedGasRateGAP' in this 'SRMOutputs_String' view. */
  adHocoptimizedGasRateGAP: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocoptimizedOilRateGAP' in this 'SRMOutputs_String' view. */
  adHocoptimizedOilRateGAP: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocoptimizedWaterInjRateGAP' in this 'SRMOutputs_String' view. */
  adHocoptimizedWaterInjRateGAP: Maybe<TimeSeries>;
  /** Reference to a time series for 'adHocoptimizedWaterRateGAP' in this 'SRMOutputs_String' view. */
  adHocoptimizedWaterRateGAP: Maybe<TimeSeries>;
  alOpt: Maybe<TimeSeries>;
  allocationFactor: Maybe<TimeSeries>;
  chokeOpt: Maybe<TimeSeries>;
  /** Reference to a time series for 'createdDate' in this 'SRMOutputs_String' view. */
  createdDate: Maybe<TimeSeries>;
  /** Reference to the related 'String_asset' entity for this 'SRMOutputs_String' row. */
  entityName: Maybe<StringAsset>;
  /** Reference to a time series for 'executionBy' in this 'SRMOutputs_String' view. */
  executionBy: Maybe<TimeSeries>;
  /** Reference to a time series for 'executionDate' in this 'SRMOutputs_String' view. */
  executionDate: Maybe<TimeSeries>;
  gasInjRateFlag: Maybe<TimeSeries>;
  hasGapWellName: Maybe<TimeSeries>;
  /** Reference to a time series for 'isOfficial' in this 'SRMOutputs_String' view. */
  isOfficial: Maybe<TimeSeries>;
  /** Reference to a time series for 'lastUpdatedDate' in this 'SRMOutputs_String' view. */
  lastUpdatedDate: Maybe<TimeSeries>;
  maxChokeSize: Maybe<TimeSeries>;
  maxESPFreq: Maybe<TimeSeries>;
  maxGLRate: Maybe<TimeSeries>;
  maxGasInjRate: Maybe<TimeSeries>;
  maxGasRate: Maybe<TimeSeries>;
  maxOilRate: Maybe<TimeSeries>;
  maxWaterInjRate: Maybe<TimeSeries>;
  minChokeSize: Maybe<TimeSeries>;
  minESPFreq: Maybe<TimeSeries>;
  minGLRate: Maybe<TimeSeries>;
  oilRateFlag: Maybe<TimeSeries>;
  /** Reference to a time series for 'optimizeGasRateSRM' in this 'SRMOutputs_String' view. */
  optimizeGasRateSRM: Maybe<TimeSeries>;
  /** Reference to a time series for 'optimizeWaterRateSRM' in this 'SRMOutputs_String' view. */
  optimizeWaterRateSRM: Maybe<TimeSeries>;
  optimizedAllocInjRateGAPRes: Maybe<TimeSeries>;
  /** Reference to a time series for 'optimizedBHFPGAP' in this 'SRMOutputs_String' view. */
  optimizedBHFPGAP: Maybe<TimeSeries>;
  optimizedCO2InjRateResCondSRM: Maybe<TimeSeries>;
  optimizedCO2InjRateSRM: Maybe<TimeSeries>;
  /** Reference to a time series for 'optimizedChokeSizeGAP' in this 'SRMOutputs_String' view. */
  optimizedChokeSizeGAP: Maybe<TimeSeries>;
  /** Reference to a time series for 'optimizedESPFrequencyGAP' in this 'SRMOutputs_String' view. */
  optimizedESPFrequencyGAP: Maybe<TimeSeries>;
  /** Reference to a time series for 'optimizedGasInjRateGAP' in this 'SRMOutputs_String' view. */
  optimizedGasInjRateGAP: Maybe<TimeSeries>;
  optimizedGasInjRateGAPRes: Maybe<TimeSeries>;
  /** Reference to a time series for 'optimizedGasInjRateResCond' in this 'SRMOutputs_String' view. */
  optimizedGasInjRateResCond: Maybe<TimeSeries>;
  /** Reference to a time series for 'optimizedGasInjRateSRM' in this 'SRMOutputs_String' view. */
  optimizedGasInjRateSRM: Maybe<TimeSeries>;
  /** Reference to a time series for 'optimizedGasLiftRateGAP' in this 'SRMOutputs_String' view. */
  optimizedGasLiftRateGAP: Maybe<TimeSeries>;
  /** Reference to a time series for 'optimizedGasRateGAP' in this 'SRMOutputs_String' view. */
  optimizedGasRateGAP: Maybe<TimeSeries>;
  /** Reference to a time series for 'optimizedInjRateResCond' in this 'SRMOutputs_String' view. */
  optimizedInjRateResCond: Maybe<TimeSeries>;
  /** Reference to a time series for 'optimizedOilRateGAP' in this 'SRMOutputs_String' view. */
  optimizedOilRateGAP: Maybe<TimeSeries>;
  /** Reference to a time series for 'optimizedOilRateSRM' in this 'SRMOutputs_String' view. */
  optimizedOilRateSRM: Maybe<TimeSeries>;
  optimizedPE5Flag: Maybe<TimeSeries>;
  optimizedProdRateGAPRes: Maybe<TimeSeries>;
  /** Reference to a time series for 'optimizedProdRateResCond' in this 'SRMOutputs_String' view. */
  optimizedProdRateResCond: Maybe<TimeSeries>;
  /** Reference to a time series for 'optimizedWHP' in this 'SRMOutputs_String' view. */
  optimizedWHP: Maybe<TimeSeries>;
  optimizedWatInjRateGAPRes: Maybe<TimeSeries>;
  /** Reference to a time series for 'optimizedWaterInjRateGAP' in this 'SRMOutputs_String' view. */
  optimizedWaterInjRateGAP: Maybe<TimeSeries>;
  /** Reference to a time series for 'optimizedWaterInjRateResCond' in this 'SRMOutputs_String' view. */
  optimizedWaterInjRateResCond: Maybe<TimeSeries>;
  /** Reference to a time series for 'optimizedWaterInjRateSRM' in this 'SRMOutputs_String' view. */
  optimizedWaterInjRateSRM: Maybe<TimeSeries>;
  /** Reference to a time series for 'optimizedWaterRateGAP' in this 'SRMOutputs_String' view. */
  optimizedWaterRateGAP: Maybe<TimeSeries>;
  /** Reference to a time series for 'scenario' in this 'SRMOutputs_String' view. */
  scenario: Maybe<TimeSeries>;
  /** Reference to a time series for 'scenaroID' in this 'SRMOutputs_String' view. */
  scenaroID: Maybe<TimeSeries>;
  waterInjRateFlag: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellType' in this 'SRMOutputs_String' view. */
  wellType: Maybe<TimeSeries>;
};

/** View 'SRMSettings' in the iPSO production optimization solution data model. */
export type SrmSettings = {
  allocationFactorType: Maybe<TimeSeries>;
  baseRateFactor: Maybe<TimeSeries>;
  chokeCalculation: Maybe<TimeSeries>;
  clusterLevelConstraint: Maybe<TimeSeries>;
  entityName: Maybe<Field>;
  facilityLevelConstraint: Maybe<TimeSeries>;
  fieldLevelConstraint: Maybe<TimeSeries>;
  gasInjectionWeight: Maybe<TimeSeries>;
  gasLiftCapacity: Maybe<TimeSeries>;
  gasProductionWeight: Maybe<TimeSeries>;
  maxIterations: Maybe<TimeSeries>;
  minNumberWellTests: Maybe<TimeSeries>;
  minRatio: Maybe<TimeSeries>;
  optAL: Maybe<TimeSeries>;
  optChoke: Maybe<TimeSeries>;
  overInjectionVRRComplianceThreshold: Maybe<Scalars['Float32']['output']>;
  overInjectionVRRThreshold: Maybe<TimeSeries>;
  rateConstraintOption: Maybe<TimeSeries>;
  rateInjConstraintOption: Maybe<TimeSeries>;
  reservoirLevelConstraint: Maybe<TimeSeries>;
  sectorLevelConstraint: Maybe<TimeSeries>;
  toleranceRate: Maybe<TimeSeries>;
  underInjectionVRRComplianceThreshold: Maybe<Scalars['Float32']['output']>;
  underInjectionVRRThreshold: Maybe<TimeSeries>;
  vrrWeight: Maybe<TimeSeries>;
  waterInjectionWeight: Maybe<TimeSeries>;
  waterProductionWeight: Maybe<TimeSeries>;
};

/** View 'SRM_Scenario_Info' in the iPSO production optimization solution data model. */
export type SrmScenarioInfo = {
  constraintsFileId: Maybe<Scalars['Int64']['output']>;
  constraintsFileIdGI: Maybe<Scalars['Int64']['output']>;
  constraintsFileIdWI: Maybe<Scalars['Int64']['output']>;
  /** Reference to the related 'Field' entity for this 'SRM_Scenario_Info' row. */
  entityName: Maybe<Field>;
  entityType: Maybe<Scalars['String']['output']>;
  executedBy: Maybe<Scalars['String']['output']>;
  executionDate: Maybe<Scalars['Timestamp']['output']>;
  isOfficial: Maybe<Scalars['Boolean']['output']>;
  runStatusGasInjNetwork: Maybe<Scalars['String']['output']>;
  runStatusProdNetwork: Maybe<Scalars['String']['output']>;
  runStatusPublish: Maybe<Scalars['String']['output']>;
  runStatusSRM: Maybe<Scalars['String']['output']>;
  runStatusWatInjNetwork: Maybe<Scalars['String']['output']>;
  scenarioDescription: Maybe<Scalars['String']['output']>;
  scenarioID: Maybe<Scalars['String']['output']>;
  scenarioName: Maybe<Scalars['String']['output']>;
  scenarioType: Maybe<Scalars['String']['output']>;
};

/** View 'Saturation_Pressure_Mapping' in the iPSO production optimization solution data model. */
export type SaturationPressureMapping = {
  /** Text attribute 'asphTable' for this 'Saturation_Pressure_Mapping' row. */
  asphTable: Maybe<Scalars['String']['output']>;
  /** Timestamp 'effectiveDate' associated with this 'Saturation_Pressure_Mapping' row. */
  effectiveDate: Maybe<Scalars['Timestamp']['output']>;
  /** Reference to the related 'String_asset' entity for this 'Saturation_Pressure_Mapping' row. */
  entityName: Maybe<StringAsset>;
  /** Text attribute 'prpFile' for this 'Saturation_Pressure_Mapping' row. */
  prpFile: Maybe<Scalars['String']['output']>;
  /** Text attribute 'pvtFile' for this 'Saturation_Pressure_Mapping' row. */
  pvtFile: Maybe<Scalars['String']['output']>;
  /** Text attribute 'pvtRef' for this 'Saturation_Pressure_Mapping' row. */
  pvtRef: Maybe<Scalars['String']['output']>;
  /** Numeric value 'resTemp' (floating point) for this 'Saturation_Pressure_Mapping' row. */
  resTemp: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'satPress' (floating point) for this 'Saturation_Pressure_Mapping' row. */
  satPress: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'solutionGOR' (floating point) for this 'Saturation_Pressure_Mapping' row. */
  solutionGOR: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'wat' (floating point) for this 'Saturation_Pressure_Mapping' row. */
  wat: Maybe<Scalars['Float32']['output']>;
};

/** View 'Sector' in the iPSO production optimization solution data model. */
export type Sector = {
  /** Timestamp 'endDateTime' associated with this 'Sector' row. */
  endDateTime: Maybe<Scalars['Timestamp']['output']>;
  /** Text attribute 'entityType' for this 'Sector' row. */
  entityType: Maybe<Scalars['String']['output']>;
  /** Text attribute 'name' for this 'Sector' row. */
  name: Maybe<Scalars['String']['output']>;
  /** Timestamp 'startDateTime' associated with this 'Sector' row. */
  startDateTime: Maybe<Scalars['Timestamp']['output']>;
};

/**
 * DENORMALIZED SECTOR LOOKUP TABLE - For sector-based flow allocation and reservoir analysis.
 *
 * STRUCTURE: Each row = one String with its sector/reservoir assignment and allocation factor.
 * Hierarchy: Reservoir â†’ Sector â†’ Well â†’ String
 *
 * WHY USE THIS: Navigate sector relationships and retrieve allocation factors for flow calculations.
 *
 * QUERY PATTERNS:
 * - Find strings in a sector: Filter sector.name = 'X', select string
 * - Find wells in a reservoir: Filter reservoir.name = 'Y', select DISTINCT well
 * - Get allocation factors: Filter by sector or reservoir, select allocationFactor
 *
 * KEY BEHAVIORS:
 * - One row per string means parent entities repeat (use DISTINCT for unique parents)
 * - References return full entity objects - access .name, .externalId, etc.
 * - Use startDateTime/endDateTime for historical sector assignments
 */
export type SectorHierarchy = {
  /** Numeric factor (0-1) used to allocate production volumes from this string to the sector. Used in flow allocation calculations when a string produces from multiple sectors. */
  allocationFactor: Maybe<Scalars['Float32']['output']>;
  /** When this sector assignment ended. NULL = currently active. For current assignments only, filter where endDateTime is null. */
  endDateTime: Maybe<Scalars['Timestamp']['output']>;
  /** Subsurface reservoir formation containing the sector. Filter here to find all sectors, wells, or strings within a specific reservoir. */
  reservoir: Maybe<Reservoir>;
  /** Subdivision of a reservoir used for flow allocation and production management. Multiple wells/strings can belong to the same sector. Filter here to analyze sector-level production. */
  sector: Maybe<Sector>;
  /** When this sector assignment became effective. Used for temporal queries when sector assignments change over time. */
  startDateTime: Maybe<Scalars['Timestamp']['output']>;
  /** Completion/producing interval within the well. Each row represents exactly one string. Use string.name for string identifier. */
  string: Maybe<StringAsset>;
  /** Physical wellbore containing this string. A well may have multiple strings (completions). Use well.name for well identifier. */
  well: Maybe<Well>;
};

/**
 * Reservoir → sector → well → string mapping with per-string allocation
 * factors, scoped to in-scope assets.
 *
 * Lookup table linking each producing string to its sector within a reservoir,
 * together with the flow allocation factor used in sector-based allocation,
 * and the effective date range of the assignment. Complements
 * FlatHierarchy_Agent, which carries the broader production hierarchy.
 *
 * @name SectorHierarchy (Agent Scoped)
 */
export type SectorHierarchyAgent = {
  /** Fractional flow allocation for this string within its sector. */
  allocationFactor: Maybe<Scalars['Float32']['output']>;
  /** Timestamp at which this sector assignment ended. */
  endDateTime: Maybe<Scalars['Timestamp']['output']>;
  /** Subsurface reservoir containing the sector. */
  reservoir: Maybe<Reservoir>;
  /** Subdivision of a reservoir used for flow allocation. */
  sector: Maybe<Sector>;
  /** Timestamp at which this sector assignment became effective. */
  startDateTime: Maybe<Scalars['Timestamp']['output']>;
  /** Completion or producing interval. One row per string. */
  string: Maybe<StringAsset>;
  /** Physical wellbore containing the string. */
  well: Maybe<Well>;
};

/** Aggregated sector-level outputs including counts of active and inactive wells, injection rates and downhole production/injection volumes, as well as voidage replacement ratio (VRR) and pressure compliance metrics for sector surveillance and optimization. */
export type SectorOutputs = {
  /** Reference to a time series for 'downholeGasInjectionVolume' in this 'SectorOutputs' view. */
  downholeGasInjectionVolume: Maybe<TimeSeries>;
  /** Reference to a time series for 'downholeGasProductionVolume' in this 'SectorOutputs' view. */
  downholeGasProductionVolume: Maybe<TimeSeries>;
  /** Reference to a time series for 'downholeOilProductionVolume' in this 'SectorOutputs' view. */
  downholeOilProductionVolume: Maybe<TimeSeries>;
  /** Reference to a time series for 'downholeWaterInjectionVolume' in this 'SectorOutputs' view. */
  downholeWaterInjectionVolume: Maybe<TimeSeries>;
  /** Reference to a time series for 'downholeWaterProductionVolume' in this 'SectorOutputs' view. */
  downholeWaterProductionVolume: Maybe<TimeSeries>;
  /** Name of the sector for which aggregated well status, injection and voidage replacement outputs are reported in this view. */
  entityName: Maybe<Sector>;
  /** Reference to the related 'Field' entity for this 'SectorOutputs' row. */
  field: Maybe<Field>;
  /** Reference to a time series for 'giRate' in this 'SectorOutputs' view. */
  giRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'giTargetRate' in this 'SectorOutputs' view. */
  giTargetRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'giTargetRateCompliance' in this 'SectorOutputs' view. */
  giTargetRateCompliance: Maybe<TimeSeries>;
  /** Reference to a time series for 'mtdVRR' in this 'SectorOutputs' view. */
  mtdVRR: Maybe<TimeSeries>;
  /** Reference to a time series for 'mtdVRRCompliance' in this 'SectorOutputs' view. */
  mtdVRRCompliance: Maybe<TimeSeries>;
  /** Reference to a time series for 'pressureCompliance' in this 'SectorOutputs' view. */
  pressureCompliance: Maybe<TimeSeries>;
  /** Reference to a time series for 'regionPressure' in this 'SectorOutputs' view. */
  regionPressure: Maybe<TimeSeries>;
  /** Reference to the related 'Reservoir' entity for this 'SectorOutputs' row. */
  reservoir: Maybe<Reservoir>;
  /** Reference to a time series for 'vrr' in this 'SectorOutputs' view. */
  vrr: Maybe<TimeSeries>;
  /** Reference to a time series for 'vrrCompliance' in this 'SectorOutputs' view. */
  vrrCompliance: Maybe<TimeSeries>;
  /** Time series of the number of active gas injector wells (GI) within the sector. */
  wellsActiveGi: Maybe<TimeSeries>;
  /** Time series of the number of active producer wells flowing to gas plant (GP) or similar grouping while on natural flow (NF) within the sector. */
  wellsActiveGpNf: Maybe<TimeSeries>;
  /** Time series of the number of active producer wells on ESP lift within the sector. */
  wellsActiveOpEsp: Maybe<TimeSeries>;
  /** Time series of the number of active producer wells on gas lift (GL) within the sector. */
  wellsActiveOpGl: Maybe<TimeSeries>;
  /** Time series of the number of active producer wells on natural flow (NF) within the sector. */
  wellsActiveOpNf: Maybe<TimeSeries>;
  /** Time series of the number of active water injector wells (WI) within the sector. */
  wellsActiveWi: Maybe<TimeSeries>;
  /** Time series of the number of inactive gas injector wells (GI) within the sector. */
  wellsInActiveGi: Maybe<TimeSeries>;
  /** Time series of the number of inactive producer wells flowing to gas plant (GP) or similar grouping while on natural flow (NF) within the sector. */
  wellsInActiveGpNf: Maybe<TimeSeries>;
  /** Time series of the number of inactive producer wells on ESP lift within the sector. */
  wellsInActiveOpEsp: Maybe<TimeSeries>;
  /** Time series of the number of inactive producer wells on gas lift (GL) within the sector. */
  wellsInActiveOpGl: Maybe<TimeSeries>;
  /** Time series of the number of inactive producer wells on natural flow (NF) within the sector. */
  wellsInActiveOpNf: Maybe<TimeSeries>;
  /** Time series of the number of inactive water injector wells (WI) within the sector. */
  wellsInActiveWi: Maybe<TimeSeries>;
  /** Reference to a time series for 'wiRate' in this 'SectorOutputs' view. */
  wiRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'wiTargetRate' in this 'SectorOutputs' view. */
  wiTargetRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'wiTargetRateCompliance' in this 'SectorOutputs' view. */
  wiTargetRateCompliance: Maybe<TimeSeries>;
  /** Reference to a time series for 'ytdVRR' in this 'SectorOutputs' view. */
  ytdVRR: Maybe<TimeSeries>;
  /** Reference to a time series for 'ytdVRRCompliance' in this 'SectorOutputs' view. */
  ytdVRRCompliance: Maybe<TimeSeries>;
};

/** View 'Sector_Prodplan' in the iPSO production optimization solution data model. */
export type SectorProdplan = {
  /** Timestamp 'effectiveDate' associated with this 'Sector_Prodplan' row. */
  effectiveDate: Maybe<Scalars['Timestamp']['output']>;
  /** Reference to the related 'Field' entity for this 'Sector_Prodplan' row. */
  field: Maybe<Field>;
  /** Reference to the related 'Reservoir' entity for this 'Sector_Prodplan' row. */
  reservoir: Maybe<Reservoir>;
  /** Reference to the related 'Sector' entity for this 'Sector_Prodplan' row. */
  sector: Maybe<Sector>;
  /** Timestamp 'submittedMonth' associated with this 'Sector_Prodplan' row. */
  submittedMonth: Maybe<Scalars['Timestamp']['output']>;
  /** Numeric value 'vrrTarget' (floating point) for this 'Sector_Prodplan' row. */
  vrrTarget: Maybe<Scalars['Float32']['output']>;
};

/** View 'Separator' in the iPSO production optimization solution data model. */
export type Separator = {
  /** Timestamp 'endDateTime' associated with this 'Separator' row. */
  endDateTime: Maybe<Scalars['Timestamp']['output']>;
  /** Text attribute 'entityType' for this 'Separator' row. */
  entityType: Maybe<Scalars['String']['output']>;
  /** Text attribute 'name' for this 'Separator' row. */
  name: Maybe<Scalars['String']['output']>;
  /** Timestamp 'startDateTime' associated with this 'Separator' row. */
  startDateTime: Maybe<Scalars['Timestamp']['output']>;
};

/** View 'SeparatorInputs' in the iPSO production optimization solution data model. */
export type SeparatorInputs = {
  /** Reference to the related 'Entity' entity for this 'SeparatorInputs' row. */
  entityName: Maybe<Entity>;
  /** Reference to a time series for 'separatorGasRate' in this 'SeparatorInputs' view. */
  separatorGasRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'separatorOilRate' in this 'SeparatorInputs' view. */
  separatorOilRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'separatorPressure' in this 'SeparatorInputs' view. */
  separatorPressure: Maybe<TimeSeries>;
  separatorRTGasRate: Maybe<TimeSeries>;
  separatorRTOilRate: Maybe<TimeSeries>;
  separatorRTWaterRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'separatorTemperature' in this 'SeparatorInputs' view. */
  separatorTemperature: Maybe<TimeSeries>;
  /** Reference to a time series for 'separatorWaterRate' in this 'SeparatorInputs' view. */
  separatorWaterRate: Maybe<TimeSeries>;
  stage1Pressure: Maybe<TimeSeries>;
  stage1Temperature: Maybe<TimeSeries>;
  stage2Pressure: Maybe<TimeSeries>;
  stage2Temperature: Maybe<TimeSeries>;
  stage3Pressure: Maybe<TimeSeries>;
  stage3Temperature: Maybe<TimeSeries>;
  stage4Pressure: Maybe<TimeSeries>;
  stage4Temperature: Maybe<TimeSeries>;
  stage5Pressure: Maybe<TimeSeries>;
  stage5Temperature: Maybe<TimeSeries>;
  stage6Pressure: Maybe<TimeSeries>;
  stage6Temperature: Maybe<TimeSeries>;
  stage7Pressure: Maybe<TimeSeries>;
  stage7Temperature: Maybe<TimeSeries>;
  stage8Pressure: Maybe<TimeSeries>;
  stage8Temperature: Maybe<TimeSeries>;
  stage9Pressure: Maybe<TimeSeries>;
  stage9Temperature: Maybe<TimeSeries>;
  stage10Pressure: Maybe<TimeSeries>;
  stage10Temperature: Maybe<TimeSeries>;
  trainStatus: Maybe<TimeSeries>;
};

/**
 * Separator-level outputs from WF7 GAP network simulation (WF7).
 *
 * Simulated oil, gas, and water rates, pressures, and temperatures per
 * separator. Use to assess separator efficiency, flag constraint violations,
 * and evaluate the throughput impact of operational changes. Excludes historical
 * performance data and aggregate network metrics.
 *
 * Use for: Network Surveillance (WF7).
 *
 * @name Separator Outputs - Network (Agent)
 */
export type SeparatorOutputsNetworkAgent = {
  /** Separator entity name. */
  entityName: Maybe<Scalars['JSONObject']['output']>;
  /** Reference to parent network model. */
  network: Maybe<Network>;
  /** Condensate-gas ratio at separator (TS). */
  nmvCgr: Maybe<TimeSeries>;
  /** Gas facility max intake utilization (%, TS). */
  nmvGasFMIPercent: Maybe<TimeSeries>;
  /** Gas-liquid ratio at separator (TS). */
  nmvGlr: Maybe<TimeSeries>;
  /** Gas-oil ratio at separator (TS). */
  nmvGor: Maybe<TimeSeries>;
  /** Oil facility max intake utilization (%, TS). */
  nmvOilFMIPercent: Maybe<TimeSeries>;
  /** Separator operating pressure (TS). */
  nmvPressure: Maybe<TimeSeries>;
  /** Measured water rate at separator (TS). */
  nmvSeparatoMeasuredrWaterRate: Maybe<TimeSeries>;
  /** Gas rate at separator (TS). */
  nmvSeparatorGasRate: Maybe<TimeSeries>;
  /** Separator at limiting constraint (0/1, TS). */
  nmvSeparatorLimitingConstraintsFlag: Maybe<TimeSeries>;
  /** Total liquid rate at separator (TS). */
  nmvSeparatorLiquidRate: Maybe<TimeSeries>;
  /** Measured gas rate at separator (TS). */
  nmvSeparatorMeasuredGasRate: Maybe<TimeSeries>;
  /** Measured oil rate at separator (TS). */
  nmvSeparatorMeasuredOilRate: Maybe<TimeSeries>;
  /** Oil rate at separator (TS). */
  nmvSeparatorOilRate: Maybe<TimeSeries>;
  /** Separator operating outside constraints (0/1, TS). */
  nmvSeparatorViolatingConstraintsFlag: Maybe<TimeSeries>;
  /** Water rate at separator (TS). */
  nmvSeparatorWaterRate: Maybe<TimeSeries>;
  /** Separator operating temperature (TS). */
  nmvTemperature: Maybe<TimeSeries>;
  /** Water cut at separator (TS). */
  nmvWaterCut: Maybe<TimeSeries>;
  /** Water facility max intake utilization (%, TS). */
  nmvWaterFMIPercent: Maybe<TimeSeries>;
  /** Water-gas ratio at separator (TS). */
  nmvWgr: Maybe<TimeSeries>;
  /** Reference to separator entity. */
  separatorEntity: Maybe<Entity>;
};

/** View 'StringFluidComposition' in the iPSO production optimization solution data model. */
export type StringFluidComposition = {
  /** Reference to a time series for 'c1' in this 'StringFluidComposition' view. */
  c1: Maybe<TimeSeries>;
  /** Reference to a time series for 'c2' in this 'StringFluidComposition' view. */
  c2: Maybe<TimeSeries>;
  /** Reference to a time series for 'c3' in this 'StringFluidComposition' view. */
  c3: Maybe<TimeSeries>;
  /** Reference to a time series for 'c6' in this 'StringFluidComposition' view. */
  c6: Maybe<TimeSeries>;
  /** Reference to a time series for 'c7c10' in this 'StringFluidComposition' view. */
  c7c10: Maybe<TimeSeries>;
  /** Reference to a time series for 'c7c13' in this 'StringFluidComposition' view. */
  c7c13: Maybe<TimeSeries>;
  /** Reference to a time series for 'c7c14' in this 'StringFluidComposition' view. */
  c7c14: Maybe<TimeSeries>;
  /** Reference to a time series for 'c7c15' in this 'StringFluidComposition' view. */
  c7c15: Maybe<TimeSeries>;
  /** Reference to a time series for 'c7c16' in this 'StringFluidComposition' view. */
  c7c16: Maybe<TimeSeries>;
  /** Reference to a time series for 'c7c18' in this 'StringFluidComposition' view. */
  c7c18: Maybe<TimeSeries>;
  /** Reference to a time series for 'c11c16' in this 'StringFluidComposition' view. */
  c11c16: Maybe<TimeSeries>;
  /** Reference to a time series for 'c14c23' in this 'StringFluidComposition' view. */
  c14c23: Maybe<TimeSeries>;
  /** Reference to a time series for 'c14c28' in this 'StringFluidComposition' view. */
  c14c28: Maybe<TimeSeries>;
  /** Reference to a time series for 'c14plus' in this 'StringFluidComposition' view. */
  c14plus: Maybe<TimeSeries>;
  /** Reference to a time series for 'c15c25' in this 'StringFluidComposition' view. */
  c15c25: Maybe<TimeSeries>;
  /** Reference to a time series for 'c16c25' in this 'StringFluidComposition' view. */
  c16c25: Maybe<TimeSeries>;
  /** Reference to a time series for 'c16c26' in this 'StringFluidComposition' view. */
  c16c26: Maybe<TimeSeries>;
  /** Reference to a time series for 'c17c24' in this 'StringFluidComposition' view. */
  c17c24: Maybe<TimeSeries>;
  /** Reference to a time series for 'c17c25' in this 'StringFluidComposition' view. */
  c17c25: Maybe<TimeSeries>;
  /** Reference to a time series for 'c17c29' in this 'StringFluidComposition' view. */
  c17c29: Maybe<TimeSeries>;
  /** Reference to a time series for 'c17plus' in this 'StringFluidComposition' view. */
  c17plus: Maybe<TimeSeries>;
  /** Reference to a time series for 'c24c73' in this 'StringFluidComposition' view. */
  c24c73: Maybe<TimeSeries>;
  /** Reference to a time series for 'c25c80' in this 'StringFluidComposition' view. */
  c25c80: Maybe<TimeSeries>;
  /** Reference to a time series for 'c25plus' in this 'StringFluidComposition' view. */
  c25plus: Maybe<TimeSeries>;
  /** Reference to a time series for 'c26c80' in this 'StringFluidComposition' view. */
  c26c80: Maybe<TimeSeries>;
  /** Reference to a time series for 'c27c80' in this 'StringFluidComposition' view. */
  c27c80: Maybe<TimeSeries>;
  /** Reference to a time series for 'c28plus' in this 'StringFluidComposition' view. */
  c28plus: Maybe<TimeSeries>;
  /** Reference to a time series for 'c30c18' in this 'StringFluidComposition' view. */
  c30c18: Maybe<TimeSeries>;
  /** Reference to a time series for 'c30c80' in this 'StringFluidComposition' view. */
  c30c80: Maybe<TimeSeries>;
  /** Reference to a time series for 'c74c80' in this 'StringFluidComposition' view. */
  c74c80: Maybe<TimeSeries>;
  /** Reference to a time series for 'c74plus' in this 'StringFluidComposition' view. */
  c74plus: Maybe<TimeSeries>;
  /** Reference to a time series for 'c80plus' in this 'StringFluidComposition' view. */
  c80plus: Maybe<TimeSeries>;
  /** Reference to a time series for 'c81plus' in this 'StringFluidComposition' view. */
  c81plus: Maybe<TimeSeries>;
  /** Reference to a time series for 'cgr' in this 'StringFluidComposition' view. */
  cgr: Maybe<TimeSeries>;
  /** Reference to a time series for 'co2' in this 'StringFluidComposition' view. */
  co2: Maybe<TimeSeries>;
  /** Reference to a time series for 'condensateGravity' in this 'StringFluidComposition' view. */
  condensateGravity: Maybe<TimeSeries>;
  /** Reference to the related 'String_asset' entity for this 'StringFluidComposition' row. */
  entityName: Maybe<StringAsset>;
  /** Reference to a time series for 'fluidType' in this 'StringFluidComposition' view. */
  fluidType: Maybe<TimeSeries>;
  /** Reference to a time series for 'h2s' in this 'StringFluidComposition' view. */
  h2s: Maybe<TimeSeries>;
  /** Reference to a time series for 'iC4' in this 'StringFluidComposition' view. */
  iC4: Maybe<TimeSeries>;
  /** Reference to a time series for 'iC4plusnC4' in this 'StringFluidComposition' view. */
  iC4plusnC4: Maybe<TimeSeries>;
  /** Reference to a time series for 'iC5' in this 'StringFluidComposition' view. */
  iC5: Maybe<TimeSeries>;
  /** Reference to a time series for 'iC5plusnC5' in this 'StringFluidComposition' view. */
  iC5plusnC5: Maybe<TimeSeries>;
  /** Reference to a time series for 'n2' in this 'StringFluidComposition' view. */
  n2: Maybe<TimeSeries>;
  /** Reference to a time series for 'nC4' in this 'StringFluidComposition' view. */
  nC4: Maybe<TimeSeries>;
  /** Reference to a time series for 'nC5' in this 'StringFluidComposition' view. */
  nC5: Maybe<TimeSeries>;
  /** Reference to a time series for 'specificGasGravity' in this 'StringFluidComposition' view. */
  specificGasGravity: Maybe<TimeSeries>;
  /** Reference to a time series for 'waterSalinity' in this 'StringFluidComposition' view. */
  waterSalinity: Maybe<TimeSeries>;
  /** Reference to a time series for 'wgr' in this 'StringFluidComposition' view. */
  wgr: Maybe<TimeSeries>;
};

/**
 * String-level fluid composition including oil, gas, and water fractions.
 *
 * Contains detailed fluid composition data at the string level, including
 * various gas and liquid fractions derived from well tests and production data.
 * Sourced from field measurements and laboratory analyses, enabling the
 * resolution of analytical questions related to fluid behavior, phase
 * interactions, and reservoir performance. It excludes historical production
 * rates or reservoir pressure data, which are available in other views. Use
 * cases: optimizing production strategies, assessing flow assurance challenges,
 * and conducting PVT studies for enhanced oil recovery.
 *
 * @name String Fluid Composition (Agent)
 */
export type StringFluidCompositionAgent = {
  c1: Maybe<TimeSeries>;
  c2: Maybe<TimeSeries>;
  c3: Maybe<TimeSeries>;
  c6: Maybe<TimeSeries>;
  cgr: Maybe<TimeSeries>;
  co2: Maybe<TimeSeries>;
  condensateGravity: Maybe<TimeSeries>;
  fluidType: Maybe<TimeSeries>;
  h2s: Maybe<TimeSeries>;
  iC4: Maybe<TimeSeries>;
  iC5: Maybe<TimeSeries>;
  n2: Maybe<TimeSeries>;
  nC4: Maybe<TimeSeries>;
  nC5: Maybe<TimeSeries>;
  specificGasGravity: Maybe<TimeSeries>;
  waterSalinity: Maybe<TimeSeries>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString: Maybe<StringAsset>;
  wgr: Maybe<TimeSeries>;
};

/** View 'StringInputs_Static' in the iPSO production optimization solution data model. */
export type StringInputsStatic = {
  /** Numeric value 'baseLatMidPerf' (floating point) for this 'StringInputs_Static' row. */
  baseLatMidPerf: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'baseLongMidPerf' (floating point) for this 'StringInputs_Static' row. */
  baseLongMidPerf: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'baseX' (floating point) for this 'StringInputs_Static' row. */
  baseX: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'baseXMidPerf' (floating point) for this 'StringInputs_Static' row. */
  baseXMidPerf: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'baseY' (floating point) for this 'StringInputs_Static' row. */
  baseY: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'baseYMidPerf' (floating point) for this 'StringInputs_Static' row. */
  baseYMidPerf: Maybe<Scalars['Float32']['output']>;
  /** Text attribute 'boreholeShape' for this 'StringInputs_Static' row. */
  boreholeShape: Maybe<Scalars['String']['output']>;
  /** Numeric value 'bottomDepth' (floating point) for this 'StringInputs_Static' row. */
  bottomDepth: Maybe<Scalars['Float32']['output']>;
  /** Text attribute 'crs' for this 'StringInputs_Static' row. */
  crs: Maybe<Scalars['String']['output']>;
  /** Numeric value 'elevation' (floating point) for this 'StringInputs_Static' row. */
  elevation: Maybe<Scalars['Float32']['output']>;
  /** Text attribute 'elevationRef' for this 'StringInputs_Static' row. */
  elevationRef: Maybe<Scalars['String']['output']>;
  /** Timestamp 'endDate' associated with this 'StringInputs_Static' row. */
  endDate: Maybe<Scalars['Timestamp']['output']>;
  /** Reference to the related 'String_asset' entity for this 'StringInputs_Static' row. */
  entityName: Maybe<StringAsset>;
  /** Numeric value 'originalBaseX' (floating point) for this 'StringInputs_Static' row. */
  originalBaseX: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'originalBaseY' (floating point) for this 'StringInputs_Static' row. */
  originalBaseY: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'originalTopX' (floating point) for this 'StringInputs_Static' row. */
  originalTopX: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'originalTopY' (floating point) for this 'StringInputs_Static' row. */
  originalTopY: Maybe<Scalars['Float32']['output']>;
  /** Timestamp 'startDate' associated with this 'StringInputs_Static' row. */
  startDate: Maybe<Scalars['Timestamp']['output']>;
  /** Numeric value 'topDepth' (floating point) for this 'StringInputs_Static' row. */
  topDepth: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'topX' (floating point) for this 'StringInputs_Static' row. */
  topX: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'topY' (floating point) for this 'StringInputs_Static' row. */
  topY: Maybe<Scalars['Float32']['output']>;
  /** Text attribute 'wellbore' for this 'StringInputs_Static' row. */
  wellbore: Maybe<Scalars['String']['output']>;
  /** Text attribute 'wellboreType' for this 'StringInputs_Static' row. */
  wellboreType: Maybe<Scalars['String']['output']>;
};

/**
 * Canonical per-network matched string outputs from the network solution model,
 * keyed by string and network (WF7/WF8/WF20).
 *
 * Uses the nmv* ("network-matched variable") property family: matched oil, gas,
 * water, liquid rates, BHP/FWHP/FBHP pressures, ESP and pump metrics, choke and
 * gas lift parameters, flow-assurance flags (PE5, hydrate, wax, scale,
 * asphaltene, constraint). Includes explicit network reference to disambiguate
 * strings in multiple GAP networks. Use for per-network performance review,
 * cross-network comparison, flow-assurance screening, broad string coverage.
 * For current-state string outputs see NetworkOutputs_String_Agent; for optimization
 * scenario families (systemOptimized*, technical*, hydraulic*, fsopr*, adHoc*)
 * see OptimizedRates_Network_String_Agent.
 *
 * Use for: Network Surveillance (WF7), Network Model Validation (WF8),
 * Flow Assurance Monitoring (WF20). Primary WF8 surface for nmv* matched outputs.
 *
 * @name Network-Matched String Outputs - by Network (Agent)
 */
export type StringOutputsNetworkAgent = {
  network: Maybe<Network>;
  nmvAsphalteneFlag: Maybe<TimeSeries>;
  nmvCgr: Maybe<TimeSeries>;
  nmvChokeSize: Maybe<TimeSeries>;
  nmvConnectedManifoldId: Maybe<TimeSeries>;
  nmvDp: Maybe<TimeSeries>;
  nmvDpChoke: Maybe<TimeSeries>;
  nmvDrawdown: Maybe<TimeSeries>;
  nmvDt: Maybe<TimeSeries>;
  nmvErosionalVelocity: Maybe<TimeSeries>;
  nmvEspMotorLoad: Maybe<TimeSeries>;
  nmvEstimatedFlowlinePressure: Maybe<TimeSeries>;
  nmvFWhTemp: Maybe<TimeSeries>;
  nmvFrequency: Maybe<TimeSeries>;
  nmvGlChp: Maybe<TimeSeries>;
  nmvGlInjectionDepth: Maybe<TimeSeries>;
  nmvGlOrificeDiameter: Maybe<TimeSeries>;
  nmvGlValveCasingPress: Maybe<TimeSeries>;
  nmvGlValveTubingPress: Maybe<TimeSeries>;
  nmvGlr: Maybe<TimeSeries>;
  nmvGlrInjected: Maybe<TimeSeries>;
  nmvGor: Maybe<TimeSeries>;
  nmvHydrateFlag: Maybe<TimeSeries>;
  nmvInjectionGasRate: Maybe<TimeSeries>;
  nmvInjectionWaterRate: Maybe<TimeSeries>;
  nmvMixtureVelocity: Maybe<TimeSeries>;
  nmvMotorCurrent: Maybe<TimeSeries>;
  nmvMotorEfficiency: Maybe<TimeSeries>;
  nmvMotorLoad: Maybe<TimeSeries>;
  nmvMotorPower: Maybe<TimeSeries>;
  nmvMotorRPM: Maybe<TimeSeries>;
  nmvPdown: Maybe<TimeSeries>;
  nmvPe5StabilityFlag: Maybe<TimeSeries>;
  nmvPmiFlpPercent: Maybe<TimeSeries>;
  nmvPmiWhpPercent: Maybe<TimeSeries>;
  nmvPressureMatchIndexFLP: Maybe<TimeSeries>;
  nmvPressureMatchIndexWHP: Maybe<TimeSeries>;
  nmvPumpEfficiency: Maybe<TimeSeries>;
  nmvPumpHead: Maybe<TimeSeries>;
  nmvPumpIntakePress: Maybe<TimeSeries>;
  nmvPumpOutletPress: Maybe<TimeSeries>;
  nmvPumpPower: Maybe<TimeSeries>;
  nmvPumpRate: Maybe<TimeSeries>;
  nmvReservoirPressure: Maybe<TimeSeries>;
  nmvScaleFlag: Maybe<TimeSeries>;
  nmvSurfaceKVA: Maybe<TimeSeries>;
  nmvTDown: Maybe<TimeSeries>;
  nmvTotalGasRate: Maybe<TimeSeries>;
  nmvTotalOilRate: Maybe<TimeSeries>;
  nmvTotalWaterRate: Maybe<TimeSeries>;
  nmvWaterCut: Maybe<TimeSeries>;
  nmvWaxFlag: Maybe<TimeSeries>;
  nmvWellBHP: Maybe<TimeSeries>;
  nmvWellGasRate: Maybe<TimeSeries>;
  nmvWellLiquidRate: Maybe<TimeSeries>;
  nmvWellOilRate: Maybe<TimeSeries>;
  nmvWellSolverDifference: Maybe<TimeSeries>;
  nmvWellSolverDifferenceGasRate: Maybe<TimeSeries>;
  nmvWellSolverDifferenceLiquidRate: Maybe<TimeSeries>;
  nmvWellSolverDifferenceWaterRate: Maybe<TimeSeries>;
  nmvWellSolverEstimatedGasRate: Maybe<TimeSeries>;
  nmvWellSolverEstimatedLiquidRate: Maybe<TimeSeries>;
  nmvWellSolverEstimatedOilRate: Maybe<TimeSeries>;
  nmvWellSolverEstimatedWaterRate: Maybe<TimeSeries>;
  nmvWellSolverFBHP: Maybe<TimeSeries>;
  nmvWellSolverFWHT: Maybe<TimeSeries>;
  nmvWellSolverGor: Maybe<TimeSeries>;
  nmvWellSolverMeasuredGasRate: Maybe<TimeSeries>;
  nmvWellSolverMeasuredLiquidRate: Maybe<TimeSeries>;
  nmvWellSolverMeasuredOilRate: Maybe<TimeSeries>;
  nmvWellSolverMeasuredWaterRate: Maybe<TimeSeries>;
  nmvWellSolverWHP: Maybe<TimeSeries>;
  nmvWellSolverWaterCut: Maybe<TimeSeries>;
  nmvWellViolatingConstraintsFlag: Maybe<TimeSeries>;
  nmvWellWaterRate: Maybe<TimeSeries>;
  nmvWgr: Maybe<TimeSeries>;
  nmvWhp: Maybe<TimeSeries>;
  nmvWht: Maybe<TimeSeries>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString: Maybe<StringAsset>;
};

/** View 'String_Function' in the iPSO production optimization solution data model. */
export type StringFunction = {
  /** Timestamp 'endDate' associated with this 'String_Function' row. */
  endDate: Maybe<Scalars['Timestamp']['output']>;
  /** Text attribute 'fieldCode' for this 'String_Function' row. */
  fieldCode: Maybe<Scalars['String']['output']>;
  /** Text attribute 'primaryWellbore' for this 'String_Function' row. */
  primaryWellbore: Maybe<Scalars['String']['output']>;
  /** Timestamp 'startDate' associated with this 'String_Function' row. */
  startDate: Maybe<Scalars['Timestamp']['output']>;
  /** Text attribute 'string' for this 'String_Function' row. */
  string: Maybe<Scalars['String']['output']>;
  /** Text attribute 'stringCode' for this 'String_Function' row. */
  stringCode: Maybe<Scalars['String']['output']>;
  /** Text attribute 'stringFunction' for this 'String_Function' row. */
  stringFunction: Maybe<Scalars['String']['output']>;
  /** Text attribute 'well' for this 'String_Function' row. */
  well: Maybe<Scalars['String']['output']>;
};

export type StringReservoirInputs = {
  entityName: Maybe<StringAsset>;
  fieldName: Maybe<Field>;
  reservoirName: Maybe<Reservoir>;
  stringReservoirInjectionAllocationFactor: Maybe<TimeSeries>;
  stringReservoirProductionAllocationFactor: Maybe<TimeSeries>;
};

/** Typed view over 'Entity' showing well strings (completions) only (where 'entityType' = 'string'). Use this view together with 'FlatHierarchy' or 'SectorHierarchy' to navigate from wells, fields, reservoirs or sectors down to individual strings. */
export type StringAsset = {
  /** Timestamp 'endDateTime' associated with this 'String_asset' row. */
  endDateTime: Maybe<Scalars['Timestamp']['output']>;
  /** Text attribute 'entityType' for this 'String_asset' row. */
  entityType: Maybe<Scalars['String']['output']>;
  /** String name */
  name: Maybe<Scalars['String']['output']>;
  /** Timestamp 'startDateTime' associated with this 'String_asset' row. */
  startDateTime: Maybe<Scalars['Timestamp']['output']>;
};

/**
 * Well surveillance alarms with medium or high priority.
 *
 * Contains well surveillance alarms that are classified as medium or high
 * priority, sourced from real-time monitoring systems and well status workflows.
 * Use for frequency and types of alarms, wells affected, duration. Excludes low-priority or historical alarms.
 *
 * Use for: Real-Time Surveillance (WF18), Well Status (WF25).
 *
 * @name Well Surveillance Alarms (Agent)
 */
export type SurveillanceAlarmsAgent = {
  alarmCategory: Maybe<Scalars['String']['output']>;
  alarmCode: Maybe<Scalars['JSONObject']['output']>;
  alarmCodeExternalId: Maybe<Scalars['String']['output']>;
  alarmCriticality: Maybe<Scalars['String']['output']>;
  alarmFlags: Maybe<Scalars['String']['output']>;
  alarmName: Maybe<Scalars['String']['output']>;
  alarmPriority: Maybe<Scalars['String']['output']>;
  customWorkflowAlarmMessage: Maybe<Scalars['String']['output']>;
  endDateTime: Maybe<Scalars['Timestamp']['output']>;
  entityExternalId: Scalars['String']['output'];
  entityName: Scalars['String']['output'];
  entityType: Scalars['String']['output'];
  startDateTime: Scalars['Timestamp']['output'];
  subCategory: Maybe<Scalars['String']['output']>;
  subWorkflowName: Maybe<Scalars['String']['output']>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString: Maybe<StringAsset>;
  workflowCode: Maybe<Scalars['String']['output']>;
  workflowName: Maybe<Scalars['String']['output']>;
};

/**
 * Troubleshooting ticket management for tracking open, closed, and assigned
 * operations tickets.
 *
 * Contains detailed records of troubleshooting tickets, including their
 * lifecycle stages, statuses, and associated metadata such as priority and
 * assignment. Sourced from operational ticketing systems, used to analyze ticket
 * trends, assess workload distribution, and identify areas requiring immediate
 * attention. Typical analytical questions include tracking the status of tickets
 * by category, evaluating response times, and determining the volume of tickets
 * related to specific entities or opportunities. Excludes financial metrics or
 * performance indicators related to ticket resolution (see operational
 * efficiency).
 */
export type TicketRegistryAgent = {
  /** Detailed action plan with steps to remediate the issue. */
  actionPlan: Maybe<Scalars['String']['output']>;
  /** Person or team assigned to resolve the ticket. */
  assignedTo: Maybe<Scalars['String']['output']>;
  /** Date/time when ticket was closed. Use for closed ticket analysis. */
  closedDate: Maybe<Scalars['Timestamp']['output']>;
  /** Full description of the issue, including context and observations. */
  description: Maybe<Scalars['String']['output']>;
  /** Target date for ticket resolution. Use to find overdue tickets. */
  dueDate: Maybe<Scalars['Timestamp']['output']>;
  /**
   * Name of the well, string, or field the ticket is associated with.
   * Primary filter for "show tickets for well X" queries.
   */
  entityName: Maybe<Scalars['String']['output']>;
  /**
   * Type of entity the ticket relates to: WELL, STRING, FIELD, RESERVOIR.
   * Use to filter tickets by entity scope.
   */
  entityType: Maybe<Scalars['String']['output']>;
  /**
   * Flag indicating if ticket represents a production optimization opportunity.
   * 'true' = opportunity for gain, 'false' = issue/problem.
   */
  isOpportunity: Maybe<Scalars['String']['output']>;
  /**
   * Ticket priority level: LOW, MEDIUM, HIGH, URGENT.
   * Use to filter critical issues that need immediate attention.
   */
  priority: Scalars['String']['output'];
  /** Recommended action or investigation steps to resolve the issue. */
  recommendation: Maybe<Scalars['String']['output']>;
  /** Date/time when the ticket was created or reported. Use for age-based queries. */
  reportedDate: Scalars['Timestamp']['output'];
  /**
   * Current ticket status: OPEN, IN_PROGRESS, CLOSED, CANCELLED.
   * Use to filter active vs completed tickets.
   */
  status: Scalars['String']['output'];
  /**
   * Category classification (e.g., WELL_ISSUE, ESP_FAILURE, OPTIMIZATION).
   * Use to filter tickets by problem type.
   */
  ticketCategory: Maybe<Scalars['String']['output']>;
  /** Unique ticket identifier. Primary key for joining to TicketHistory or SubTasks. */
  ticketId: Scalars['String']['output'];
  /**
   * Origin of the ticket (e.g., ALARM, MANUAL, SURVEILLANCE, WORKFLOW).
   * Indicates how the ticket was created.
   */
  ticketSource: Maybe<Scalars['String']['output']>;
  /** Brief summary of the issue or action item. Use for quick scanning of tickets. */
  ticketSummary: Scalars['String']['output'];
};

export type TimeSeries = {
  externalId: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['Int32']['output']>;
};

/** View 'VRR_Formation_Volume_Factor' in the iPSO production optimization solution data model. */
export type VrrFormationVolumeFactor = {
  /** Numeric value 'bCO2' (floating point) for this 'VRR_Formation_Volume_Factor' row. */
  bCO2: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'bGas' (floating point) for this 'VRR_Formation_Volume_Factor' row. */
  bGas: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'bGasInjector' (floating point) for this 'VRR_Formation_Volume_Factor' row. */
  bGasInjector: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'bOil' (floating point) for this 'VRR_Formation_Volume_Factor' row. */
  bOil: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'bWater' (floating point) for this 'VRR_Formation_Volume_Factor' row. */
  bWater: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'bWaterInjector' (floating point) for this 'VRR_Formation_Volume_Factor' row. */
  bWaterInjector: Maybe<Scalars['Float32']['output']>;
  /** Timestamp 'effectiveDate' associated with this 'VRR_Formation_Volume_Factor' row. */
  effectiveDate: Maybe<Scalars['Timestamp']['output']>;
  /** Reference to the related 'Entity' entity for this 'VRR_Formation_Volume_Factor' row. */
  entityName: Maybe<Entity>;
  /** Numeric value 'pb' (floating point) for this 'VRR_Formation_Volume_Factor' row. */
  pb: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'rs' (floating point) for this 'VRR_Formation_Volume_Factor' row. */
  rs: Maybe<Scalars['Float32']['output']>;
};

/** View 'VRR_Monitoring' in the iPSO production optimization solution data model. */
export type VrrMonitoring = {
  /** Reference to a time series for 'allocGas' in this 'VRR_Monitoring' row. */
  allocGas: Maybe<TimeSeries>;
  /** Reference to a time series for 'allocGasInj' in this 'VRR_Monitoring' row. */
  allocGasInj: Maybe<TimeSeries>;
  /** Reference to a time series for 'allocOil' in this 'VRR_Monitoring' row. */
  allocOil: Maybe<TimeSeries>;
  /** Reference to a time series for 'allocWater' in this 'VRR_Monitoring' row. */
  allocWater: Maybe<TimeSeries>;
  /** Reference to a time series for 'allocWaterInj' in this 'VRR_Monitoring' row. */
  allocWaterInj: Maybe<TimeSeries>;
  /** Reference to the related 'String_asset' entity for this 'VRR_Monitoring' row. */
  entityName: Maybe<StringAsset>;
  /** Reference to the related 'Reservoir' entity for this 'VRR_Monitoring' row. */
  reservoir: Maybe<Reservoir>;
  /** Reference to the related 'Sector' entity for this 'VRR_Monitoring' row. */
  sector: Maybe<Sector>;
  /** Reference to a time series for 'secvGas' in this 'VRR_Monitoring' row. */
  secvGas: Maybe<TimeSeries>;
  /** Reference to a time series for 'secvGasInj' in this 'VRR_Monitoring' row. */
  secvGasInj: Maybe<TimeSeries>;
  /** Reference to a time series for 'secvOil' in this 'VRR_Monitoring' row. */
  secvOil: Maybe<TimeSeries>;
  /** Reference to a time series for 'secvWater' in this 'VRR_Monitoring' row. */
  secvWater: Maybe<TimeSeries>;
  /** Reference to a time series for 'secvWaterInj' in this 'VRR_Monitoring' row. */
  secvWaterInj: Maybe<TimeSeries>;
};

/**
 * DENORMALIZED SECTOR LOOKUP TABLE - For sector-based flow allocation and reservoir analysis.
 *
 * STRUCTURE: Each row = one String with its sector/reservoir assignment and allocation factor.
 * Hierarchy: Reservoir â†’ Sector â†’ Well â†’ String
 *
 * WHY USE THIS: Navigate sector relationships and retrieve allocation factors for flow calculations.
 *
 * QUERY PATTERNS:
 * - Find strings in a sector: Filter sector.name = 'X', select string
 * - Find wells in a reservoir: Filter reservoir.name = 'Y', select DISTINCT well
 * - Get allocation factors: Filter by sector or reservoir, select allocationFactor
 *
 * KEY BEHAVIORS:
 * - One row per string means parent entities repeat (use DISTINCT for unique parents)
 * - References return full entity objects - access .name, .externalId, etc.
 * - Use startDateTime/endDateTime for historical sector assignments
 */
export type VrrSectorHierarchy = {
  /** Numeric factor (0-1) used to allocate production volumes from this string to the sector. Used in flow allocation calculations when a string produces from multiple sectors. */
  allocationFactor: Maybe<Scalars['Float32']['output']>;
  /** When this sector assignment ended. NULL = currently active. For current assignments only, filter where endDateTime is null. */
  endDateTime: Maybe<Scalars['Timestamp']['output']>;
  /** Subsurface reservoir formation containing the sector. Filter here to find all sectors, wells, or strings within a specific reservoir. */
  reservoir: Maybe<Scalars['String']['output']>;
  /** Subdivision of a reservoir used for flow allocation and production management. Multiple wells/strings can belong to the same sector. Filter here to analyze sector-level production. */
  sector: Maybe<Scalars['String']['output']>;
  /** When this sector assignment became effective. Used for temporal queries when sector assignments change over time. */
  startDateTime: Maybe<Scalars['Timestamp']['output']>;
  /** Completion/producing interval within the well. Each row represents exactly one string. Use string.name for string identifier. */
  string: Maybe<Scalars['String']['output']>;
  /** Physical wellbore containing this string. A well may have multiple strings (completions). Use well.name for well identifier. */
  well: Maybe<Scalars['String']['output']>;
};

/**
 * Value realization tracking with production gain and cost saving records per
 * opportunity.
 *
 * Contains comprehensive data on value realization associated with production
 * gains and cost savings in USD or barrel oil equivalent, derived from various
 * optimization opportunities. Sourced from well performance metrics, ticketing
 * systems, and optimization records, allowing it to answer analytical questions
 * regarding the effectiveness of specific interventions and their financial
 * impacts. It excludes raw production data or detailed operational metrics that
 * may be found in other views focused on real-time production tracking. Use
 * cases: performance assessment of optimization strategies, financial
 * forecasting, and operational efficiency analysis.
 *
 * @name Value Tracking (Agent)
 */
export type ValueTrackingAgent = {
  controlParameter: Maybe<Scalars['String']['output']>;
  controlParameterPostOptimizedValue: Maybe<Scalars['Float']['output']>;
  controlParameterScenarioName: Maybe<Scalars['String']['output']>;
  endDate: Maybe<Scalars['Timestamp']['output']>;
  estimatedGasRate: Maybe<Scalars['Float']['output']>;
  estimatedOilRate: Maybe<Scalars['Float']['output']>;
  estimatedTargetGasGain: Maybe<Scalars['Float']['output']>;
  estimatedTargetOilGain: Maybe<Scalars['Float']['output']>;
  estimatedTargetTotalGain: Maybe<Scalars['Float']['output']>;
  oilPrice: Maybe<Scalars['Float']['output']>;
  realizedCumGasVolumeGain: Maybe<TimeSeries>;
  realizedCumGasVolumeGainBOE: Maybe<TimeSeries>;
  realizedCumOilVolumeGain: Maybe<TimeSeries>;
  realizedDollarCumValueGain: Maybe<TimeSeries>;
  realizedDollarValueGain: Maybe<TimeSeries>;
  realizedGasPerformance: Maybe<TimeSeries>;
  realizedGasRateGain: Maybe<TimeSeries>;
  realizedGasVolumeGain: Maybe<TimeSeries>;
  realizedOilPerformance: Maybe<TimeSeries>;
  realizedOilRateGain: Maybe<TimeSeries>;
  realizedOilVolumeGain: Maybe<TimeSeries>;
  realizedTotalCumVolumeGainBOE: Maybe<TimeSeries>;
  realizedTotalVolumeGainBOE: Maybe<TimeSeries>;
  realizedWaterPerformance: Maybe<TimeSeries>;
  realizedWaterRateGain: Maybe<TimeSeries>;
  source: Maybe<Scalars['String']['output']>;
  startDate: Maybe<Scalars['Timestamp']['output']>;
  status: Maybe<Scalars['String']['output']>;
  wellName: Maybe<Scalars['String']['output']>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString: Maybe<StringAsset>;
  wellUptimeHours: Maybe<TimeSeries>;
};

/** Field-level outputs from the WF05 workflow, summarizing virtual flow meter (VFM) estimates, actual daily production, allocation errors and allocation factors for oil, gas and water across all wells in the field. */
export type Wf05FieldOutputs = {
  agProductionAllocationStatus: Maybe<TimeSeries>;
  calculatedTotalGasLiftInjRate: Maybe<TimeSeries>;
  dailyActualGasInjection: Maybe<TimeSeries>;
  /** Time series of daily actual oil production for the field in the WF05 field-level workflow output. */
  dailyActualOilProduction: Maybe<TimeSeries>;
  dailyActualWaterInjection: Maybe<TimeSeries>;
  /** Time series of daily actual water production for the field in the WF05 field-level workflow output. */
  dailyActualWaterProduction: Maybe<TimeSeries>;
  /** Time series of daily associated gas production for the field in the WF05 field-level workflow output. */
  dailyAssociatedGasProduction: Maybe<TimeSeries>;
  /** Time series of daily non-associated gas production for the field in the WF05 field-level workflow output. */
  dailyNonAssociatedGasProduction: Maybe<TimeSeries>;
  /** Name of the field for which WF05 workflow outputs (VFM estimates, allocation errors and allocation factors) are reported in this view. */
  entityName: Maybe<Field>;
  /** Time series of execution type for the field in the WF05 field-level workflow output. */
  executionType: Maybe<TimeSeries>;
  expansionFactorGasPtsRef: Maybe<TimeSeries>;
  /** Time series of field allocation volume source for the field in the WF05 field-level workflow output. */
  fieldAllocationVolumeSource: Maybe<TimeSeries>;
  fieldAssociatedGasVolumePtsRef: Maybe<TimeSeries>;
  fieldInjectionAllocationVolumeSource: Maybe<TimeSeries>;
  fieldNonAssociatedGasVolumePtsRef: Maybe<TimeSeries>;
  fieldOilVolumePtsRef: Maybe<TimeSeries>;
  fieldWaterVolumePtsRef: Maybe<TimeSeries>;
  formationGOR: Maybe<TimeSeries>;
  fvfWaterPtsRef: Maybe<TimeSeries>;
  gasInjectioAllocationStatus: Maybe<TimeSeries>;
  gasInjectionAllocationFactor: Maybe<TimeSeries>;
  gasProductionAllocationStatus: Maybe<TimeSeries>;
  /** Time series of injection wfexecution type for the field in the WF05 field-level workflow output. */
  injectionWFExecutionType: Maybe<TimeSeries>;
  nagProductionAllocationStatus: Maybe<TimeSeries>;
  nmvMeasuredTotalGasLiftInjRate: Maybe<TimeSeries>;
  oilProductionAllocationStatus: Maybe<TimeSeries>;
  /** Time series of preferred vfmassociated gas allocation factor for the field in the WF05 field-level workflow output. */
  preferredVFMAssociatedGasAllocationFactor: Maybe<TimeSeries>;
  /** Time series of preferred vfmnon-associated gas allocation factor for the field in the WF05 field-level workflow output. */
  preferredVFMNonAssociatedGasAllocationFactor: Maybe<TimeSeries>;
  /** Time series of preferred vfmoil allocation factor for the field in the WF05 field-level workflow output. */
  preferredVFMOilAllocationFactor: Maybe<TimeSeries>;
  /** Time series of preferred vfmrelative field associated gas volume error for the field in the WF05 field-level workflow output. */
  preferredVFMRelativeFieldAssociatedGasVolumeError: Maybe<TimeSeries>;
  /** Time series of preferred vfmrelative field non-associated gas volume error for the field in the WF05 field-level workflow output. */
  preferredVFMRelativeFieldNonAssociatedGasVolumeError: Maybe<TimeSeries>;
  /** Time series of preferred vfmrelative field oil volume error for the field in the WF05 field-level workflow output. */
  preferredVFMRelativeFieldOilVolumeError: Maybe<TimeSeries>;
  /** Time series of preferred vfmrelative field water volume error for the field in the WF05 field-level workflow output. */
  preferredVFMRelativeFieldWaterVolumeError: Maybe<TimeSeries>;
  /** Time series of preferred vfmtotal wells estimated associated gas volume for the field in the WF05 field-level workflow output. */
  preferredVFMTotalWellsEstimatedAssociatedGasVolume: Maybe<TimeSeries>;
  /** Time series of preferred vfmtotal wells estimated non-associated gas volume for the field in the WF05 field-level workflow output. */
  preferredVFMTotalWellsEstimatedNonAssociatedGasVolume: Maybe<TimeSeries>;
  /** Time series of preferred vfmtotal wells estimated oil volume for the field in the WF05 field-level workflow output. */
  preferredVFMTotalWellsEstimatedOilVolume: Maybe<TimeSeries>;
  /** Time series of preferred vfmtotal wells estimated water volume for the field in the WF05 field-level workflow output. */
  preferredVFMTotalWellsEstimatedWaterVolume: Maybe<TimeSeries>;
  /** Time series of preferred vfmwater allocation factor for the field in the WF05 field-level workflow output. */
  preferredVFMWaterAllocationFactor: Maybe<TimeSeries>;
  prpFileId: Maybe<TimeSeries>;
  relativeFieldGasVolumeError: Maybe<TimeSeries>;
  relativeFieldWaterVolumeError: Maybe<TimeSeries>;
  reservoirTemperature: Maybe<TimeSeries>;
  shrinkageFactorGasPtsRef: Maybe<TimeSeries>;
  shrinkageFactorOilPtsRef: Maybe<TimeSeries>;
  specificGasGravity: Maybe<TimeSeries>;
  specificOilGravity: Maybe<TimeSeries>;
  surfaceGasVolumePtsRef: Maybe<TimeSeries>;
  surfaceGasVolumeRealTime: Maybe<TimeSeries>;
  surfaceOilVolumePtsRef: Maybe<TimeSeries>;
  surfaceOilVolumeRealTime: Maybe<TimeSeries>;
  /** Time series of total wells gas injection volume for the field in the WF05 field-level workflow output. */
  totalWellsGasInjectionVolume: Maybe<TimeSeries>;
  /** Time series of total wells water injection volume for the field in the WF05 field-level workflow output. */
  totalWellsWaterInjectionVolume: Maybe<TimeSeries>;
  waterInjectionAllocationFactor: Maybe<TimeSeries>;
  waterInjectionAllocationStatus: Maybe<TimeSeries>;
  waterProductionAllocationStatus: Maybe<TimeSeries>;
  waterSalinity: Maybe<TimeSeries>;
  /** Time series of weighted average vfmassociated gas allocation factor for the field in the WF05 field-level workflow output. */
  weightedAverageVFMAssociatedGasAllocationFactor: Maybe<TimeSeries>;
  /** Time series of weighted average vfmnon-associated gas allocation factor for the field in the WF05 field-level workflow output. */
  weightedAverageVFMNonAssociatedGasAllocationFactor: Maybe<TimeSeries>;
  /** Time series of weighted average vfmoil allocation factor for the field in the WF05 field-level workflow output. */
  weightedAverageVFMOilAllocationFactor: Maybe<TimeSeries>;
  /** Time series of weighted average vfmrelative field associated gas volume error for the field in the WF05 field-level workflow output. */
  weightedAverageVFMRelativeFieldAssociatedGasVolumeError: Maybe<TimeSeries>;
  /** Time series of weighted average vfmrelative field non-associated gas volume error for the field in the WF05 field-level workflow output. */
  weightedAverageVFMRelativeFieldNonAssociatedGasVolumeError: Maybe<TimeSeries>;
  /** Time series of weighted average vfmrelative field oil volume error for the field in the WF05 field-level workflow output. */
  weightedAverageVFMRelativeFieldOilVolumeError: Maybe<TimeSeries>;
  /** Time series of weighted average vfmrelative field water volume error for the field in the WF05 field-level workflow output. */
  weightedAverageVFMRelativeFieldWaterVolumeError: Maybe<TimeSeries>;
  /** Time series of weighted average vfmtotal wells estimated associated gas volume for the field in the WF05 field-level workflow output. */
  weightedAverageVFMTotalWellsEstimatedAssociatedGasVolume: Maybe<TimeSeries>;
  /** Time series of weighted average vfmtotal wells estimated non-associated gas volume for the field in the WF05 field-level workflow output. */
  weightedAverageVFMTotalWellsEstimatedNonAssociatedGasVolume: Maybe<TimeSeries>;
  /** Time series of weighted average vfmtotal wells estimated oil volume for the field in the WF05 field-level workflow output. */
  weightedAverageVFMTotalWellsEstimatedOilVolume: Maybe<TimeSeries>;
  /** Time series of weighted average vfmtotal wells estimated water volume for the field in the WF05 field-level workflow output. */
  weightedAverageVFMTotalWellsEstimatedWaterVolume: Maybe<TimeSeries>;
  /** Time series of weighted average vfmwater allocation factor for the field in the WF05 field-level workflow output. */
  weightedAverageVFMWaterAllocationFactor: Maybe<TimeSeries>;
};

/** String level outputs from the WF05 workflow, providing virtual flow meter (VFM) based oil, gas and water rates, estimated well volumes, method-specific VFM rates and diagnostics used for allocation and well performance evaluation. */
export type Wf05StringOutputs = {
  agProductionAllocationStatus: Maybe<TimeSeries>;
  allocatedWellInjectionGasRate: Maybe<TimeSeries>;
  allocatedWellInjectionGasVolume: Maybe<TimeSeries>;
  allocatedWellInjectionWaterRate: Maybe<TimeSeries>;
  allocatedWellInjectionWaterVolume: Maybe<TimeSeries>;
  /** Time series of average gas injection rate for this well string in the WF05 string-level workflow output. */
  averageGasInjectionRate: Maybe<TimeSeries>;
  /** Time series of average water injection rate for this well string in the WF05 string-level workflow output. */
  averageWaterInjectionRate: Maybe<TimeSeries>;
  chokeAnalysisWeightFactor: Maybe<TimeSeries>;
  dataDrivenAnalysisWeightFactor: Maybe<TimeSeries>;
  /** Name of the well string (completion) for which WF05 workflow VFM-based rates, volumes and diagnostics are reported in this view. */
  entityName: Maybe<StringAsset>;
  espAnalysisWeightFactor: Maybe<TimeSeries>;
  /** Time series of execution type for this well string in the WF05 string-level workflow output. */
  executionType: Maybe<TimeSeries>;
  gasInjectioAllocationStatus: Maybe<TimeSeries>;
  gasProductionAllocationStatus: Maybe<TimeSeries>;
  /** Time series of injection rate data source flag for this well string in the WF05 string-level workflow output. */
  injectionRateDataSourceFlag: Maybe<TimeSeries>;
  iprAnalysisWeightFactor: Maybe<TimeSeries>;
  isWag: Maybe<TimeSeries>;
  nagProductionAllocationStatus: Maybe<TimeSeries>;
  /** Time series of normalized weight factor choke for this well string in the WF05 string-level workflow output. */
  normalizedWeightFactorChoke: Maybe<TimeSeries>;
  /** Time series of normalized weight factor data driven for this well string in the WF05 string-level workflow output. */
  normalizedWeightFactorDataDriven: Maybe<TimeSeries>;
  /** Time series of normalized weight factor electric submersible pump (ESP) for this well string in the WF05 string-level workflow output. */
  normalizedWeightFactorESP: Maybe<TimeSeries>;
  /** Time series of normalized weight factor inflow performance relationship (IPR) for this well string in the WF05 string-level workflow output. */
  normalizedWeightFactorIPR: Maybe<TimeSeries>;
  /** Time series of normalized weight factor system analysis for this well string in the WF05 string-level workflow output. */
  normalizedWeightFactorSystemAnalysis: Maybe<TimeSeries>;
  /** Time series of normalized weight factor vertical lift performance (VLP) for this well string in the WF05 string-level workflow output. */
  normalizedWeightFactorVLP: Maybe<TimeSeries>;
  oilProductionAllocationStatus: Maybe<TimeSeries>;
  /** Time series of preferred vfmallocated well associated gas volume for this well string in the WF05 string-level workflow output. */
  preferredVFMAllocatedWellAssociatedGasVolume: Maybe<TimeSeries>;
  /** Time series of preferred vfmallocated well non-associated gas volume for this well string in the WF05 string-level workflow output. */
  preferredVFMAllocatedWellNonAssociatedGasVolume: Maybe<TimeSeries>;
  /** Time series of preferred vfmallocated well oil volume for this well string in the WF05 string-level workflow output. */
  preferredVFMAllocatedWellOilVolume: Maybe<TimeSeries>;
  /** Time series of preferred vfmallocated well water volume for this well string in the WF05 string-level workflow output. */
  preferredVFMAllocatedWellWaterVolume: Maybe<TimeSeries>;
  /** Time series of preferred vfmaverage associated gas rate for this well string in the WF05 string-level workflow output. */
  preferredVFMAverageAssociatedGasRate: Maybe<TimeSeries>;
  /** Time series of preferred vfmaverage non-associated gas rate for this well string in the WF05 string-level workflow output. */
  preferredVFMAverageNonAssociatedGasRate: Maybe<TimeSeries>;
  /** Time series of preferred vfmaverage oil rate for this well string in the WF05 string-level workflow output. */
  preferredVFMAverageOilRate: Maybe<TimeSeries>;
  /** Time series of preferred vfmaverage water rate for this well string in the WF05 string-level workflow output. */
  preferredVFMAverageWaterRate: Maybe<TimeSeries>;
  /** Time series of preferred vfmdata source flag for this well string in the WF05 string-level workflow output. */
  preferredVFMDataSourceFlag: Maybe<TimeSeries>;
  /** Time series of preferred vfmestimated well associated gas volume for this well string in the WF05 string-level workflow output. */
  preferredVFMEstimatedWellAssociatedGasVolume: Maybe<TimeSeries>;
  /** Time series of preferred vfmestimated well non-associated gas volume for this well string in the WF05 string-level workflow output. */
  preferredVFMEstimatedWellNonAssociatedGasVolume: Maybe<TimeSeries>;
  /** Time series of preferred vfmestimated well oil volume for this well string in the WF05 string-level workflow output. */
  preferredVFMEstimatedWellOilVolume: Maybe<TimeSeries>;
  /** Time series of preferred vfmestimated well water volume for this well string in the WF05 string-level workflow output. */
  preferredVFMEstimatedWellWaterVolume: Maybe<TimeSeries>;
  systemAnalysisWeightFactor: Maybe<TimeSeries>;
  /** Time series of virtual flow meter (VFM) choke average associated gas rate for this well string in the WF05 string-level workflow output. */
  vfmChokeAverageAssociatedGasRate: Maybe<TimeSeries>;
  /** Time series of virtual flow meter (VFM) choke average non-associated gas rate for this well string in the WF05 string-level workflow output. */
  vfmChokeAverageNonAssociatedGasRate: Maybe<TimeSeries>;
  /** Time series of virtual flow meter (VFM) choke average oil rate for this well string in the WF05 string-level workflow output. */
  vfmChokeAverageOilRate: Maybe<TimeSeries>;
  /** Time series of virtual flow meter (VFM) choke average water rate for this well string in the WF05 string-level workflow output. */
  vfmChokeAverageWaterRate: Maybe<TimeSeries>;
  /** Time series of virtual flow meter (VFM) data driven average associated gas rate for this well string in the WF05 string-level workflow output. */
  vfmDataDrivenAverageAssociatedGasRate: Maybe<TimeSeries>;
  /** Time series of virtual flow meter (VFM) data driven average non-associated gas rate for this well string in the WF05 string-level workflow output. */
  vfmDataDrivenAverageNonAssociatedGasRate: Maybe<TimeSeries>;
  /** Time series of virtual flow meter (VFM) data driven average oil rate for this well string in the WF05 string-level workflow output. */
  vfmDataDrivenAverageOilRate: Maybe<TimeSeries>;
  /** Time series of virtual flow meter (VFM) data driven average water rate for this well string in the WF05 string-level workflow output. */
  vfmDataDrivenAverageWaterRate: Maybe<TimeSeries>;
  /** Time series of virtual flow meter (VFM) espaverage associated gas rate for this well string in the WF05 string-level workflow output. */
  vfmESPAverageAssociatedGasRate: Maybe<TimeSeries>;
  /** Time series of virtual flow meter (VFM) espaverage non-associated gas rate for this well string in the WF05 string-level workflow output. */
  vfmESPAverageNonAssociatedGasRate: Maybe<TimeSeries>;
  /** Time series of virtual flow meter (VFM) espaverage oil rate for this well string in the WF05 string-level workflow output. */
  vfmESPAverageOilRate: Maybe<TimeSeries>;
  /** Time series of virtual flow meter (VFM) espaverage water rate for this well string in the WF05 string-level workflow output. */
  vfmESPAverageWaterRate: Maybe<TimeSeries>;
  /** Time series of virtual flow meter (VFM) ipraverage associated gas rate for this well string in the WF05 string-level workflow output. */
  vfmIPRAverageAssociatedGasRate: Maybe<TimeSeries>;
  /** Time series of virtual flow meter (VFM) ipraverage non-associated gas rate for this well string in the WF05 string-level workflow output. */
  vfmIPRAverageNonAssociatedGasRate: Maybe<TimeSeries>;
  /** Time series of virtual flow meter (VFM) ipraverage oil rate for this well string in the WF05 string-level workflow output. */
  vfmIPRAverageOilRate: Maybe<TimeSeries>;
  /** Time series of virtual flow meter (VFM) ipraverage water rate for this well string in the WF05 string-level workflow output. */
  vfmIPRAverageWaterRate: Maybe<TimeSeries>;
  vfmPreferredMethodAssociatedGasAllocationRate: Maybe<TimeSeries>;
  vfmPreferredMethodNonAssociatedGasAllocationRate: Maybe<TimeSeries>;
  vfmPreferredMethodOilAllocationRate: Maybe<TimeSeries>;
  vfmPreferredMethodWaterAllocationRate: Maybe<TimeSeries>;
  /** Time series of virtual flow meter (VFM) system analysis average associated gas rate for this well string in the WF05 string-level workflow output. */
  vfmSystemAnalysisAverageAssociatedGasRate: Maybe<TimeSeries>;
  /** Time series of virtual flow meter (VFM) system analysis average associated non-associated gas rate for this well string in the WF05 string-level workflow output. */
  vfmSystemAnalysisAverageAssociatedNonAssociatedGasRate: Maybe<TimeSeries>;
  /** Time series of virtual flow meter (VFM) system analysis average oil rate for this well string in the WF05 string-level workflow output. */
  vfmSystemAnalysisAverageOilRate: Maybe<TimeSeries>;
  /** Time series of virtual flow meter (VFM) system analysis average water rate for this well string in the WF05 string-level workflow output. */
  vfmSystemAnalysisAverageWaterRate: Maybe<TimeSeries>;
  /** Time series of virtual flow meter (VFM) vlpaverage associated gas rate for this well string in the WF05 string-level workflow output. */
  vfmVLPAverageAssociatedGasRate: Maybe<TimeSeries>;
  /** Time series of virtual flow meter (VFM) vlpaverage non-associated gas rate for this well string in the WF05 string-level workflow output. */
  vfmVLPAverageNonAssociatedGasRate: Maybe<TimeSeries>;
  /** Time series of virtual flow meter (VFM) vlpaverage oil rate for this well string in the WF05 string-level workflow output. */
  vfmVLPAverageOilRate: Maybe<TimeSeries>;
  /** Time series of virtual flow meter (VFM) vlpaverage water rate for this well string in the WF05 string-level workflow output. */
  vfmVLPAverageWaterRate: Maybe<TimeSeries>;
  vfmWeightedAverageAssociatedGasAllocationRate: Maybe<TimeSeries>;
  vfmWeightedAverageMethodOilAllocationRate: Maybe<TimeSeries>;
  vfmWeightedAverageNonAssociatedGasAllocationRate: Maybe<TimeSeries>;
  vfmWeightedAverageWaterAllocationRate: Maybe<TimeSeries>;
  vlpAnalysisWeightFactor: Maybe<TimeSeries>;
  waterInjectionAllocationStatus: Maybe<TimeSeries>;
  waterProductionAllocationStatus: Maybe<TimeSeries>;
  /** Time series of weighted average data source flag for this well string in the WF05 string-level workflow output. */
  weightedAverageDataSourceFlag: Maybe<TimeSeries>;
  /** Time series of weighted average vfmallocated well associated gas volume for this well string in the WF05 string-level workflow output. */
  weightedAverageVFMAllocatedWellAssociatedGasVolume: Maybe<TimeSeries>;
  /** Time series of weighted average vfmallocated well non-associated gas volume for this well string in the WF05 string-level workflow output. */
  weightedAverageVFMAllocatedWellNonAssociatedGasVolume: Maybe<TimeSeries>;
  /** Time series of weighted average vfmallocated well oil volume for this well string in the WF05 string-level workflow output. */
  weightedAverageVFMAllocatedWellOilVolume: Maybe<TimeSeries>;
  /** Time series of weighted average vfmallocated well water volume for this well string in the WF05 string-level workflow output. */
  weightedAverageVFMAllocatedWellWaterVolume: Maybe<TimeSeries>;
  /** Time series of weighted average vfmassociated gas rate for this well string in the WF05 string-level workflow output. */
  weightedAverageVFMAssociatedGasRate: Maybe<TimeSeries>;
  /** Time series of weighted average vfmestimated well associated gas volume for this well string in the WF05 string-level workflow output. */
  weightedAverageVFMEstimatedWellAssociatedGasVolume: Maybe<TimeSeries>;
  /** Time series of weighted average vfmestimated well non-associated gas volume for this well string in the WF05 string-level workflow output. */
  weightedAverageVFMEstimatedWellNonAssociatedGasVolume: Maybe<TimeSeries>;
  /** Time series of weighted average vfmestimated well oil volume for this well string in the WF05 string-level workflow output. */
  weightedAverageVFMEstimatedWellOilVolume: Maybe<TimeSeries>;
  /** Time series of weighted average vfmestimated well water volume for this well string in the WF05 string-level workflow output. */
  weightedAverageVFMEstimatedWellWaterVolume: Maybe<TimeSeries>;
  /** Time series of weighted average vfmnon-associated gas rate for this well string in the WF05 string-level workflow output. */
  weightedAverageVFMNonAssociatedGasRate: Maybe<TimeSeries>;
  /** Time series of weighted average vfmoil rate for this well string in the WF05 string-level workflow output. */
  weightedAverageVFMOilRate: Maybe<TimeSeries>;
  /** Time series of weighted average vfmwater rate for this well string in the WF05 string-level workflow output. */
  weightedAverageVFMWaterRate: Maybe<TimeSeries>;
  /** Time series of well gas injection volume for this well string in the WF05 string-level workflow output. */
  wellGasInjectionVolume: Maybe<TimeSeries>;
  wellType: Maybe<TimeSeries>;
  /** Time series of well uptime for this well string in the WF05 string-level workflow output. */
  wellUptime: Maybe<TimeSeries>;
  /** Time series of well water injection volume for this well string in the WF05 string-level workflow output. */
  wellWaterInjectionVolume: Maybe<TimeSeries>;
};

/** String-reservoir level outputs from the WF05 workflow, providing virtual flow meter (VFM) based oil, gas and water rates, estimated well volumes, method-specific VFM rates and diagnostics used for allocation and well performance evaluation at the reservoir sector level. */
export type Wf05StringReservoirOutputs = {
  allocatedWellInjectionGasRate: Maybe<TimeSeries>;
  allocatedWellInjectionGasVolume: Maybe<TimeSeries>;
  allocatedWellInjectionWaterRate: Maybe<TimeSeries>;
  allocatedWellInjectionWaterVolume: Maybe<TimeSeries>;
  /** Name of the well string (completion) for which WF05 reservoir-level string outputs are reported in this view, sourced from the 'String_asset' view. */
  entityName: Maybe<StringAsset>;
  /** Time series of execution type flag for this string-reservoir combination in the WF05 reservoir-level string workflow output (for example scheduled run, manual run). */
  executionType: Maybe<TimeSeries>;
  /** Name of the field in which this reservoir and string are located, sourced from the 'Field' view. */
  fieldName: Maybe<Field>;
  /** Text attribute 'linkString' for this 'WF05_String_Reservoir_Outputs' row. */
  linkString: Maybe<Scalars['String']['output']>;
  /** Time series of normalized weight factor choke for this string-reservoir combination in the WF05 reservoir-level string workflow output. */
  normalizedWeightFactorChoke: Maybe<TimeSeries>;
  /** Time series of normalized weight factor data-driven for this string-reservoir combination in the WF05 reservoir-level string workflow output. */
  normalizedWeightFactorDataDriven: Maybe<TimeSeries>;
  /** Time series of normalized weight factor electric submersible pump (ESP) for this string-reservoir combination in the WF05 reservoir-level string workflow output. */
  normalizedWeightFactorESP: Maybe<TimeSeries>;
  /** Time series of normalized weight factor inflow performance relationship (IPR) for this string-reservoir combination in the WF05 reservoir-level string workflow output. */
  normalizedWeightFactorIPR: Maybe<TimeSeries>;
  /** Time series of normalized weight factor system analysis for this string-reservoir combination in the WF05 reservoir-level string workflow output. */
  normalizedWeightFactorSystemAnalysis: Maybe<TimeSeries>;
  /** Time series of normalized weight factor vertical lift performance (VLP) for this string-reservoir combination in the WF05 reservoir-level string workflow output. */
  normalizedWeightFactorVLP: Maybe<TimeSeries>;
  preferredVFMAllocatedWellAssociatedGasRate: Maybe<TimeSeries>;
  /** Time series of preferred VFM allocated well associated gas volume for this string-reservoir combination in the WF05 reservoir-level string workflow output. Represents the portion of associated gas volume allocated to this string when using the preferred VFM method. */
  preferredVFMAllocatedWellAssociatedGasVolume: Maybe<TimeSeries>;
  preferredVFMAllocatedWellNonAssociatedGasRate: Maybe<TimeSeries>;
  /** Time series of preferred VFM allocated well non-associated gas volume for this string-reservoir combination in the WF05 reservoir-level string workflow output. Represents the portion of non-associated gas volume allocated to this string when using the preferred VFM method. */
  preferredVFMAllocatedWellNonAssociatedGasVolume: Maybe<TimeSeries>;
  preferredVFMAllocatedWellOilRate: Maybe<TimeSeries>;
  /** Time series of preferred VFM allocated well oil volume for this string-reservoir combination in the WF05 reservoir-level string workflow output. Represents the portion of reservoir oil volume allocated to this string when using the preferred VFM method. */
  preferredVFMAllocatedWellOilVolume: Maybe<TimeSeries>;
  preferredVFMAllocatedWellWaterRate: Maybe<TimeSeries>;
  /** Time series of preferred VFM allocated well water volume for this string-reservoir combination in the WF05 reservoir-level string workflow output. Represents the portion of produced water volume allocated to this string when using the preferred VFM method. */
  preferredVFMAllocatedWellWaterVolume: Maybe<TimeSeries>;
  /** Time series of preferred VFM average associated gas production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output. */
  preferredVFMAverageAssociatedGasRate: Maybe<TimeSeries>;
  /** Time series of preferred VFM average non-associated gas production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output. */
  preferredVFMAverageNonAssociatedGasRate: Maybe<TimeSeries>;
  /** Time series of preferred VFM average oil production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output. */
  preferredVFMAverageOilRate: Maybe<TimeSeries>;
  /** Time series of preferred VFM average water production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output. */
  preferredVFMAverageWaterRate: Maybe<TimeSeries>;
  /** Time series of preferred VFM data source flag for this string-reservoir combination in the WF05 reservoir-level string workflow output. */
  preferredVFMDataSourceFlag: Maybe<TimeSeries>;
  /** Time series of preferred VFM estimated well associated gas volume for this string-reservoir combination in the WF05 reservoir-level string workflow output. */
  preferredVFMEstimatedWellAssociatedGasVolume: Maybe<TimeSeries>;
  /** Time series of preferred VFM estimated well non-associated gas volume for this string-reservoir combination in the WF05 reservoir-level string workflow output. */
  preferredVFMEstimatedWellNonAssociatedGasVolume: Maybe<TimeSeries>;
  /** Time series of preferred VFM estimated well oil volume for this string-reservoir combination in the WF05 reservoir-level string workflow output. */
  preferredVFMEstimatedWellOilVolume: Maybe<TimeSeries>;
  /** Time series of preferred VFM estimated well water volume for this string-reservoir combination in the WF05 reservoir-level string workflow output. */
  preferredVFMEstimatedWellWaterVolume: Maybe<TimeSeries>;
  /** Name of the reservoir to which this string's WF05 outputs apply, sourced from the 'Reservoir' view. */
  reservoirName: Maybe<Reservoir>;
  /** Time series of virtual flow meter (VFM) choke average associated gas rate for this string-reservoir combination in the WF05 reservoir-level string workflow output. */
  vfmChokeAverageAssociatedGasRate: Maybe<TimeSeries>;
  /** Time series of virtual flow meter (VFM) choke-based average non-associated gas production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output. */
  vfmChokeAverageNonAssociatedGasRate: Maybe<TimeSeries>;
  /** Time series of virtual flow meter (VFM) choke average oil rate for this string-reservoir combination in the WF05 reservoir-level string workflow output. */
  vfmChokeAverageOilRate: Maybe<TimeSeries>;
  /** Time series of virtual flow meter (VFM) choke-based average water production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output. */
  vfmChokeAverageWaterRate: Maybe<TimeSeries>;
  /** Time series of virtual flow meter (VFM) data-driven average associated gas production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output. */
  vfmDataDrivenAverageAssociatedGasRate: Maybe<TimeSeries>;
  /** Time series of virtual flow meter (VFM) data-driven average non-associated gas production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output. */
  vfmDataDrivenAverageNonAssociatedGasRate: Maybe<TimeSeries>;
  /** Time series of virtual flow meter (VFM) data-driven average oil rate for this string-reservoir combination in the WF05 reservoir-level string workflow output. */
  vfmDataDrivenAverageOilRate: Maybe<TimeSeries>;
  /** Time series of virtual flow meter (VFM) data-driven average water production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output. */
  vfmDataDrivenAverageWaterRate: Maybe<TimeSeries>;
  /** Time series of virtual flow meter (VFM) ESP-based average associated gas production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output. */
  vfmESPAverageAssociatedGasRate: Maybe<TimeSeries>;
  /** Time series of virtual flow meter (VFM) ESP-based average non-associated gas production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output. */
  vfmESPAverageNonAssociatedGasRate: Maybe<TimeSeries>;
  /** Time series of virtual flow meter (VFM) ESP-based average oil production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output. */
  vfmESPAverageOilRate: Maybe<TimeSeries>;
  /** Time series of virtual flow meter (VFM) ESP-based average water production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output. */
  vfmESPAverageWaterRate: Maybe<TimeSeries>;
  /** Time series of virtual flow meter (VFM) IPR-based average associated gas production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output. */
  vfmIPRAverageAssociatedGasRate: Maybe<TimeSeries>;
  /** Time series of virtual flow meter (VFM) IPR-based average non-associated gas production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output. */
  vfmIPRAverageNonAssociatedGasRate: Maybe<TimeSeries>;
  /** Time series of virtual flow meter (VFM) IPR-based average oil production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output. */
  vfmIPRAverageOilRate: Maybe<TimeSeries>;
  /** Time series of virtual flow meter (VFM) IPR-based average water production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output. */
  vfmIPRAverageWaterRate: Maybe<TimeSeries>;
  /** Time series of virtual flow meter (VFM) system analysis average associated gas rate for this string-reservoir combination in the WF05 reservoir-level string workflow output. */
  vfmSystemAnalysisAverageAssociatedGasRate: Maybe<TimeSeries>;
  /** Time series of virtual flow meter (VFM) system-analysis average combined associated and non-associated gas production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output. */
  vfmSystemAnalysisAverageAssociatedNonAssociatedGasRate: Maybe<TimeSeries>;
  /** Time series of virtual flow meter (VFM) system analysis average oil rate for this string-reservoir combination in the WF05 reservoir-level string workflow output. */
  vfmSystemAnalysisAverageOilRate: Maybe<TimeSeries>;
  /** Time series of virtual flow meter (VFM) system-analysis average water production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output. */
  vfmSystemAnalysisAverageWaterRate: Maybe<TimeSeries>;
  /** Time series of virtual flow meter (VFM) VLP-based average associated gas production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output. */
  vfmVLPAverageAssociatedGasRate: Maybe<TimeSeries>;
  /** Time series of virtual flow meter (VFM) VLP-based average non-associated gas production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output. */
  vfmVLPAverageNonAssociatedGasRate: Maybe<TimeSeries>;
  /** Time series of virtual flow meter (VFM) VLP-based average oil production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output. */
  vfmVLPAverageOilRate: Maybe<TimeSeries>;
  /** Time series of virtual flow meter (VFM) VLP-based average water production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output. */
  vfmVLPAverageWaterRate: Maybe<TimeSeries>;
  /** Time series of weighted average data source flag for this string-reservoir combination in the WF05 reservoir-level string workflow output. */
  weightedAverageDataSourceFlag: Maybe<TimeSeries>;
  weightedAverageVFMAllocatedWellAssociatedGasRate: Maybe<TimeSeries>;
  /** Time series of weighted average VFM allocated well associated gas volume for this string-reservoir combination in the WF05 reservoir-level string workflow output. Combines multiple VFM methods using their normalized weights to produce a single allocated associated gas volume per string. */
  weightedAverageVFMAllocatedWellAssociatedGasVolume: Maybe<TimeSeries>;
  weightedAverageVFMAllocatedWellNonAssociatedGasRate: Maybe<TimeSeries>;
  /** Time series of weighted average VFM allocated well non-associated gas volume for this string-reservoir combination in the WF05 reservoir-level string workflow output. Combines multiple VFM methods using their normalized weights to produce a single allocated non-associated gas volume per string. */
  weightedAverageVFMAllocatedWellNonAssociatedGasVolume: Maybe<TimeSeries>;
  weightedAverageVFMAllocatedWellOilRate: Maybe<TimeSeries>;
  /** Time series of weighted average VFM allocated well oil volume for this string-reservoir combination in the WF05 reservoir-level string workflow output. Combines multiple VFM methods using their normalized weights to produce a single allocated oil volume per string. */
  weightedAverageVFMAllocatedWellOilVolume: Maybe<TimeSeries>;
  weightedAverageVFMAllocatedWellWaterRate: Maybe<TimeSeries>;
  /** Time series of weighted average VFM allocated well water volume for this string-reservoir combination in the WF05 reservoir-level string workflow output. Combines multiple VFM methods using their normalized weights to produce a single allocated water volume per string. */
  weightedAverageVFMAllocatedWellWaterVolume: Maybe<TimeSeries>;
  /** Time series of weighted average VFM associated gas production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output. */
  weightedAverageVFMAssociatedGasRate: Maybe<TimeSeries>;
  /** Time series of weighted average VFM estimated well associated gas volume for this string-reservoir combination in the WF05 reservoir-level string workflow output. */
  weightedAverageVFMEstimatedWellAssociatedGasVolume: Maybe<TimeSeries>;
  /** Time series of weighted average VFM estimated well non-associated gas volume for this string-reservoir combination in the WF05 reservoir-level string workflow output. */
  weightedAverageVFMEstimatedWellNonAssociatedGasVolume: Maybe<TimeSeries>;
  /** Time series of weighted average VFM estimated well oil volume for this string-reservoir combination in the WF05 reservoir-level string workflow output. */
  weightedAverageVFMEstimatedWellOilVolume: Maybe<TimeSeries>;
  /** Time series of weighted average VFM estimated well water volume for this string-reservoir combination in the WF05 reservoir-level string workflow output. */
  weightedAverageVFMEstimatedWellWaterVolume: Maybe<TimeSeries>;
  /** Time series of weighted average VFM non-associated gas production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output. */
  weightedAverageVFMNonAssociatedGasRate: Maybe<TimeSeries>;
  /** Time series of weighted average VFM oil production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output. */
  weightedAverageVFMOilRate: Maybe<TimeSeries>;
  /** Time series of weighted average VFM water production rate for this string-reservoir combination in the WF05 reservoir-level string workflow output. */
  weightedAverageVFMWaterRate: Maybe<TimeSeries>;
  /** Time series of well uptime for this string-reservoir combination in the WF05 reservoir-level string workflow output. */
  wellUptime: Maybe<TimeSeries>;
};

/** View 'Water_Analysis' in the iPSO production optimization solution data model. */
export type WaterAnalysis = {
  /** Reference to a time series for 'analysisDate' in this 'Water_Analysis' view. */
  analysisDate: Maybe<TimeSeries>;
  /** Reference to a time series for 'barium' in this 'Water_Analysis' view. */
  barium: Maybe<TimeSeries>;
  /** Reference to a time series for 'bicarbonate' in this 'Water_Analysis' view. */
  bicarbonate: Maybe<TimeSeries>;
  /** Reference to a time series for 'boron' in this 'Water_Analysis' view. */
  boron: Maybe<TimeSeries>;
  /** Reference to a time series for 'bsw' in this 'Water_Analysis' view. */
  bsw: Maybe<TimeSeries>;
  /** Reference to a time series for 'calcium' in this 'Water_Analysis' view. */
  calcium: Maybe<TimeSeries>;
  /** Reference to a time series for 'calculatedTotalDisolvedSolids' in this 'Water_Analysis' view. */
  calculatedTotalDisolvedSolids: Maybe<TimeSeries>;
  /** Reference to a time series for 'carbonate' in this 'Water_Analysis' view. */
  carbonate: Maybe<TimeSeries>;
  /** Reference to a time series for 'chloride' in this 'Water_Analysis' view. */
  chloride: Maybe<TimeSeries>;
  /** Reference to a time series for 'companyProgramRef' in this 'Water_Analysis' view. */
  companyProgramRef: Maybe<TimeSeries>;
  /** Reference to a time series for 'companySampleNo' in this 'Water_Analysis' view. */
  companySampleNo: Maybe<TimeSeries>;
  /** Reference to a time series for 'dissolvedIron' in this 'Water_Analysis' view. */
  dissolvedIron: Maybe<TimeSeries>;
  /** Reference to the related 'String_asset' entity for this 'Water_Analysis' row. */
  entityName: Maybe<StringAsset>;
  /** Reference to a time series for 'h2s' in this 'Water_Analysis' view. */
  h2s: Maybe<TimeSeries>;
  /** Reference to a time series for 'hydroxide' in this 'Water_Analysis' view. */
  hydroxide: Maybe<TimeSeries>;
  /** Reference to a time series for 'id' in this 'Water_Analysis' view. */
  id: Maybe<TimeSeries>;
  /** Reference to a time series for 'iron' in this 'Water_Analysis' view. */
  iron: Maybe<TimeSeries>;
  /** Reference to a time series for 'magnesium' in this 'Water_Analysis' view. */
  magnesium: Maybe<TimeSeries>;
  /** Reference to a time series for 'measuredTotalDisolvedSolids' in this 'Water_Analysis' view. */
  measuredTotalDisolvedSolids: Maybe<TimeSeries>;
  /** Reference to a time series for 'oilContentVol' in this 'Water_Analysis' view. */
  oilContentVol: Maybe<TimeSeries>;
  /** Reference to a time series for 'ph' in this 'Water_Analysis' view. */
  ph: Maybe<TimeSeries>;
  /** Reference to a time series for 'phTemp' in this 'Water_Analysis' view. */
  phTemp: Maybe<TimeSeries>;
  /** Reference to a time series for 'phosphorous' in this 'Water_Analysis' view. */
  phosphorous: Maybe<TimeSeries>;
  /** Reference to a time series for 'potassium' in this 'Water_Analysis' view. */
  potassium: Maybe<TimeSeries>;
  /** Reference to a time series for 'remarks' in this 'Water_Analysis' view. */
  remarks: Maybe<TimeSeries>;
  /** Reference to a time series for 'reportRef' in this 'Water_Analysis' view. */
  reportRef: Maybe<TimeSeries>;
  /** Reference to a time series for 'resistivity' in this 'Water_Analysis' view. */
  resistivity: Maybe<TimeSeries>;
  /** Reference to a time series for 'resistivityTemp' in this 'Water_Analysis' view. */
  resistivityTemp: Maybe<TimeSeries>;
  /** Reference to a time series for 'salinity' in this 'Water_Analysis' view. */
  salinity: Maybe<TimeSeries>;
  /** Reference to a time series for 'sampleDate' in this 'Water_Analysis' view. */
  sampleDate: Maybe<TimeSeries>;
  /** Reference to a time series for 'sampleType' in this 'Water_Analysis' view. */
  sampleType: Maybe<TimeSeries>;
  /** Reference to a time series for 'sgTemp' in this 'Water_Analysis' view. */
  sgTemp: Maybe<TimeSeries>;
  /** Reference to a time series for 'sodium' in this 'Water_Analysis' view. */
  sodium: Maybe<TimeSeries>;
  /** Reference to a time series for 'solubility' in this 'Water_Analysis' view. */
  solubility: Maybe<TimeSeries>;
  /** Reference to a time series for 'specificGravity' in this 'Water_Analysis' view. */
  specificGravity: Maybe<TimeSeries>;
  /** Reference to a time series for 'strontium' in this 'Water_Analysis' view. */
  strontium: Maybe<TimeSeries>;
  /** Reference to a time series for 'sulphate' in this 'Water_Analysis' view. */
  sulphate: Maybe<TimeSeries>;
  /** Reference to a time series for 'temperature' in this 'Water_Analysis' view. */
  temperature: Maybe<TimeSeries>;
  /** Reference to a time series for 'totalIron' in this 'Water_Analysis' view. */
  totalIron: Maybe<TimeSeries>;
  /** Reference to a time series for 'totalSuspendedSolids' in this 'Water_Analysis' view. */
  totalSuspendedSolids: Maybe<TimeSeries>;
};

/** Typed view over 'Entity' showing wells only (where 'entityType' = 'well'). Use this view together with 'FlatHierarchy' or 'SectorHierarchy' to navigate from fields, reservoirs or sectors to their wells. */
export type Well = {
  /** Timestamp 'endDateTime' associated with this 'Well' row. */
  endDateTime: Maybe<Scalars['Timestamp']['output']>;
  /** Text attribute 'entityType' for this 'Well' row. */
  entityType: Maybe<Scalars['String']['output']>;
  /** Text attribute 'name' for this 'Well' row. */
  name: Maybe<Scalars['String']['output']>;
  /** Timestamp 'startDateTime' associated with this 'Well' row. */
  startDateTime: Maybe<Scalars['Timestamp']['output']>;
};

/**
 * Well behaviour and productivity alarms with medium or high priority.
 *
 * Contains well behaviour and productivity alarms, alarms classified with medium
 * or high priority. Sourced from workflows that monitor well operating
 * envelopes, real-time measurements of well rates and pressures, and reservoir
 * pressure estimations. Use for alarm frequency, duration, impact on well performance. Excludes low-priority alarms.
 *
 * Use for: Real-Time Surveillance (WF18), envelope (WF6), rate/pressure (WF10).
 *
 * @name Well Behaviour & Productivity Alarms (Agent)
 */
export type WellBehaviourAlarmsAgent = {
  alarmCategory: Maybe<Scalars['String']['output']>;
  alarmCode: Maybe<Scalars['JSONObject']['output']>;
  alarmCodeExternalId: Maybe<Scalars['String']['output']>;
  alarmCriticality: Maybe<Scalars['String']['output']>;
  alarmFlags: Maybe<Scalars['String']['output']>;
  alarmName: Maybe<Scalars['String']['output']>;
  alarmPriority: Maybe<Scalars['String']['output']>;
  customWorkflowAlarmMessage: Maybe<Scalars['String']['output']>;
  endDateTime: Maybe<Scalars['Timestamp']['output']>;
  entityExternalId: Scalars['String']['output'];
  entityName: Scalars['String']['output'];
  entityType: Scalars['String']['output'];
  startDateTime: Scalars['Timestamp']['output'];
  subCategory: Maybe<Scalars['String']['output']>;
  subWorkflowName: Maybe<Scalars['String']['output']>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString: Maybe<StringAsset>;
  workflowCode: Maybe<Scalars['String']['output']>;
  workflowName: Maybe<Scalars['String']['output']>;
};

/** View 'WellInputs_Static' in the iPSO production optimization solution data model. */
export type WellInputsStatic = {
  /** Numeric value 'crs' (floating point) for this 'WellInputs_Static' row. */
  crs: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'elevation' (floating point) for this 'WellInputs_Static' row. */
  elevation: Maybe<Scalars['Float32']['output']>;
  /** Text attribute 'elevationRef' for this 'WellInputs_Static' row. */
  elevationRef: Maybe<Scalars['String']['output']>;
  /** Reference to the related 'Well' entity for this 'WellInputs_Static' row. */
  entityName: Maybe<Well>;
  /** Numeric value 'latitude' (floating point) for this 'WellInputs_Static' row. */
  latitude: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'longitude' (floating point) for this 'WellInputs_Static' row. */
  longitude: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'originalCRS' (floating point) for this 'WellInputs_Static' row. */
  originalCRS: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'originalX' (floating point) for this 'WellInputs_Static' row. */
  originalX: Maybe<Scalars['Float32']['output']>;
  /** Numeric value 'originalY' (floating point) for this 'WellInputs_Static' row. */
  originalY: Maybe<Scalars['Float32']['output']>;
  /** Timestamp 'spudDate' associated with this 'WellInputs_Static' row. */
  spudDate: Maybe<Scalars['Timestamp']['output']>;
};

/** High-frequency well string input measurements used as boundary conditions for modelling and optimization, including ESP pump parameters, gas lift injection conditions, wellhead and flowline pressures and temperatures, choke settings and key valve statuses. */
export type WellInputsString = {
  /** Time series of annulus pressure for this string. */
  annulusPress: Maybe<TimeSeries>;
  /** Time series of bottom-hole flowing pressure (for example from PDG or modeled) for this string. */
  bottomHolePress: Maybe<TimeSeries>;
  /** Time series of bottom-hole temperature for this string. */
  bottomHoleTemp: Maybe<TimeSeries>;
  /** Time series of casing head pressure for this string. */
  casingHeadPress: Maybe<TimeSeries>;
  /** Reference to a time series for 'chokeDownstreamPressure1' in this 'WellInputs_String' view. */
  chokeDownstreamPressure1: Maybe<TimeSeries>;
  /** Reference to a time series for 'chokeDownstreamPressure2' in this 'WellInputs_String' view. */
  chokeDownstreamPressure2: Maybe<TimeSeries>;
  /** Reference to a time series for 'chokeOpening' in this 'WellInputs_String' view. */
  chokeOpening: Maybe<TimeSeries>;
  /** Time series of surface choke opening or size setting for this string. */
  chokeSize: Maybe<TimeSeries>;
  /** Time series representing the position or status of the surface control valve associated with this string. */
  controlValve: Maybe<TimeSeries>;
  /** Reference to a time series for 'depthSensor' in this 'WellInputs_String' view. */
  depthSensor: Maybe<TimeSeries>;
  /** Time series of pressure measured downstream of the well control valve for this string. */
  downstreamPressure: Maybe<TimeSeries>;
  /** Name of the well string (completion) for which well input measurements are captured, sourced from the 'String_asset' view. */
  entityName: Maybe<StringAsset>;
  /** Time series of flowline pressure downstream of the wellhead for this string. */
  flowLinePress: Maybe<TimeSeries>;
  /** Time series of flowline temperature downstream of the wellhead for this string. */
  flowLineTemp: Maybe<TimeSeries>;
  /** Reference to a time series for 'gasInjChokeOpening' in this 'WellInputs_String' view. */
  gasInjChokeOpening: Maybe<TimeSeries>;
  /** Reference to a time series for 'gasInjRate' in this 'WellInputs_String' view. */
  gasInjRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'gasInjWellheadPress' in this 'WellInputs_String' view. */
  gasInjWellheadPress: Maybe<TimeSeries>;
  /** Time series of inlet pressure at the gas lift flow control valve for this string. */
  gasLiftFlowCVInletPress: Maybe<TimeSeries>;
  /** Reference to a time series for 'gasLiftFlowCVInletTemp' in this 'WellInputs_String' view. */
  gasLiftFlowCVInletTemp: Maybe<TimeSeries>;
  /** Time series of effective orifice/trim size of the gas lift flow control valve for this string. */
  gasLiftFlowCVSize: Maybe<TimeSeries>;
  /** Time series of gas lift injection rate into this string. */
  gasLiftInjRate: Maybe<TimeSeries>;
  /** Time series of gas lift injection temperature for this string. */
  gasLiftInjTemp: Maybe<TimeSeries>;
  /** Reference to a time series for 'gasRateFlow' in this 'WellInputs_String' view. */
  gasRateFlow: Maybe<TimeSeries>;
  /** Reference to a time series for 'giHeaderPressure' in this 'WellInputs_String' view. */
  giHeaderPressure: Maybe<TimeSeries>;
  /** Reference to a time series for 'giHeaderTemperature' in this 'WellInputs_String' view. */
  giHeaderTemperature: Maybe<TimeSeries>;
  /** Time series indicating the artificial lift type currently applied to this string (for example natural flow, gas lift, ESP). */
  liftType: Maybe<TimeSeries>;
  /** Reference to a time series for 'modelComposition' in this 'WellInputs_String' view. */
  modelComposition: Maybe<TimeSeries>;
  /** Reference to a time series for 'potentialGasInjection' in this 'WellInputs_String' view. */
  potentialGasInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'potentialGasProduction' in this 'WellInputs_String' view. */
  potentialGasProduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'potentialOilProduction' in this 'WellInputs_String' view. */
  potentialOilProduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'potentialWaterInjection' in this 'WellInputs_String' view. */
  potentialWaterInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'potentialWaterProduction' in this 'WellInputs_String' view. */
  potentialWaterProduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'productionHeaderPressure' in this 'WellInputs_String' view. */
  productionHeaderPressure: Maybe<TimeSeries>;
  /** Time series of electrical current drawn by the pump motor for this string. */
  pumpCurrent: Maybe<TimeSeries>;
  /** Time series of pump discharge pressure at the pump outlet for this string. */
  pumpDischargePress: Maybe<TimeSeries>;
  /** Time series of fluid temperature at the pump discharge for this string. */
  pumpDischargeTemp: Maybe<TimeSeries>;
  /** Time series of downhole pump operating frequency (for example ESP motor frequency in Hz) for this string. */
  pumpFrequency: Maybe<TimeSeries>;
  /** Time series of pump intake pressure at the pump suction for this string. */
  pumpIntakePress: Maybe<TimeSeries>;
  /** Time series of fluid temperature at the pump intake for this string. */
  pumpIntakeTemp: Maybe<TimeSeries>;
  /** Time series of downhole pump motor temperature for this string. */
  pumpMotorTemp: Maybe<TimeSeries>;
  /** Time series of vibration level measured on the downhole pump or completion for this string. */
  pumpVibration: Maybe<TimeSeries>;
  /** Time series of electrical voltage supplied to the pump motor for this string. */
  pumpVoltage: Maybe<TimeSeries>;
  /** Reference to a time series for 'sPress' in this 'WellInputs_String' view. */
  sPress: Maybe<TimeSeries>;
  /** Reference to a time series for 'subSurfaceSafetyValve' in this 'WellInputs_String' view. */
  subSurfaceSafetyValve: Maybe<TimeSeries>;
  /** Reference to a time series for 'surfaceSafetyValve' in this 'WellInputs_String' view. */
  surfaceSafetyValve: Maybe<TimeSeries>;
  /** Reference to a time series for 'targetGasInjection' in this 'WellInputs_String' view. */
  targetGasInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'targetGasProduction' in this 'WellInputs_String' view. */
  targetGasProduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'targetOilProduction' in this 'WellInputs_String' view. */
  targetOilProduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'targetWaterInjection' in this 'WellInputs_String' view. */
  targetWaterInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'targetWaterProduction' in this 'WellInputs_String' view. */
  targetWaterProduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'toProdHeader' in this 'WellInputs_String' view. */
  toProdHeader: Maybe<TimeSeries>;
  /** Reference to a time series for 'toTestHeader' in this 'WellInputs_String' view. */
  toTestHeader: Maybe<TimeSeries>;
  /** Reference to a time series for 'waterHeaderPressure' in this 'WellInputs_String' view. */
  waterHeaderPressure: Maybe<TimeSeries>;
  /** Reference to a time series for 'waterInjChokeOpening' in this 'WellInputs_String' view. */
  waterInjChokeOpening: Maybe<TimeSeries>;
  /** Reference to a time series for 'waterInjRate' in this 'WellInputs_String' view. */
  waterInjRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'waterInjWellheadPress' in this 'WellInputs_String' view. */
  waterInjWellheadPress: Maybe<TimeSeries>;
  /** Time series of wellhead pressure measured at the tree for this string. */
  wellHeadPress: Maybe<TimeSeries>;
  /** Time series of wellhead temperature measured at the tree for this string. */
  wellHeadTemp: Maybe<TimeSeries>;
  /** Time series representing the status or opening of the wing valve on this string. */
  wingValve: Maybe<TimeSeries>;
};

/** High-frequency well string input measurements used as boundary conditions for modelling and optimization, including ESP pump parameters, gas lift injection conditions, wellhead and flowline pressures and temperatures, choke settings and key valve statuses. */
export type WellInputsStringReverse = {
  /** Time series of annulus pressure for this string. */
  annulusPress: Maybe<TimeSeries>;
  /** Time series of bottom-hole flowing pressure (for example from PDG or modeled) for this string. */
  bottomHolePress: Maybe<TimeSeries>;
  /** Time series of bottom-hole temperature for this string. */
  bottomHoleTemp: Maybe<TimeSeries>;
  /** Time series of casing head pressure for this string. */
  casingHeadPress: Maybe<TimeSeries>;
  /** Reference to a time series for 'chokeDownstreamPressure1' in this 'WellInputs_String_Reverse' view. */
  chokeDownstreamPressure1: Maybe<TimeSeries>;
  /** Reference to a time series for 'chokeDownstreamPressure2' in this 'WellInputs_String_Reverse' view. */
  chokeDownstreamPressure2: Maybe<TimeSeries>;
  /** Reference to a time series for 'chokeOpening' in this 'WellInputs_String_Reverse' view. */
  chokeOpening: Maybe<TimeSeries>;
  /** Time series of surface choke opening or size setting for this string. */
  chokeSize: Maybe<TimeSeries>;
  /** Time series representing the position or status of the surface control valve associated with this string. */
  controlValve: Maybe<TimeSeries>;
  /** Reference to a time series for 'depthSensor' in this 'WellInputs_String_Reverse' view. */
  depthSensor: Maybe<TimeSeries>;
  /** Time series of pressure measured downstream of the well control valve for this string. */
  downstreamPressure: Maybe<TimeSeries>;
  /** Name of the well string (completion) for which well input measurements are captured, sourced from the 'String_asset' view. */
  entityName: Maybe<StringAsset>;
  /** Time series of flowline pressure downstream of the wellhead for this string. */
  flowLinePress: Maybe<TimeSeries>;
  /** Time series of flowline temperature downstream of the wellhead for this string. */
  flowLineTemp: Maybe<TimeSeries>;
  /** Reference to a time series for 'gasInjChokeOpening' in this 'WellInputs_String_Reverse' view. */
  gasInjChokeOpening: Maybe<TimeSeries>;
  /** Reference to a time series for 'gasInjRate' in this 'WellInputs_String_Reverse' view. */
  gasInjRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'gasInjWellheadPress' in this 'WellInputs_String_Reverse' view. */
  gasInjWellheadPress: Maybe<TimeSeries>;
  /** Time series of inlet pressure at the gas lift flow control valve for this string. */
  gasLiftFlowCVInletPress: Maybe<TimeSeries>;
  /** Reference to a time series for 'gasLiftFlowCVInletTemp' in this 'WellInputs_String_Reverse' view. */
  gasLiftFlowCVInletTemp: Maybe<TimeSeries>;
  /** Time series of effective orifice/trim size of the gas lift flow control valve for this string. */
  gasLiftFlowCVSize: Maybe<TimeSeries>;
  /** Time series of gas lift injection rate into this string. */
  gasLiftInjRate: Maybe<TimeSeries>;
  /** Time series of gas lift injection temperature for this string. */
  gasLiftInjTemp: Maybe<TimeSeries>;
  /** Reference to a time series for 'gasRateFlow' in this 'WellInputs_String_Reverse' view. */
  gasRateFlow: Maybe<TimeSeries>;
  /** Reference to a time series for 'giHeaderPressure' in this 'WellInputs_String_Reverse' view. */
  giHeaderPressure: Maybe<TimeSeries>;
  /** Reference to a time series for 'giHeaderTemperature' in this 'WellInputs_String_Reverse' view. */
  giHeaderTemperature: Maybe<TimeSeries>;
  /** Time series indicating the artificial lift type currently applied to this string (for example natural flow, gas lift, ESP). */
  liftType: Maybe<TimeSeries>;
  /** Reference to a time series for 'modelComposition' in this 'WellInputs_String_Reverse' view. */
  modelComposition: Maybe<TimeSeries>;
  /** Reference to a time series for 'potentialGasInjection' in this 'WellInputs_String_Reverse' view. */
  potentialGasInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'potentialGasProduction' in this 'WellInputs_String_Reverse' view. */
  potentialGasProduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'potentialOilProduction' in this 'WellInputs_String_Reverse' view. */
  potentialOilProduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'potentialWaterInjection' in this 'WellInputs_String_Reverse' view. */
  potentialWaterInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'potentialWaterProduction' in this 'WellInputs_String_Reverse' view. */
  potentialWaterProduction: Maybe<TimeSeries>;
  /** Time series of electrical current drawn by the pump motor for this string. */
  pumpCurrent: Maybe<TimeSeries>;
  /** Time series of pump discharge pressure at the pump outlet for this string. */
  pumpDischargePress: Maybe<TimeSeries>;
  /** Time series of fluid temperature at the pump discharge for this string. */
  pumpDischargeTemp: Maybe<TimeSeries>;
  /** Time series of downhole pump operating frequency (for example ESP motor frequency in Hz) for this string. */
  pumpFrequency: Maybe<TimeSeries>;
  /** Time series of pump intake pressure at the pump suction for this string. */
  pumpIntakePress: Maybe<TimeSeries>;
  /** Time series of fluid temperature at the pump intake for this string. */
  pumpIntakeTemp: Maybe<TimeSeries>;
  /** Time series of downhole pump motor temperature for this string. */
  pumpMotorTemp: Maybe<TimeSeries>;
  /** Time series of vibration level measured on the downhole pump or completion for this string. */
  pumpVibration: Maybe<TimeSeries>;
  /** Time series of electrical voltage supplied to the pump motor for this string. */
  pumpVoltage: Maybe<TimeSeries>;
  /** Reference to a time series for 'sPress' in this 'WellInputs_String_Reverse' view. */
  sPress: Maybe<TimeSeries>;
  /** Reference to a time series for 'subSurfaceSafetyValve' in this 'WellInputs_String_Reverse' view. */
  subSurfaceSafetyValve: Maybe<TimeSeries>;
  /** Reference to a time series for 'surfaceSafetyValve' in this 'WellInputs_String_Reverse' view. */
  surfaceSafetyValve: Maybe<TimeSeries>;
  /** Reference to a time series for 'targetGasInjection' in this 'WellInputs_String_Reverse' view. */
  targetGasInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'targetGasProduction' in this 'WellInputs_String_Reverse' view. */
  targetGasProduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'targetOilProduction' in this 'WellInputs_String_Reverse' view. */
  targetOilProduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'targetWaterInjection' in this 'WellInputs_String_Reverse' view. */
  targetWaterInjection: Maybe<TimeSeries>;
  /** Reference to a time series for 'targetWaterProduction' in this 'WellInputs_String_Reverse' view. */
  targetWaterProduction: Maybe<TimeSeries>;
  /** Reference to a time series for 'toProdHeader' in this 'WellInputs_String_Reverse' view. */
  toProdHeader: Maybe<TimeSeries>;
  /** Reference to a time series for 'toTestHeader' in this 'WellInputs_String_Reverse' view. */
  toTestHeader: Maybe<TimeSeries>;
  /** Reference to a time series for 'waterHeaderPressure' in this 'WellInputs_String_Reverse' view. */
  waterHeaderPressure: Maybe<TimeSeries>;
  /** Reference to a time series for 'waterInjChokeOpening' in this 'WellInputs_String_Reverse' view. */
  waterInjChokeOpening: Maybe<TimeSeries>;
  /** Reference to a time series for 'waterInjRate' in this 'WellInputs_String_Reverse' view. */
  waterInjRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'waterInjWellheadPress' in this 'WellInputs_String_Reverse' view. */
  waterInjWellheadPress: Maybe<TimeSeries>;
  /** Time series of wellhead pressure measured at the tree for this string. */
  wellHeadPress: Maybe<TimeSeries>;
  /** Time series of wellhead temperature measured at the tree for this string. */
  wellHeadTemp: Maybe<TimeSeries>;
  /** Time series representing the status or opening of the wing valve on this string. */
  wingValve: Maybe<TimeSeries>;
};

/**
 * Well movement records including choke adjustments, ESP frequency changes, and
 * GL optimization.
 *
 * Contains detailed records of operational changes made to wells, choke
 * adjustments, ESP frequency changes, GL rate optimization, and injection rate
 * modifications. Sourced from well management systems and operational logs,
 * allowing for analysis of optimization recommendations and their execution
 * status. Answers questions on the impact of specific adjustments on well
 * performance and efficiency, as well as track the timeline of changes made.
 * Excludes historical production data or reservoir characteristics (see other
 * related views).
 *
 * @name Well Movement (Agent)
 */
export type WellMovementAgent = {
  actualExecutionDate: Maybe<Scalars['Date']['output']>;
  baselineGasRate: Maybe<Scalars['Float']['output']>;
  baselineOilRate: Maybe<Scalars['Float']['output']>;
  baselineWaterRate: Maybe<Scalars['Float']['output']>;
  controlParameter: Maybe<Scalars['String']['output']>;
  controlParameterPostOptimizedValue: Maybe<Scalars['Float']['output']>;
  controlParameterPreOptimizedValue: Maybe<Scalars['Float']['output']>;
  createdBy: Maybe<Scalars['String']['output']>;
  createdDate: Maybe<Scalars['Date']['output']>;
  description: Maybe<Scalars['String']['output']>;
  doNotDisturb: Maybe<Scalars['Boolean']['output']>;
  doNotDisturbEndDate: Maybe<Scalars['Date']['output']>;
  estimatedGasRate: Maybe<Scalars['Float']['output']>;
  estimatedOilRate: Maybe<Scalars['Float']['output']>;
  estimatedWaterRate: Maybe<Scalars['Float']['output']>;
  executionStatus: Maybe<Scalars['String']['output']>;
  plannedExecutionDate: Maybe<Scalars['Date']['output']>;
  scenarioName: Maybe<Scalars['String']['output']>;
  scenarioType: Maybe<Scalars['String']['output']>;
  source: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  ticketExternalId: Maybe<Scalars['String']['output']>;
  validationStatus: Maybe<Scalars['String']['output']>;
  wellName: Maybe<Scalars['String']['output']>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString: Maybe<StringAsset>;
  wellType: Maybe<Scalars['String']['output']>;
};

/** View 'WellOutputs_Ext_1_String' in the iPSO production optimization solution data model. */
export type WellOutputsExt_1String = {
  /** Reference to a time series for 'dataDrivenGasRateStd' in this 'WellOutputs_Ext_1_String' view. */
  dataDrivenGasRateStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'dataDrivenLiquidRateStd' in this 'WellOutputs_Ext_1_String' view. */
  dataDrivenLiquidRateStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'dataDrivenOilRateStd' in this 'WellOutputs_Ext_1_String' view. */
  dataDrivenOilRateStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'dataDrivenWaterRateStd' in this 'WellOutputs_Ext_1_String' view. */
  dataDrivenWaterRateStd: Maybe<TimeSeries>;
  /** Reference to the related 'String_asset' entity for this 'WellOutputs_Ext_1_String' row. */
  entityName: Maybe<StringAsset>;
  /** Reference to a time series for 'giBHPCompliance' in this 'WellOutputs_Ext_1_String' view. */
  giBHPCompliance: Maybe<TimeSeries>;
  /** Reference to a time series for 'giTargetRateCompliance' in this 'WellOutputs_Ext_1_String' view. */
  giTargetRateCompliance: Maybe<TimeSeries>;
  /** Reference to a time series for 'giTechnicalRateCompliance' in this 'WellOutputs_Ext_1_String' view. */
  giTechnicalRateCompliance: Maybe<TimeSeries>;
  /** Reference to a time series for 'giWHPCompliance' in this 'WellOutputs_Ext_1_String' view. */
  giWHPCompliance: Maybe<TimeSeries>;
  /** Reference to a time series for 'wiBHPCompliance' in this 'WellOutputs_Ext_1_String' view. */
  wiBHPCompliance: Maybe<TimeSeries>;
  /** Reference to a time series for 'wiTargetRateCompliance' in this 'WellOutputs_Ext_1_String' view. */
  wiTargetRateCompliance: Maybe<TimeSeries>;
  /** Reference to a time series for 'wiTechnicalRateCompliance' in this 'WellOutputs_Ext_1_String' view. */
  wiTechnicalRateCompliance: Maybe<TimeSeries>;
  /** Reference to a time series for 'wiWHPCompliance' in this 'WellOutputs_Ext_1_String' view. */
  wiWHPCompliance: Maybe<TimeSeries>;
};

/** View 'WellOutputs_String' in the iPSO production optimization solution data model. */
export type WellOutputsString = {
  /** Reference to a time series for 'calcFVF' in this 'WellOutputs_String' view. */
  calcFVF: Maybe<TimeSeries>;
  /** Reference to a time series for 'calcGasFVF' in this 'WellOutputs_String' view. */
  calcGasFVF: Maybe<TimeSeries>;
  /** Reference to a time series for 'calcGasViscosity' in this 'WellOutputs_String' view. */
  calcGasViscosity: Maybe<TimeSeries>;
  /** Time series of flowing bottom-hole pressure corresponding to choke analysis results for this string. */
  chokeAnalysisFbhp: Maybe<TimeSeries>;
  /** Time series of gas production rate at standard conditions obtained from choke analysis for this string. */
  chokeAnalysisGasRateStd: Maybe<TimeSeries>;
  /** Time series of total liquid production rate at standard conditions obtained from choke analysis for this string. */
  chokeAnalysisLiquidRateStd: Maybe<TimeSeries>;
  /** Time series of oil production rate at standard conditions obtained from choke analysis for this string. */
  chokeAnalysisOilRateStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'chokeAnalysisStatus' in this 'WellOutputs_String' view. */
  chokeAnalysisStatus: Maybe<TimeSeries>;
  /** Time series of water production rate at standard conditions obtained from choke analysis for this string. */
  chokeAnalysisWaterRateStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'chokeCdCalc' in this 'WellOutputs_String' view. */
  chokeCdCalc: Maybe<TimeSeries>;
  /** Reference to a time series for 'chokeSizeCalc' in this 'WellOutputs_String' view. */
  chokeSizeCalc: Maybe<TimeSeries>;
  /** Reference to a time series for 'cumulativeGasInjPress' in this 'WellOutputs_String' view. */
  cumulativeGasInjPress: Maybe<TimeSeries>;
  /** Reference to a time series for 'cumulativeGasInjVol' in this 'WellOutputs_String' view. */
  cumulativeGasInjVol: Maybe<TimeSeries>;
  /** Reference to a time series for 'cumulativeWaterInjPress' in this 'WellOutputs_String' view. */
  cumulativeWaterInjPress: Maybe<TimeSeries>;
  /** Reference to a time series for 'cumulativeWaterInjVol' in this 'WellOutputs_String' view. */
  cumulativeWaterInjVol: Maybe<TimeSeries>;
  /** Reference to a time series for 'curveAnalysisFbhp' in this 'WellOutputs_String' view. */
  curveAnalysisFbhp: Maybe<TimeSeries>;
  /** Reference to a time series for 'curveAnalysisGasRateStd' in this 'WellOutputs_String' view. */
  curveAnalysisGasRateStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'curveAnalysisLiquidRateStd' in this 'WellOutputs_String' view. */
  curveAnalysisLiquidRateStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'curveAnalysisOilRateStd' in this 'WellOutputs_String' view. */
  curveAnalysisOilRateStd: Maybe<TimeSeries>;
  /** Calculation status as a string for every run of the ESP curve method */
  curveAnalysisStatus: Maybe<TimeSeries>;
  /** Reference to a time series for 'curveAnalysisWaterRateStd' in this 'WellOutputs_String' view. */
  curveAnalysisWaterRateStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'dataAnalysisFbhp' in this 'WellOutputs_String' view. */
  dataAnalysisFbhp: Maybe<TimeSeries>;
  /** Reference to a time series for 'dataAnalysisGasRateStd' in this 'WellOutputs_String' view. */
  dataAnalysisGasRateStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'dataAnalysisLiquidRateStd' in this 'WellOutputs_String' view. */
  dataAnalysisLiquidRateStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'dataAnalysisOilRateStd' in this 'WellOutputs_String' view. */
  dataAnalysisOilRateStd: Maybe<TimeSeries>;
  /** Calculation status as a string for every run of the data driven VFM method */
  dataAnalysisStatus: Maybe<TimeSeries>;
  /** Reference to a time series for 'dataAnalysisWaterRateStd' in this 'WellOutputs_String' view. */
  dataAnalysisWaterRateStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'downholeFluidFlowRate' in this 'WellOutputs_String' view. */
  downholeFluidFlowRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'downholeFluidVelocity' in this 'WellOutputs_String' view. */
  downholeFluidVelocity: Maybe<TimeSeries>;
  /** Reference to a time series for 'downholeGasInjectionVolume' in this 'WellOutputs_String' view. */
  downholeGasInjectionVolume: Maybe<TimeSeries>;
  /** Reference to a time series for 'downholeGasProductionVolume' in this 'WellOutputs_String' view. */
  downholeGasProductionVolume: Maybe<TimeSeries>;
  /** Reference to a time series for 'downholeOilProductionVolume' in this 'WellOutputs_String' view. */
  downholeOilProductionVolume: Maybe<TimeSeries>;
  /** Reference to a time series for 'downholeWaterInjectionVolume' in this 'WellOutputs_String' view. */
  downholeWaterInjectionVolume: Maybe<TimeSeries>;
  /** Reference to a time series for 'downholeWaterProductionVolume' in this 'WellOutputs_String' view. */
  downholeWaterProductionVolume: Maybe<TimeSeries>;
  /** Name of the well string (completion) for which modelled and calculated well outputs are provided, sourced from the 'String_asset' view. */
  entityName: Maybe<StringAsset>;
  /** Reference to a time series for 'espqlAnalysisStatus' in this 'WellOutputs_String' view. */
  espqlAnalysisStatus: Maybe<TimeSeries>;
  /** Reference to a time series for 'giBHP' in this 'WellOutputs_String' view. */
  giBHP: Maybe<TimeSeries>;
  /** Reference to a time series for 'giRate' in this 'WellOutputs_String' view. */
  giRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'giTargetRate' in this 'WellOutputs_String' view. */
  giTargetRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'giTechnicalRate' in this 'WellOutputs_String' view. */
  giTechnicalRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'giWHP' in this 'WellOutputs_String' view. */
  giWHP: Maybe<TimeSeries>;
  /** Reference to a time series for 'glChokeCdCalc' in this 'WellOutputs_String' view. */
  glChokeCdCalc: Maybe<TimeSeries>;
  /** Reference to a time series for 'glChokeSizeCalc' in this 'WellOutputs_String' view. */
  glChokeSizeCalc: Maybe<TimeSeries>;
  /** Reference to a time series for 'glirAllocated' in this 'WellOutputs_String' view. */
  glirAllocated: Maybe<TimeSeries>;
  /** Reference to a time series for 'glirChokeEquation' in this 'WellOutputs_String' view. */
  glirChokeEquation: Maybe<TimeSeries>;
  /** Reference to a time series for 'glirMeasured' in this 'WellOutputs_String' view. */
  glirMeasured: Maybe<TimeSeries>;
  /** Reference to a time series for 'glirNetworkSimulation' in this 'WellOutputs_String' view. */
  glirNetworkSimulation: Maybe<TimeSeries>;
  /** Reference to a time series for 'glirSelected' in this 'WellOutputs_String' view. */
  glirSelected: Maybe<TimeSeries>;
  /** Reference to a time series for 'glirSelectedType' in this 'WellOutputs_String' view. */
  glirSelectedType: Maybe<TimeSeries>;
  /** Reference to a time series for 'glqlAnalysisStatus' in this 'WellOutputs_String' view. */
  glqlAnalysisStatus: Maybe<TimeSeries>;
  /** Reference to a time series for 'grdAnalysisStatus' in this 'WellOutputs_String' view. */
  grdAnalysisStatus: Maybe<TimeSeries>;
  /** Reference to a time series for 'hallInterpretation' in this 'WellOutputs_String' view. */
  hallInterpretation: Maybe<TimeSeries>;
  /** Reference to a time series for 'hallLine' in this 'WellOutputs_String' view. */
  hallLine: Maybe<TimeSeries>;
  /** Hours online since midnight UTC+04:00. Calculated from the onlineStatus property. */
  hoursOnline: Maybe<TimeSeries>;
  /** Reference to a time series for 'injectionEfficiency' in this 'WellOutputs_String' view. */
  injectionEfficiency: Maybe<TimeSeries>;
  /** Reference to a time series for 'injectionEfficiencyFlag' in this 'WellOutputs_String' view. */
  injectionEfficiencyFlag: Maybe<TimeSeries>;
  /** Reference to a time series for 'injectionEfficiencyRank' in this 'WellOutputs_String' view. */
  injectionEfficiencyRank: Maybe<TimeSeries>;
  /** Reference to a time series for 'injectivityIndex' in this 'WellOutputs_String' view. */
  injectivityIndex: Maybe<TimeSeries>;
  /** Numeric value 'instrumented' (floating point) for this 'WellOutputs_String' row. */
  instrumented: Maybe<Scalars['Float32']['output']>;
  /** Reference to a time series for 'iprAnalysisFbhp' in this 'WellOutputs_String' view. */
  iprAnalysisFbhp: Maybe<TimeSeries>;
  /** Reference to a time series for 'iprAnalysisGasRateStd' in this 'WellOutputs_String' view. */
  iprAnalysisGasRateStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'iprAnalysisLiquidRateStd' in this 'WellOutputs_String' view. */
  iprAnalysisLiquidRateStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'iprAnalysisOilRateStd' in this 'WellOutputs_String' view. */
  iprAnalysisOilRateStd: Maybe<TimeSeries>;
  /** Calculation status as a string for every run of the IPR method */
  iprAnalysisStatus: Maybe<TimeSeries>;
  /** Reference to a time series for 'iprAnalysisWaterRateStd' in this 'WellOutputs_String' view. */
  iprAnalysisWaterRateStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'liftType' in this 'WellOutputs_String' view. */
  liftType: Maybe<TimeSeries>;
  /** Reference to a time series for 'motorEfficiency' in this 'WellOutputs_String' view. */
  motorEfficiency: Maybe<TimeSeries>;
  /** Reference to a time series for 'motorLoad' in this 'WellOutputs_String' view. */
  motorLoad: Maybe<TimeSeries>;
  /** 0 indicates the well string is shut-in, 1 indicates the well string is flowing */
  onlineStatus: Maybe<TimeSeries>;
  /** The reason for a shut-in detection is saved at the shut-in start time as a string of comma seperated criteria that were satisfied during the shut-in. */
  onlineStatusReason: Maybe<TimeSeries>;
  /** Reference to a time series for 'pressureCompliance' in this 'WellOutputs_String' view. */
  pressureCompliance: Maybe<TimeSeries>;
  /** Reference to a time series for 'pressureSource' in this 'WellOutputs_String' view. */
  pressureSource: Maybe<TimeSeries>;
  /** Reference to a time series for 'priorityFbhp' in this 'WellOutputs_String' view. */
  priorityFbhp: Maybe<TimeSeries>;
  /** Reference to a time series for 'priorityGasRateStd' in this 'WellOutputs_String' view. */
  priorityGasRateStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'priorityLiquidRateStd' in this 'WellOutputs_String' view. */
  priorityLiquidRateStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'priorityMethod' in this 'WellOutputs_String' view. */
  priorityMethod: Maybe<TimeSeries>;
  /** Reference to a time series for 'priorityOilRateStd' in this 'WellOutputs_String' view. */
  priorityOilRateStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'priorityWaterRateStd' in this 'WellOutputs_String' view. */
  priorityWaterRateStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'priotiryWaterRateStd' in this 'WellOutputs_String' view. */
  priotiryWaterRateStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'product' in this 'WellOutputs_String' view. */
  product: Maybe<TimeSeries>;
  /** Reference to a time series for 'productivityIndex' in this 'WellOutputs_String' view. */
  productivityIndex: Maybe<TimeSeries>;
  /** Reference to a time series for 'prosperLiftType' in this 'WellOutputs_String' view. */
  prosperLiftType: Maybe<TimeSeries>;
  /** Reference to a time series for 'prosperProduct' in this 'WellOutputs_String' view. */
  prosperProduct: Maybe<TimeSeries>;
  /** Reference to a time series for 'prosperWag' in this 'WellOutputs_String' view. */
  prosperWag: Maybe<TimeSeries>;
  /** Reference to a time series for 'prosperWellType' in this 'WellOutputs_String' view. */
  prosperWellType: Maybe<TimeSeries>;
  /** Reference to a time series for 'pumpAvgRate' in this 'WellOutputs_String' view. */
  pumpAvgRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'pumpHead' in this 'WellOutputs_String' view. */
  pumpHead: Maybe<TimeSeries>;
  /** Reference to a time series for 'pvt_AlarmCode' in this 'WellOutputs_String' view. */
  pvt_AlarmCode: Maybe<TimeSeries>;
  /** Reference to a time series for 'qliqDelta' in this 'WellOutputs_String' view. */
  qliqDelta: Maybe<TimeSeries>;
  /** Reference to a time series for 'reservoirPressureDatum' in this 'WellOutputs_String' view. */
  reservoirPressureDatum: Maybe<TimeSeries>;
  /** Reference to a time series for 'reservoirPressureMidPerforation' in this 'WellOutputs_String' view. */
  reservoirPressureMidPerforation: Maybe<TimeSeries>;
  /** CH simulation run ID history */
  simulationChokeId: Maybe<TimeSeries>;
  /** ESP Curve inputs history */
  simulationCurveInput: Maybe<TimeSeries>;
  /** SA simulation run ID history */
  simulationId: Maybe<TimeSeries>;
  /** IPR inputs history */
  simulationIprInput: Maybe<TimeSeries>;
  /** VLP inputs history */
  simulationVlpInput: Maybe<TimeSeries>;
  /** 1 indicates hydrodynamic slug flow in the well string, 0 indicates the opposite. */
  sluggingStatus: Maybe<TimeSeries>;
  /** 0 indicates well string is in a transient state or shut-in, 1 indicates the well string is in a flowing quasi-steady state */
  steadyStateStatus: Maybe<TimeSeries>;
  /** Which number in the subsurface safety valve time series for the well string corresponds to the closed state. Based on statistical analysis. To be removed when extractor is able to retreive the subsurface safety valve position. */
  subSurfaceSafetyValveCloseState: Maybe<Scalars['Int']['output']>;
  /** Which number in the surface safety valve time series for the well string corresponds to the closed state. Based on statistical analysis. To be removed when extractor is able to retreive the surface safety valve position. */
  surfaceSafetyValveCloseState: Maybe<Scalars['Int']['output']>;
  /** Time series of flowing bottom-hole pressure (FBHP) from system analysis for this string. */
  systemAnalysisFbhp: Maybe<TimeSeries>;
  /** Time series of gas production rate at standard conditions from system analysis for this string. */
  systemAnalysisGasRateStd: Maybe<TimeSeries>;
  /** Time series of total liquid production rate at standard conditions from system analysis for this string. */
  systemAnalysisLiquidRateStd: Maybe<TimeSeries>;
  /** Time series of oil production rate at standard conditions from system analysis for this string. */
  systemAnalysisOilRateStd: Maybe<TimeSeries>;
  /** PROSPER system analysis output of pump discharge pressure */
  systemAnalysisPdp: Maybe<TimeSeries>;
  /** PROSPER system analysis output of pump intake pressure */
  systemAnalysisPip: Maybe<TimeSeries>;
  /** Reference to a time series for 'systemAnalysisStatus' in this 'WellOutputs_String' view. */
  systemAnalysisStatus: Maybe<TimeSeries>;
  /** Time series of water production rate at standard conditions from system analysis for this string. */
  systemAnalysisWaterRateStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'vlpAnalysisFbhp' in this 'WellOutputs_String' view. */
  vlpAnalysisFbhp: Maybe<TimeSeries>;
  /** Reference to a time series for 'vlpAnalysisGasRateStd' in this 'WellOutputs_String' view. */
  vlpAnalysisGasRateStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'vlpAnalysisLiquidRateStd' in this 'WellOutputs_String' view. */
  vlpAnalysisLiquidRateStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'vlpAnalysisOilRateStd' in this 'WellOutputs_String' view. */
  vlpAnalysisOilRateStd: Maybe<TimeSeries>;
  /** Calculation status as a string for every run of the VLP method */
  vlpAnalysisStatus: Maybe<TimeSeries>;
  /** Reference to a time series for 'vlpAnalysisWaterRateStd' in this 'WellOutputs_String' view. */
  vlpAnalysisWaterRateStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'wag' in this 'WellOutputs_String' view. */
  wag: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellPerformance' in this 'WellOutputs_String' view. */
  wellPerformance: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellSepDP' in this 'WellOutputs_String' view. */
  wellSepDP: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellSepDT' in this 'WellOutputs_String' view. */
  wellSepDT: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestValidation' in this 'WellOutputs_String' view. */
  wellTestValidation: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellType' in this 'WellOutputs_String' view. */
  wellType: Maybe<TimeSeries>;
  /** Reference to a time series for 'wiBHP' in this 'WellOutputs_String' view. */
  wiBHP: Maybe<TimeSeries>;
  /** Reference to a time series for 'wiRate' in this 'WellOutputs_String' view. */
  wiRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'wiTargetRate' in this 'WellOutputs_String' view. */
  wiTargetRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'wiTechnicalRate' in this 'WellOutputs_String' view. */
  wiTechnicalRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'wiWHP' in this 'WellOutputs_String' view. */
  wiWHP: Maybe<TimeSeries>;
  /** Which number in the wing valve time series for the well string corresponds to the closed state. Based on statistical analysis. To be removed when extractor is able to retreive the wing valve position. */
  wingValveCloseState: Maybe<Scalars['Int']['output']>;
};

/**
 * Unconstrained production and injection potential time series per well string (WellInputs_String).
 *
 * All potential* rates: oil, gas, water production and water/gas injection. Compare to
 * PriorityRates_String_Agent or EstimatedRates_String_Agent for producers, and measured or
 * allocated injection views for injectors. Pair with Prodplan_String_Agent for allowable
 * and prodplan technical limits (separate container).
 *
 * Use for: potential vs estimated rate checks, underperforming wells (WF10/WF19).
 *
 * @name Well Potential — String (Agent)
 */
export type WellPotentialStringAgent = {
  /**
   * Unconstrained gas injection potential (TS). Compare to giRate, giTargetRate, or
   * MeasuredInjection_String_Agent gasInjRate.
   */
  potentialGasInjection: Maybe<TimeSeries>;
  /**
   * Unconstrained gas production potential / technical producer gas rate (TS). IPSO mapping
   * for technical gas rate. Compare to priorityGasRateStd or EstimatedRates.
   */
  potentialGasProduction: Maybe<TimeSeries>;
  /**
   * Unconstrained oil production potential (stb/d, TS). Compare to priorityOilRateStd
   * or EstimatedRates for underperformance on producers.
   */
  potentialOilProduction: Maybe<TimeSeries>;
  /**
   * Unconstrained water injection potential (stb/d, TS). Compare to wiRate, wiTargetRate,
   * or MeasuredInjection_String_Agent waterInjRate.
   */
  potentialWaterInjection: Maybe<TimeSeries>;
  /**
   * Unconstrained water production potential (stb/d, TS). Compare to priorityWaterRateStd
   * or EstimatedRates.
   */
  potentialWaterProduction: Maybe<TimeSeries>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString: Maybe<StringAsset>;
};

/**
 * Per-string operational status — lift type, well type, online state, valve
 * states, and reservoir pressure estimates.
 *
 * String-level state attributes sourced from field sensors and monitoring
 * systems, covering online, flow stability, and slugging indicators, surface
 * and subsurface valve positions, well classification (lift type, product,
 * WAG), and current reservoir pressure estimates. Distinct from
 * InactiveString_Agent, which classifies long-term inactivity. Excludes
 * historical performance and detailed production rates.
 *
 * Use for: Well Status Detection (WF25), Real-Time Surveillance (WF18).
 */
export type WellStatusStringAgent = {
  /** Hours online since midnight UTC+04:00, derived from onlineStatus (max 24). */
  hoursOnline: Maybe<TimeSeries>;
  /** Downhole instrumentation flag, numeric. 1 = real-time P/T gauges present, 0 = not instrumented. */
  instrumented: Maybe<Scalars['Float32']['output']>;
  /** Artificial lift method. Values are NATURAL_FLOW, ESP, GAS_LIFT, ROD_PUMP, JET_PUMP, PCP. String Time Series. */
  liftType: Maybe<TimeSeries>;
  /** Online state, numeric. 0 = shut-in, 1 = flowing. */
  onlineStatus: Maybe<TimeSeries>;
  /** Reasons recorded at shut-in start that triggered the shut-in detection. String Time Series. */
  onlineStatusReason: Maybe<TimeSeries>;
  /** Pressure compliance status. Values are COMPLIANT, NON_COMPLIANT, WARNING. String Time Series. */
  pressureCompliance: Maybe<TimeSeries>;
  /** Source method used to derive reservoir pressure. String Time Series. */
  pressureSource: Maybe<TimeSeries>;
  /** Primary product type. Values are OIL, GAS, CONDENSATE, WATER. String Time Series. */
  product: Maybe<TimeSeries>;
  /** Estimated reservoir pressure at datum depth (psi). */
  reservoirPressureDatum: Maybe<TimeSeries>;
  /** Estimated reservoir pressure at mid-perforation depth (psi). */
  reservoirPressureMidPerforation: Maybe<TimeSeries>;
  /** Hydrodynamic slug-flow indicator, numeric. 0 = not slugging, 1 = slugging. */
  sluggingStatus: Maybe<TimeSeries>;
  /** Flow stability, numeric. 0 = transient or shut-in, 1 = quasi-steady-state flowing. */
  steadyStateStatus: Maybe<TimeSeries>;
  /** Subsurface safety valve (SSSV) state, numeric. 0 = OPEN, 1 = CLOSED. */
  subSurfaceSafetyValveCloseState: Maybe<Scalars['Int']['output']>;
  /** Surface safety valve (SSV) state, numeric. 0 = OPEN, 1 = CLOSED. */
  surfaceSafetyValveCloseState: Maybe<Scalars['Int']['output']>;
  /** Water-alternating-gas injection flag. Values are YES, NO. String Time Series. */
  wag: Maybe<TimeSeries>;
  /** Reference to the well string entity. */
  wellString: Maybe<StringAsset>;
  /** Validation status of the most recent well test. Values are VALID, INVALID, PENDING_REVIEW. String Time Series. */
  wellTestValidation: Maybe<TimeSeries>;
  /** Well classification. Values are PRODUCTION, INJECTION, OBSERVATION, DISPOSAL, WAG. String Time Series. */
  wellType: Maybe<TimeSeries>;
  /** Wing valve state, numeric. 0 = OPEN, 1 = CLOSED. */
  wingValveCloseState: Maybe<Scalars['Int']['output']>;
};

/**
 * Per-string well test analysis outputs — productivity and injectivity
 * indices, reservoir pressure, last-test rates and pressures, and current
 * model estimates.
 *
 * String-level outputs from the well test analysis workflow (WF03).
 * Productivity and injectivity indices with percent change versus the
 * previous accepted test, reservoir pressure with percent change, timestamp
 * and measured rates and pressures from the last accepted test, and current
 * real-time model estimates of rates and flowing bottomhole pressure.
 * Excludes raw measurement curves and detailed completion or geological
 * context.
 *
 * Use for: Well Test Analysis (WF03), Real-Time Surveillance (WF18).
 *
 * @name Well Test Analysis (Agent)
 */
export type WellTestAnalysisAgent = {
  /** Current model-estimated flowing bottomhole pressure (psia). */
  modelEstimatedFbhp: Maybe<TimeSeries>;
  /** Current model-estimated gas rate (Mscf/d). */
  modelEstimatedGasRate: Maybe<TimeSeries>;
  /** Current model-estimated total liquid rate (oil + water) (stb/d). */
  modelEstimatedLiquidRate: Maybe<TimeSeries>;
  /** Current model-estimated oil rate (stb/d). */
  modelEstimatedOilRate: Maybe<TimeSeries>;
  /** Current model-estimated water rate (stb/d). */
  modelEstimatedWaterRate: Maybe<TimeSeries>;
  /** Injectivity Index for injection wells from the well test model (stb/d/psi). */
  modelInjectivityIndex: Maybe<TimeSeries>;
  /** Percent change in injectivity index versus the previous accepted well test (%). */
  modelInjectivityIndexPercentChange: Maybe<TimeSeries>;
  /** Productivity Index from the well test model (stb/d/psi). */
  modelProductivityIndex: Maybe<TimeSeries>;
  /** Percent change in productivity index versus the previous accepted well test (%). */
  modelProductivityIndexPercentChange: Maybe<TimeSeries>;
  /** Reservoir pressure from the well test model (psia). */
  modelReservoirPressure: Maybe<TimeSeries>;
  /** Percent change in reservoir pressure versus the previous accepted well test (%). */
  modelReservoirPressurePercentChange: Maybe<TimeSeries>;
  /** Casing head pressure during the last accepted well test (psia). */
  modelWellTestChp: Maybe<TimeSeries>;
  /** Gas rate measured at the last accepted well test (Mscf/d). */
  modelWellTestGasRate: Maybe<TimeSeries>;
  /** Gas-Oil Ratio measured at the last accepted well test (scf/stb). */
  modelWellTestGor: Maybe<TimeSeries>;
  /** Total liquid rate (oil + water) measured at the last accepted well test (stb/d). */
  modelWellTestLiquidRate: Maybe<TimeSeries>;
  /** Permanent downhole gauge pressure during the last accepted well test (psia). */
  modelWellTestPdgPress: Maybe<TimeSeries>;
  /** Timestamp of the last accepted well test. */
  modelWellTestTimestamp: Maybe<TimeSeries>;
  /** Water cut (water / total liquid) measured at the last accepted well test (%). */
  modelWellTestWc: Maybe<TimeSeries>;
  /** Wellhead pressure during the last accepted well test (psia). */
  modelWellTestWhp: Maybe<TimeSeries>;
  /** Reference to the well string entity. */
  wellString: Maybe<StringAsset>;
};

/** View 'WellTestGauge_String' in the iPSO production optimization solution data model. */
export type WellTestGaugeString = {
  /** Reference to the related 'String_asset' entity for this 'WellTestGauge_String' row. */
  entityName: Maybe<StringAsset>;
  /** Reference to a time series for 'lowerDatumDepth' in this 'WellTestGauge_String' view. */
  lowerDatumDepth: Maybe<TimeSeries>;
  /** Reference to a time series for 'lowerGaugeDepth' in this 'WellTestGauge_String' view. */
  lowerGaugeDepth: Maybe<TimeSeries>;
  /** Reference to a time series for 'lowerGaugePosition' in this 'WellTestGauge_String' view. */
  lowerGaugePosition: Maybe<TimeSeries>;
  /** Reference to a time series for 'lowerProductivityIndex' in this 'WellTestGauge_String' view. */
  lowerProductivityIndex: Maybe<TimeSeries>;
  /** Reference to a time series for 'lowerProductivityIndexSS' in this 'WellTestGauge_String' view. */
  lowerProductivityIndexSS: Maybe<TimeSeries>;
  /** Reference to a time series for 'lowerResPressAtDatum' in this 'WellTestGauge_String' view. */
  lowerResPressAtDatum: Maybe<TimeSeries>;
  /** Reference to a time series for 'lowerResPressAtGauge' in this 'WellTestGauge_String' view. */
  lowerResPressAtGauge: Maybe<TimeSeries>;
  /** Reference to a time series for 'lowerSelectedGradient' in this 'WellTestGauge_String' view. */
  lowerSelectedGradient: Maybe<TimeSeries>;
  /** Reference to a time series for 'lowerTestType' in this 'WellTestGauge_String' view. */
  lowerTestType: Maybe<TimeSeries>;
  /** Reference to a time series for 'naDatumDepth' in this 'WellTestGauge_String' view. */
  naDatumDepth: Maybe<TimeSeries>;
  /** Reference to a time series for 'naGaugeDepth' in this 'WellTestGauge_String' view. */
  naGaugeDepth: Maybe<TimeSeries>;
  /** Reference to a time series for 'naGaugePosition' in this 'WellTestGauge_String' view. */
  naGaugePosition: Maybe<TimeSeries>;
  /** Reference to a time series for 'naProductivityIndex' in this 'WellTestGauge_String' view. */
  naProductivityIndex: Maybe<TimeSeries>;
  /** Reference to a time series for 'naProductivityIndexSS' in this 'WellTestGauge_String' view. */
  naProductivityIndexSS: Maybe<TimeSeries>;
  /** Reference to a time series for 'naResPressAtDatum' in this 'WellTestGauge_String' view. */
  naResPressAtDatum: Maybe<TimeSeries>;
  /** Reference to a time series for 'naResPressAtGauge' in this 'WellTestGauge_String' view. */
  naResPressAtGauge: Maybe<TimeSeries>;
  /** Reference to a time series for 'naSelectedGradient' in this 'WellTestGauge_String' view. */
  naSelectedGradient: Maybe<TimeSeries>;
  /** Reference to a time series for 'naTestType' in this 'WellTestGauge_String' view. */
  naTestType: Maybe<TimeSeries>;
  /** Reference to a time series for 'upperDatumDepth' in this 'WellTestGauge_String' view. */
  upperDatumDepth: Maybe<TimeSeries>;
  /** Reference to a time series for 'upperGaugeDepth' in this 'WellTestGauge_String' view. */
  upperGaugeDepth: Maybe<TimeSeries>;
  /** Reference to a time series for 'upperGaugePosition' in this 'WellTestGauge_String' view. */
  upperGaugePosition: Maybe<TimeSeries>;
  /** Reference to a time series for 'upperProductivityIndex' in this 'WellTestGauge_String' view. */
  upperProductivityIndex: Maybe<TimeSeries>;
  /** Reference to a time series for 'upperProductivityIndexSS' in this 'WellTestGauge_String' view. */
  upperProductivityIndexSS: Maybe<TimeSeries>;
  /** Reference to a time series for 'upperResPressAtDatum' in this 'WellTestGauge_String' view. */
  upperResPressAtDatum: Maybe<TimeSeries>;
  /** Reference to a time series for 'upperResPressAtGauge' in this 'WellTestGauge_String' view. */
  upperResPressAtGauge: Maybe<TimeSeries>;
  /** Reference to a time series for 'upperSelectedGradient' in this 'WellTestGauge_String' view. */
  upperSelectedGradient: Maybe<TimeSeries>;
  /** Reference to a time series for 'upperTestType' in this 'WellTestGauge_String' view. */
  upperTestType: Maybe<TimeSeries>;
};

/** View 'WellTestInputs_String' in the iPSO production optimization solution data model. */
export type WellTestInputsString = {
  /** Reference to a time series for 'cgrLC' in this 'WellTestInputs_String' view. */
  cgrLC: Maybe<TimeSeries>;
  /** Reference to a time series for 'chokeAlarms' in this 'WellTestInputs_String' view. */
  chokeAlarms: Maybe<TimeSeries>;
  /** Reference to a time series for 'chokeAlarmsCode' in this 'WellTestInputs_String' view. */
  chokeAlarmsCode: Maybe<TimeSeries>;
  /** Reference to a time series for 'chokeMatchedliquidRate' in this 'WellTestInputs_String' view. */
  chokeMatchedliquidRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'comments' in this 'WellTestInputs_String' view. */
  comments: Maybe<TimeSeries>;
  /** Reference to a time series for 'composition' in this 'WellTestInputs_String' view. */
  composition: Maybe<TimeSeries>;
  /** Reference to the related 'String_asset' entity for this 'WellTestInputs_String' row. */
  entityName: Maybe<StringAsset>;
  /** Reference to a time series for 'espwear' in this 'WellTestInputs_String' view. */
  espwear: Maybe<TimeSeries>;
  /** Reference to a time series for 'fluidProperties' in this 'WellTestInputs_String' view. */
  fluidProperties: Maybe<TimeSeries>;
  /** Reference to a time series for 'formationGOR' in this 'WellTestInputs_String' view. */
  formationGOR: Maybe<TimeSeries>;
  /** Reference to a time series for 'gasDensityLC' in this 'WellTestInputs_String' view. */
  gasDensityLC: Maybe<TimeSeries>;
  /** Reference to a time series for 'gasDensitySC' in this 'WellTestInputs_String' view. */
  gasDensitySC: Maybe<TimeSeries>;
  /** Reference to a time series for 'gasMassFlowRateLC' in this 'WellTestInputs_String' view. */
  gasMassFlowRateLC: Maybe<TimeSeries>;
  /** Reference to a time series for 'gasMassFlowRateSC' in this 'WellTestInputs_String' view. */
  gasMassFlowRateSC: Maybe<TimeSeries>;
  /** Reference to a time series for 'gasVolumeFractionLC' in this 'WellTestInputs_String' view. */
  gasVolumeFractionLC: Maybe<TimeSeries>;
  /** Reference to a time series for 'glFcvOutletTemp' in this 'WellTestInputs_String' view. */
  glFcvOutletTemp: Maybe<TimeSeries>;
  /** Reference to a time series for 'glinjectionRate' in this 'WellTestInputs_String' view. */
  glinjectionRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'historicalAlarms' in this 'WellTestInputs_String' view. */
  historicalAlarms: Maybe<TimeSeries>;
  /** Reference to a time series for 'historicalAlarmsCode' in this 'WellTestInputs_String' view. */
  historicalAlarmsCode: Maybe<TimeSeries>;
  /** Reference to a time series for 'lastUpdatedByStablePeriod' in this 'WellTestInputs_String' view. */
  lastUpdatedByStablePeriod: Maybe<TimeSeries>;
  /** Reference to a time series for 'lastUpdatedByWellTest' in this 'WellTestInputs_String' view. */
  lastUpdatedByWellTest: Maybe<TimeSeries>;
  /** Reference to a time series for 'liquidRateLc' in this 'WellTestInputs_String' view. */
  liquidRateLc: Maybe<TimeSeries>;
  /** Reference to a time series for 'liquidRateSc' in this 'WellTestInputs_String' view. */
  liquidRateSc: Maybe<TimeSeries>;
  /** Reference to a time series for 'modelAlarms' in this 'WellTestInputs_String' view. */
  modelAlarms: Maybe<TimeSeries>;
  /** Reference to a time series for 'modelAlarmsCode' in this 'WellTestInputs_String' view. */
  modelAlarmsCode: Maybe<TimeSeries>;
  /** Reference to a time series for 'modelComposition' in this 'WellTestInputs_String' view. */
  modelComposition: Maybe<TimeSeries>;
  /** Reference to a time series for 'modelMatchedBHP' in this 'WellTestInputs_String' view. */
  modelMatchedBHP: Maybe<TimeSeries>;
  /** Reference to a time series for 'modelMatchedgasRate' in this 'WellTestInputs_String' view. */
  modelMatchedgasRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'modelMatchedliquidRate' in this 'WellTestInputs_String' view. */
  modelMatchedliquidRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'modelMatchedoilRate' in this 'WellTestInputs_String' view. */
  modelMatchedoilRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'modelMatchedwaterRate' in this 'WellTestInputs_String' view. */
  modelMatchedwaterRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'modelMinStableRate' in this 'WellTestInputs_String' view. */
  modelMinStableRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'modelProductivityIndex' in this 'WellTestInputs_String' view. */
  modelProductivityIndex: Maybe<TimeSeries>;
  /** Reference to a time series for 'modelReservoirModel' in this 'WellTestInputs_String' view. */
  modelReservoirModel: Maybe<TimeSeries>;
  /** Reference to a time series for 'modelReservoirPressure' in this 'WellTestInputs_String' view. */
  modelReservoirPressure: Maybe<TimeSeries>;
  /** Reference to a time series for 'modelStabilityFlag' in this 'WellTestInputs_String' view. */
  modelStabilityFlag: Maybe<TimeSeries>;
  /** Reference to a time series for 'modelVlpModel' in this 'WellTestInputs_String' view. */
  modelVlpModel: Maybe<TimeSeries>;
  /** Reference to a time series for 'modelWellTestTimestamp' in this 'WellTestInputs_String' view. */
  modelWellTestTimestamp: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmAlarms' in this 'WellTestInputs_String' view. */
  mpfmAlarms: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmDifferentialPressure' in this 'WellTestInputs_String' view. */
  mpfmDifferentialPressure: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmLinePressure' in this 'WellTestInputs_String' view. */
  mpfmLinePressure: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmLineTemperature' in this 'WellTestInputs_String' view. */
  mpfmLineTemperature: Maybe<TimeSeries>;
  /** Reference to a time series for 'oilDensityLC' in this 'WellTestInputs_String' view. */
  oilDensityLC: Maybe<TimeSeries>;
  /** Reference to a time series for 'oilDensitySC' in this 'WellTestInputs_String' view. */
  oilDensitySC: Maybe<TimeSeries>;
  /** Reference to a time series for 'oilMassFlowRateLC' in this 'WellTestInputs_String' view. */
  oilMassFlowRateLC: Maybe<TimeSeries>;
  /** Reference to a time series for 'oilMassFlowRateSC' in this 'WellTestInputs_String' view. */
  oilMassFlowRateSC: Maybe<TimeSeries>;
  /** Reference to a time series for 'oilVolumeFractionLC' in this 'WellTestInputs_String' view. */
  oilVolumeFractionLC: Maybe<TimeSeries>;
  /** Reference to a time series for 'optionalComments' in this 'WellTestInputs_String' */
  optionalComments: Maybe<TimeSeries>;
  /** Reference to a time series for 'ptsDateTime' in this 'WellTestInputs_String' view. */
  ptsDateTime: Maybe<TimeSeries>;
  /** Reference to a time series for 'pumpDischargeTemp' in this 'WellTestInputs_String' view. */
  pumpDischargeTemp: Maybe<TimeSeries>;
  /** Reference to a time series for 'pumpMotorTemp' in this 'WellTestInputs_String' view. */
  pumpMotorTemp: Maybe<TimeSeries>;
  /** Reference to a time series for 'pumpPower' in this 'WellTestInputs_String' view. */
  pumpPower: Maybe<TimeSeries>;
  /** Reference to a time series for 'pumpVibration' in this 'WellTestInputs_String' view. */
  pumpVibration: Maybe<TimeSeries>;
  /** Reference to a time series for 'pvtAlarms' in this 'WellTestInputs_String' view. */
  pvtAlarms: Maybe<TimeSeries>;
  /** Reference to a time series for 'rejectionCategory' in this 'WellTestInputs_String' view. */
  rejectionCategory: Maybe<TimeSeries>;
  /** Reference to a time series for 'sampleDateTime' in this 'WellTestInputs_String' view. */
  sampleDateTime: Maybe<TimeSeries>;
  /** Reference to a time series for 'stablePeriodEndDate' in this 'WellTestInputs_String' view. */
  stablePeriodEndDate: Maybe<TimeSeries>;
  /** Reference to a time series for 'stablePeriodStartDate' in this 'WellTestInputs_String' view. */
  stablePeriodStartDate: Maybe<TimeSeries>;
  /** Reference to a time series for 'validatedBy' in this 'WellTestInputs_String' view. */
  validatedBy: Maybe<TimeSeries>;
  /** Reference to a time series for 'waterDensityLC' in this 'WellTestInputs_String' view. */
  waterDensityLC: Maybe<TimeSeries>;
  /** Reference to a time series for 'waterDensitySC' in this 'WellTestInputs_String' view. */
  waterDensitySC: Maybe<TimeSeries>;
  /** Reference to a time series for 'waterMassFlowRateLC' in this 'WellTestInputs_String' view. */
  waterMassFlowRateLC: Maybe<TimeSeries>;
  /** Reference to a time series for 'waterMassFlowRateSC' in this 'WellTestInputs_String' view. */
  waterMassFlowRateSC: Maybe<TimeSeries>;
  /** Reference to a time series for 'waterVolumeFractionLC' in this 'WellTestInputs_String' view. */
  waterVolumeFractionLC: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestApprovedAllocationFlag' in this 'WellTestInputs_String' view. */
  wellTestApprovedAllocationFlag: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestArtificialLiftType' in this 'WellTestInputs_String' view. */
  wellTestArtificialLiftType: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestBottomHolePressure' in this 'WellTestInputs_String' view. */
  wellTestBottomHolePressure: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestBottomHoleTemperature' in this 'WellTestInputs_String' view. */
  wellTestBottomHoleTemperature: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestCGR' in this 'WellTestInputs_String' view. */
  wellTestCGR: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestCasingHeadPressure' in this 'WellTestInputs_String' view. */
  wellTestCasingHeadPressure: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestCasingHeadTemperature' in this 'WellTestInputs_String' view. */
  wellTestCasingHeadTemperature: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestChokeOpening' in this 'WellTestInputs_String' view. */
  wellTestChokeOpening: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestChokeSize' in this 'WellTestInputs_String' view. */
  wellTestChokeSize: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestCreatedBy' in this 'WellTestInputs_String' */
  wellTestCreatedBy: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestCreatedDateTime' in this 'WellTestInputs_String' */
  wellTestCreatedDateTime: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestDuration' in this 'WellTestInputs_String' view. */
  wellTestDuration: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestEgorVendorStdGasRate' in this 'WellTestInputs_String' view. */
  wellTestEgorVendorStdGasRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestEgorVendorStdOilRate' in this 'WellTestInputs_String' view. */
  wellTestEgorVendorStdOilRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestEgorVendorStdWaterRate' in this 'WellTestInputs_String' view. */
  wellTestEgorVendorStdWaterRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestEndDate' in this 'WellTestInputs_String' view. */
  wellTestEndDate: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestEspMotorCurrent' in this 'WellTestInputs_String' view. */
  wellTestEspMotorCurrent: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestEspMotorPower' in this 'WellTestInputs_String' view. */
  wellTestEspMotorPower: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestEspMotorVoltage' in this 'WellTestInputs_String' view. */
  wellTestEspMotorVoltage: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestEspPumpDischargePressure' in this 'WellTestInputs_String' view. */
  wellTestEspPumpDischargePressure: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestEspPumpFrequency' in this 'WellTestInputs_String' view. */
  wellTestEspPumpFrequency: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestEspPumpIntakePressure' in this 'WellTestInputs_String' view. */
  wellTestEspPumpIntakePressure: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestEspPumpIntakeTemperature' in this 'WellTestInputs_String' view. */
  wellTestEspPumpIntakeTemperature: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestFlowlinePressure' in this 'WellTestInputs_String' view. */
  wellTestFlowlinePressure: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestFlowlineTemperature' in this 'WellTestInputs_String' view. */
  wellTestFlowlineTemperature: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGOR' in this 'WellTestInputs_String' view. */
  wellTestGOR: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGasDensityInSitu' in this 'WellTestInputs_String' view. */
  wellTestGasDensityInSitu: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGasLiftVolume' in this 'WellTestInputs_String' view. */
  wellTestGasLiftVolume: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGasRateInsitu' in this 'WellTestInputs_String' view. */
  wellTestGasRateInsitu: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGasRatePts' in this 'WellTestInputs_String' view. */
  wellTestGasRatePts: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGasRateStd' in this 'WellTestInputs_String' view. */
  wellTestGasRateStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGlFlControlValvOutletPres' in this 'WellTestInputs_String' view. */
  wellTestGlFlControlValvOutletPres: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGlFlControlValveInletPres' in this 'WellTestInputs_String' view. */
  wellTestGlFlControlValveInletPres: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGlFlControlValveInletTemp' in this 'WellTestInputs_String' view. */
  wellTestGlFlControlValveInletTemp: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGlInjectionChokeOpening' in this 'WellTestInputs_String' view. */
  wellTestGlInjectionChokeOpening: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGlInjectionChokeSize' in this 'WellTestInputs_String' view. */
  wellTestGlInjectionChokeSize: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGorInsitu' in this 'WellTestInputs_String' view. */
  wellTestGorInsitu: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGorPts' in this 'WellTestInputs_String' view. */
  wellTestGorPts: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestLiquidRateLC' in this 'WellTestInputs_String' view. */
  wellTestLiquidRateLC: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestLiquidRatePts' in this 'WellTestInputs_String' view. */
  wellTestLiquidRatePts: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestLiquidRateSC' in this 'WellTestInputs_String' view. */
  wellTestLiquidRateSC: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestMpfmName' in this 'WellTestInputs_String' view. */
  wellTestMpfmName: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestOilDensityInSitu' in this 'WellTestInputs_String' view. */
  wellTestOilDensityInSitu: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestOilRateInsitu' in this 'WellTestInputs_String' view. */
  wellTestOilRateInsitu: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestOilRatePts' in this 'WellTestInputs_String' view. */
  wellTestOilRatePts: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestOilRateStd' in this 'WellTestInputs_String' view. */
  wellTestOilRateStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestStartDate' in this 'WellTestInputs_String' view. */
  wellTestStartDate: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestStartDateDH' in this 'WellTestInputs_String' view. */
  wellTestStartDateDH: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestStatusDetails' in this 'WellTestInputs_String' */
  wellTestStatusDetails: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestStringFunction' in this 'WellTestInputs_String' view. */
  wellTestStringFunction: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestTestMethod' in this 'WellTestInputs_String' view. */
  wellTestTestMethod: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestTestSeparatorLinePressure' in this 'WellTestInputs_String' view. */
  wellTestTestSeparatorLinePressure: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestTestSeparatorLineTemperature' in this 'WellTestInputs_String' view. */
  wellTestTestSeparatorLineTemperature: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestTestType' in this 'WellTestInputs_String' view. */
  wellTestTestType: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestTestTypeDesc' in this 'WellTestInputs_String' view. */
  wellTestTestTypeDesc: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestTotalGorStd' in this 'WellTestInputs_String' view. */
  wellTestTotalGorStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestTotalMassFlowRateGas' in this 'WellTestInputs_String' view. */
  wellTestTotalMassFlowRateGas: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestTotalMassFlowRateOil' in this 'WellTestInputs_String' view. */
  wellTestTotalMassFlowRateOil: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestTotalMassFlowRateWater' in this 'WellTestInputs_String' view. */
  wellTestTotalMassFlowRateWater: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestValidationFlag' in this 'WellTestInputs_String' view. */
  wellTestValidationFlag: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestValidationTime' in this 'WellTestInputs_String' */
  wellTestValidationTime: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestWGR' in this 'WellTestInputs_String' view. */
  wellTestWGR: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestWaterCut' in this 'WellTestInputs_String' view. */
  wellTestWaterCut: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestWaterCutInsitu' in this 'WellTestInputs_String' view. */
  wellTestWaterCutInsitu: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestWaterCutPts' in this 'WellTestInputs_String' view. */
  wellTestWaterCutPts: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestWaterRateInsitu' in this 'WellTestInputs_String' view. */
  wellTestWaterRateInsitu: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestWaterRatePts' in this 'WellTestInputs_String' view. */
  wellTestWaterRatePts: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestWaterRateStd' in this 'WellTestInputs_String' view. */
  wellTestWaterRateStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestWellheadPressure' in this 'WellTestInputs_String' view. */
  wellTestWellheadPressure: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestWellheadTemperature' in this 'WellTestInputs_String' view. */
  wellTestWellheadTemperature: Maybe<TimeSeries>;
  /** Reference to a time series for 'wgrLC' in this 'WellTestInputs_String' view. */
  wgrLC: Maybe<TimeSeries>;
  /** Reference to a time series for 'wlrLC' in this 'WellTestInputs_String' view. */
  wlrLC: Maybe<TimeSeries>;
};

/** Aggregated outputs from individual well tests for each well string, including test timing, multiphase rates at standard and line conditions, derived ratios (GOR, WCT), phase densities and mass flow rates used for well performance and model calibration. */
export type WellTestOutputsString = {
  /** Reference to a time series for 'cdValue' in this 'WellTestOutputs_String' view. */
  cdValue: Maybe<TimeSeries>;
  /** Reference to a time series for 'cgrLC' in this 'WellTestOutputs_String' view. */
  cgrLC: Maybe<TimeSeries>;
  /** Reference to a time series for 'cgrSC' in this 'WellTestOutputs_String' view. */
  cgrSC: Maybe<TimeSeries>;
  /** Reference to a time series for 'chokeAlarms' in this 'WellTestOutputs_String' view. */
  chokeAlarms: Maybe<TimeSeries>;
  /** Reference to a time series for 'chokeAlarmsCode' in this 'WellTestOutputs_String' view. */
  chokeAlarmsCode: Maybe<TimeSeries>;
  /** Reference to a time series for 'chokeMatchedgasRate' in this 'WellTestOutputs_String' view. */
  chokeMatchedgasRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'chokeMatchedliquidRate' in this 'WellTestOutputs_String' view. */
  chokeMatchedliquidRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'chokeSize' in this 'WellTestOutputs_String' view. */
  chokeSize: Maybe<TimeSeries>;
  /** Reference to a time series for 'chokeSizeInch' in this 'WellTestOutputs_String' view. */
  chokeSizeInch: Maybe<TimeSeries>;
  /** Reference to a time series for 'chp' in this 'WellTestOutputs_String' view. */
  chp: Maybe<TimeSeries>;
  /** Reference to a time series for 'dhgp' in this 'WellTestOutputs_String' view. */
  dhgp: Maybe<TimeSeries>;
  /** Reference to a time series for 'dhgt' in this 'WellTestOutputs_String' view. */
  dhgt: Maybe<TimeSeries>;
  /** Name of the well string (completion) for which well test results are stored in this view, sourced from the 'String_asset' view. */
  entityName: Maybe<StringAsset>;
  /** Reference to a time series for 'espwear' in this 'WellTestOutputs_String' view. */
  espwear: Maybe<TimeSeries>;
  /** Reference to a time series for 'flp' in this 'WellTestOutputs_String' view. */
  flp: Maybe<TimeSeries>;
  /** Reference to a time series for 'flt' in this 'WellTestOutputs_String' view. */
  flt: Maybe<TimeSeries>;
  /** Reference to a time series for 'gasDensityLC' in this 'WellTestOutputs_String' view. */
  gasDensityLC: Maybe<TimeSeries>;
  /** Reference to a time series for 'gasDensitySC' in this 'WellTestOutputs_String' view. */
  gasDensitySC: Maybe<TimeSeries>;
  /** Reference to a time series for 'gasMassFlowRateLC' in this 'WellTestOutputs_String' view. */
  gasMassFlowRateLC: Maybe<TimeSeries>;
  /** Reference to a time series for 'gasMassFlowRateSC' in this 'WellTestOutputs_String' view. */
  gasMassFlowRateSC: Maybe<TimeSeries>;
  /** Reference to a time series for 'gasRateLC' in this 'WellTestOutputs_String' view. */
  gasRateLC: Maybe<TimeSeries>;
  /** Time series of measured gas production rate at standard conditions during the well test. */
  gasRateSC: Maybe<TimeSeries>;
  /** Reference to a time series for 'gasVolumeFractionLC' in this 'WellTestOutputs_String' view. */
  gasVolumeFractionLC: Maybe<TimeSeries>;
  /** Reference to a time series for 'glFcvChokeSize' in this 'WellTestOutputs_String' view. */
  glFcvChokeSize: Maybe<TimeSeries>;
  /** Reference to a time series for 'glFcvInletPress' in this 'WellTestOutputs_String' view. */
  glFcvInletPress: Maybe<TimeSeries>;
  /** Reference to a time series for 'glFcvInletTemp' in this 'WellTestOutputs_String' view. */
  glFcvInletTemp: Maybe<TimeSeries>;
  /** Reference to a time series for 'glFcvOutletPress' in this 'WellTestOutputs_String' view. */
  glFcvOutletPress: Maybe<TimeSeries>;
  /** Reference to a time series for 'glFcvOutletTemp' in this 'WellTestOutputs_String' view. */
  glFcvOutletTemp: Maybe<TimeSeries>;
  /** Reference to a time series for 'glinjectionRate' in this 'WellTestOutputs_String' view. */
  glinjectionRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'gorLC' in this 'WellTestOutputs_String' view. */
  gorLC: Maybe<TimeSeries>;
  /** Reference to a time series for 'historicalAlarms' in this 'WellTestOutputs_String' view. */
  historicalAlarms: Maybe<TimeSeries>;
  /** Reference to a time series for 'historicalAlarmsCode' in this 'WellTestOutputs_String' view. */
  historicalAlarmsCode: Maybe<TimeSeries>;
  /** Reference to a time series for 'liquidRateLc' in this 'WellTestOutputs_String' view. */
  liquidRateLc: Maybe<TimeSeries>;
  /** Reference to a time series for 'liquidRateSc' in this 'WellTestOutputs_String' view. */
  liquidRateSc: Maybe<TimeSeries>;
  /** Reference to a time series for 'modelAlarms' in this 'WellTestOutputs_String' view. */
  modelAlarms: Maybe<TimeSeries>;
  /** Reference to a time series for 'modelAlarmsCode' in this 'WellTestOutputs_String' view. */
  modelAlarmsCode: Maybe<TimeSeries>;
  /** Reference to a time series for 'modelMatchedBHP' in this 'WellTestOutputs_String' view. */
  modelMatchedBHP: Maybe<TimeSeries>;
  /** Reference to a time series for 'modelMatchedgasRate' in this 'WellTestOutputs_String' view. */
  modelMatchedgasRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'modelMatchedliquidRate' in this 'WellTestOutputs_String' view. */
  modelMatchedliquidRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'modelMatchedoilRate' in this 'WellTestOutputs_String' view. */
  modelMatchedoilRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'modelMatchedwaterRate' in this 'WellTestOutputs_String' view. */
  modelMatchedwaterRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'modelMinStableRate' in this 'WellTestOutputs_String' view. */
  modelMinStableRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'modelProductivityIndex' in this 'WellTestOutputs_String' view. */
  modelProductivityIndex: Maybe<TimeSeries>;
  /** Reference to a time series for 'modelReservoirModel' in this 'WellTestOutputs_String' view. */
  modelReservoirModel: Maybe<TimeSeries>;
  /** Reference to a time series for 'modelReservoirPressure' in this 'WellTestOutputs_String' view. */
  modelReservoirPressure: Maybe<TimeSeries>;
  /** Reference to a time series for 'modelStabilityFlag' in this 'WellTestOutputs_String' view. */
  modelStabilityFlag: Maybe<TimeSeries>;
  /** Timestamp 'modelVlpModel' associated with this 'WellTestOutputs_String' row. */
  modelVlpModel: Maybe<Scalars['Timestamp']['output']>;
  /** Reference to a time series for 'modelWellTestTimestamp' in this 'WellTestOutputs_String' view. */
  modelWellTestTimestamp: Maybe<TimeSeries>;
  /** Time series flag or identifier indicating that the test was performed using a multiphase flow meter (MPFM). */
  mpfm: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmAlarms' in this 'WellTestOutputs_String' view. */
  mpfmAlarms: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmDifferentialPressure' in this 'WellTestOutputs_String' view. */
  mpfmDifferentialPressure: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmLinePressure' in this 'WellTestOutputs_String' view. */
  mpfmLinePressure: Maybe<TimeSeries>;
  /** Reference to a time series for 'mpfmLineTemperature' in this 'WellTestOutputs_String' view. */
  mpfmLineTemperature: Maybe<TimeSeries>;
  /** Reference to a time series for 'oilDensityLC' in this 'WellTestOutputs_String' view. */
  oilDensityLC: Maybe<TimeSeries>;
  /** Reference to a time series for 'oilDensitySC' in this 'WellTestOutputs_String' view. */
  oilDensitySC: Maybe<TimeSeries>;
  /** Reference to a time series for 'oilMassFlowRateLC' in this 'WellTestOutputs_String' view. */
  oilMassFlowRateLC: Maybe<TimeSeries>;
  /** Reference to a time series for 'oilMassFlowRateSC' in this 'WellTestOutputs_String' view. */
  oilMassFlowRateSC: Maybe<TimeSeries>;
  /** Reference to a time series for 'oilRateLC' in this 'WellTestOutputs_String' view. */
  oilRateLC: Maybe<TimeSeries>;
  /** Time series of measured oil production rate at standard conditions during the well test. */
  oilRateSC: Maybe<TimeSeries>;
  /** Reference to a time series for 'oilVolumeFractionLC' in this 'WellTestOutputs_String' view. */
  oilVolumeFractionLC: Maybe<TimeSeries>;
  /** Reference to a time series for 'pumpCurrent' in this 'WellTestOutputs_String' view. */
  pumpCurrent: Maybe<TimeSeries>;
  /** Reference to a time series for 'pumpDischargePress' in this 'WellTestOutputs_String' view. */
  pumpDischargePress: Maybe<TimeSeries>;
  /** Reference to a time series for 'pumpDischargeTemp' in this 'WellTestOutputs_String' view. */
  pumpDischargeTemp: Maybe<TimeSeries>;
  /** Reference to a time series for 'pumpFrequency' in this 'WellTestOutputs_String' view. */
  pumpFrequency: Maybe<TimeSeries>;
  /** Reference to a time series for 'pumpIntakePress' in this 'WellTestOutputs_String' view. */
  pumpIntakePress: Maybe<TimeSeries>;
  /** Reference to a time series for 'pumpIntakeTemp' in this 'WellTestOutputs_String' view. */
  pumpIntakeTemp: Maybe<TimeSeries>;
  /** Reference to a time series for 'pumpMotorTemp' in this 'WellTestOutputs_String' view. */
  pumpMotorTemp: Maybe<TimeSeries>;
  /** Reference to a time series for 'pumpPower' in this 'WellTestOutputs_String' view. */
  pumpPower: Maybe<TimeSeries>;
  /** Reference to a time series for 'pumpVibration' in this 'WellTestOutputs_String' view. */
  pumpVibration: Maybe<TimeSeries>;
  /** Reference to a time series for 'pumpVoltage' in this 'WellTestOutputs_String' view. */
  pumpVoltage: Maybe<TimeSeries>;
  /** Reference to a time series for 'pvtAlarms' in this 'WellTestOutputs_String' view. */
  pvtAlarms: Maybe<TimeSeries>;
  /** Reference to a time series for 'pvtAlarmsCode' in this 'WellTestOutputs_String' view. */
  pvtAlarmsCode: Maybe<TimeSeries>;
  /** Time series of timestamps indicating when the stable measurement period of each well test ends. */
  stablePeriodEndDate: Maybe<TimeSeries>;
  /** Time series of timestamps indicating when the stable measurement period of each well test begins. */
  stablePeriodStartDate: Maybe<TimeSeries>;
  /** Time series of total gasâ€“oil ratio (GOR) at standard conditions derived from well test measurements. */
  totalGorSC: Maybe<TimeSeries>;
  /** Reference to a time series for 'waterCutLC' in this 'WellTestOutputs_String' view. */
  waterCutLC: Maybe<TimeSeries>;
  /** Time series of water cut at standard conditions (water fraction of liquid rate) derived from well test measurements. */
  waterCutSC: Maybe<TimeSeries>;
  /** Reference to a time series for 'waterDensityLC' in this 'WellTestOutputs_String' view. */
  waterDensityLC: Maybe<TimeSeries>;
  /** Reference to a time series for 'waterDensitySC' in this 'WellTestOutputs_String' view. */
  waterDensitySC: Maybe<TimeSeries>;
  /** Reference to a time series for 'waterMassFlowRateLC' in this 'WellTestOutputs_String' view. */
  waterMassFlowRateLC: Maybe<TimeSeries>;
  /** Reference to a time series for 'waterMassFlowRateSC' in this 'WellTestOutputs_String' view. */
  waterMassFlowRateSC: Maybe<TimeSeries>;
  /** Reference to a time series for 'waterRateLC' in this 'WellTestOutputs_String' view. */
  waterRateLC: Maybe<TimeSeries>;
  /** Time series of measured water production rate at standard conditions during the well test. */
  waterRateSC: Maybe<TimeSeries>;
  /** Reference to a time series for 'waterVolumeFractionLC' in this 'WellTestOutputs_String' view. */
  waterVolumeFractionLC: Maybe<TimeSeries>;
  /** Time series of timestamps marking the end of each well test for this string. */
  wellTestEndDate: Maybe<TimeSeries>;
  /** Time series of timestamps marking the start of each well test for this string. */
  wellTestStartDate: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestStartDateDH' in this 'WellTestOutputs_String' view. */
  wellTestStartDateDH: Maybe<TimeSeries>;
  /** Reference to a time series for 'wf01ExecutedBy' in this 'WellTestOutputs_String' view. */
  wf01ExecutedBy: Maybe<TimeSeries>;
  /** Reference to a time series for 'wf01ExecutionTime' in this 'WellTestOutputs_String' view. */
  wf01ExecutionTime: Maybe<TimeSeries>;
  /** Reference to a time series for 'wf01Status' in this 'WellTestOutputs_String' view. */
  wf01Status: Maybe<TimeSeries>;
  /** Reference to a time series for 'wf01StatusDescription' in this 'WellTestOutputs_String' view. */
  wf01StatusDescription: Maybe<TimeSeries>;
  /** Reference to a time series for 'wf02ExecutedBy' in this 'WellTestOutputs_String' view. */
  wf02ExecutedBy: Maybe<TimeSeries>;
  /** Reference to a time series for 'wf02ExecutionTime' in this 'WellTestOutputs_String' view. */
  wf02ExecutionTime: Maybe<TimeSeries>;
  /** Reference to a time series for 'wf02Status' in this 'WellTestOutputs_String' view. */
  wf02Status: Maybe<TimeSeries>;
  /** Reference to a time series for 'wf02StatusDescription' in this 'WellTestOutputs_String' view. */
  wf02StatusDescription: Maybe<TimeSeries>;
  /** Reference to a time series for 'wf03ExecutedBy' in this 'WellTestOutputs_String' view. */
  wf03ExecutedBy: Maybe<TimeSeries>;
  /** Reference to a time series for 'wf03ExecutionTime' in this 'WellTestOutputs_String' view. */
  wf03ExecutionTime: Maybe<TimeSeries>;
  /** Reference to a time series for 'wf03Status' in this 'WellTestOutputs_String' view. */
  wf03Status: Maybe<TimeSeries>;
  /** Reference to a time series for 'wf03StatusDescription' in this 'WellTestOutputs_String' view. */
  wf03StatusDescription: Maybe<TimeSeries>;
  /** Reference to a time series for 'wf04ExecutedBy' in this 'WellTestOutputs_String' view. */
  wf04ExecutedBy: Maybe<TimeSeries>;
  /** Reference to a time series for 'wf04ExecutionTime' in this 'WellTestOutputs_String' view. */
  wf04ExecutionTime: Maybe<TimeSeries>;
  /** Reference to a time series for 'wf04Status' in this 'WellTestOutputs_String' view. */
  wf04Status: Maybe<TimeSeries>;
  /** Reference to a time series for 'wf04StatusDescription' in this 'WellTestOutputs_String' view. */
  wf04StatusDescription: Maybe<TimeSeries>;
  /** Reference to a time series for 'wgrLC' in this 'WellTestOutputs_String' view. */
  wgrLC: Maybe<TimeSeries>;
  /** Reference to a time series for 'wgrSC' in this 'WellTestOutputs_String' view. */
  wgrSC: Maybe<TimeSeries>;
  /** Reference to a time series for 'whp' in this 'WellTestOutputs_String' view. */
  whp: Maybe<TimeSeries>;
  /** Reference to a time series for 'wht' in this 'WellTestOutputs_String' view. */
  wht: Maybe<TimeSeries>;
};

/**
 * Prosper model tuning parameters from well test analysis including VLP, IPR,
 * and ESP wear.
 *
 * Contains detailed parameters derived from well test analysis, focusing on the
 * tuning of Prosper models for various well types, including vertical lift
 * performance (VLP), inflow performance relationship (IPR), and electrical
 * submersible pump (ESP) wear factors. Sourced from well test results and model
 * calibration processes, enabling production specialists to assess and optimize
 * well performance. It answers specific questions regarding the correlations and
 * parameters used in VLP and IPR models, as well as the wear factors for ESP
 * systems, while it excludes raw test data or historical performance metrics
 * found in other views. Use cases: quality control of models, trend analysis for
 * performance optimization, and tracking pump degradation over time.
 *
 * @name Well Test Model Parameters (Agent)
 */
export type WellTestModelParametersAgent = {
  /**
   * Flag indicating this string has an active Prosper model. True = model exists and
   * calibration outputs are available.
   */
  hasProsperModel: Maybe<Scalars['Boolean']['output']>;
  /**
   *   ESP pump wear factor (TS). 1.0 = new pump performance.
   *   < 0.7 indicates significant pump degradation - consider workover.
   *   Track trend over time for predictive maintenance.
   *
   * @name espWearFactor
   */
  modelEspWf: Maybe<TimeSeries>;
  /**
   *   Percent change in ESP wear factor (%, TS). Declining WF = pump wearing.
   *
   * @name espWearFactorChange
   */
  modelEspWfPercentChange: Maybe<TimeSeries>;
  /**
   *   Gas lift orifice size from model (inches, TS). Should match actual installed size.
   *
   * @name glOrificeSize
   */
  modelGlOrificeSize: Maybe<TimeSeries>;
  /**
   *   Percent change in orifice size (%, TS). Large change may indicate multipoint issue.
   *
   * @name glOrificeSizeChange
   */
  modelGlOrificeSizePercentChange: Maybe<TimeSeries>;
  /**
   *   IPR C coefficient (TS). From backpressure equation: Q = C * (Pr² - Pwf²)^n.
   *   Related to deliverability - higher C = better inflow.
   *
   * @name iprCoefficientC
   */
  modelIprC: Maybe<TimeSeries>;
  /**
   *   IPR n exponent (TS). Typically 0.5 to 1.0.
   *   n=1 = Darcy flow (linear). n<1 = non-Darcy/turbulent near wellbore.
   *
   * @name iprExponentN
   */
  modelIprN: Maybe<TimeSeries>;
  /**
   *   Indicates whether the well test rate was matched during the WF03 calibration process (TS).
   *   Values: MATCHED, FAILED, MANUAL. Use to filter for successfully calibrated well tests.
   *
   * @name matchStatus
   */
  modelMatchStatus: Maybe<TimeSeries>;
  /**
   *   Reservoir model type used (TS). E.g., 'Vogel', 'Fetkovitch', 'Jones'.
   *
   * @name reservoirModelType
   */
  modelReservoirModel: Maybe<TimeSeries>;
  /**
   *   Prosper model revision number (TS). Track model updates.
   *
   * @name modelRevision
   */
  modelRevisionNumber: Maybe<TimeSeries>;
  /**
   *   Overall heat transfer coefficient U-value (BTU/hr/ft2/degF, TS). Affects
   *   temperature profile and flow assurance calculations.
   *
   * @name overallHeatTransferCoeff
   */
  modelUval: Maybe<TimeSeries>;
  /**
   *   VLP correlation used (TS). E.g., 'Beggs and Brill', 'Hagedorn Brown', 'Petroleum Experts'.
   *   Different correlations work better for different conditions.
   *
   * @name vlpCorrelation
   */
  modelVlpCorrelation: Maybe<TimeSeries>;
  /**
   *   VLP tuning parameter 1 (TS). Typically friction factor multiplier.
   *   Together with modelMatchStatus, indicates whether the well test rate was successfully
   *   matched during WF03 calibration. Values > 1.5 or < 0.5 may indicate model issues.
   *
   * @name vlpParameter1
   */
  modelVlpParameter1: Maybe<TimeSeries>;
  /**
   *   Percent change in VLP parameter 1 (%, TS). Large changes may indicate tubing issues.
   *
   * @name vlpParam1Change
   */
  modelVlpParameter1PercentChange: Maybe<TimeSeries>;
  /**
   *   VLP tuning parameter 2 (TS). Typically holdup factor multiplier.
   *
   * @name vlpParameter2
   */
  modelVlpParameter2: Maybe<TimeSeries>;
  /**
   *   Percent change in VLP parameter 2 (%, TS).
   *
   * @name vlpParam2Change
   */
  modelVlpParameter2PercentChange: Maybe<TimeSeries>;
  /**
   *   ESP frequency during model match (Hz, TS). Reference point for analysis.
   *
   * @name espTestFrequency
   */
  modelWellTestEspFrequency: Maybe<TimeSeries>;
  /**
   *   Gas lift injection rate used in model (MMscfd, TS).
   *
   * @name glInjectionRate
   */
  modelWellTestGlInjection: Maybe<TimeSeries>;
  /**
   * External ID of the associated ProsperModel instance. Use to cross-reference with
   * ProsperModel_Agent for model metadata.
   */
  prosperModelExternalId: Maybe<Scalars['String']['output']>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString: Maybe<StringAsset>;
};

/** View 'WellTest_Raw' in the iPSO production optimization solution data model. */
export type WellTestRaw = {
  /** Reference to a time series for 'comments' in this 'WellTest_Raw' view. */
  comments: Maybe<TimeSeries>;
  /** Reference to a time series for 'composition' in this 'WellTest_Raw' view. */
  composition: Maybe<TimeSeries>;
  /** Reference to the related 'String_asset' entity for this 'WellTest_Raw' row. */
  entityName: Maybe<StringAsset>;
  /** Reference to a time series for 'fluidProperties' in this 'WellTest_Raw' view. */
  fluidProperties: Maybe<TimeSeries>;
  /** Reference to a time series for 'modelComposition' in this 'WellTest_Raw' view. */
  modelComposition: Maybe<TimeSeries>;
  /** Reference to a time series for 'ptsDateTime' in this 'WellTest_Raw' view. */
  ptsDateTime: Maybe<TimeSeries>;
  /** Reference to a time series for 'sampleDateTime' in this 'WellTest_Raw' view. */
  sampleDateTime: Maybe<TimeSeries>;
  /** Reference to a time series for 'stablePeriodEndDate' in this 'WellTest_Raw' view. */
  stablePeriodEndDate: Maybe<TimeSeries>;
  /** Reference to a time series for 'stablePeriodStartDate' in this 'WellTest_Raw' view. */
  stablePeriodStartDate: Maybe<TimeSeries>;
  /** Reference to a time series for 'validatedBy' in this 'WellTest_Raw' view. */
  validatedBy: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestApprovedAllocationFlag' in this 'WellTest_Raw' view. */
  wellTestApprovedAllocationFlag: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestArtificialLiftType' in this 'WellTest_Raw' view. */
  wellTestArtificialLiftType: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestBottomHolePressure' in this 'WellTest_Raw' view. */
  wellTestBottomHolePressure: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestBottomHoleTemperature' in this 'WellTest_Raw' view. */
  wellTestBottomHoleTemperature: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestCGR' in this 'WellTest_Raw' view. */
  wellTestCGR: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestCasingHeadPressure' in this 'WellTest_Raw' view. */
  wellTestCasingHeadPressure: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestCasingHeadTemperature' in this 'WellTest_Raw' view. */
  wellTestCasingHeadTemperature: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestChokeOpening' in this 'WellTest_Raw' view. */
  wellTestChokeOpening: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestChokeSize' in this 'WellTest_Raw' view. */
  wellTestChokeSize: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestDuration' in this 'WellTest_Raw' view. */
  wellTestDuration: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestEgorVendorStdGasRate' in this 'WellTest_Raw' view. */
  wellTestEgorVendorStdGasRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestEgorVendorStdOilRate' in this 'WellTest_Raw' view. */
  wellTestEgorVendorStdOilRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestEgorVendorStdWaterRate' in this 'WellTest_Raw' view. */
  wellTestEgorVendorStdWaterRate: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestEndDate' in this 'WellTest_Raw' view. */
  wellTestEndDate: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestEspMotorCurrent' in this 'WellTest_Raw' view. */
  wellTestEspMotorCurrent: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestEspMotorPower' in this 'WellTest_Raw' view. */
  wellTestEspMotorPower: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestEspMotorVoltage' in this 'WellTest_Raw' view. */
  wellTestEspMotorVoltage: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestEspPumpDischargePressure' in this 'WellTest_Raw' view. */
  wellTestEspPumpDischargePressure: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestEspPumpFrequency' in this 'WellTest_Raw' view. */
  wellTestEspPumpFrequency: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestEspPumpIntakePressure' in this 'WellTest_Raw' view. */
  wellTestEspPumpIntakePressure: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestEspPumpIntakeTemperature' in this 'WellTest_Raw' view. */
  wellTestEspPumpIntakeTemperature: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestFlowlinePressure' in this 'WellTest_Raw' view. */
  wellTestFlowlinePressure: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestFlowlineTemperature' in this 'WellTest_Raw' view. */
  wellTestFlowlineTemperature: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGOR' in this 'WellTest_Raw' view. */
  wellTestGOR: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGasDensityInSitu' in this 'WellTest_Raw' view. */
  wellTestGasDensityInSitu: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGasLiftVolume' in this 'WellTest_Raw' view. */
  wellTestGasLiftVolume: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGasRateInsitu' in this 'WellTest_Raw' view. */
  wellTestGasRateInsitu: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGasRatePts' in this 'WellTest_Raw' view. */
  wellTestGasRatePts: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGasRateStd' in this 'WellTest_Raw' view. */
  wellTestGasRateStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGlFlControlValvOutletPres' in this 'WellTest_Raw' view. */
  wellTestGlFlControlValvOutletPres: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGlFlControlValveInletPres' in this 'WellTest_Raw' view. */
  wellTestGlFlControlValveInletPres: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGlFlControlValveInletTemp' in this 'WellTest_Raw' view. */
  wellTestGlFlControlValveInletTemp: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGlInjectionChokeOpening' in this 'WellTest_Raw' view. */
  wellTestGlInjectionChokeOpening: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGorInsitu' in this 'WellTest_Raw' view. */
  wellTestGorInsitu: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestGorPts' in this 'WellTest_Raw' view. */
  wellTestGorPts: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestLiquidRatePts' in this 'WellTest_Raw' view. */
  wellTestLiquidRatePts: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestMpfmName' in this 'WellTest_Raw' view. */
  wellTestMpfmName: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestOilDensityInSitu' in this 'WellTest_Raw' view. */
  wellTestOilDensityInSitu: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestOilRateInsitu' in this 'WellTest_Raw' view. */
  wellTestOilRateInsitu: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestOilRatePts' in this 'WellTest_Raw' view. */
  wellTestOilRatePts: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestOilRateStd' in this 'WellTest_Raw' view. */
  wellTestOilRateStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestStartDate' in this 'WellTest_Raw' view. */
  wellTestStartDate: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestStringFunction' in this 'WellTest_Raw' view. */
  wellTestStringFunction: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestTestMethod' in this 'WellTest_Raw' view. */
  wellTestTestMethod: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestTestSeparatorLinePressure' in this 'WellTest_Raw' view. */
  wellTestTestSeparatorLinePressure: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestTestSeparatorLineTemperature' in this 'WellTest_Raw' view. */
  wellTestTestSeparatorLineTemperature: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestTestType' in this 'WellTest_Raw' view. */
  wellTestTestType: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestTestTypeDesc' in this 'WellTest_Raw' view. */
  wellTestTestTypeDesc: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestTotalGorStd' in this 'WellTest_Raw' view. */
  wellTestTotalGorStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestTotalMassFlowRateGas' in this 'WellTest_Raw' view. */
  wellTestTotalMassFlowRateGas: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestTotalMassFlowRateOil' in this 'WellTest_Raw' view. */
  wellTestTotalMassFlowRateOil: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestTotalMassFlowRateWater' in this 'WellTest_Raw' view. */
  wellTestTotalMassFlowRateWater: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestValidationFlag' in this 'WellTest_Raw' view. */
  wellTestValidationFlag: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestWGR' in this 'WellTest_Raw' view. */
  wellTestWGR: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestWaterCut' in this 'WellTest_Raw' view. */
  wellTestWaterCut: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestWaterCutInsitu' in this 'WellTest_Raw' view. */
  wellTestWaterCutInsitu: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestWaterCutPts' in this 'WellTest_Raw' view. */
  wellTestWaterCutPts: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestWaterRateInsitu' in this 'WellTest_Raw' view. */
  wellTestWaterRateInsitu: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestWaterRatePts' in this 'WellTest_Raw' view. */
  wellTestWaterRatePts: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestWaterRateStd' in this 'WellTest_Raw' view. */
  wellTestWaterRateStd: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestWellheadPressure' in this 'WellTest_Raw' view. */
  wellTestWellheadPressure: Maybe<TimeSeries>;
  /** Reference to a time series for 'wellTestWellheadTemperature' in this 'WellTest_Raw' view. */
  wellTestWellheadTemperature: Maybe<TimeSeries>;
};

/**
 * Reservoir performance from well test analysis including PI, II, and reservoir
 * pressure.
 *
 * Contains data derived from well test analyses, focusing on key performance
 * indicators such as the Productivity Index (PI), Injectivity Index (II), and
 * reservoir pressure metrics. Sourced from field tests conducted on production
 * and injection wells, allowing for the assessment of reservoir deliverability
 * and performance over time. It answers critical questions regarding changes in
 * PI, reservoir pressure trends, and the efficiency of reservoir depletion, but
 * excludes detailed geological data or historical production rates found in
 * other views. Use cases: monitoring reservoir performance, identifying wells
 * with declining efficiency, and comparing performance across different fields.
 *
 * @name Well Test Reservoir Analysis (Agent)
 */
export type WellTestReservoirAnalysisAgent = {
  /**
   *   Injectivity Index - II (bbl/d/psi, TS). For water/gas injectors.
   *   II = Qinj / (Pwf - Pr). HIGHER II = better injection efficiency.
   *
   * @name injectivityIndex
   */
  modelInjectivityIndex: Maybe<TimeSeries>;
  /**
   *   Percent change in II from previous test (%, TS).
   *   Declining II may indicate: formation damage, scale, or plugging.
   *
   * @name iiPercentChange
   */
  modelInjectivityIndexPercentChange: Maybe<TimeSeries>;
  /**
   *   Minimum rate for stable flow (stb/d, TS). Below this = slugging risk.
   *
   * @name minimumStableRate
   */
  modelMinStableRate: Maybe<TimeSeries>;
  /**
   *   Productivity Index - PI (stb/d/psi, TS).
   *   PI = Q / (Pr - Pwf) where Q=liquid rate, Pr=reservoir pressure, Pwf=flowing BHP.
   *   HIGHER PI = better reservoir deliverability.
   *   Compare across wells in same reservoir for benchmarking.
   *
   * @name productivityIndex
   */
  modelProductivityIndex: Maybe<TimeSeries>;
  /**
   *   Percent change in PI from previous accepted test (%, TS).
   *   NEGATIVE = PI declined (possible causes: scale, skin, depletion).
   *   > -20% decline warrants investigation.
   *
   * @name piPercentChange
   */
  modelProductivityIndexPercentChange: Maybe<TimeSeries>;
  /**
   *   Static reservoir pressure from analysis (psia, TS).
   *   Declining Pres = depletion. Compare to neighboring wells for aquifer/pressure support.
   *
   * @name reservoirPressure
   */
  modelReservoirPressure: Maybe<TimeSeries>;
  /**
   *   Percent change in reservoir pressure (%, TS).
   *   Rapid decline may indicate: poor sweep, inadequate injection support.
   *
   * @name reservoirPressureChange
   */
  modelReservoirPressurePercentChange: Maybe<TimeSeries>;
  /**
   *   Is well operating in stable regime? (TS). STABLE, UNSTABLE, TRANSIENT.
   *   Unstable wells may have PI calculation issues.
   *
   * @name stabilityFlag
   */
  modelStabilityFlag: Maybe<TimeSeries>;
  /**
   *   Status of analysis result (TS). ACCEPTED, PENDING, REJECTED.
   *   Only use ACCEPTED results for reservoir surveillance.
   *
   * @name analysisStatus
   */
  modelStatus: Maybe<TimeSeries>;
  /**
   *   When this analysis was performed (TS). Use to check analysis freshness.
   *
   * @name analysisTimestamp
   */
  modelWellTestTimestamp: Maybe<TimeSeries>;
  /** Reference to well string. Join to FlatHierarchy_Agent for reservoir grouping. */
  wellString: Maybe<StringAsset>;
};

/** View 'Well_Choke_Mapping' in the iPSO production optimization solution data model. */
export type WellChokeMapping = {
  /** Reference to a time series for 'choketype' in this 'Well_Choke_Mapping' view. */
  choketype: Maybe<TimeSeries>;
  /** Reference to the related 'String_asset' entity for this 'Well_Choke_Mapping' row. */
  entityName: Maybe<StringAsset>;
  /** Reference to a time series for 'gasLiftChokeType' in this 'Well_Choke_Mapping' view. */
  gasLiftChokeType: Maybe<TimeSeries>;
};

/** WF3 well string model outputs and configuration identifiers, including productivity and injectivity indices, modelled reservoir pressures, minimum stable rates and links to the underlying reservoir and VLP model versions used for simulation and calibration. */
export type Wf3OutputsString = {
  calibrationAlarmCode: Maybe<TimeSeries>;
  /** Time series of choke best gasâ€“oil ratio (GOR) for this well string as estimated by the WF3 well model. */
  chokeBestGor: Maybe<TimeSeries>;
  /** Time series of choke best wc for this well string as estimated by the WF3 well model. */
  chokeBestWc: Maybe<TimeSeries>;
  /** Time series of choke best wgr for this well string as estimated by the WF3 well model. */
  chokeBestWgr: Maybe<TimeSeries>;
  /** Name of the well string (completion) for which WF3 model outputs are generated, sourced from the 'String_asset' view. */
  entityName: Maybe<StringAsset>;
  /** Time series of model electric submersible pump (ESP) wf for this well string as estimated by the WF3 well model. */
  modelEspWf: Maybe<TimeSeries>;
  /** Time series of model electric submersible pump (ESP) wf percent change for this well string as estimated by the WF3 well model. */
  modelEspWfPercentChange: Maybe<TimeSeries>;
  /** Time series of model estimated flowing bottom-hole pressure (FBHP) for this well string as estimated by the WF3 well model. */
  modelEstimatedFbhp: Maybe<TimeSeries>;
  /** Time series of model estimated gas rate for this well string as estimated by the WF3 well model. */
  modelEstimatedGasRate: Maybe<TimeSeries>;
  /** Time series of model estimated liquid rate for this well string as estimated by the WF3 well model. */
  modelEstimatedLiquidRate: Maybe<TimeSeries>;
  /** Time series of model estimated oil rate for this well string as estimated by the WF3 well model. */
  modelEstimatedOilRate: Maybe<TimeSeries>;
  /** Time series of model estimated pdg press for this well string as estimated by the WF3 well model. */
  modelEstimatedPdgPress: Maybe<TimeSeries>;
  /** Time series of model estimated pdp for this well string as estimated by the WF3 well model. */
  modelEstimatedPdp: Maybe<TimeSeries>;
  /** Time series of model estimated pip for this well string as estimated by the WF3 well model. */
  modelEstimatedPip: Maybe<TimeSeries>;
  /** Time series of model estimated water rate for this well string as estimated by the WF3 well model. */
  modelEstimatedWaterRate: Maybe<TimeSeries>;
  /** Time series of model gas lift (GL) orifice size for this well string as estimated by the WF3 well model. */
  modelGlOrificeSize: Maybe<TimeSeries>;
  /** Time series of model gas lift (GL) orifice size percent change for this well string as estimated by the WF3 well model. */
  modelGlOrificeSizePercentChange: Maybe<TimeSeries>;
  /** Time series of modelled well injectivity index for this string as estimated in WF3. */
  modelInjectivityIndex: Maybe<TimeSeries>;
  /** Time series of model injectivity index percent change for this well string as estimated by the WF3 well model. */
  modelInjectivityIndexPercentChange: Maybe<TimeSeries>;
  /** Time series of model inflow performance relationship (IPR) c for this well string as estimated by the WF3 well model. */
  modelIprC: Maybe<TimeSeries>;
  /** Time series of model inflow performance relationship (IPR) n for this well string as estimated by the WF3 well model. */
  modelIprN: Maybe<TimeSeries>;
  /** Time series of model match status for this well string as estimated by the WF3 well model. */
  modelMatchStatus: Maybe<TimeSeries>;
  /** Time series of minimum stable liquid production rate for which the WF3 model predicts stable operation for this string. */
  modelMinStableRate: Maybe<TimeSeries>;
  /** Identifier of the updated or calibrated model file produced by WF3 for this string. */
  modelNewFileId: Maybe<Scalars['Int64']['output']>;
  /** Identifier of the original input model file used for WF3 simulations for this string. */
  modelOriginalFileId: Maybe<Scalars['Int64']['output']>;
  /** Time series of modelled well productivity index (PI) for this string as estimated in WF3. */
  modelProductivityIndex: Maybe<TimeSeries>;
  /** Time series of model productivity index percent change for this well string as estimated by the WF3 well model. */
  modelProductivityIndexPercentChange: Maybe<TimeSeries>;
  /** Time series reference to the selected reservoir model or scenario used in WF3 for this string. */
  modelReservoirModel: Maybe<TimeSeries>;
  /** Time series of modelled average reservoir pressure used in WF3 computations for this string. */
  modelReservoirPressure: Maybe<TimeSeries>;
  /** Time series of model reservoir pressure percent change for this well string as estimated by the WF3 well model. */
  modelReservoirPressurePercentChange: Maybe<TimeSeries>;
  /** Time series of model revision external id for this well string as estimated by the WF3 well model. */
  modelRevisionExternalId: Maybe<TimeSeries>;
  /** Time series of model revision number for this well string as estimated by the WF3 well model. */
  modelRevisionNumber: Maybe<TimeSeries>;
  /** Time series flag indicating stability of the WF3 solution for this string (for example stable versus unstable operating point). */
  modelStabilityFlag: Maybe<TimeSeries>;
  /** Time series of model status for this well string as estimated by the WF3 well model. */
  modelStatus: Maybe<TimeSeries>;
  /** Time series of overall heat-transfer coefficient (U-value) or similar model parameter used in WF3 for this string. */
  modelUval: Maybe<TimeSeries>;
  /** Time series of model vertical lift performance (VLP) correlation for this well string as estimated by the WF3 well model. */
  modelVlpCorrelation: Maybe<TimeSeries>;
  /** Timestamp or identifier associated with the vertical lift performance (VLP) model version used in WF3 for this string. */
  modelVlpModel: Maybe<Scalars['Timestamp']['output']>;
  /** Time series of model vertical lift performance (VLP) parameter1 for this well string as estimated by the WF3 well model. */
  modelVlpParameter1: Maybe<TimeSeries>;
  /** Time series of model vertical lift performance (VLP) parameter1 percent change for this well string as estimated by the WF3 well model. */
  modelVlpParameter1PercentChange: Maybe<TimeSeries>;
  /** Time series of model vertical lift performance (VLP) parameter2 for this well string as estimated by the WF3 well model. */
  modelVlpParameter2: Maybe<TimeSeries>;
  /** Time series of model vertical lift performance (VLP) parameter2 percent change for this well string as estimated by the WF3 well model. */
  modelVlpParameter2PercentChange: Maybe<TimeSeries>;
  /** Time series of model well test chp for this well string as estimated by the WF3 well model. */
  modelWellTestChp: Maybe<TimeSeries>;
  /** Time series of model well test electric submersible pump (ESP) frequency for this well string as estimated by the WF3 well model. */
  modelWellTestEspFrequency: Maybe<TimeSeries>;
  /** Time series of model well test gas rate for this well string as estimated by the WF3 well model. */
  modelWellTestGasRate: Maybe<TimeSeries>;
  /** Time series of model well test gas lift (GL) injection for this well string as estimated by the WF3 well model. */
  modelWellTestGlInjection: Maybe<TimeSeries>;
  /** Time series of model well test gasâ€“oil ratio (GOR) for this well string as estimated by the WF3 well model. */
  modelWellTestGor: Maybe<TimeSeries>;
  /** Time series of model well test liquid rate for this well string as estimated by the WF3 well model. */
  modelWellTestLiquidRate: Maybe<TimeSeries>;
  /** PDG - permanent downhole gauge */
  modelWellTestPdgPress: Maybe<TimeSeries>;
  /** Time series of model well test timestamp for this well string as estimated by the WF3 well model. */
  modelWellTestTimestamp: Maybe<TimeSeries>;
  /** Time series of model well test wc for this well string as estimated by the WF3 well model. */
  modelWellTestWc: Maybe<TimeSeries>;
  /** Time series of model well test whp for this well string as estimated by the WF3 well model. */
  modelWellTestWhp: Maybe<TimeSeries>;
  /** Time series of new file id for this well string as estimated by the WF3 well model. */
  newFileId: Maybe<TimeSeries>;
  /** Time series of original file id for this well string as estimated by the WF3 well model. */
  originalFileId: Maybe<TimeSeries>;
  /** Time series of vertical lift performance (VLP) best gasâ€“oil ratio (GOR) for this well string as estimated by the WF3 well model. */
  vlpBestGor: Maybe<TimeSeries>;
  /** Time series of vertical lift performance (VLP) best wc for this well string as estimated by the WF3 well model. */
  vlpBestWc: Maybe<TimeSeries>;
  /** Time series of vertical lift performance (VLP) best wgr for this well string as estimated by the WF3 well model. */
  vlpBestWgr: Maybe<TimeSeries>;
};

/** View 'WfAlarms' in the iPSO production optimization solution data model. */
export type WfAlarms = {
  /** Property 'additionalInformation' for this 'WfAlarms' row. */
  additionalInformation: Maybe<Scalars['JSONObject']['output']>;
  /** Reference to the related 'AlarmDefinition' entity for this 'WfAlarms' row. */
  alarmCode: Maybe<AlarmDefinition>;
  /** Numeric value 'alarmCounter' (integer) for this 'WfAlarms' row. */
  alarmCounter: Scalars['Int']['output'];
  /** Text attribute 'alarmFlags' for this 'WfAlarms' row. */
  alarmFlags: Maybe<Scalars['String']['output']>;
  /** Text attribute 'customWorkflowAlarmMessage' for this 'WfAlarms' row. */
  customWorkflowAlarmMessage: Scalars['String']['output'];
  /** Timestamp 'endDateTime' associated with this 'WfAlarms' row. */
  endDateTime: Scalars['Timestamp']['output'];
  /** Text attribute 'entityExternalId' for this 'WfAlarms' row. */
  entityExternalId: Scalars['String']['output'];
  /** Text attribute 'entityName' for this 'WfAlarms' row. */
  entityName: Scalars['String']['output'];
  /** Text attribute 'entityType' for this 'WfAlarms' row. */
  entityType: Scalars['String']['output'];
  /** Property 'markAsRead' for this 'WfAlarms' row. */
  markAsRead: Maybe<Scalars['JSONObject']['output']>;
  /** Text attribute 'operationType' for this 'WfAlarms' row. */
  operationType: Maybe<Scalars['String']['output']>;
  referencedEntityStartDateTime: Maybe<Scalars['Timestamp']['output']>;
  /** Text attribute 'relatedEntity' for this 'WfAlarms' row. */
  relatedEntity: Maybe<Scalars['String']['output']>;
  /** Text attribute 'relatedEntityExternalId' for this 'WfAlarms' row. */
  relatedEntityExternalId: Maybe<Scalars['String']['output']>;
  /** Property 'removeAlaramForUser' for this 'WfAlarms' row. */
  removeAlaramForUser: Maybe<Scalars['JSONObject']['output']>;
  /** Text attribute 'runId' for this 'WfAlarms' row. */
  runId: Maybe<Scalars['String']['output']>;
  /** Text attribute 'ssWorkflowAlarmMessage' for this 'WfAlarms' row. */
  ssWorkflowAlarmMessage: Maybe<Scalars['String']['output']>;
  /** Timestamp 'startDateTime' associated with this 'WfAlarms' row. */
  startDateTime: Scalars['Timestamp']['output'];
  /** Text attribute 'ticketId' for this 'WfAlarms' row. */
  ticketId: Maybe<Scalars['String']['output']>;
};

/**
 * Denormalized alarms with alarm-definition properties inlined; retention is
 * about 48 hours by alarm start (see delete job).
 *
 * The Workflow Alarms (Agent) view holds recent denormalized alarm data,
 * including properties such as alarmPriority,
 * alarmCriticality, and workflow details. This view facilitates analysis of
 * alarm occurrences and their characteristics, to address questions related to
 * alarm frequency, severity, and workflow impact. Sourced from real-time alarm
 * systems, ensuring that it reflects the most current operational status.
 * Excludes pre-filtered alarms for WF12/WF14 (use ESPAlarms_Agent, GasLiftAlarms_Agent).
 *
 * Use for: Real-Time Surveillance (WF18), cross-workflow alarm rollup.
 *
 * @name Workflow Alarms (Agent)
 */
export type WfAlarmsAgent = {
  /** Alarm category from AlarmDefinition (e.g., ESP, Gas Lift, Production). */
  alarmCategory: Maybe<Scalars['String']['output']>;
  /** Reference to AlarmDefinition node. */
  alarmCode: Maybe<Scalars['JSONObject']['output']>;
  /** External ID of the alarm code (e.g., WF12-001) for easy filtering. */
  alarmCodeExternalId: Maybe<Scalars['String']['output']>;
  /** Count of how many times this alarm has occurred. */
  alarmCounter: Maybe<Scalars['Int']['output']>;
  /** Alarm criticality level from AlarmDefinition. */
  alarmCriticality: Maybe<Scalars['String']['output']>;
  /** Alarm validity flag (Valid, Invalid, etc.). */
  alarmFlags: Maybe<Scalars['String']['output']>;
  /** Standard alarm message template from AlarmDefinition. */
  alarmMessage: Maybe<Scalars['String']['output']>;
  /** Human-readable alarm name from AlarmDefinition. */
  alarmName: Maybe<Scalars['String']['output']>;
  /** Alarm priority level from AlarmDefinition (e.g., HIGH, MEDIUM, LOW). */
  alarmPriority: Maybe<Scalars['String']['output']>;
  /** Detailed alarm message with specific conditions that triggered it. */
  customWorkflowAlarmMessage: Maybe<Scalars['String']['output']>;
  /** When the alarm was cleared. Null means alarm is still active. */
  endDateTime: Maybe<Scalars['Timestamp']['output']>;
  /** External ID of the entity for joining to other views. */
  entityExternalId: Scalars['String']['output'];
  /** Display name of the entity (well, string) with the alarm. */
  entityName: Scalars['String']['output'];
  /** Type of entity (string, well, field). */
  entityType: Scalars['String']['output'];
  /** When the alarm was triggered. */
  startDateTime: Scalars['Timestamp']['output'];
  /** Sub-category from AlarmDefinition. */
  subCategory: Maybe<Scalars['String']['output']>;
  /** Sub-workflow name from AlarmDefinition. */
  subWorkflowName: Maybe<Scalars['String']['output']>;
  /** Associated troubleshooting ticket ID if one was created. */
  ticketId: Maybe<Scalars['String']['output']>;
  /**
   * Direct relation to String_asset (when entityType = 'string').
   * Navigate to string properties like lift type, status, field hierarchy.
   */
  wellString: Maybe<StringAsset>;
  /** Workflow code from AlarmDefinition (e.g., WF12). */
  workflowCode: Maybe<Scalars['String']['output']>;
  /** Workflow name from AlarmDefinition. */
  workflowName: Maybe<Scalars['String']['output']>;
};

/** View 'WfFieldAlarms' in the iPSO production optimization solution data model. */
export type WfFieldAlarms = {
  /** Numeric value 'alarmCounter' (integer) for this 'WfFieldAlarms' row. */
  alarmCounter: Maybe<Scalars['Int']['output']>;
  /** Text attribute 'alarmFlags' for this 'WfFieldAlarms' row. */
  alarmFlags: Maybe<Scalars['String']['output']>;
  /** Text attribute 'alarmLevel' for this 'WfFieldAlarms' row. */
  alarmLevel: Maybe<Scalars['String']['output']>;
  /** Text attribute 'alarmMessage' for this 'WfFieldAlarms' row. */
  alarmMessage: Maybe<Scalars['String']['output']>;
  /** Text attribute 'alarmName' for this 'WfFieldAlarms' row. */
  alarmName: Maybe<Scalars['String']['output']>;
  /** Text attribute 'alarmType' for this 'WfFieldAlarms' row. */
  alarmType: Maybe<Scalars['String']['output']>;
  /** Text attribute 'configuration' for this 'WfFieldAlarms' row. */
  configuration: Maybe<Scalars['String']['output']>;
  /** Timestamp 'endDateTime' associated with this 'WfFieldAlarms' row. */
  endDateTime: Maybe<Scalars['Timestamp']['output']>;
  /** Reference to the related 'Field' entity for this 'WfFieldAlarms' row. */
  entityName: Maybe<Field>;
  /** Text attribute 'operationType' for this 'WfFieldAlarms' row. */
  operationType: Maybe<Scalars['String']['output']>;
  /** Timestamp 'startDateTime' associated with this 'WfFieldAlarms' row. */
  startDateTime: Maybe<Scalars['Timestamp']['output']>;
  /** Text attribute 'ticketId' for this 'WfFieldAlarms' row. */
  ticketId: Maybe<Scalars['String']['output']>;
  /** Text attribute 'workflowName' for this 'WfFieldAlarms' row. */
  workflowName: Maybe<Scalars['String']['output']>;
};

/** View 'WfReservoirAlarms' in the iPSO production optimization solution data model. */
export type WfReservoirAlarms = {
  /** Numeric value 'alarmCounter' (integer) for this 'WfReservoirAlarms' row. */
  alarmCounter: Maybe<Scalars['Int']['output']>;
  /** Text attribute 'alarmFlags' for this 'WfReservoirAlarms' row. */
  alarmFlags: Maybe<Scalars['String']['output']>;
  /** Text attribute 'alarmLevel' for this 'WfReservoirAlarms' row. */
  alarmLevel: Maybe<Scalars['String']['output']>;
  /** Text attribute 'alarmMessage' for this 'WfReservoirAlarms' row. */
  alarmMessage: Maybe<Scalars['String']['output']>;
  /** Text attribute 'alarmName' for this 'WfReservoirAlarms' row. */
  alarmName: Maybe<Scalars['String']['output']>;
  /** Text attribute 'alarmType' for this 'WfReservoirAlarms' row. */
  alarmType: Maybe<Scalars['String']['output']>;
  /** Text attribute 'configuration' for this 'WfReservoirAlarms' row. */
  configuration: Maybe<Scalars['String']['output']>;
  /** Timestamp 'endDateTime' associated with this 'WfReservoirAlarms' row. */
  endDateTime: Maybe<Scalars['Timestamp']['output']>;
  /** Reference to the related 'Reservoir' entity for this 'WfReservoirAlarms' row. */
  entityName: Maybe<Reservoir>;
  /** Text attribute 'operationType' for this 'WfReservoirAlarms' row. */
  operationType: Maybe<Scalars['String']['output']>;
  /** Timestamp 'startDateTime' associated with this 'WfReservoirAlarms' row. */
  startDateTime: Maybe<Scalars['Timestamp']['output']>;
  /** Text attribute 'ticketId' for this 'WfReservoirAlarms' row. */
  ticketId: Maybe<Scalars['String']['output']>;
  /** Text attribute 'workflowName' for this 'WfReservoirAlarms' row. */
  workflowName: Maybe<Scalars['String']['output']>;
};

/** View 'WfSectorAlarms' in the iPSO production optimization solution data model. */
export type WfSectorAlarms = {
  /** Numeric value 'alarmCounter' (integer) for this 'WfSectorAlarms' row. */
  alarmCounter: Maybe<Scalars['Int']['output']>;
  /** Text attribute 'alarmFlags' for this 'WfSectorAlarms' row. */
  alarmFlags: Maybe<Scalars['String']['output']>;
  /** Text attribute 'alarmLevel' for this 'WfSectorAlarms' row. */
  alarmLevel: Maybe<Scalars['String']['output']>;
  /** Text attribute 'alarmMessage' for this 'WfSectorAlarms' row. */
  alarmMessage: Maybe<Scalars['String']['output']>;
  /** Text attribute 'alarmName' for this 'WfSectorAlarms' row. */
  alarmName: Maybe<Scalars['String']['output']>;
  /** Text attribute 'alarmType' for this 'WfSectorAlarms' row. */
  alarmType: Maybe<Scalars['String']['output']>;
  /** Text attribute 'configuration' for this 'WfSectorAlarms' row. */
  configuration: Maybe<Scalars['String']['output']>;
  /** Timestamp 'endDateTime' associated with this 'WfSectorAlarms' row. */
  endDateTime: Maybe<Scalars['Timestamp']['output']>;
  /** Reference to the related 'Sector' entity for this 'WfSectorAlarms' row. */
  entityName: Maybe<Sector>;
  /** Text attribute 'operationType' for this 'WfSectorAlarms' row. */
  operationType: Maybe<Scalars['String']['output']>;
  /** Timestamp 'startDateTime' associated with this 'WfSectorAlarms' row. */
  startDateTime: Maybe<Scalars['Timestamp']['output']>;
  /** Text attribute 'ticketId' for this 'WfSectorAlarms' row. */
  ticketId: Maybe<Scalars['String']['output']>;
  /** Text attribute 'workflowName' for this 'WfSectorAlarms' row. */
  workflowName: Maybe<Scalars['String']['output']>;
};

/** View 'WfStringAlarms' in the iPSO production optimization solution data model. */
export type WfStringAlarms = {
  /** Numeric value 'alarmCounter' (integer) for this 'WfStringAlarms' row. */
  alarmCounter: Maybe<Scalars['Int']['output']>;
  /** Text attribute 'alarmFlags' for this 'WfStringAlarms' row. */
  alarmFlags: Maybe<Scalars['String']['output']>;
  /** Text attribute 'alarmLevel' for this 'WfStringAlarms' row. */
  alarmLevel: Maybe<Scalars['String']['output']>;
  /** Text attribute 'alarmMessage' for this 'WfStringAlarms' row. */
  alarmMessage: Maybe<Scalars['String']['output']>;
  /** Text attribute 'alarmName' for this 'WfStringAlarms' row. */
  alarmName: Maybe<Scalars['String']['output']>;
  /** Text attribute 'alarmType' for this 'WfStringAlarms' row. */
  alarmType: Maybe<Scalars['String']['output']>;
  /** Text attribute 'configuration' for this 'WfStringAlarms' row. */
  configuration: Maybe<Scalars['String']['output']>;
  /** Timestamp 'endDateTime' associated with this 'WfStringAlarms' row. */
  endDateTime: Maybe<Scalars['Timestamp']['output']>;
  /** Reference to the related 'String_asset' entity for this 'WfStringAlarms' row. */
  entityName: Maybe<StringAsset>;
  /** Text attribute 'operationType' for this 'WfStringAlarms' row. */
  operationType: Maybe<Scalars['String']['output']>;
  /** Timestamp 'startDateTime' associated with this 'WfStringAlarms' row. */
  startDateTime: Maybe<Scalars['Timestamp']['output']>;
  /** Text attribute 'ticketId' for this 'WfStringAlarms' row. */
  ticketId: Maybe<Scalars['String']['output']>;
  /** Text attribute 'workflowName' for this 'WfStringAlarms' row. */
  workflowName: Maybe<Scalars['String']['output']>;
};

/** View 'WfWellAlarms' in the iPSO production optimization solution data model. */
export type WfWellAlarms = {
  /** Numeric value 'alarmCounter' (integer) for this 'WfWellAlarms' row. */
  alarmCounter: Maybe<Scalars['Int']['output']>;
  /** Text attribute 'alarmFlags' for this 'WfWellAlarms' row. */
  alarmFlags: Maybe<Scalars['String']['output']>;
  /** Text attribute 'alarmLevel' for this 'WfWellAlarms' row. */
  alarmLevel: Maybe<Scalars['String']['output']>;
  /** Text attribute 'alarmMessage' for this 'WfWellAlarms' row. */
  alarmMessage: Maybe<Scalars['String']['output']>;
  /** Text attribute 'alarmName' for this 'WfWellAlarms' row. */
  alarmName: Maybe<Scalars['String']['output']>;
  /** Text attribute 'alarmType' for this 'WfWellAlarms' row. */
  alarmType: Maybe<Scalars['String']['output']>;
  /** Text attribute 'configuration' for this 'WfWellAlarms' row. */
  configuration: Maybe<Scalars['String']['output']>;
  /** Timestamp 'endDateTime' associated with this 'WfWellAlarms' row. */
  endDateTime: Maybe<Scalars['Timestamp']['output']>;
  /** Reference to the related 'Well' entity for this 'WfWellAlarms' row. */
  entityName: Maybe<Well>;
  /** Text attribute 'operationType' for this 'WfWellAlarms' row. */
  operationType: Maybe<Scalars['String']['output']>;
  /** Timestamp 'startDateTime' associated with this 'WfWellAlarms' row. */
  startDateTime: Maybe<Scalars['Timestamp']['output']>;
  /** Text attribute 'ticketId' for this 'WfWellAlarms' row. */
  ticketId: Maybe<Scalars['String']['output']>;
  /** Text attribute 'workflowName' for this 'WfWellAlarms' row. */
  workflowName: Maybe<Scalars['String']['output']>;
};
